/*export const mockMarkeplace = {
  data:
}*/

export const mockMarkeplace = {
  response: [{
    "ID_lista": 4333,
    "Title": "Forms",
    "Fecha_solicitud": "24/08/2023",
    "Correo_solicitante": "carescob@bancolombia.com.co",
    "Nombre_solicitante": "Carolina Escobar Pemberthy",
    "Nombre_iniciativa": "ID 4333 - Herramienta para investigaciones cualitativas",
    "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
    "CW_a_renovar": "",
    "Justificación_legalización": "",
    "Es_core_leasing": "",
    "Detalle_producto_o_servicio": "Se solicita actualizar la cotización para poder dar inicio a la compra de 5 licencias anuales de MAXQDA. Ya habíamos realizado la evaluación previa del proveedor con Tatiana Tangarife, pero estábamos a la espera de la aprobación de la compra por parte del líder de EVC.",
    "Requerimiento_legal": "No",
    "Tiene_presupuesto": "Si",
    "Justificación_sin_presupuesto": "",
    "Valor_presupuesto": "USD 4020",
    "Proveedores_conocidos": "Software Shop",
    "Cuadrante_Proveedor": "",
    "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
    "Nombre_area_y_ceco": "EVC Conocimiento de Cliente C105900005",
    "Nombre_lider_EVC": "Camilo Restrepo Saldarriaga",
    "SR_ARIBA": "SR4162813500",
    "Familias": "Licenciamiento Menor",
    "Categoría": "Apoyo al negocio",
    "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
    "Negociador": "",
    "Rol_asesor": "",
    "Observaciones": "Naty no lo envié a PN ya se había hecho con el SR3898068733",
    "Comentarios BP": "",
    "Fecha MarketPlace": "",
    "Fecha Asignación/Delegación": "",
    "En_fábricas": "False",
    "Fecha_envío_fábricas": "",
    "Fecha ok. PN": "",
    "sin equipo": "",
    "Áreas pendientes": "25/08/2023",
    "Fecha_fin_fábricas": "False",
    "Es_fuera_de_política": "True",
    "Envío aprobación BP": "",
    "Estado": "Servicio de software",
    "Subcategoría_F": "Crítico",
    "Criticidad_F": ""
  },],
  data: [
    {
      "ID_lista": 4346,
      "Title": "Forms",
      "Fecha_solicitud": "25/08/2023",
      "Correo_solicitante": "rgroldan@bancolombia.com.co",
      "Nombre_solicitante": "Ruben Gonzalo Roldan Agudelo",
      "Nombre_iniciativa": "ID 4346 - Renovación contrato CW2268598 Tarifas Suministros Promontajes",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2268598",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere el apoyo en la negociación de la renovación de tarifas en $USD y en $COP para los suministros del proveedor Promontajes, contrat CW2268598\nPrestación de servicios de mantenimiento preventivo, correctivo y suministro de repuestos e insumos a las instalaciones eléctricas y de comunicaciones en el COB (Niquía)",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "No aplica debido a que se ejecuta bajo demanda de acuerdo a cada proyecto TI",
      "Valor_presupuesto": "Depende de Cad",
      "Proveedores_conocidos": "Promontajes S.A.S",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GAA (Gerencia Administración del Activo), CeCo: C104300029",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4164464667",
      "Familias": "HARD (Operadores de Mantenimiento)",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Fábricas de Negociación",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "25/08/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Facility Managment",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4345,
      "Title": "Forms",
      "Fecha_solicitud": "25/08/2023",
      "Correo_solicitante": "jeberare@bancolombia.com.co",
      "Nombre_solicitante": "Jennifer Bergano Arenas",
      "Nombre_iniciativa": "ID 4345 - Proveedor de Eventos de actividades teconologicas y de la información - Nequi sera patrocinador de ese evento",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Este proveedor se encarga de fomentar todo tipo de actividades con tecnologías de la información y la comunicación, ellos harán un evento que se llama  Colombia Fintech,  para el evento se encargan de la producción de un evento  y nosotros como nequi haremos parte con un patrocinio para posicionamiento y presencia de marca",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "32 millones + IVA",
      "Proveedores_conocidos": "ASOCIACION COLOMBIANA DE EMPRESAS DE TECNOLOGIA E INNOVACION FINANCIERA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "C102200008",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4345,
      "Familias": "Patrocinios Mercadeo",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "25/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "25/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4344,
      "Title": "Forms",
      "Fecha_solicitud": "25/08/2023",
      "Correo_solicitante": "RICASALL@bancolombia.com.co",
      "Nombre_solicitante": "Ricardo Casallas Lopez",
      "Nombre_iniciativa": "ID 4344 - Rediseño del Código de ética centrada en el usuario con enfoque en behavioural design",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere consultor o proveedor que haga un rediseño y/o actualización del Código de Ética de la organización, con enfoque en diseño conductual",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "60.000.000",
      "Proveedores_conocidos": "Háptica, Instintivo, BeWay, Heurística, Amurabi, Ethos, Empathy",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "LDC FC ETICA PAF ANTICORRUPCION C102600011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4164164955",
      "Familias": "Consultorias Corporativas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Naty ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "25/08/2023",
      "Fecha ok. PN": "25/08/2023",
      "sin equipo": "",
      "Áreas pendientes": "25/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Consultorias Corporativas",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4343,
      "Title": "Forms",
      "Fecha_solicitud": "25/08/2023",
      "Correo_solicitante": "macorozc@bancolombia.com.co",
      "Nombre_solicitante": "Maria Camila Cardona Orozco",
      "Nombre_iniciativa": "ID 4343 - Creación de contenido",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Alicia es una periodista que está creando contenido para un proyecto de mercadeo",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 15000000,
      "Proveedores_conocidos": "Alicia Peñaralda",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Marca",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4343,
      "Familias": "Contenidos Digitales",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "25/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "25/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4342,
      "Title": "Forms",
      "Fecha_solicitud": "25/08/2023",
      "Correo_solicitante": "macorozc@bancolombia.com.co",
      "Nombre_solicitante": "Maria Camila Cardona Orozco",
      "Nombre_iniciativa": "ID 4342 - Creación Proveedor BizNation",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Vamos a estar en un evento que Biz Nation Organiza y para poder realizar la participación en dicho evento debemos crearlo como proveedor",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 35000000,
      "Proveedores_conocidos": "Biz Nation",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Marca",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4342,
      "Familias": "Patrocinios Mercadeo",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "25/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "25/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4341,
      "Title": "Forms",
      "Fecha_solicitud": "25/08/2023",
      "Correo_solicitante": "ASTRREST@bancolombia.com.co",
      "Nombre_solicitante": "Astrid Restrepo Cardona",
      "Nombre_iniciativa": "ID 4341 - Consumer Clarity",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Desde gestión del Fraude, se desea adquirir una nueva herramienta llamada Consumer Clarity, esta herramienta es de MasterCard. Es una herramienta de consulta multifranquicia que permite consultar el detalle del producto o servicio adquirido en comercios puntuales, con el fin de brindar esta información a nuestros clientes y aclarar transacciones.\nActualmente el acceso a la herramienta es a través de una URL. A futuro se desea consumir vía API. Cuando se haga el consumo vía API, es posible que se diseñe un front ajustado a las áreas de consumo. (es decir, enmascaramiento de información y navegación controlada para las líneas generales de Bancolombia)\nEl gestor transaccional de la línea telefónica consumiría el API de Consumer Clarity. A futuro se desea que Consumer Clarity este en TABOT y en la APP banco.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "10.000 USD al mes ( aplica desde Agosto a Diciembre de 2023)",
      "Proveedores_conocidos": "Mastercard",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC GESTION DEL FRAUDE - C104300550",
      "Nombre_lider_EVC": "Mauricio Cano Restrepo",
      "SR_ARIBA": "SR4164464589",
      "Familias": "Seguridad Canales y Productos",
      "Categoría": "Seguridad",
      "¿Cómo se va a gestionar?": "Ok PN, pero sin equipo",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "25/08/2023",
      "Fecha ok. PN": "25/08/2023",
      "sin equipo": "Ciber, PDP",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Gestión del Fraude",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4340,
      "Title": "Forms",
      "Fecha_solicitud": "25/08/2023",
      "Correo_solicitante": "juanrami@bancolombia.com.co",
      "Nombre_solicitante": "Juan David Ramirez Ruiz",
      "Nombre_iniciativa": "ID 4340 - Se requiere compra de Vajilla para presidencia.",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Se requiere Vincular al proveedor elegido por presindencia para la compra de la Vajilla",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Vajilla para eventos de presidencia.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Business People Unlimited & Cia SCA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C104300023",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4340,
      "Familias": "Equipos de Oficina",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "25/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "25/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Activos Fijos",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4339,
      "Title": "Forms",
      "Fecha_solicitud": "24/08/2023",
      "Correo_solicitante": "jechapar@bancolombia.com.co",
      "Nombre_solicitante": "Jeferson Arley Chaparro Rojas",
      "Nombre_iniciativa": "ID 4339 - Desbloqueo de Proveedor JAIME ALBERTO VELASQUEZ BOTERO",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Desbloquear al proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se realizo un pago al proveedor JAIME ALBERTO VELASQUEZ BOTERO N° 14255 Por servicios de honorarios por asesoría en la Vicepresidencia de Talento y Cultura, no obstante, desde el área contables no informan que para desbloquear al proveedor se debe evaluarlo de nuevo.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "JAIME ALBERTO VELASQUEZ BOTERO",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GCIA DE GESTION TALENTO Y CULTURA - C103200014",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4339,
      "Familias": "Servicios Profesionales Formación y Entrenamiento",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "25/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "25/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4338,
      "Title": "Forms",
      "Fecha_solicitud": "24/08/2023",
      "Correo_solicitante": "marianlo@bancolombia.com.co",
      "Nombre_solicitante": "Mariana Londono Grisales",
      "Nombre_iniciativa": "ID 4338 - Participación en evento ACOPI CAFE EJE CAFETERO",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere pago al proveedor por participacion en evento ACOPI",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "ACOPI REGIONAL CENTRO OCCIDENTE",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C102100313",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4338,
      "Familias": "Patrocinios Mercadeo",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "24/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "24/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4337,
      "Title": "Forms",
      "Fecha_solicitud": "24/08/2023",
      "Correo_solicitante": "nlpena@bancolombia.com.co",
      "Nombre_solicitante": "Nalliver Lorena Pena Quiroga",
      "Nombre_iniciativa": "ID 4337 - Se requiere negociar con Konecta el entrenamiento de perfiles integrales Sufi",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "En el entrenamiento de los nuevos perfiles integrales de SAC y Levantamiento de Prenda, Konecta indica que requiere un tiempo de estabilización de 2 meses posterior a la formación de estos agentes, en donde nos indican que no debemos generar penalizaciones y renegociación de indicadores si estos se ven afectados por la estabilización del conocimiento de los agentes.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 217000000,
      "Proveedores_conocidos": "Multienlace",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Estrategia de Clientes Sufi",
      "Nombre_lider_EVC": "Juliana Velasquez",
      "SR_ARIBA": "",
      "Familias": "",
      "Categoría": "",
      "¿Cómo se va a gestionar?": "Seleccionar una opción",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "",
      "Subcategoría_F": "",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4336,
      "Title": "Forms",
      "Fecha_solicitud": "24/08/2023",
      "Correo_solicitante": "pmajana@bancolombia.com.co",
      "Nombre_solicitante": "Paula Andrea Majana Basilio",
      "Nombre_iniciativa": "ID 4336 - Se requiere añadir a INSTITUTO DE AUDITORES INTERNOS DE COLOMBIA como proveedor de Nequi",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere añadir a INSTITUTO DE AUDITORES INTERNOS DE COLOMBIA como proveedor de Nequi ya que hay una persona interesada en participar del congreso por lo cual se realiza la solicitud para el pago de la inscripción.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 3000000,
      "Proveedores_conocidos": "INSTITUTO DE AUDITORES INTERNOS DE COLOMBIA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "C475000000 Talento Humano",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4336,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "24/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "24/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4335,
      "Title": "Forms",
      "Fecha_solicitud": "24/08/2023",
      "Correo_solicitante": "andcamar@bancolombia.com.co",
      "Nombre_solicitante": "Andrea Paola Camargo Maldonado",
      "Nombre_iniciativa": "ID 4335 - Vincular Proveedor Para actividad en Santa Marta",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular a Proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere vincular proveedor para que preste servicio de alimentos en Santa Marta en su establecimiento de comercio",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "39047362\tALBA JANETH AMOROCHO VESGA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gcia Calidad de Vida c103100710",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4335,
      "Familias": "Convenios y Beneficios",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "24/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "24/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4334,
      "Title": "Forms",
      "Fecha_solicitud": "24/08/2023",
      "Correo_solicitante": "jssosa@bancolombia.com.co",
      "Nombre_solicitante": "John Sebastian Sosa Suarez",
      "Nombre_iniciativa": "ID 4334 - Vinculación de proveedor para Reclutamiento / Búsqueda de Personal",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Reclutamiento / Búsqueda de Personal\nEl proveedor nos apoyara con el proceso completo de reclutamiento: búsqueda, contacto y mapeo de potenciales candidatos, agendamientos, rechazos, asistencia en la negociación de ofertas y demás etapas que se establezcan en la necesidad.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "30 000 000",
      "Proveedores_conocidos": "REMOTI S.A.S",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "ATRACCION DEL TALENTO C103200040",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4164164903",
      "Familias": "Servicios Selección al Personal",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "25/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "25/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Atracción y desarrollo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4333,
      "Title": "Forms",
      "Fecha_solicitud": "24/08/2023",
      "Correo_solicitante": "carescob@bancolombia.com.co",
      "Nombre_solicitante": "Carolina Escobar Pemberthy",
      "Nombre_iniciativa": "ID 4333 - Herramienta para investigaciones cualitativas",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se solicita actualizar la cotización para poder dar inicio a la compra de 5 licencias anuales de MAXQDA. Ya habíamos realizado la evaluación previa del proveedor con Tatiana Tangarife, pero estábamos a la espera de la aprobación de la compra por parte del líder de EVC.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "USD 4020",
      "Proveedores_conocidos": "Software Shop",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Conocimiento de Cliente C105900005",
      "Nombre_lider_EVC": "Camilo Restrepo Saldarriaga",
      "SR_ARIBA": "SR4162813500",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Naty no lo envié a PN ya se había hecho con el SR3898068733",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "25/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4332,
      "Title": "Forms",
      "Fecha_solicitud": "24/08/2023",
      "Correo_solicitante": "ANFRENDO@bancolombia.com.co",
      "Nombre_solicitante": "Andres Felipe Rendon Dederle",
      "Nombre_iniciativa": "ID 4332 - Aumento de licencias de Udemy",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se require aumentar la cantidad de licencias que tenemos actualmente contratadas con Udemy, inicialmente compramos 200 licencias y vamos a comprar 300 más. Udemy es una plataforma educativa que está especializada en temas de tecnología y que aporta mucho valor en el aumento del conocimiento de los Ingenieros y Arquitectos de la VSTI.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "61600 usd",
      "Proveedores_conocidos": "Udemy Bussiness",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Administración integral de equipos de TI - C103500002",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4162813485",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Leidy Tatiana Tangarife Gonzalez",
      "Rol_asesor": "Monica Marcela Alzate Granda",
      "Observaciones": "naty hace poco hicieron la compra inicial no lo envio a PN,  los atendió Taty.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "25/08/2023",
      "Fecha Asignación/Delegación": "25/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "24/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4331,
      "Title": "Forms",
      "Fecha_solicitud": "24/08/2023",
      "Correo_solicitante": "dpancha@bancolombia.com.co",
      "Nombre_solicitante": "Daniela Del Pilar Pancha Camacho",
      "Nombre_iniciativa": "ID 4331 - Asesoría Tu360movilidad",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la implementación de una asesoría integral por medio de llamadas y habilidades de los agentes del proveedor con el fin de dar acompañamiento al proceso de compra de un vehículo (carro, moto o bicicleta) que se encuentran desde tu360movilidad.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "10.178.540 mensual",
      "Proveedores_conocidos": "Multienlaces sas o Konecta colombia",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Ecosistemas - EVC TU360 MOVILIDAD C107500007",
      "Nombre_lider_EVC": "Juan David Restrepo del Toro",
      "SR_ARIBA": "SR4162483869",
      "Familias": "Televenta",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Ok PN, pero sin equipo",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "24/08/2023",
      "Fecha ok. PN": "25/08/2023",
      "sin equipo": "Ciber, PDP",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Modelos de Relacionamiento Integral",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4330,
      "Title": "Forms",
      "Fecha_solicitud": "24/08/2023",
      "Correo_solicitante": "CARARROY@bancolombia.com.co",
      "Nombre_solicitante": "Carolina Maria Arroyave Chica",
      "Nombre_iniciativa": "ID 4330 - Atención Stand by Nivel 1 - EVC Tesoreria",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Actualmente tenemos 2 FTES de Accenture que cubren el servicio de stand by del cierre de Murex desde las 4:30 pm hasta las 8 am del siguiente día hábil y cubren también los fines de semana y festivos como nivel 1 pero están contando como capacidad del equipo.\nSe tiene una problemática para garantizar la cobertura del servicio en los casos en los que los recursos actuales vinculados a estas labores no pueden trabajar efectivamente y en algunos casos no se ha tenido fácil maniobra de parte de Accenture para cubrirlos ante una ausencia inesperada transmitiendo la responsabilidad a Bancolombia.\nSe tiene una propuesta de parte de Accenture de manejar este esquema bajo un servicio donde ellos garantizan que bajo una tarifa fija mensual se contará con un equipo de personas que estarán en capacidad de cubrir las labores que actualmente se hacen y en caso de que se presente una ausencia repentina o planeada de uno de sus miembros Accenture garantizará que podrán cubrirlo de manera inmediata sin impactar el servicio o trasladarle cargas al Banco.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "$146.500.000",
      "Proveedores_conocidos": "Accenture",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Tesorería - C103500025",
      "Nombre_lider_EVC": "Frank Ricardo Muñoz Arbelaez, Lina Marcela Cardenas Paniagua",
      "SR_ARIBA": "SR4162483855",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Fábricas de Negociación",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "24/08/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4329,
      "Title": "Forms",
      "Fecha_solicitud": "24/08/2023",
      "Correo_solicitante": "CLOLAYA@bancolombia.com.co",
      "Nombre_solicitante": "Claudia Maria Olaya Giraldo",
      "Nombre_iniciativa": "ID 4329 - Definición contable OCC CONSULTING S.A.S.",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Solicitar material para el ingreo de la factura en SAP.",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se realizó la contratación del proveedor para acompañamiento y taller en proceso de conexión nace de confianza de la VP Financiera.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "OCC CONSULTING S.A.S.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "VP Financiera -C102500000",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4329,
      "Familias": "Servicios Profesionales Formación y Entrenamiento",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "24/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "24/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4328,
      "Title": "Forms",
      "Fecha_solicitud": "23/08/2023",
      "Correo_solicitante": "aljarami@bancolombia.com.co",
      "Nombre_solicitante": "Juan Alberto Jaramillo Raigosa",
      "Nombre_iniciativa": "ID 4328 - Neoris gobierno y evolucion CloudNative para Nequi",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Aseguramiento y gobierno de componentes cloud reusables y de calidad​.\nAceleración en implementación de componentes de cloud con entregables.\nRequerimiento para Nequi",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "39.500.000",
      "Proveedores_conocidos": "Neoris",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "GCIA INFRA CIBER Y OPERACION TI\tC471000022",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4161677238",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Jose ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "24/08/2023",
      "Fecha ok. PN": "25/08/2023",
      "sin equipo": "",
      "Áreas pendientes": "25/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4327,
      "Title": "Forms",
      "Fecha_solicitud": "23/08/2023",
      "Correo_solicitante": "msuarez@bancolombia.com.co",
      "Nombre_solicitante": "Maryory Suarez Garcia",
      "Nombre_iniciativa": "ID 4327 - Renovación contrato CW2293901 - Modelo BPO en campo Vivienda",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2293901",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere renovar el contrato CW2293901 piloto que se tiene con Konecta del modelo BPO en campo para realizar la extensión bajo nuevas condiciones.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "72.280.000",
      "Proveedores_conocidos": "Konecta",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC DISTRIBUCION A DISTANCIA",
      "Nombre_lider_EVC": "Cristina Duque Jaramillo",
      "SR_ARIBA": "SR4161677224",
      "Familias": "Venta en Campo",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Fábricas de Negociación",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "24/08/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Modelos de Relacionamiento Integral",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4326,
      "Title": "Forms",
      "Fecha_solicitud": "23/08/2023",
      "Correo_solicitante": "",
      "Nombre_solicitante": "Willinton De jesus Cadavid Rodriguez",
      "Nombre_iniciativa": "ID 4326 - Cambio Modelo Contrato por Mandato Cliente TUYA en el COB",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "N/A",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere apoyo del área para la negociación del nuevo modelo de contrato por Mandato que actualmente se tiene con el cliente TUYA para los servicios alojados en el COB. (concesión de espacios para servidores de tecnología, alojados en el COB y de uso para TUYA.",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Es servicio que se brinda desde el COB al cliente TUYA",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "TUYA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GAA (Gerencia Administración del Activo), CeCo: C104300029",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4164164918",
      "Familias": "Arrendamiento Bienes Inmuebles",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Fábricas de Negociación",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "25/08/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Gestión Inmobiliaria",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4325,
      "Title": "Forms",
      "Fecha_solicitud": "23/08/2023",
      "Correo_solicitante": "andcamar@bancolombia.com.co",
      "Nombre_solicitante": "Andrea Paola Camargo Maldonado",
      "Nombre_iniciativa": "ID 4325 - Vinculación de Proveedor",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular a Proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere vincular proveedor para prestar servicio de alimentos en establecimiento de comercio Cangre pizza pastas y vino  unbicado en Riohacha",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "1006578600\tCamila Andrea Oñate  Vangriekin",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Bienestar c 103200170",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4325,
      "Familias": "Convenios y Beneficios",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "23/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "23/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4324,
      "Title": "Forms",
      "Fecha_solicitud": "23/08/2023",
      "Correo_solicitante": "andcamar@bancolombia.com.co",
      "Nombre_solicitante": "Andrea Paola Camargo Maldonado",
      "Nombre_iniciativa": "ID 4324 - Proveedora de Alimentos en Santa Marta",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular Proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere vincular proveedor para prestar servicio de alimentacion en santa marta",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "cc 36721318\tPatricia de la Milagrosa Vives Noriega",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Bienestar c 103200170",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4324,
      "Familias": "Convenios y Beneficios",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "23/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "23/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4323,
      "Title": "Forms",
      "Fecha_solicitud": "23/08/2023",
      "Correo_solicitante": "mozapata@bancolombia.com.co",
      "Nombre_solicitante": "Monica Maria Zapata Calle",
      "Nombre_iniciativa": "ID 4323 - Renovación de tarifas Chequeras, CONTRATO CW2305158",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW66",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Actualización de tarifas. Contrato CW2305158  Producción de cheques forma continua, cheques de gerencia y chequeras, esto de acuerdo a las especificaciones técnicas enviadas desde Banco",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "1.858.000.000",
      "Proveedores_conocidos": "CADENA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Sección Servicios Cheques - C105500105",
      "Nombre_lider_EVC": "Marta Lucia Salgado Olascuaga",
      "SR_ARIBA": "SR4160906411",
      "Familias": "Cheques",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Enviar al category",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Biatri ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "24/08/2023",
      "Fecha ok. PN": "25/08/2023",
      "sin equipo": "",
      "Áreas pendientes": "25/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Insumos para el Negocio",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4322,
      "Title": "Forms",
      "Fecha_solicitud": "23/08/2023",
      "Correo_solicitante": "jeberare@bancolombia.com.co",
      "Nombre_solicitante": "Jennifer Bergano Arenas",
      "Nombre_iniciativa": "ID 4322 - Produccion de material pop",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Producción de material pop para marcación en calle de habladores, escarapelas, stickers etc",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 200000000,
      "Proveedores_conocidos": "GAMA DIGITAL S.A.S",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "C102200008",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4322,
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "23/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "23/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4321,
      "Title": "Forms",
      "Fecha_solicitud": "23/08/2023",
      "Correo_solicitante": "anrendon@bancolombia.com.co",
      "Nombre_solicitante": "Ana Maria Rendon Lopez",
      "Nombre_iniciativa": "ID 4321 - pago de inscripcion evento money 20/20",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se necesita realizar el pago de la inscripción de dos directivos de nequi para su asistencia al evento en las vegas de Money20/20",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 30000000,
      "Proveedores_conocidos": "money 20/20",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "Talento Humano C475000000",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4321,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "23/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "23/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4320,
      "Title": "Forms",
      "Fecha_solicitud": "23/08/2023",
      "Correo_solicitante": "camescob@bancolombia.com.co",
      "Nombre_solicitante": "Camilo Escobar Mesa",
      "Nombre_iniciativa": "ID 4320 - Estudio urbanístico bodega/lote Calle 26 Bogotá para adquisición Renta y Uso",
      "Tipo_Requerimiento": "Es un requerimiento del equipo de Renta y Uso de Leasing",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "En aplicativos de Leasing como Mercurio y/o Delfin",
      "Detalle_producto_o_servicio": "Estudio urbanístico y normativo previo a la adquisición de una bodega/lote ubicada en la Calle 26 Bogotá para adquisición Renta y Uso",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 10000000,
      "Proveedores_conocidos": "PLAN LEGAL S.A.S.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Soluciones Leasing Renta y Uso",
      "Nombre_lider_EVC": "Juan Pablo Acosta Velez",
      "SR_ARIBA": 4320,
      "Familias": "Servicios de Investigación de Bienes",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "23/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "23/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios de Conciliación y Cobranza",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4319,
      "Title": "Forms",
      "Fecha_solicitud": "23/08/2023",
      "Correo_solicitante": "catcano@bancolombia.com.co",
      "Nombre_solicitante": "Catalina Cano Zapata",
      "Nombre_iniciativa": "ID 4319 - Desbloqueo Proveedor 200000293 - THE EQUATOR PRINCIPLES ASSOCIATION",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Desbloquear al proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Estandar para la evaluación de riesgos ambientales y sociales en la financiación",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "proveedor 200000293 - THE EQUATOR PRINCIPLES ASSOCIATION",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Sostenibilidad y Bienestar -  C102200062",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4319,
      "Familias": "Consultorias Corporativas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "23/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "23/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Consultorias Corporativas",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4318,
      "Title": "Forms",
      "Fecha_solicitud": "23/08/2023",
      "Correo_solicitante": "catcano@bancolombia.com.co",
      "Nombre_solicitante": "Catalina Cano Zapata",
      "Nombre_iniciativa": "ID 4318 - Definición contable y creación proveedor PCAF",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Requiero vincular a un proveedor para realizar apgo de factura",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "PCAF (Partnership for Carbon Accounting Financials) es el estandar para medir misiones financiadas, uno de los procesos que se requieren para dar cumplimiento al tema regulatorio %231 del banco que son los temas ASG (Ambientales, Sociales y de Gobierno Corporativo)",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "PCAF (Partnership for Carbon Accounting Financials",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Sostenibilidad y Bienestar C102200062",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4318,
      "Familias": "Consultorias Corporativas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "23/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "23/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Consultorias Corporativas",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4317,
      "Title": "Forms",
      "Fecha_solicitud": "23/08/2023",
      "Correo_solicitante": "secastri@bancolombia.com.co",
      "Nombre_solicitante": "Sergio Andres Castrillon Navales",
      "Nombre_iniciativa": "ID 4317 - Renovar Contrato SMARTLAW TECH CW2284834",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2284834",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Requiero la renovación del contrato CW2284834 con el proveedor SMARTLAW TECH, el cual solo debe contener lo relacionado con la compra de certificados digitales",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Porque este dinero lo pagan directamente los usuarios",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "SMARTLAW",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "C103500166",
      "Nombre_lider_EVC": "Fernando Enrique Velasco",
      "SR_ARIBA": "SR4160906396",
      "Familias": "Servicios SaaS",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Ok PN, pero sin equipo",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "23/08/2023",
      "Fecha ok. PN": "25/08/2023",
      "sin equipo": "Ciber",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicio de plataformas",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4316,
      "Title": "Forms",
      "Fecha_solicitud": "22/08/2023",
      "Correo_solicitante": "andcamar@bancolombia.com.co",
      "Nombre_solicitante": "Andrea Paola Camargo Maldonado",
      "Nombre_iniciativa": "ID 4316 - Vincular Proveedor para actividad de bienestar en  Santa Marta",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular a Proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere vincular al proveedor para actividades en Bolera de la ciudad de Santa Marta",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "ALBA JANETH AMOROCHO VESGA cc 39047362-6",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia Calidad de Vida c103200170",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4316,
      "Familias": "Convenios y Beneficios",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "23/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "23/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4315,
      "Title": "Forms",
      "Fecha_solicitud": "22/08/2023",
      "Correo_solicitante": "JUARINCO@bancolombia.com.co",
      "Nombre_solicitante": "Juan Pablo Rincon Suarez",
      "Nombre_iniciativa": "ID 4315 - Renovación contrato servicios CW2268421",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2268421",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere renovar el contrato CW2268421 de horas de servicio para el soporte y mantenimiento del software licenciado (SAAS)",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "40000 USD",
      "Proveedores_conocidos": "CX SOFTWARE SOLUTIONS SA DE CV",
      "Cuadrante_Proveedor": 1,
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Gcia Inteliencia Experiencia del Cliente - C107200203",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4162483796",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Ok PN, pero sin equipo",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "24/08/2023",
      "Fecha ok. PN": "25/08/2023",
      "sin equipo": "Ciber, PDP",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4314,
      "Title": "Forms",
      "Fecha_solicitud": "22/08/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 4314 - Compra de curso de extensión PROGRAMA PRODUCT MANAGEMENT\tCOLECTIVO 23",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión PROGRAMA PRODUCT MANAGEMENT\tCOLECTIVO 23",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "COLECTIVO 23",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4314,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "22/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "22/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4313,
      "Title": "Forms",
      "Fecha_solicitud": "22/08/2023",
      "Correo_solicitante": "ANFELOPE@bancolombia.com.co",
      "Nombre_solicitante": "Andres Felipe Lopez Estrada",
      "Nombre_iniciativa": "ID 4313 - Renovación CW2222173 de servicio de conectividad Orange Bancolombia - Swift",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2222173",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación CW2222173 del paquete de conectividad entre Bancolombia y Swift con Orange",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "7millones mes y/o 1720UDS mes",
      "Proveedores_conocidos": "ORANGE BUSINESS SERVICES COLOMBIA S.A.S",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "LDC FC ING CONECTIVIDAD CORE TI, C1035000100",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4159126243",
      "Familias": "Telecomunicaciones",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Luis Guillermo Salcedo Valderrama",
      "Rol_asesor": "No aplica",
      "Observaciones": "Jose ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "25/08/2023",
      "Fecha Asignación/Delegación": "25/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "22/08/2023",
      "Fecha ok. PN": "23/08/2023",
      "sin equipo": "",
      "Áreas pendientes": "23/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio telecomunicación",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4312,
      "Title": "Forms",
      "Fecha_solicitud": "22/08/2023",
      "Correo_solicitante": "narrubla@bancolombia.com.co",
      "Nombre_solicitante": "Natalia Arrubla Gomez",
      "Nombre_iniciativa": "ID 4312 - RFP para servicio de Revisoría Fiscal",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere lanzar un RFP para los servicios de revisoría fiscal del Grupo Bancolombia para el periodo 2024-2025, esto incluye a todas las entidades del Grupo.",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "El valor de los honorarios debe ser aprobado por la Asamblea General de Accionistas a celebrarse en marzo 2024.",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Los terceros que podrían llegar a participar son: PWC (proveedor actual), Deloitte, KPMG",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Dirección Corporativa de Contailidad y Tributaria",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4159126229",
      "Familias": "Revisoría Fiscal",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Ok PN, pero sin equipo",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "22/08/2023",
      "Fecha ok. PN": "25/08/2023",
      "sin equipo": "Ciber, PDP",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios Profesionales Procesos del Negocio",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4311,
      "Title": "Forms",
      "Fecha_solicitud": "22/08/2023",
      "Correo_solicitante": "anfemont@bancolombia.com.co",
      "Nombre_solicitante": "Andres Felipe Montoya Torres",
      "Nombre_iniciativa": "ID 4311 - Legalización de un Servicio",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Pagar una Factura de un servicio que ya se prestó",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Hace algunos meses, realizamos un piloto entre el equipo de Medios de Pago y Ecosistemas. Para poder llevar a cabo este piloto, fue necesario que un tercero realizara un desarrollo, el cual, no estábamos en la capacidad de hacer. Se solicita apoyo para ralizar el pago del servicio al tercero que \"no se encuentra vinculado como proveedor del banco\" \nEl desarrollo fue para posibilitar el pago a cuotas con una tarjeta débito a través de tu360, para procesar las transacciones mensuales del pago.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "JPG S.A.S",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Medios de Pago",
      "Nombre_lider_EVC": "Luisa Monsalve",
      "SR_ARIBA": 4311,
      "Familias": "Pasarelas de Pago",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "23/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "23/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Medios de Pago",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4310,
      "Title": "Forms",
      "Fecha_solicitud": "22/08/2023",
      "Correo_solicitante": "RUCARDEN@bancolombia.com.co",
      "Nombre_solicitante": "Ruben Dario Cardenas Henao",
      "Nombre_iniciativa": "ID 4310 - Renovación Homini CW2298372",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2298372",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación CW2298372 servicio BioVoz periodo 2023 -2024 con el provedor Homini",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "$28.000.000",
      "Proveedores_conocidos": "Homini",
      "Cuadrante_Proveedor": 1,
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Capacidades Ciberseguridad CC: C103500075",
      "Nombre_lider_EVC": "Ruben Dario Cardenas Henao",
      "SR_ARIBA": "SR4159126188",
      "Familias": "Servicios de  Plataformas",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Fábricas de Negociación",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "22/08/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicio de plataformas",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4309,
      "Title": "Forms",
      "Fecha_solicitud": "22/08/2023",
      "Correo_solicitante": "JAANROJA@bancolombia.com.co",
      "Nombre_solicitante": "Jaider Andres Rojas Vanegas",
      "Nombre_iniciativa": "ID 4309 - Modelo Servicio o FTE Devops con proveedor",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la participación de abastecimiento en la negociación con un proveedor para centralizar el servicio de DEVOPS.   Actualmente este proveedor es SETI, de acuerdo a varios análisis que se hicieron dentro del equipo de Arquitectura e innovacion.\nLa idea es simplificar los prestadores de servicio actuales y dar paso al nuevo modelo con este presupuesto.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "La idea es simplificar los prestadores de servicio actuales y dar paso al nuevo modelo con este presupuesto.",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "SETI",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "C102200031",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4159126211",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Angie Lorena Castrillon Palacio",
      "Rol_asesor": "Adriana Maria Arango Restrepo",
      "Observaciones": "Jose ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "25/08/2023",
      "Fecha Asignación/Delegación": "25/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "22/08/2023",
      "Fecha ok. PN": "22/08/2023",
      "sin equipo": "Ciber",
      "Áreas pendientes": "24/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4308,
      "Title": "Forms",
      "Fecha_solicitud": "22/08/2023",
      "Correo_solicitante": "almurill@bancolombia.com.co",
      "Nombre_solicitante": "Alejandro Murillo Puerta",
      "Nombre_iniciativa": "ID 4308 - Renovación Contrato MASIVIAN SAS - CW2235173",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2235173",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere renovación del contrato para Masivian. CW2235173\nServicio envío de Email y SMS Batch y transaccionales",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "16.490.000.000",
      "Proveedores_conocidos": "MASIVIAN SAS",
      "Cuadrante_Proveedor": 3,
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C103700710",
      "Nombre_lider_EVC": "Sara Lucia Parra Galvis",
      "SR_ARIBA": "SR4158878969",
      "Familias": "SMS y Otras Notificaciones",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Isabella Correa Valencia",
      "Rol_asesor": "No aplica",
      "Observaciones": "Dianis es renovación, proveedor riesgo 3 no va a PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "25/08/2023",
      "Fecha Asignación/Delegación": "25/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "22/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Contactabilidad con Clientes",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4307,
      "Title": "Forms",
      "Fecha_solicitud": "22/08/2023",
      "Correo_solicitante": "DAVVASQU@bancolombia.com.co",
      "Nombre_solicitante": "David Vasquez Gutierrez",
      "Nombre_iniciativa": "ID 4307 - Piloto Mapas de Mercadeo Equipo Comercial Colectivos",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la entrega de una metodología al equipo comercial de colectivos llamada Mapas de Mercadeo, a través de la cual buscamos que este equipo comercial aumente el nivel de profundización de empleados de sus empresas asignadas.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "17.136.000",
      "Proveedores_conocidos": "Real Mercadeo",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Personas e Independientes - Presupuesto de franquicias centralizado de luz Maria",
      "Nombre_lider_EVC": "Luisa Fernanda Estrada Castro",
      "SR_ARIBA": "SR4158878933",
      "Familias": "Servicios profesionales de Mercadeo",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Validando con naty si lo delegamos..",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "23/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "23/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4306,
      "Title": "Forms",
      "Fecha_solicitud": "18/08/2023",
      "Correo_solicitante": "edangel@bancolombia.com.co",
      "Nombre_solicitante": "Eduardo Angel Gutierrez",
      "Nombre_iniciativa": "ID 4306 - Desatrase clientes B2B Nequi firma electronica",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la contratación de un proveedor con el que podamos desatrasar la firma electrónica de todos los contratos con clientes B2B de Nequi. Este desatrase es prioritario para poder tener la cesión de contratos hacia Nequi S.A, por lo tanto esto debe quedar listo antes del primer Q del 2024. En ese sentido, estamos buscando un proveedor que tenga una solución que no requiera desarrollo, la idea es que podamos entrar al portal que nos habilité el proveedor, subir de manera masiva los datos de los firmantes y documentos a firmar y tener la posibilidad de enviar la solicitud de firma por distintos medios (SMS, whatsapp, correo). Para que el documento quede firmado con validez jurídica debemos realizar la validación biométrica facial vs el documento. Hemos explorado a Certicamara y Truora y ya tenemos un análisis de requisitos funcionales y propuesta económica de estos terceros.",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Necesitamos definir con cual proveedor nos iremos para solicitar el presupuesto. Es un requerimiento legal, ya lo conversamos con el equipo VITA y financiero.",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Truora",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "Gerencia de desarrollo de producto - 102200019",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4158878919",
      "Familias": "Licenciamiento Mayor",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Fábricas de Negociación",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "22/08/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4305,
      "Title": "Forms",
      "Fecha_solicitud": "18/08/2023",
      "Correo_solicitante": "mmmartin@bancolombia.com.co",
      "Nombre_solicitante": "Monica Maria Martinez Medina",
      "Nombre_iniciativa": "ID 4305 - Vinculación proveedor para suministro de material promocional (bonos)",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor comercializa bonos virtuales de diferentes establecimientos",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Aún no es requerido, en su monneto lo asumirá cada área que requiera bonos para regalos.",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "JUAN CAMILO VALENCIA RIVERA (APPRECIO)",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C104300243 Servicios Abasteciminto Apoyo al Negocio.",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4305,
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "18/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "18/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4304,
      "Title": "Forms",
      "Fecha_solicitud": "18/08/2023",
      "Correo_solicitante": "PAUARIAS@bancolombia.com.co",
      "Nombre_solicitante": "Paulo Andres Arias Esguerra",
      "Nombre_iniciativa": "ID 4304 - Renovación de contrato CW2300466. Herramienta de Pricing",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2300466",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere realizar la renovación de contrato del contrato que tenemos actualmente con el proveedor Prexus CW2300466\nEs de una herramienta para la definición de los precios de Bancolombia (PGP). La herramienta debe estar en la capacidad de recibir la información necesaria para definir o asignar precios a nuestros productos, basados en una serie de variables y metodologías probadas para identificar el precio óptimo asignar a los productos de Bancolombia.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "1.900.000.000",
      "Proveedores_conocidos": "Prexus",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Pricing  -  C103500245",
      "Nombre_lider_EVC": "Paulo Andrés Arias Esguerra",
      "SR_ARIBA": "SR4153765692",
      "Familias": "Servicios SaaS",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Enviar al category",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Dianis ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "18/08/2023",
      "Fecha ok. PN": "18/08/2023",
      "sin equipo": "Ciber, PDP",
      "Áreas pendientes": "25/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de plataformas",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4303,
      "Title": "Forms",
      "Fecha_solicitud": "18/08/2023",
      "Correo_solicitante": "PAUARIAS@bancolombia.com.co",
      "Nombre_solicitante": "Paulo Andres Arias Esguerra",
      "Nombre_iniciativa": "ID 4303 - Persona para consultoria de definicion de operación de Pricing",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere de una persona del proveedor Prexus para que acompañe al equipo de la EVC de Pricing a realizar las definiciones para poder desarrollar la funcionalidad de operación en la EVC de Pricing.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "1.000.000.000",
      "Proveedores_conocidos": "Prexus",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Pricing - C107200104",
      "Nombre_lider_EVC": "Paulo Andrés Arias Esguerra",
      "SR_ARIBA": "SR4153765707",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Sara Quintero Perez",
      "Rol_asesor": "Adriana Maria Arango Restrepo",
      "Observaciones": "Dianis ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "25/08/2023",
      "Fecha Asignación/Delegación": "25/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "18/08/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "22/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4302,
      "Title": "Forms",
      "Fecha_solicitud": "18/08/2023",
      "Correo_solicitante": "yuvergar@bancolombia.com.co",
      "Nombre_solicitante": "Yuliana Marcela Vergara Marin",
      "Nombre_iniciativa": "ID 4302 - Alcance contrato facturación electrónica de valores",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Actualmente con el proveedor Carvajal se tiene contratado para todo el grupo el servicio de facturación electrónica , propiamente para Valores Bancolombia como emisores requerimos ampliar el servicio de CUSTODIA de facturas en el CEN financiero otros 5 años más, debido a un cambio en la normatividad vigente que nos exige custodiar este tipo de documentos 10 años (actualmente solo contamos con el servicio de custodia a 5 años ). ellos finalizando 5 años, nos entregan las facturas generadas o las eliminan, lo que nosotros necesitamos es que nos custodien las facturas 10 años, que no las eliminen o nos las entregue; es decir, lo que necesitamos garantizar a hoy es que una factura que se emitiÓ el año 2019 (año que iniciamos con Carvajal) se custodie hasta el 2029",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "600.000 mensual que será asumido por el area dueña de proceso a partir de nov del 2024.",
      "Proveedores_conocidos": "Carvajal",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Inversiones",
      "Nombre_lider_EVC": "Rafael Alberto Luna Uribe",
      "SR_ARIBA": "SR4153765723",
      "Familias": "Procesamiento de Información",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Ok PN, pero sin equipo",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "18/08/2023",
      "Fecha ok. PN": "18/08/2023",
      "sin equipo": "Ciber",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Back Office",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4301,
      "Title": "Forms",
      "Fecha_solicitud": "18/08/2023",
      "Correo_solicitante": "RAVALENC@bancolombia.com.co",
      "Nombre_solicitante": "Rafael Alberto Valencia Alvarez",
      "Nombre_iniciativa": "ID 4301 - Taller identidad de equipo EVC Ventas Digitales",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Obtener el material contable y las instrucciones para generar el pedido y MIGO en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la contratación del proveedor Become para realizar un workshop de alineación y cierre de brechas de comunicación con el equipo de Dueños de Producto del EVC Ventas S Digitales.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "BECOME",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Gerencia de Cultura y Gestión del Cambio",
      "Nombre_lider_EVC": "Maria Fernanda Scarpetta",
      "SR_ARIBA": 4301,
      "Familias": "Servicios Profesionales Formación y Entrenamiento",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "18/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "18/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4300,
      "Title": "Forms",
      "Fecha_solicitud": "18/08/2023",
      "Correo_solicitante": "jssosa@bancolombia.com.co",
      "Nombre_solicitante": "John Sebastian Sosa Suarez",
      "Nombre_iniciativa": "ID 4300 - Vinculación como proveedor a o María Claudia Londoño Brigard",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "María Claudia Londoño Brigard apoyara a talentos clave de Bancolombia en el desarrollo de su potencial por medio de sesiones de coaching.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "$ 50´000.000",
      "Proveedores_conocidos": "María Claudia Londoño Brigard",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C103200040",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4300,
      "Familias": "Servicios Profesionales Formación y Entrenamiento",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "18/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "18/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4299,
      "Title": "Forms",
      "Fecha_solicitud": "18/08/2023",
      "Correo_solicitante": "JULIAROD@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Rodriguez Jaramillo",
      "Nombre_iniciativa": "ID 4299 - Otrosi orden de servicio CW2288632  por cambio de perfil",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2288632",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere cambiar un perfil del montajista por un perfil de copy redactor",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "6.000.000 mensuales adicionales",
      "Proveedores_conocidos": "Triario",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "C106500025  EVC VENTAS DIGITALES Y TECNOLOGIA MDEO",
      "Nombre_lider_EVC": "Maria Fernanda Scarpetta",
      "SR_ARIBA": "SR4160468981",
      "Familias": "Servicios profesionales de Mercadeo",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Carlos Andres Ramos Ospina",
      "Rol_asesor": "No aplica",
      "Observaciones": "Naty por la naturaleza de la solicitud que es un otro si para cambiar el tipo de perfil, no lo envié a PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "25/08/2023",
      "Fecha Asignación/Delegación": "25/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "23/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4298,
      "Title": "Forms",
      "Fecha_solicitud": "18/08/2023",
      "Correo_solicitante": "ehidalgo@bancolombia.com.co",
      "Nombre_solicitante": "Erwin Hidalgo Cardenas",
      "Nombre_iniciativa": "ID 4298 - Licencia para uso herramienta de replica QLIK en iseries Nacional",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere contratar con Qlik una licencia para la maquina iseries nacional, actualmente tenemos una licencia vigente para la máquina iseries Leasing, por lo que el proveedor conoce las necesidades. Requerimos que dicha licencia sea en modo replica bidireccional, es decir onpremise - nube y nube - onpremise, en tecnología DB2 y PostgreSQL",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "75000 USD",
      "Proveedores_conocidos": "Qlik tecnology",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "NEON EVC00036 - c103500000",
      "Nombre_lider_EVC": "Maria Elsy Giraldo Rendon",
      "SR_ARIBA": "SR4153124132",
      "Familias": "Licenciamiento Mayor",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Jose ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "18/08/2023",
      "Fecha ok. PN": "18/08/2023",
      "sin equipo": "Ciber",
      "Áreas pendientes": "25/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4297,
      "Title": "Forms",
      "Fecha_solicitud": "17/08/2023",
      "Correo_solicitante": "jrrengif@bancolombia.com.co",
      "Nombre_solicitante": "Jose Manuel Rodriguez Rengifo",
      "Nombre_iniciativa": "ID 4297 - Sublime Local Sas",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Productos artesanales de salud, cocina y cuidado. para realizar actividades para empleados.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 2000000,
      "Proveedores_conocidos": "Sublime Local Sas",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gcia Calidad de Vida : C103200030",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4297,
      "Familias": "Convenios y Beneficios",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "18/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "18/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4296,
      "Title": "Forms",
      "Fecha_solicitud": "17/08/2023",
      "Correo_solicitante": "jrrengif@bancolombia.com.co",
      "Nombre_solicitante": "Jose Manuel Rodriguez Rengifo",
      "Nombre_iniciativa": "ID 4296 - Ekilibrio Bienestar personal y empresarial",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Productos, charlas y programas de bienestar personal y empresarial.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 2000000,
      "Proveedores_conocidos": "Sandra Paola Torres Abadía",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C103200030",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4296,
      "Familias": "Convenios y Beneficios",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "17/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "17/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4295,
      "Title": "Forms",
      "Fecha_solicitud": "17/08/2023",
      "Correo_solicitante": "NANURIBE@bancolombia.com.co",
      "Nombre_solicitante": "Nancy Milena Uribe Cardona",
      "Nombre_iniciativa": "ID 4295 - Alquiler de espacios para taller Hechos de Corazón en Popayán",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Alquiler de espacios para taller Hechos de Corazón en Popayán",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 0,
      "Proveedores_conocidos": "Comfacauca (Caja de Compensación Familiar del Cauca)",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Gerencia de Aprendizaje-C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4295,
      "Familias": "Otros Servicios Bienes Inmuebles - Muebles",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "17/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "17/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Gestión Inmobiliaria",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4294,
      "Title": "Forms",
      "Fecha_solicitud": "17/08/2023",
      "Correo_solicitante": "ntilano@bancolombia.com.co",
      "Nombre_solicitante": "Nahomy Daniela Tilano Diaz",
      "Nombre_iniciativa": "ID 4294 - Patrocinio al municipio de Puerto Colombia",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular a un proveedor y hacer el pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor suministra servicios de diseño y confección de uniformes deportivos, escolares, empresariales, entre otros.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "NESTOR GALVIS HERNANDEZ",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "gobierno de red C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4294,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "17/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "17/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4293,
      "Title": "Forms",
      "Fecha_solicitud": "17/08/2023",
      "Correo_solicitante": "andcamar@bancolombia.com.co",
      "Nombre_solicitante": "Andrea Paola Camargo Maldonado",
      "Nombre_iniciativa": "ID 4293 - Vincular proveedor Santa Marta",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular Proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se solicita crear proveedor para actividades de bienestar en santa marta (bolera)",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "DESARROLLADORA INVICO S.A.S.\t900408961",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "c103200170",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4293,
      "Familias": "Convenios y Beneficios",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "17/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "17/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4292,
      "Title": "Forms",
      "Fecha_solicitud": "17/08/2023",
      "Correo_solicitante": "crhramir@bancolombia.com.co",
      "Nombre_solicitante": "Crhistian David Ramirez Vasquez",
      "Nombre_iniciativa": "ID 4292 - Apoyo plan de acción auditoría para outsourcings Agro",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Los aliados apoyan con el proceso de cartera fomento Finagro, desde el estudio de viabilidad técnica a los proyectos agropecuarios que se van a financiar con los recursos de la entidad o en condiciones definidas por esta. Adicional a otros servicios de control de inversión, requerimiento por Finagro, donde se hace seguimiento a los proyectos financiados y se verifica la destinación de los recursos, entre otros.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Son aliados que se tienen actualmente, no requerimos el presupuesto para la negociación nueva",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "SFA CEBAR, GRUPO MEGAG, CAMPO ESTRATEGICO",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Pyme y Empresas C105900008",
      "Nombre_lider_EVC": "PAULA ANDREA VELEZ",
      "SR_ARIBA": "SR4151749957",
      "Familias": "Consultas Especializadas",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Enviar al category",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Biatri ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "17/08/2023",
      "Fecha ok. PN": "18/08/2023",
      "sin equipo": "Ciber, PDP",
      "Áreas pendientes": "25/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios de Información",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4291,
      "Title": "Forms",
      "Fecha_solicitud": "17/08/2023",
      "Correo_solicitante": "andcamar@bancolombia.com.co",
      "Nombre_solicitante": "Andrea Paola Camargo Maldonado",
      "Nombre_iniciativa": "ID 4291 - Vinculación proveedor actividad en Santa Marta",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular a Proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere vincular proveedor para realizar actividades de Bienestar en Santa marta",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "3904736\tALBA JANETH AMOROCHO VESGA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "c103200170",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4291,
      "Familias": "Convenios y Beneficios",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "17/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "17/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4290,
      "Title": "Forms",
      "Fecha_solicitud": "17/08/2023",
      "Correo_solicitante": "stovar@bancolombia.com.co",
      "Nombre_solicitante": "Silvana Tovar Escobar",
      "Nombre_iniciativa": "ID 4290 - Datasite proyecto Qatar",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Solicitar material",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Servicios de Data room. Es un servicio de almacenamiento de información en la nube. El servicio ya lo prestaron",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Datasite",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "VP de negocios, centro de costos: C102000050",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4290,
      "Familias": "Servicios SaaS",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "17/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "17/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicio de plataformas",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4289,
      "Title": "Forms",
      "Fecha_solicitud": "17/08/2023",
      "Correo_solicitante": "pmajana@bancolombia.com.co",
      "Nombre_solicitante": "Paula Andrea Majana Basilio",
      "Nombre_iniciativa": "ID 4289 - añadir a Instituto de Auditores Internos Colombia como proveedor de Nequi",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere añadir a Instituto de Auditores Internos Colombia como proveedor de Nequi\nhay una persona interesada en participar del congreso, entonces se hace la solicitud para luego realizar el pago de la inscripción",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 3000000,
      "Proveedores_conocidos": "Instituto de Auditores Internos Colombia",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "C475000000 Talento Humano",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4289,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "17/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "17/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4288,
      "Title": "Forms",
      "Fecha_solicitud": "17/08/2023",
      "Correo_solicitante": "JACGOMEZ@bancolombia.com.co",
      "Nombre_solicitante": "Jackelyne Gomez Restrepo",
      "Nombre_iniciativa": "ID 4288 - Workshop Contabilidad de Coberturas Barranquilla y Bucaramanga",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Solicitar pago a proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Serán 4 taller que dictará Maso Consultores, dirigidos a clientes de la VP tesorería. Serán dos eventos por ciudad, programados para 23 de septiembre y 27 de septiembre.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Maso Consultores Asociados y CIA SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Dirección Mesas de Negociación C107000054",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4288,
      "Familias": "Servicios profesionales de Mercadeo",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "17/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "17/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4287,
      "Title": "Forms",
      "Fecha_solicitud": "16/08/2023",
      "Correo_solicitante": "MARTJARA@bancolombia.com.co",
      "Nombre_solicitante": "Martha Gladys Jaramillo Rincon",
      "Nombre_iniciativa": "ID 4287 - Renovacion contrato Tarjeta Diligo Advanced CW2286390",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2286390",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la renovación del servicio de Tarjetas Diligo Advanced, CW2286390 las cuales son usadas por el personal de seguridad física para cubrir gastos autorizados previamente para los vehículos de seguridad Banco.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 180000000,
      "Proveedores_conocidos": "SODEXO SERVICIOS DE BENEFICIOS E INCENTIVOS COLOMBIA S.A.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C104300023",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4151749926",
      "Familias": "Transporte de Empleados",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Katherine Sanchez Henao",
      "Rol_asesor": "No aplica",
      "Observaciones": "Naty es renovación, proveedor riesgo 4, no va a PN .  la renovación de tarjetas canasta la gestionó Kathe.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "25/08/2023",
      "Fecha Asignación/Delegación": "25/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "17/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios de viajes",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4286,
      "Title": "Forms",
      "Fecha_solicitud": "16/08/2023",
      "Correo_solicitante": "fevelasc@bancolombia.com.co",
      "Nombre_solicitante": "Fernando Enrique Velasco Forero",
      "Nombre_iniciativa": "ID 4286 - Intervención Contrato DECEVAL  CW2249769",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2249769",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "•\tDeceval: \no\tServicio de Pagaré electrónico\no\tNegociador: Jorge Mario Aguinaga Quiros\no\tComercial: \n\tYireth Dayanna Ortiz Alvarez yireth.ortiz@bvc.com.co Cel: 301 5774779\n\tPaulina Saldarriaga psaldarriaga@bvc.com.co Cel: 310 4492904\no\tFecha renovación Contrato: 31 dic 2023\n\nRequerimos necesarios que se deben de tener desde el contrato.\n\n1.\tANS de incidentes en producción\nMe lo sueño con la misma definición que tenemos de ANS de TI con una clasificación de incidente crítico, medio y bajo.\nAcuerdo de la disponibilidad del servicio, que % debe de ser y como lo vamos a medir.\nDisponibilidad 7x24\n\n2.\tModelo de soporte y herramientas de soporte:\nContar con las herramientas de administración y soporte que nos permitan medir los ANSs y el cumplimiento de los mismos, si el proveedor no los tiene, se debe de unir a USD.\nStandby número y modelo de atención inmediato.\n              Poder contar con ellos en mesas de atención de incidentes para cuando es requerido por el COES.\n\n3.\tSolicitud de implementaciones nuevas\nTarifa hora de implementación nuevos requerimientos.\nANSs de entrega de las diferentes etapas de requerimientos (propuesta de implementación, desarrollo, certificación, producción, estabilización).\nANSs mínimos para poner en marcha un requerimiento nuevo, cuanto tiempo se pueden tardar para dar inicio de un proyecto cuando ya está aprobado.\nHoras de asesorías funcionales o técnicas, puede ser en el modelo de demanda, pero que cuando se solicite nos atiendan de forma oportuna.\n\n4.\tAmbientes pre-productivos\nANSs de corrección inconvenientes ambientes pre-productivos.\nModelo de escalamiento definido\nDisponibilidad mínima en horario laboral\n\n5.\tMonitoreo de la solución\nPoder monitorear las soluciones para lograr trabajar desde la prevención, no desde la reacción\nPor lo general lo que se requiere es que nos den usuarios con permisos en sus servicios para identificar si la aplicación está sana (se debe dar doble clic con monitoreo).\n\n6.\tDesde lo funcional\nANSs definidos para la entrega de facturación\nModelo definido de capacitaciones\nANSs escalamientos funcionales y técnicos (inquietudes) y ANSs de respuestas\nMejorar el modelo de facturación transaccional, que se pueda identificar quien es el consumidor, para poder realizar costos descentralizados \nANSs de las parametrizaciones y configuraciones funcionales que los proveedores configuran en una nueva incorporación\n\n7.\tClausulas de penalización por incumplimiento de todo lo anterior\n\n8.\tSeguimiento mínimo mensual y periódico, donde nos entreguen planes de acción de los incidentes reiterativos e inconvenientes del servicio y demostración del cumplimiento de todo el servicio en conjunto.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "300.000.000",
      "Proveedores_conocidos": "DECEVAL",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "C1003500106",
      "Nombre_lider_EVC": "Fernando Enrique Velasco Forero",
      "SR_ARIBA": "SR4151749912",
      "Familias": "Servicios Gestión Documental",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Laura Serna Rodriguez",
      "Rol_asesor": "No aplica",
      "Observaciones": "Biatri ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "25/08/2023",
      "Fecha Asignación/Delegación": "25/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "17/08/2023",
      "Fecha ok. PN": "17/08/2023",
      "sin equipo": "Ciber",
      "Áreas pendientes": "24/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Back Office",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4285,
      "Title": "Forms",
      "Fecha_solicitud": "16/08/2023",
      "Correo_solicitante": "fevelasc@bancolombia.com.co",
      "Nombre_solicitante": "Fernando Enrique Velasco Forero",
      "Nombre_iniciativa": "ID 4285 - Intervención contrato CERTICAMARA 8917 (CW2221493)",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": 8917,
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Intervención contrato CERTICAMARA 8917 (CW2221493)\no\tServicio de Firma simple\no\tNegociador: Jorge Mario Aguinaga Quiros\no\tComercial: Sandra Serrando sandra.serrano@certicamara.com cel: 311 5406632\no\tFecha renovación Contrato: 31 dic 2023\n\nRequerimos necesarios que se deben de tener desde el contrato.\n\n1.\tANS de incidentes en producción\nMe lo sueño con la misma definición que tenemos de ANS de TI con una clasificación de incidente crítico, medio y bajo.\nAcuerdo de la disponibilidad del servicio, que % debe de ser y como lo vamos a medir.\nDisponibilidad 7x24\n\n2.\tModelo de soporte y herramientas de soporte:\nContar con las herramientas de administración y soporte que nos permitan medir los ANSs y el cumplimiento de los mismos, si el proveedor no los tiene, se debe de unir a USD.\nStandby número y modelo de atención inmediato.\n              Poder contar con ellos en mesas de atención de incidentes para cuando es requerido por el COES.\n\n3.\tSolicitud de implementaciones nuevas\nTarifa hora de implementación nuevos requerimientos.\nANSs de entrega de las diferentes etapas de requerimientos (propuesta de implementación, desarrollo, certificación, producción, estabilización).\nANSs mínimos para poner en marcha un requerimiento nuevo, cuanto tiempo se pueden tardar para dar inicio de un proyecto cuando ya está aprobado.\nHoras de asesorías funcionales o técnicas, puede ser en el modelo de demanda, pero que cuando se solicite nos atiendan de forma oportuna.\n\n4.\tAmbientes pre-productivos\nANSs de corrección inconvenientes ambientes pre-productivos.\nModelo de escalamiento definido\nDisponibilidad mínima en horario laboral\n\n5.\tMonitoreo de la solución\nPoder monitorear las soluciones para lograr trabajar desde la prevención, no desde la reacción\nPor lo general lo que se requiere es que nos den usuarios con permisos en sus servicios para identificar si la aplicación está sana (se debe dar doble clic con monitoreo).\n\n6.\tDesde lo funcional\nANSs definidos para la entrega de facturación\nModelo definido de capacitaciones\nANSs escalamientos funcionales y técnicos (inquietudes) y ANSs de respuestas\nMejorar el modelo de facturación transaccional, que se pueda identificar quien es el consumidor, para poder realizar costos descentralizados \nANSs de las parametrizaciones y configuraciones funcionales que los proveedores configuran en una nueva incorporación\n\n7.\tClausulas de penalización por incumplimiento de todo lo anterior\n\n8.\tSeguimiento mínimo mensual y periódico, donde nos entreguen planes de acción de los incidentes reiterativos e inconvenientes del servicio y demostración del cumplimiento de todo el servicio en conjunto.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "300.000.000",
      "Proveedores_conocidos": "CERTICAMARA",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "C103500106",
      "Nombre_lider_EVC": "Fernando Enrique Velasco Forero",
      "SR_ARIBA": "SR4151749897",
      "Familias": "Servicios Gestión Documental",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Laura Serna Rodriguez",
      "Rol_asesor": "No aplica",
      "Observaciones": "Biatri ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "25/08/2023",
      "Fecha Asignación/Delegación": "25/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "17/08/2023",
      "Fecha ok. PN": "17/08/2023",
      "sin equipo": "Ciber",
      "Áreas pendientes": "24/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Back Office",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4284,
      "Title": "Forms",
      "Fecha_solicitud": "16/08/2023",
      "Correo_solicitante": "dizuluag@bancolombia.com.co",
      "Nombre_solicitante": "Diana Sofia Zuluaga Duque",
      "Nombre_iniciativa": "ID 4284 - Pago formación",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Solicitar datos de proveedor y material para realziar el pedido por SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere pagar al proveedor Comfama por la participación en unos programas formativos",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Comfama",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Dirección de Diversidad, Equidad e Inclusión, C102000019",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4284,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "17/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "17/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4282,
      "Title": "Forms",
      "Fecha_solicitud": "16/08/2023",
      "Correo_solicitante": "carescob@bancolombia.com.co",
      "Nombre_solicitante": "Carolina Escobar Pemberthy",
      "Nombre_iniciativa": "ID 4282 - Renovacion contrato RED DE NEGOCIOS - Real Risk - Observatorio CW2279590",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2279590",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere renovar este contrato CW2279590 para dar inicio las investigaciones de Observatorio que se realizarán durante este año.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "44.000.000",
      "Proveedores_conocidos": "RED DE NEGOCIOS - Real Risk",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Conocimiento de Clientes - C105900005",
      "Nombre_lider_EVC": "Camilo Restrepo Saldarriaga",
      "SR_ARIBA": "SR4151446359",
      "Familias": "Consultorias Corporativas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Maria Alejandra Delgado Leon",
      "Rol_asesor": "No aplica",
      "Observaciones": "naty es renovación, proveedor riesgo 4 no va a PN.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "18/08/2023",
      "Fecha Asignación/Delegación": "18/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "17/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Consultorias Corporativas",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4281,
      "Title": "Forms",
      "Fecha_solicitud": "16/08/2023",
      "Correo_solicitante": "ANDRIVER@bancolombia.com.co",
      "Nombre_solicitante": "Andres Camilo Rivera Delgado",
      "Nombre_iniciativa": "ID 4281 - Renovación contrato CW2287791 de Servicios Administrados de Azure ADP con Synergy Advisors",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2287791",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere revisar la renovación del contrato CW2287791 con el proveedor Synergy Advisors para la administración de los controles de Azure ADP que hacen parte de la Área de Conocimiento Administración de Identidades y Accesos.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Depende de la negociación con el proveedor",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Synergy Advisors",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "ADC ADMIN DE IDENTIDADES Y ACCESOS y 104300554",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4151446345",
      "Familias": "Controles de Ciberseguridad",
      "Categoría": "Seguridad",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Mateo Villada Rodriguez",
      "Rol_asesor": "No aplica",
      "Observaciones": "",
      "Comentarios BP": "Llevar al MP y asignar a Mateo",
      "Fecha MarketPlace": "25/08/2023",
      "Fecha Asignación/Delegación": "25/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "17/08/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "24/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Ciberseguridad y seguridad de la información",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4280,
      "Title": "Forms",
      "Fecha_solicitud": "16/08/2023",
      "Correo_solicitante": "clopez@bancolombia.com.co",
      "Nombre_solicitante": "Cesar Augusto Lopez Hernandez",
      "Nombre_iniciativa": "ID 4280 - LAVADO DE VEHICULOS",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Lavado de ECOSPA de vehículos del Banco. El servicio se prestaría en las instalaciones del banco (servicio a domicilio en los parqueaderos).  Si pasa algo con ese carro, en un lavadero, quien responde?, La ventaja de no llevar el vehículo a un lavadero es que lo lavan en sitio.\nAl ingresar personal externo a las instalaciones se debe tener en cuenta temas de riesgos?",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "180.000.000",
      "Proveedores_conocidos": "Ecodesa",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia Seguridad De Personas e Infraestructura Fisica C104300571",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4153979323",
      "Familias": "HARD (Operadores de Mantenimiento)",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Juan Pablo Ramirez Cardenas",
      "Rol_asesor": "No aplica",
      "Observaciones": "naty ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "25/08/2023",
      "Fecha Asignación/Delegación": "25/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "22/08/2023",
      "Fecha ok. PN": "24/08/2023",
      "sin equipo": "",
      "Áreas pendientes": "24/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Facility Managment",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4279,
      "Title": "Forms",
      "Fecha_solicitud": "16/08/2023",
      "Correo_solicitante": "lisezulu@bancolombia.com.co",
      "Nombre_solicitante": "Liset Vanessa Zuluaga Jimenez",
      "Nombre_iniciativa": "ID 4279 - Negociación Modelos Integrales Konecta 2024. contrato CW2271314",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2271314",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Hola, la idea de la iniciativa es comenzar a trabajar la negociación del 2024 de los modelos integrales, inicialmente aclarando las expectativas internas en Banco de la  Negociación y luego con las mesas de negociación con konecta, con el fin de tener claro lo que vamos a negociar y que comience aplicar desde enero.  CW2271314",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "no sabemos cual sera el presupuesto aprobado para el 2024",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Konecta TVT",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Sección Servicios BPO, C103700018",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4151446331",
      "Familias": "Ventas Digitales",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Ok PN, pero sin equipo",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "17/08/2023",
      "Fecha ok. PN": "17/08/2023",
      "sin equipo": "Ciber",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Modelos de Relacionamiento Integral",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4278,
      "Title": "Forms",
      "Fecha_solicitud": "16/08/2023",
      "Correo_solicitante": "scasalin@bancolombia.com.co",
      "Nombre_solicitante": "Scarlett De Jesus Casalins Pertuz",
      "Nombre_iniciativa": "ID 4278 - Patrocinio Caribe Biz Forum 2023",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Actulizar información del proveedor si aplica para generación de Orden de Compra y MIGO",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Patrocinio al evento de Caribe Biz Forum con exposición de la marca  y entradas funcionarios Banco - Año de las relaciones",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Cámara de comercio Barranquilla",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GERENCIA DE GESTIÓN CARIBE C102100403",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4278,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "16/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "16/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4277,
      "Title": "Forms",
      "Fecha_solicitud": "16/08/2023",
      "Correo_solicitante": "natalvar@bancolombia.com.co",
      "Nombre_solicitante": "Natalia Fernanda Alvarez Arenas",
      "Nombre_iniciativa": "ID 4277 - Desarrollo de experiencia Tranformación Vice Talento y CUltura",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Este proveedor nos hizo una experiencia con la cerámica",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "7.650.000",
      "Proveedores_conocidos": "Potterapy",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Vicepresidencia de Talento y CUlturaC103200000",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4277,
      "Familias": "Servicios Profesionales de Bienestar al Personal",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "17/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "17/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4276,
      "Title": "Forms",
      "Fecha_solicitud": "16/08/2023",
      "Correo_solicitante": "lde@bancolombia.com.co",
      "Nombre_solicitante": "Laura Marcela De La Ossa Neira",
      "Nombre_iniciativa": "ID 4276 - Legalización orden de servicio, proveedor Tessi Gestiona, línea de negocio Sufi",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Legalizar los servicios ofrecidos por Tessi a Sufi",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere anexo al contrato en el que se especifique los servicios que Tessi realiza para Sufi Bancolombia\nTessi tiene un contrato macro para BANCOLOMBIA, bajo este hemos venido trabajando durante estos años; sin embargo, Leasing de vehículo no solo lo tiene Sufi, sino que también existe en Leasing Banco, ambos tenemos el mismo NIT, por lo que, nos gustaría oficializar que presta servicios para Sufi, como diferenciarlo de los servicios de Leasing Banco",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Tessi Gestiona",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Posventa Sufi 105000223",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4151446317",
      "Familias": "Procesamiento de Información",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Enviar al category",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Biatri ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "17/08/2023",
      "Fecha ok. PN": "22/08/2023",
      "sin equipo": "Ciber",
      "Áreas pendientes": "25/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Back Office",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4275,
      "Title": "Forms",
      "Fecha_solicitud": "16/08/2023",
      "Correo_solicitante": "NANURIBE@bancolombia.com.co",
      "Nombre_solicitante": "Nancy Milena Uribe Cardona",
      "Nombre_iniciativa": "ID 4275 - Alquiler de salones y alimentación para evento en Pasto taller Hechos de Corazón",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Alquiler de salones y alimentación para evento en Pasto taller Hechos de Corazón",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 0,
      "Proveedores_conocidos": "Corporación Club Colombia",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Gerencia de Aprendizaje-C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4275,
      "Familias": "Otros Servicios Bienes Inmuebles - Muebles",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "16/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "16/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Gestión Inmobiliaria",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4274,
      "Title": "Forms",
      "Fecha_solicitud": "16/08/2023",
      "Correo_solicitante": "jmpulgar@bancolombia.com.co",
      "Nombre_solicitante": "John Mauricio Pulgarin",
      "Nombre_iniciativa": "ID 4274 - FORMACIONES DE LECTURA PARA LOS EMPLEADOS",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "VINCULAR AL PROVEEDOR",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "FORMACIONES DE LECTURA PARA LOS EMPLEADOS",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Javier Ignacio Saldarriaga Cadavid 98557228-1",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GERENCIA DE BIENESTAR C103200030",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4274,
      "Familias": "Convenios y Beneficios",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "16/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "16/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4273,
      "Title": "Forms",
      "Fecha_solicitud": "16/08/2023",
      "Correo_solicitante": "NANURIBE@bancolombia.com.co",
      "Nombre_solicitante": "Nancy Milena Uribe Cardona",
      "Nombre_iniciativa": "ID 4273 - Alquiler de espascios para evento de Presidencia y Junta Directiva en novimebre de 2023",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Alquiler de espascios para evento de Presidencia y Junta Directiva en novimebre de 2023",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 0,
      "Proveedores_conocidos": "Corporación Club Campestre",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Gerencia de Aprendizaje-C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4273,
      "Familias": "Otros Servicios Bienes Inmuebles - Muebles",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "17/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "17/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Gestión Inmobiliaria",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4272,
      "Title": "Forms",
      "Fecha_solicitud": "16/08/2023",
      "Correo_solicitante": "jtsanche@bancolombia.com.co",
      "Nombre_solicitante": "July Tatiana Sanchez Agudelo",
      "Nombre_iniciativa": "ID 4272 - Actualización Proveedor ASOPAGOS (Fondo Nacional del Ahorro)",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": 0,
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor recauda cesantías para el cliente fondo nacional del ahorro y el banco liquida el valor correspondiente a esas transacciones, único pago al año. Se requiere actualizar al proveedor para proceder con el pago de la factura.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 10000000,
      "Proveedores_conocidos": "ASOPAGOS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Gestión de Fliujos",
      "Nombre_lider_EVC": "Juan Gonzalo",
      "SR_ARIBA": 4272,
      "Familias": "Pasarelas de Pago",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "17/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "17/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Medios de Pago",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4271,
      "Title": "Forms",
      "Fecha_solicitud": "16/08/2023",
      "Correo_solicitante": "danicast@bancolombia.com.co",
      "Nombre_solicitante": "Daniela Castano Ballesteros",
      "Nombre_iniciativa": "ID 4271 - Alimentos para evento en congreso de centros comerciales",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular al proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor nos vendió una paletas de agua para regalar en el congreso de  centros comerciales en América Latina realizado en Cartagena,",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "SER PRODUCCIONES LTDA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Pagos sin Friccion C107500005",
      "Nombre_lider_EVC": "Santiago Ceballos Aristizabal",
      "SR_ARIBA": 4271,
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "17/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "17/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4269,
      "Title": "Forms",
      "Fecha_solicitud": "16/08/2023",
      "Correo_solicitante": "cjhenao@bancolombia.com.co",
      "Nombre_solicitante": "Claudia Jazmin Henao Arias",
      "Nombre_iniciativa": "ID 4269 - Pago participación evento Andicom",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "realizar todo el proceso que corresponda para lograr realizar el pago al proveedor.",
      "Es_core_leasing": "En aplicativo Banco (SAP)",
      "Detalle_producto_o_servicio": "Se va a realizar el evento ANDICOM. Nuestro proveedor MAAKAL tendrá un stand asignado y nos dará protagonismo en el espacio, negociamos el pago de un monto por esta participación.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "MAAKAL COLOMBIA SA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC ACTIVOS LEASING RENTA Y USO - C103808300",
      "Nombre_lider_EVC": "ALBERTO ECHEVERRI ARCILA",
      "SR_ARIBA": 4269,
      "Familias": "Patrocinios Mercadeo",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "16/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "16/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4268,
      "Title": "Forms",
      "Fecha_solicitud": "16/08/2023",
      "Correo_solicitante": "yequinte@bancolombia.com.co",
      "Nombre_solicitante": "Yenifer Quintero Quiceno",
      "Nombre_iniciativa": "ID 4268 - Patrocinio al municipio de Envigado",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Hacer pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "EL proveedor fabrica y entrega balones con la imagen de Bancolombia en todas las regiones del país",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Segundo Adán Neita Fonseca - Arcueros deportes Monguí CC: 4168847",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gobierno de Red - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4268,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "16/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "16/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4267,
      "Title": "Forms",
      "Fecha_solicitud": "16/08/2023",
      "Correo_solicitante": "jusarist@bancolombia.com.co",
      "Nombre_solicitante": "Juan Sebastian Aristizabal Aguado",
      "Nombre_iniciativa": "ID 4267 - Plataforma de GMF Entidades Financieras",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Con la reforma tributaria del 2022 se tendrán cambios en la administración de la exención del GMF de los 350 UVTS y se requiere contratar un proveedor que centralice y acumule las transacciones sujetas al gravamen, de forma que pueda informar a las Entidades Financieras si la transacción del cliente es sujeta o no del cobro de GMF.",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Priorizado por el CAE",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "3.000.0000.000",
      "Proveedores_conocidos": "TransUnion, Experian,ACH",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Depositos y Cuentas Especiales",
      "Nombre_lider_EVC": "Santiago Perez Posada",
      "SR_ARIBA": "SR4148361734",
      "Familias": "Servicios SaaS",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Diana Marcela Gomez Grisales",
      "Rol_asesor": "Adriana Maria Arango Restrepo",
      "Observaciones": "Dianis ok PN.\nFamilia de TI que atiende Canales",
      "Comentarios BP": "",
      "Fecha MarketPlace": "25/08/2023",
      "Fecha Asignación/Delegación": "25/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "16/08/2023",
      "Fecha ok. PN": "17/08/2023",
      "sin equipo": "Ciber",
      "Áreas pendientes": "24/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de plataformas",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4266,
      "Title": "Forms",
      "Fecha_solicitud": "16/08/2023",
      "Correo_solicitante": "jmpulgar@bancolombia.com.co",
      "Nombre_solicitante": "John Mauricio Pulgarin",
      "Nombre_iniciativa": "ID 4266 - COMPRA DE TRAJES TIPICOS PARA LAS FIESTAS DE SAN PACHO",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "DESBLOQUEAR PROVEEDOR",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "COMPRA DE TRAJES TIPICOS PARA LAS FIESTAS DE SAN PACHO",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "ASOCIACION ARTE Y JOYA\tNIT 900702875-5",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GERENCIA DE BIENESTAR C103200030",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4266,
      "Familias": "Convenios y Beneficios",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "16/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "16/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4265,
      "Title": "Forms",
      "Fecha_solicitud": "16/08/2023",
      "Correo_solicitante": "anmarios@bancolombia.com.co",
      "Nombre_solicitante": "Ana Maria Rios Benjumea",
      "Nombre_iniciativa": "ID 4265 - Asistencias MOK",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere aperturar un contrato marco con el aliado MOK para Seguros, con el fin de ofertar los productos, servicios y asistencias que ofrece el aliado.  esta iniciativa sería estrategia foco para los empleados y sus familias",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "No se cuenta con presupuesto, debido a que somos parte del area de beneficios y esta iniciativa sería estrategia foco para los empleados y sus familias",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "MOK",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC SEGUROS C105500010",
      "Nombre_lider_EVC": "Oscar Julio Orozco Cano",
      "SR_ARIBA": "SR4149728224",
      "Familias": "Seguros",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Enviar al category",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Biatri OK PN\nal fin no me definiste si se delegaba o no, entonces te lo remito para que definas si lo llevas al MP o lo delegas.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "22/08/2023",
      "Fecha ok. PN": "22/08/2023",
      "sin equipo": "Ciber",
      "Áreas pendientes": "25/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "GASTO NO GESTIONADO",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4283,
      "Title": "Forms",
      "Fecha_solicitud": "15/08/2023",
      "Correo_solicitante": "joifranc@bancolombia.com.co",
      "Nombre_solicitante": "Jorge Ivan Franco Osorio",
      "Nombre_iniciativa": "ID 4283 - Renegociación contrato Gamma - SWG CW2290224",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2290224 Administrador: Sergio Ivan Orrego Gonzales",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la renovación del contrato CW2290224  que se tiene con Gamma Ingenieros para el servicio de SWG el cual tiene fecha de vencimiento",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "N/A",
      "Proveedores_conocidos": "Gamma Ingenieros",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Capacidades de ciberseguridad",
      "Nombre_lider_EVC": "Andres Felipe Rivas Gonzalez",
      "SR_ARIBA": "SR4151749875",
      "Familias": "Controles de Ciberseguridad",
      "Categoría": "Seguridad",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Cata ok PN",
      "Comentarios BP": "Llevar al MP del 22 de septiembre y asignar a Pablo Zapata",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "17/08/2023",
      "Fecha ok. PN": "22/08/2023",
      "sin equipo": "Ciber",
      "Áreas pendientes": "25/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Ciberseguridad y seguridad de la información",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4270,
      "Title": "Forms",
      "Fecha_solicitud": "15/08/2023",
      "Correo_solicitante": "lotero@bancolombia.com.co",
      "Nombre_solicitante": "Luis Alberto Otero Gomez",
      "Nombre_iniciativa": "ID 4270 - consultoria con el BID para gestión de riesgos de biodiversidad",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "vincular al proveedor \"BID",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere una consultoría  a través del BID para desarrollar una metodología de gestión del riesgo de biodiversidad, el costo de la consultoría es asumida en parte por el BID y ellos contrataran un consultor.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "BID",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C102300008",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4270,
      "Familias": "Consultorias Corporativas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "16/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "16/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Consultorias Corporativas",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4264,
      "Title": "Forms",
      "Fecha_solicitud": "15/08/2023",
      "Correo_solicitante": "lmmolina@bancolombia.com.co",
      "Nombre_solicitante": "Liliana Marcela Molina Castro",
      "Nombre_iniciativa": "ID 4264 - Analizar pertinencia de adquisición de herramienta de inteligencia artificial generativa",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor 2nV nos ofrece un servicio de inteligencia artificial generativa (Zathinker) que facilita la construcción de diseños de procesos a partir de un contexto básico de la necesidad ingresada, ya nos compartieron una propuesta económica de lo que cuesta el servicio y quisiéramos tener acompañamiento para valorar la pertinencia de los precios y condiciones ofrecidas e igualmente de adquirir los servicios del proveedor.\nEs una herramienta alojada en nube que tendría personalización de los servicios para adaptar el desarrollo a nuestra necesidad y tendría integración con bases de datos internas\nes similar a un chat GPT pero más evolucionado",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "0000",
      "Proveedores_conocidos": "2nV",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Centro de Excelencia en Procesos - Gerencia Gobierno de Procesos - C103700012",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4148361720",
      "Familias": "Servicios SaaS",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Ok PN, pero sin equipo",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "16/08/2023",
      "Fecha ok. PN": "17/08/2023",
      "sin equipo": "Ciber",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicio de plataformas",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4263,
      "Title": "Forms",
      "Fecha_solicitud": "15/08/2023",
      "Correo_solicitante": "abarbon@bancolombia.com.co",
      "Nombre_solicitante": "Adriana Barbon Venegas",
      "Nombre_iniciativa": "ID 4263 - Pago de servicio herramienta diagnostico Innoquotient - área de  innovación-  pago en euros",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El servicio que se solicita al proveedor es que por medio de una herramienta realizar el DIAGNÓSTICO INNOQUOTIENT, con el objetivo de evaluar que tan innovadora es la organización Bancolombia. el pago es en euros y hay que validar temas de impuestos y retenciones.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "20.000.000",
      "Proveedores_conocidos": "Innoquotient",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "LDC FC INNOVACION",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4148361691",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Nicolas Quiceno Carmona",
      "Rol_asesor": "Monica Marcela Alzate Granda",
      "Observaciones": "Naty ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "25/08/2023",
      "Fecha Asignación/Delegación": "25/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "16/08/2023",
      "Fecha ok. PN": "16/08/2023",
      "sin equipo": "Ciber",
      "Áreas pendientes": "24/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4262,
      "Title": "Forms",
      "Fecha_solicitud": "15/08/2023",
      "Correo_solicitante": "ANGMAROD@bancolombia.com.co",
      "Nombre_solicitante": "Angela Maria Rodriguez Castano",
      "Nombre_iniciativa": "ID 4262 - Desbloqueo del proveedor  JULIANA SIERRA BETANCUR",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Desbloqueo del proveedor   JULIANA SIERRA BETANCUR nos apoyara con MERCH de la gerencia",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Desbloqueo del proveedor   JULIANA SIERRA BETANCUR nos apoyara con MERCH de la gerencia",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "JULIANA SIERRA BETANCUR",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "c103200040",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4262,
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "15/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "15/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4261,
      "Title": "Forms",
      "Fecha_solicitud": "15/08/2023",
      "Correo_solicitante": "jorvarga@bancolombia.com.co",
      "Nombre_solicitante": "Jorge Alejandro Vargas Perdomo",
      "Nombre_iniciativa": "ID 4261 - Activación Proveedor",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Actualizar un proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Actualizar al proveedor Natalia Gonzalez que desarrollará un taller de Team Building al equipo de Soluciones Digitales",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Natalia Gonzalez Gonzalez",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Dirección de Soluciones Digitales",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4261,
      "Familias": "Servicios Profesionales Formación y Entrenamiento",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Ago. 15  usuario radicó esta misma necesidad el 14 de agosto con el ID 4242. e informa que es porque el paso 2 le quedó mal diligenciado y le toca reprocesar.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "15/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "15/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4260,
      "Title": "Forms",
      "Fecha_solicitud": "15/08/2023",
      "Correo_solicitante": "avbetanc@bancolombia.com.co",
      "Nombre_solicitante": "Alejandra Victoria Betancourt Latorre",
      "Nombre_iniciativa": "ID 4260 - Renovación de la orden de servicio con Accenture (Fjord)  CW2290856",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2290856",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación OS29 CW2290856 Acompañamiento en proyectos outsourcing para el diseño de experiencia de clientes",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "400 millones",
      "Proveedores_conocidos": "ACCENTURE LTDA",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Gestión de diseño 107200221",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4147904266",
      "Familias": "Servicios profesionales de Mercadeo",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Carlos Andres Ramos Ospina",
      "Rol_asesor": "No aplica",
      "Observaciones": "naty ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "18/08/2023",
      "Fecha Asignación/Delegación": "18/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "15/08/2023",
      "Fecha ok. PN": "15/08/2023",
      "sin equipo": "",
      "Áreas pendientes": "15/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4259,
      "Title": "Forms",
      "Fecha_solicitud": "15/08/2023",
      "Correo_solicitante": "ELKGOMEZ@bancolombia.com.co",
      "Nombre_solicitante": "Elkin Dario Gomez Loaiza",
      "Nombre_iniciativa": "ID 4259 - Renovación contrato CW2294681 certificados digitales - GSE",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2294681",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "S requiere apoyo para revisar la renovación del contrato CW2294681 con GSE. Por favor asignar a la negociadora Andrea Ortega.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "336 mm anuales",
      "Proveedores_conocidos": "GSE",
      "Cuadrante_Proveedor": 3,
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Capacidades de Ciberseguridad",
      "Nombre_lider_EVC": "Andrés Felipe Rivas González",
      "SR_ARIBA": "SR4147904232",
      "Familias": "Controles de Ciberseguridad",
      "Categoría": "Seguridad",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Yuri Andrea Ortega Davila",
      "Rol_asesor": "Monica Marcela Alzate Granda",
      "Observaciones": "Cata es renovación, proveedor riesgo 3 no va a PN",
      "Comentarios BP": "Llevar al MP y asignar a Andrea",
      "Fecha MarketPlace": "16/08/2023",
      "Fecha Asignación/Delegación": "16/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "15/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Ciberseguridad y seguridad de la información",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4258,
      "Title": "Forms",
      "Fecha_solicitud": "15/08/2023",
      "Correo_solicitante": "dianavil@bancolombia.com.co",
      "Nombre_solicitante": "Diana Marcela Avila Herrera",
      "Nombre_iniciativa": "ID 4258 - Estudio de titulo con debida diligencia",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere un estudio de titulo profundo para un BRP 50830043, se recibió en dación de pago y se le hizo el estudio de titulo inicial, al parecer por información del aliado, este estudio de titulo se realizó con documentos falsos y esta impidiendo su comercialización, por lo cual se hace necesario realizar un estudio de titulo con debida diligencia, al inmueble identificado con matrícula inmobiliaria252-4501 de la Oficina de Registro de Instrumentos Públicos Tumaco, para conocer la situación jurídica actual y real del predio, identificando si existen vicios en la cadena de tradición y riesgos jurídicos que deban considerarse.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "33.934.000.000",
      "Proveedores_conocidos": "GECASER - Gestión cartera y servicios S.A.S",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C101000045",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4258,
      "Familias": "Servicios Legales",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Esperando confirmación de Biatri sobre la familia para delegarlo.  solo requieren vinculación.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "23/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "23/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios Profesionales Procesos del Negocio",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4257,
      "Title": "Forms",
      "Fecha_solicitud": "15/08/2023",
      "Correo_solicitante": "coarango@bancolombia.com.co",
      "Nombre_solicitante": "Cesar Octavio Arango Ruiz",
      "Nombre_iniciativa": "ID 4257 - RFP de Herramientas Colaborativas",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere generar un nuevo RFP de Herramientas Colaborativas con el proveedor existente mas nuevos proveedores para la protección a nivel de seguridad correo y herramientas colaborativas donde deban cumplir con los siguientes requisitos:\n- Protección a nivel de Suplantación de identidad, reglas de protección para usuarios VIP y de cadena de Valor.\n- Ataques avanzados.\n- Ataques tipo BEC.\n- Comportamiento de flujo de correos y inteligencia social.\n- Análisis de correos, link, adjuntos en tiempo real.\n- Contención de correos.\n- Flujo de correos con tiempo de SLA.\n- Integraciones con herramientas Banco.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "No aplica",
      "Proveedores_conocidos": "Microsoft, Trellix Email, Checkpoint, Opswat",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "EVC Capacidades de Ciberseguridad, centro de costos: C104300559",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4148356921",
      "Familias": "Controles de Ciberseguridad",
      "Categoría": "Seguridad",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Cata ok PN",
      "Comentarios BP": "Llevar al MP del 22 de septiembre y asignar a Pablo Zapata",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "16/08/2023",
      "Fecha ok. PN": "18/08/2023",
      "sin equipo": "Ciber",
      "Áreas pendientes": "25/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Ciberseguridad y seguridad de la información",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4256,
      "Title": "Forms",
      "Fecha_solicitud": "15/08/2023",
      "Correo_solicitante": "olserran@bancolombia.com.co",
      "Nombre_solicitante": "Oscar Leonel Serrano Nino",
      "Nombre_iniciativa": "ID 4256 - CONTRATO DE SERVICIOS DE SERVICIOS DE SEGURIDAD CON IBM (XDR)",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Buen dia, se requiere realizar la negociación del CONTRATO DE SERVICIOS DE SERVICIOS DE SEGURIDAD CON IBM (XDR) donde se incluye el valor de las licencias y la AOM con CrowdStrike e IBM.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "Por definir",
      "Proveedores_conocidos": "IBM",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Capacidades de Ciberseguridad - C104300559",
      "Nombre_lider_EVC": "Sergio Ivan Orrego Gonzalez",
      "SR_ARIBA": "SR4147638769",
      "Familias": "Controles de Ciberseguridad",
      "Categoría": "Seguridad",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Pablo Zapata Franco",
      "Rol_asesor": "Adriana Maria Arango Restrepo",
      "Observaciones": "Cata ok PN",
      "Comentarios BP": "Asignar a Pablo",
      "Fecha MarketPlace": "25/08/2023",
      "Fecha Asignación/Delegación": "25/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "15/08/2023",
      "Fecha ok. PN": "16/08/2023",
      "sin equipo": "Ciber",
      "Áreas pendientes": "24/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Ciberseguridad y seguridad de la información",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4255,
      "Title": "Forms",
      "Fecha_solicitud": "15/08/2023",
      "Correo_solicitante": "daalzat@bancolombia.com.co",
      "Nombre_solicitante": "Daniel Alzate Rua",
      "Nombre_iniciativa": "ID 4255 - Abogado externo que nos ayuda con la firma de las escrituras",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Abogado externo que nos ayuda con la firma de las escrituras del negocio P.A. San Felipe IV",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Presupuesto se genera por demanda",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Abogado externo que nos ayuda con la firma de las escrituras del negocio P.A. San Felipe IV",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C302400400",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4255,
      "Familias": "Servicios Legales",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "15/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "15/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios Profesionales Procesos del Negocio",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4254,
      "Title": "Forms",
      "Fecha_solicitud": "15/08/2023",
      "Correo_solicitante": "andcamar@bancolombia.com.co",
      "Nombre_solicitante": "Andrea Paola Camargo Maldonado",
      "Nombre_iniciativa": "ID 4254 - Vinculacion Proveedor para actividad Santa Marta",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere vincular proveedor para actividades en santa marta",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Maria Alejandra Vives Paez\t1082979589",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "c103200170",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4254,
      "Familias": "Convenios y Beneficios",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "15/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "15/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4253,
      "Title": "Forms",
      "Fecha_solicitud": "15/08/2023",
      "Correo_solicitante": "JACKELOP@bancolombia.com.co",
      "Nombre_solicitante": "Jackeline Lopez Moreno",
      "Nombre_iniciativa": "ID 4253 - Compra de camisetas comunidad analitica",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de 15 camisetas para evento de Comunidad Analitica del grupo bancolombia con Proveedor Brandex, adicional se requieren mas actividsades con el proveedor a la luz de actividades de comunidad analitica",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 70000000,
      "Proveedores_conocidos": "BRANDEX",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Centro de Excelencia Analitica e IA",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4253,
      "Familias": "BTL",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "15/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "15/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4252,
      "Title": "Forms",
      "Fecha_solicitud": "14/08/2023",
      "Correo_solicitante": "JULIAROD@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Rodriguez Jaramillo",
      "Nombre_iniciativa": "ID 4252 - Acompañamiento plan migración sitio web a Contentful",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Requerimos acompañamiento de un proveedor para definir plan de ruta de migración del sitio web del banco al nuevo CMS Headless.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "200.000.000",
      "Proveedores_conocidos": "Apply Digital",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "C106500025  EVC VENTAS DIGITALES Y TECNOLOGIA MDEO",
      "Nombre_lider_EVC": "Maria Fernanda Scarpetta",
      "SR_ARIBA": "SR4148356907",
      "Familias": "Contenidos Digitales",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Katherine Sanchez Henao",
      "Rol_asesor": "Adriana Maria Arango Restrepo",
      "Observaciones": "Naty ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "18/08/2023",
      "Fecha Asignación/Delegación": "18/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "16/08/2023",
      "Fecha ok. PN": "16/08/2023",
      "sin equipo": "",
      "Áreas pendientes": "17/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4251,
      "Title": "Forms",
      "Fecha_solicitud": "14/08/2023",
      "Correo_solicitante": "jamador@bancolombia.com.co",
      "Nombre_solicitante": "Juan Esteban Amador Aguirre",
      "Nombre_iniciativa": "ID 4251 - Compra de Maletines de Bienvenida nuevos Alcaldes y Gobernadores",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere contratar la compra de 1.000 maletines (aprox.) para entregar a los Alcaldes y Gobernadores que queden electos por elección popular el próximo 29 de octubre. Esto se entrega como detalle de Bienvenida (Fidelización) al inicio de nuevas relaciones con los representantes del sector público territorial.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "$170.000.000",
      "Proveedores_conocidos": "Cueros Velez",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Clientes Pymes y Empresas - CECO: C105900011",
      "Nombre_lider_EVC": "Paula Andrea Velez Gomez",
      "SR_ARIBA": 4251,
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "15/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "15/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4250,
      "Title": "Forms",
      "Fecha_solicitud": "14/08/2023",
      "Correo_solicitante": "narivill@bancolombia.com.co",
      "Nombre_solicitante": "Natalia Andrea Rivillas Castrillon",
      "Nombre_iniciativa": "ID 4250 - Controles de Cumplimiento de Bancos Corresponsales",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere apoyo de un Negociador para establecer con Filiales del exterior como realizar el cobro del licenciamiento del software SafeWatch que hoy se tiene con BCG FINANCE SYSTEMS SA para hacer extensivo el contrato a Colombia y realizar un traslado entre compañías. Lo anterior con el objetivo de implementar los controles de cumplimiento de Bancos Corresponsales para mitigar el riesgo residual crítico, valorado en $ 5.984 MM. Este tema se estaba trabajando con el SR3723787678 y corresponde a: Consultoría Control Cumplimiento Corresponsales (EVC Financiación y Consumo), el cual se declaró desierto y se requiere dar continuidad la tema. ¡Muchas gracias!",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "30.000 USD aproximadamente",
      "Proveedores_conocidos": "BCG FINANCE SYSTEMS SA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC de Financiación y Consumo",
      "Nombre_lider_EVC": "David Gonzalo Pelaez",
      "SR_ARIBA": "SR4147484437",
      "Familias": "Servicios SaaS",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Sergio Humberto Ramirez Tobon",
      "Rol_asesor": "Adriana Maria Arango Restrepo",
      "Observaciones": "Jose es un tema que se retoma, se habia declarado decierto.  con SR anterior (SR3723787678 ) se realizó PN, activando a Ciber, Seguros, RO y PDP. proceso atendido por Checho.  ste nuevo no va a PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "18/08/2023",
      "Fecha Asignación/Delegación": "18/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "15/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de plataformas",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4249,
      "Title": "Forms",
      "Fecha_solicitud": "14/08/2023",
      "Correo_solicitante": "ednarvae@bancolombia.com.co",
      "Nombre_solicitante": "Eddy Johanna Narvaez Garzon",
      "Nombre_iniciativa": "ID 4249 - EKILIBIRIO - charlas saludables, inteligencia emocional y VIDA EN EQUILIBRIO, mindflunes , yoga",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Charlas y talleres y secciones de yoga. Mindflunes",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 5000000,
      "Proveedores_conocidos": "Nombre de la empresa: EKILIBRIO, Persona natural contacto SANDRA PAOLA TORRES ABADIA  C.C. 31539561 CELULAR 3147349592 CORREO ELECTRONICO STORRES@EKILIBRIO.CO",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "CALIDAD DE VIDA C103200030",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4249,
      "Familias": "Convenios y Beneficios",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "14/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "14/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4248,
      "Title": "Forms",
      "Fecha_solicitud": "14/08/2023",
      "Correo_solicitante": "fermesa@bancolombia.com.co",
      "Nombre_solicitante": "Fernando Mesa Rivera",
      "Nombre_iniciativa": "ID 4248 - Material contable presupuesto CB",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Solicitar material de la pospre GG1203-02 ADECU REPARACIONES L",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere saber cual es el material de la pospre GG1203-02 ADECU REPARACIONES L para legalizar una factura de la impresión de unos stiker para corregir una información interna de los CB.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Publimpresos",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "ADC Corresponsales Bancarios",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR No requerido",
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Contención",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Ago. 14. Por Teams se le informó al usuario que conversara con Mauro Jimenez, ya que el tema de impresión lo maneja él y les ayudó con esta compra puntual.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "14/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4247,
      "Title": "Forms",
      "Fecha_solicitud": "14/08/2023",
      "Correo_solicitante": "gevelasq@bancolombia.com.co",
      "Nombre_solicitante": "Geraldine Velasquez Villalba",
      "Nombre_iniciativa": "ID 4247 - Actividades recreativas para empleados",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "desbloquear al proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Comprar una actividad recreativa para los empleados de la sucursal Arauca",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "NIT:800219488 Caja de compensacion COMFIAR",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GERENCIA DE BIENESTAR C103200030",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4247,
      "Familias": "Convenios y Beneficios",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "14/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "14/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4246,
      "Title": "Forms",
      "Fecha_solicitud": "14/08/2023",
      "Correo_solicitante": "smvasqu@bancolombia.com.co",
      "Nombre_solicitante": "Sebastian Maya Vasquez",
      "Nombre_iniciativa": "ID 4246 - Pago factura Workshare, renovación  CW2256891 licencias",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Solicitar los materiales para el pago de la factura Workshare",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación del licenciamiento menor de la herramienta WorkShare Profesional, del cual tenemos 15 licencias y debemos continuar con ellas.  contrato CW2256891 esta herramienta sirve para comprar un documento frente a otro.\nEl presupuesto se encuentra en nuestra EVC Otras Funciones de Apoyo",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Aptus legal systems",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Otras funciones de apoyo C103500005",
      "Nombre_lider_EVC": "Adriana Patricia Bustamante Barrera",
      "SR_ARIBA": "SR4146328993",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Carlos Andres Ramos Ospina",
      "Rol_asesor": "Monica Marcela Alzate Granda",
      "Observaciones": "Naty es renovación, proveedor riesgo 3 no va a PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "18/08/2023",
      "Fecha Asignación/Delegación": "18/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "14/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4245,
      "Title": "Forms",
      "Fecha_solicitud": "14/08/2023",
      "Correo_solicitante": "emgomez@bancolombia.com.co",
      "Nombre_solicitante": "Emanuel Medina Gomez",
      "Nombre_iniciativa": "ID 4245 - Renovación licenciamiento Artifactory - CW2268411",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2268411",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere renovación de CW2268411 licencia de jfrog artifactory + xfray ya que esta herramienta presta el servicio de gestion de dependencias y vulnerabilidades para el ciclo de vida de desarrollo de software.\nRenovación de suscripción artifactory pro + xray.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "19900 usd",
      "Proveedores_conocidos": "JFROG",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "CDE Ingeniería de Software DevExp, LC DevOps y Métricas, C103500036",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4145897915",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Nicolas Quiceno Carmona",
      "Rol_asesor": "Monica Marcela Alzate Granda",
      "Observaciones": "Naty ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "18/08/2023",
      "Fecha Asignación/Delegación": "18/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "14/08/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "15/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4244,
      "Title": "Forms",
      "Fecha_solicitud": "14/08/2023",
      "Correo_solicitante": "stcardon@bancolombia.com.co",
      "Nombre_solicitante": "Stefany Cardona Cano",
      "Nombre_iniciativa": "ID 4244 - crear nueva sociedad para proveedor existente",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Actualizar datos del proveedor, para agregar en una nueva sociedad en la que debe estar creado para proceder al pago",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "patrocinio de evento comercial",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Frubana SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "gerencia crecimeinto- C102200017",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4244,
      "Familias": "Patrocinios Mercadeo",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "14/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "14/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4243,
      "Title": "Forms",
      "Fecha_solicitud": "14/08/2023",
      "Correo_solicitante": "SACALLE@bancolombia.com.co",
      "Nombre_solicitante": "Santiago Alberto Calle Fernandez",
      "Nombre_iniciativa": "ID 4243 - Renovación soporte Premium SAP Active Attention. CW2277860",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación soporte Premium SAP Active Attention. CW2277860",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "250.000 usd",
      "Proveedores_conocidos": "SAP",
      "Cuadrante_Proveedor": 1,
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Talento Cultura y Administrativo",
      "Nombre_lider_EVC": "Santiago Alberto Calle Fernández",
      "SR_ARIBA": "SR4145897964",
      "Familias": "Licenciamiento Mayor",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Daniela Alvarez Montoya",
      "Rol_asesor": "No aplica",
      "Observaciones": "Jose pok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "18/08/2023",
      "Fecha Asignación/Delegación": "18/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "14/08/2023",
      "Fecha ok. PN": "16/08/2023",
      "sin equipo": "",
      "Áreas pendientes": "17/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4242,
      "Title": "Forms",
      "Fecha_solicitud": "14/08/2023",
      "Correo_solicitante": "jorvarga@bancolombia.com.co",
      "Nombre_solicitante": "Jorge Alejandro Vargas Perdomo",
      "Nombre_iniciativa": "ID 4242 - Actualización Proveedor",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": 51893290,
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Actualización de proveedor que nos presta el servicio de un Taller de Team Building al equipo de Soluciones Digitales",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Para esta actividad no se requiere presuopuesto",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Natalia Gonzalez Gonzalez",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Dirección Soluciones Digitales",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4242,
      "Familias": "Servicios Profesionales Formación y Entrenamiento",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "14/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "14/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4241,
      "Title": "Forms",
      "Fecha_solicitud": "12/08/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 4241 - Compra de curso de extensión UXDX EMEA\tUXDX",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión UXDX EMEA\tUXDX",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "UXDX",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4241,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "14/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "14/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4240,
      "Title": "Forms",
      "Fecha_solicitud": "11/08/2023",
      "Correo_solicitante": "LROLDAN@bancolombia.com.co",
      "Nombre_solicitante": "Luz Adriana Roldan Pardo",
      "Nombre_iniciativa": "ID 4240 - Renovación de la Orden de Servicio CW2235856",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2235856",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere hacer la renovación del contrato CW2235856 , sobre prestación de servicios profesionales de Agile Coach por parte de Informática y tecnología Stefanini S.A.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "2.654.000.000 (aproximadamente el año de renovación septiembre de 2023 a septiembre de 2024)",
      "Proveedores_conocidos": "Informática y tecnología Stefanini S.A.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "CdE de Agiliad, CC103200013",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4145510053",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Angie Lorena Castrillon Palacio",
      "Rol_asesor": "Adriana Maria Arango Restrepo",
      "Observaciones": "Jose ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "25/08/2023",
      "Fecha Asignación/Delegación": "25/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "14/08/2023",
      "Fecha ok. PN": "15/08/2023",
      "sin equipo": "Ciber",
      "Áreas pendientes": "24/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4239,
      "Title": "Forms",
      "Fecha_solicitud": "11/08/2023",
      "Correo_solicitante": "iraceved@bancolombia.com.co",
      "Nombre_solicitante": "Iris Yadira Acevedo Blanco",
      "Nombre_iniciativa": "ID 4239 - Renovar CW2299741 -OS Nro. 02 - Smartnet Equipos Videoconferencia Cisco",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "LOGICALIS COLOMBIA S A S",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovar CW2299741 - OS 2 -Contrato de Smartnet de Equipos Videoconferencia Cisco propiedad de Bancolombia",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "USD 17000",
      "Proveedores_conocidos": "LOGICALIS COLOMBIA S A S",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "LdC FC Ing Telefonía y Video TI - C103500100",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4145510034",
      "Familias": "Telecomunicaciones",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Andres Felipe Meneses Vergara",
      "Rol_asesor": "Adriana Maria Arango Restrepo",
      "Observaciones": "Jose ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "18/08/2023",
      "Fecha Asignación/Delegación": "18/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "14/08/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "15/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio telecomunicación",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4238,
      "Title": "Forms",
      "Fecha_solicitud": "11/08/2023",
      "Correo_solicitante": "iraceved@bancolombia.com.co",
      "Nombre_solicitante": "Iris Yadira Acevedo Blanco",
      "Nombre_iniciativa": "ID 4238 - Renovación CW2297648 -OS Nro. 01 - Licencias Webex Webinars",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2297648",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación CW2297648 - OS1 Licencias Webex Webinars para Bancolombia",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "USD 5657",
      "Proveedores_conocidos": "LOGICALIS COLOMBIA S A S",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "LdC FC Ing Telefonía y Video TI - C103500100",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4145510018",
      "Familias": "Telecomunicaciones",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Jose ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "14/08/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "15/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio telecomunicación",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },{
      "ID_lista": 4237,
      "Title": "Forms",
      "Fecha_solicitud": "11/08/2023",
      "Correo_solicitante": "iraceved@bancolombia.com.co",
      "Nombre_solicitante": "Iris Yadira Acevedo Blanco",
      "Nombre_iniciativa": "ID 4237 - Renovación CW2278336 - OS 13 servicio de TV digital",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2278336",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación CW2278336 OS 13 - Servicios de Televisión digital con el operador Tigo para las sedes y sucursales de Bancolombia.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "$1.127.000 Promedio de gasto mes durante 2023",
      "Proveedores_conocidos": "UNE EPM TELECO S.A.",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "LdC FC Ing Telefonía y Video TI - C103500100",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4145510000",
      "Familias": "Telecomunicaciones",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Jose ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "14/08/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "15/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio telecomunicación",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4236,
      "Title": "Forms",
      "Fecha_solicitud": "11/08/2023",
      "Correo_solicitante": "iraceved@bancolombia.com.co",
      "Nombre_solicitante": "Iris Yadira Acevedo Blanco",
      "Nombre_iniciativa": "ID 4236 - Renovar CW2282516 - Orden de servicio 18. para la prestación de los servicios de Troncal SIP Fija entre Tigo y Bancolombia",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2282516",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovar CW2282516 - Servicios de Troncal SIP Fija de Telefonía con el operador Tigo para las sedes y sucursales de Bancolombia.  OS%2318",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "56.000.000 Gasto promedio mes del año 2023",
      "Proveedores_conocidos": "UNE EPM TELECO S.A.",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "LdC FC Ing Telefonía y Video TI - C103500100",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4145509986",
      "Familias": "Telecomunicaciones",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Jose ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "14/08/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "15/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio telecomunicación",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4235,
      "Title": "Forms",
      "Fecha_solicitud": "11/08/2023",
      "Correo_solicitante": "ppelaez@bancolombia.com.co",
      "Nombre_solicitante": "Paula Andrea Pelaez Vivanco",
      "Nombre_iniciativa": "ID 4235 - Crédio de Consumo como Servicio",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Los clientes vinculados al producto Consumo como servicio actuarán como plataforma desde la cual se podrán exponer y colocar créditos de consumo de libre inversión lo cual dará lugar a un pago de comisión atado a los montos desembolsados. \nDesde la EVC de Banking as a Service tenemos un producto en el cual le ofrecemos a los clientes la posibilidad de realizar compras de productos y servicios a través de un crédito de consumo libre inversión, ofreciendo la posibilidad adicional de desembolsar dinero adicional a su cuenta propia … de acuerdo al valor de la compra y el desembolso puede haber lugar al pago de una comisión al tercero (comercio) por exponer el cupo en su canal",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "Se tiene proyectado desde la EVC por caso de negocio",
      "Proveedores_conocidos": "VALIDDA SAS.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Banking as a Service",
      "Nombre_lider_EVC": "Carolina Giraldo Giraldo",
      "SR_ARIBA": "SR4148356890",
      "Familias": "Ventas Digitales",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Diana indica que esto es netamente comercial y se debe delegar pues es para vincular al proveedor.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "16/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "16/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Modelos de Relacionamiento Integral",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4234,
      "Title": "Forms",
      "Fecha_solicitud": "11/08/2023",
      "Correo_solicitante": "esgoez@bancolombia.com.co",
      "Nombre_solicitante": "Esteban Goez Jaramillo",
      "Nombre_iniciativa": "ID 4234 - Pagos de créditos en la web para créditos Nequi",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Contratación del servicio de pasarela de pagos y habilitación de PSE como medio de pago de los créditos en Nequi.",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "30 000 000",
      "Proveedores_conocidos": "Wompi",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "C102200200 Dirección de Estrategia y Dllo de Negocio",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4143349609",
      "Familias": "Pasarelas de Pago",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Sara Quintero Perez",
      "Rol_asesor": "Adriana Maria Arango Restrepo",
      "Observaciones": "Dianis ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "18/08/2023",
      "Fecha Asignación/Delegación": "18/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "11/08/2023",
      "Fecha ok. PN": "11/08/2023",
      "sin equipo": "Ciber",
      "Áreas pendientes": "15/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Medios de Pago",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4233,
      "Title": "power_apps",
      "Fecha_solicitud": "11/08/2023",
      "Correo_solicitante": "PJALVARA@bancolombia.com.co",
      "Nombre_solicitante": "Pedro Juan Alvaran Gonzalez",
      "Nombre_iniciativa": "ID 4233 - Renovación licencias software computación forense Cellebrite Physical Analyzer, Cellebrite UFED",
      "Tipo_Requerimiento": "Renovación",
      "CW_a_renovar": "NA",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación software computación forense : Cellebrite Physical Analyzer, Cellebrite UFED (4PC and Touch3).\nHerramientas de computación forense, son programas que usamos para apoyar la investigación de fraudes monetarios por internet, o para apoyar la investigación interna de algún colaborador del Banco al cual tenemos que revisar su computador o su celular con estos programas.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "$14000 USD",
      "Proveedores_conocidos": "Cellebrite Enterprise Solutions <Enterprise.Solutions@engage.cellebrite.com>",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "VICEPRESIDENCIA SERV PARA CLIENTES Y EMPLEADOS",
      "Nombre_area_y_ceco": "Gerencia Inteligencia y Reacción de Ciberseguridad",
      "Nombre_lider_EVC": "Ferney de Jesus Taborda Araque",
      "SR_ARIBA": "SR4143349593",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Leidy Tatiana Tangarife Gonzalez",
      "Rol_asesor": "Monica Marcela Alzate Granda",
      "Observaciones": "Naty, es renovación, proveedor riesgo 4 no va a PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "25/08/2023",
      "Fecha Asignación/Delegación": "25/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "11/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4232,
      "Title": "power_apps",
      "Fecha_solicitud": "11/08/2023",
      "Correo_solicitante": "PJALVARA@bancolombia.com.co",
      "Nombre_solicitante": "Pedro Juan Alvaran Gonzalez",
      "Nombre_iniciativa": "ID 4232 - Renovación licencias de computación forense con MAGNET FORENSICS",
      "Tipo_Requerimiento": "Renovación",
      "CW_a_renovar": "NA",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación Software de computación forense X 3 licencias.\nHerramientas de computación forense, son programas que usamos para apoyar la investigación de fraudes monetarios por internet, o para apoyar la investigación interna de algún colaborador del Banco al cual tenemos que revisar su computador o su celular con estos programas.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "$14000 USD",
      "Proveedores_conocidos": "MAGNET FORENSICS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "VICEPRESIDENCIA SERV PARA CLIENTES Y EMPLEADOS",
      "Nombre_area_y_ceco": "Gerencia Inteligencia y Reacción de Ciberseguridad",
      "Nombre_lider_EVC": "Ferney de Jesus Taborda Araque",
      "SR_ARIBA": "SR4143349575",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Leidy Tatiana Tangarife Gonzalez",
      "Rol_asesor": "Monica Marcela Alzate Granda",
      "Observaciones": "Naty es renovación, proveedor riesgo 3 no va a PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "25/08/2023",
      "Fecha Asignación/Delegación": "25/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "11/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4231,
      "Title": "Forms",
      "Fecha_solicitud": "11/08/2023",
      "Correo_solicitante": "cpcarvaj@bancolombia.com.co",
      "Nombre_solicitante": "Claudia Patricia Carvajal Paiba",
      "Nombre_iniciativa": "ID 4231 - Breathwork Sutil, Respiración y Meditación",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Taller que fortalecerá al equipo legal en técnicas que permitirán la concentración, manejo de ansiedad y estrés para las situaciones difíciles que día a día deben enfrentar para la defensa jurídica de Bancolombia y sus filiales.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Area funcional",
      "Valor_presupuesto": 4000000,
      "Proveedores_conocidos": "Andrea Halaby - 43743070",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Dirección Jurídicade Procesos C102400080",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4231,
      "Familias": "Convenios y Beneficios",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "11/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "11/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4230,
      "Title": "Forms",
      "Fecha_solicitud": "11/08/2023",
      "Correo_solicitante": "lmnieto@bancolombia.com.co",
      "Nombre_solicitante": "Lina Marcela Nieto Ruendes",
      "Nombre_iniciativa": "ID 4230 - Identificación de material de una factura",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "solicitar material en el cual lo debería facturar",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Honorarios parciales y descontados para la asesoría legal Emisión Bonos. (abogados)",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Gomez Pinzon",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Corporativo",
      "Nombre_lider_EVC": "Sara Mejia",
      "SR_ARIBA": 4230,
      "Familias": "Servicios Legales",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "11/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "11/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios Profesionales Procesos del Negocio",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4229,
      "Title": "Forms",
      "Fecha_solicitud": "11/08/2023",
      "Correo_solicitante": "JORGVALD@Bancolombia.com.co",
      "Nombre_solicitante": "Jorge Valderrama Betancur",
      "Nombre_iniciativa": "ID 4229 - Contratación Desarrollo como Servicio",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere contratar un desarrollo como servicio con el proveedor Sophos, con los cuales se construirá un nuevo componente para el aliado EDN en conjunto con Factoring Bancolombia.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "500.000.000",
      "Proveedores_conocidos": "Sophos",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Factoring C103500007",
      "Nombre_lider_EVC": "Jorge Valderrama Betancur",
      "SR_ARIBA": "SR4143300122",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Angie Lorena Castrillon Palacio",
      "Rol_asesor": "Adriana Maria Arango Restrepo",
      "Observaciones": "Jose ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "18/08/2023",
      "Fecha Asignación/Delegación": "18/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "11/08/2023",
      "Fecha ok. PN": "11/08/2023",
      "sin equipo": "Continuidad",
      "Áreas pendientes": "17/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4228,
      "Title": "Forms",
      "Fecha_solicitud": "11/08/2023",
      "Correo_solicitante": "mjcarden@bancolombia.com.co",
      "Nombre_solicitante": "Maria Jose Cardenas Bravo",
      "Nombre_iniciativa": "ID 4228 - Contrato Bancolombia Willis Towers Watson",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Conocer contrato",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere contrato de Bancolombia Willis para revisión juridica.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "WILLIS TOWERS WATSON",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "SEGUROS SUFI - C105000009",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR No requerido",
      "Familias": "Servicios Legales",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Contención",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Ago. 11 se le informa al usuario por correo, quien es el negociador a cargo para que hable con ella: Andrea Diaz Soto.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "11/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios Profesionales Procesos del Negocio",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4227,
      "Title": "Forms",
      "Fecha_solicitud": "10/08/2023",
      "Correo_solicitante": "mobernal@bancolombia.com.co",
      "Nombre_solicitante": "Monica Yineth Bernal Gomez",
      "Nombre_iniciativa": "ID 4227 - PRG_2023_2503128 - PATROCINIO MUNICIPIO DE CORINTO 2023",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "VINCUAR PROVEEDOR Y GENERAR PEDIDO SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "SUMINISTRO DE 35 ALMUERZOS PARA ASISTENTES DEL EVENTO EXPO EMPRENDIMIENTO TRABAJEMOS POR EL CAMPO.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "LESLYE ADRIANA REYES GARCIA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "PATROCINIOS GOBIERNO DE RED - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4227,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "11/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "11/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4226,
      "Title": "Forms",
      "Fecha_solicitud": "10/08/2023",
      "Correo_solicitante": "luferodr@bancolombia.com.co",
      "Nombre_solicitante": "Luis Fernando Rodriguez Canaveral",
      "Nombre_iniciativa": "ID 4226 - RENOVACION CONTRATO CW2293644 Operación de impuesto de vehiculos en favor de la gobernación de Boyacá",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2293644",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "SE REQUIERE LA RENOVACION DEL CONTRATO CW2293644 SERVICIO DE PROCESAMIENTO DE INFORMACIÓN ELECTRÓNICA GOBERNACION DE BOYACA",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "3.000.000.000",
      "Proveedores_conocidos": "THOMAS GREG & SONS DE COLOMBIA S.A",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C105500103\tSECCION EVOLUCION RECAUDO PAGO IMPUESTOS",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4142087071",
      "Familias": "Redes",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Ok PN, pero sin equipo",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Dianis en Ariba quedó con la nueva familia: PORTALES DIGITALES GOBIERNO.  \nago 18 se le recierda al usuario la gestión de PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "11/08/2023",
      "Fecha ok. PN": "23/08/2023",
      "sin equipo": "Ciber, SOX",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Medios de Pago",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4225,
      "Title": "Forms",
      "Fecha_solicitud": "10/08/2023",
      "Correo_solicitante": "ANIEBLES@bancolombia.com.co",
      "Nombre_solicitante": "Angel David Niebles Anzola",
      "Nombre_iniciativa": "ID 4225 - Contratación Enlaces Starlink",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere legalizar el servicio de enlaces Starlink con los proveedores Cirion y IFX",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "300 millones mes",
      "Proveedores_conocidos": "CIRION y IFX",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "ADC DISEÑO Y OPERACION TELCO TI",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4142087057",
      "Familias": "Telecomunicaciones",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Jose, de acuerdo a solicitud de made, por correo de ago. 10, esto no va a PN, que tu estás enterado.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "11/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio telecomunicación",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4224,
      "Title": "Forms",
      "Fecha_solicitud": "10/08/2023",
      "Correo_solicitante": "suholgui@bancolombia.com.co",
      "Nombre_solicitante": "Susana Holguin Cano",
      "Nombre_iniciativa": "ID 4224 - Pago de honorarios Asesor Externo. Compensacion Bilateral.",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Pagar unos honorarios  Asesor Externo. Compensacion Bilateral.",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Asesoría para solicitarle a la DIAN un concepto de exención para la compensación interbancaria Bilateral.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Adriana Gisela Monsalve Agamez",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "C102200130",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4224,
      "Familias": "Servicios Legales",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "11/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "11/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios Profesionales Procesos del Negocio",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4223,
      "Title": "Forms",
      "Fecha_solicitud": "10/08/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 4223 - Compra de curso de extensión HR TECHNOLOGY CONFERENCE & EXPOSITION\tHUMAN RESOURCE EXECUTIVE",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión HR TECHNOLOGY CONFERENCE & EXPOSITION\tHUMAN RESOURCE EXECUTIVE",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "HUMAN RESOURCE EXECUTIVE",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4223,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "10/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "10/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4222,
      "Title": "Forms",
      "Fecha_solicitud": "10/08/2023",
      "Correo_solicitante": "RUCARDEN@bancolombia.com.co",
      "Nombre_solicitante": "Ruben Dario Cardenas Henao",
      "Nombre_iniciativa": "ID 4222 - Renovación Homini 2022 2023, contrato CW2236278",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2236278",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación Servicio Biométrico de voz, contrato CW2236278",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "$27.120.731",
      "Proveedores_conocidos": "Homini",
      "Cuadrante_Proveedor": 1,
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Capacidades Ciberseguridad CC: C103500075",
      "Nombre_lider_EVC": "Ruben Dario Cardenas Henao",
      "SR_ARIBA": "SR4141741625 (R)",
      "Familias": "Licenciamiento Ciberseguridad y Seguridad de la Información",
      "Categoría": "Seguridad",
      "¿Cómo se va a gestionar?": "Retirar Requerimiento",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Ago. 18 se cancela req. no gestionó PN a pesar que se le rcordó el 15 de agosto.  Se le notifica al usuario la cancelación el 18 de ago.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "18/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "10/08/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Ciberseguridad y seguridad de la información",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4221,
      "Title": "Forms",
      "Fecha_solicitud": "10/08/2023",
      "Correo_solicitante": "catcebal@bancolombia.com.co",
      "Nombre_solicitante": "Catalina Ceballos Atehortua",
      "Nombre_iniciativa": "ID 4221 - Vinculación proveedor ATL",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Pauta publicitaria a campañas de mercadeo",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "FEDERACION COLOMBIANA DE PRODUCTORES DE PAPA FEDEPAPA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C106500018",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4221,
      "Familias": "Pautas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "10/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "10/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4220,
      "Title": "Forms",
      "Fecha_solicitud": "10/08/2023",
      "Correo_solicitante": "catcebal@bancolombia.com.co",
      "Nombre_solicitante": "Catalina Ceballos Atehortua",
      "Nombre_iniciativa": "ID 4220 - Viculación proveedores ATL",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vinculación",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Pauta publicitaria a campañas de mercadeo",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "SERVICIOS PUBLICITARIOS POC S.A.S",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C106500018",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4220,
      "Familias": "Pautas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "10/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "10/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4219,
      "Title": "Forms",
      "Fecha_solicitud": "10/08/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 4219 - Compra de curso de extensión XVI CONGRESO DE AUDITORÍA INTERNA\tINSTITUTO DE AUDITORES INTERNOS DE COLOMBIA",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión XVI CONGRESO DE AUDITORÍA INTERNA\tINSTITUTO DE AUDITORES INTERNOS DE COLOMBIA",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "INSTITUTO DE AUDITORES INTERNOS DE COLOMBIA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4219,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "10/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "10/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4218,
      "Title": "Forms",
      "Fecha_solicitud": "10/08/2023",
      "Correo_solicitante": "anrendon@bancolombia.com.co",
      "Nombre_solicitante": "Ana Maria Rendon Lopez",
      "Nombre_iniciativa": "ID 4218 - Inscripción al evento money 20/20",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "inscripción de varios directivos de Nequi al evento Money 20/ 20 que se realizará en la ciudad de Las vegas en el mes de octubre",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 14000000,
      "Proveedores_conocidos": "Evento-Money 20/20",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "C475000000 talento humano",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4218,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "10/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "10/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4217,
      "Title": "Forms",
      "Fecha_solicitud": "10/08/2023",
      "Correo_solicitante": "saracard@bancolombia.com.co",
      "Nombre_solicitante": "Sara Cardona Lopez",
      "Nombre_iniciativa": "ID 4217 - Adquisición de souvenires para APIverso 2023",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Adquisición de botones, stickers para souvenires evento APIverso 2023",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 30000000,
      "Proveedores_conocidos": "Color liquido",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Servicios de Integración y APIs C102200042",
      "Nombre_lider_EVC": "Yenny Paulina Sanchez Lopez",
      "SR_ARIBA": 4217,
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "10/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "10/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4216,
      "Title": "Forms",
      "Fecha_solicitud": "10/08/2023",
      "Correo_solicitante": "saracard@bancolombia.com.co",
      "Nombre_solicitante": "Sara Cardona Lopez",
      "Nombre_iniciativa": "ID 4216 - Servicio Catering",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Servicio de Catering para evento APIverso 2023",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 30000000,
      "Proveedores_conocidos": "Milkytree",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Servicios de Integración y APIs C102200042",
      "Nombre_lider_EVC": "Yenny Paulina Sanchez Lopez",
      "SR_ARIBA": 4216,
      "Familias": "BTL",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "10/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "10/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4215,
      "Title": "Forms",
      "Fecha_solicitud": "10/08/2023",
      "Correo_solicitante": "saracard@bancolombia.com.co",
      "Nombre_solicitante": "Sara Cardona Lopez",
      "Nombre_iniciativa": "ID 4215 - Alquiler de materiales para montar escensario de evento en Dirección General",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Con Brandex se hizo cotización para montar un escenario para dar un evento en Dirección General. La cotización está acorde al presupuesto.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 30000000,
      "Proveedores_conocidos": "Brandex",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Servicios de Integración y APIs C102200042",
      "Nombre_lider_EVC": "Yenny Paulina Sanchez Lopez",
      "SR_ARIBA": 4215,
      "Familias": "BTL",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "10/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "10/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4214,
      "Title": "Forms",
      "Fecha_solicitud": "10/08/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 4214 - Compra de curso de extensión X Cumbre INCP - INCP Instituto Nacional de Contadores Públicos",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión X Cumbre INCP - INCP Instituto Nacional de Contadores Públicos",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "INCP Instituto Nacional de Contadores Públicos",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4214,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "10/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "10/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4213,
      "Title": "Forms",
      "Fecha_solicitud": "10/08/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 4213 -  Compra de curso de extensión CONGRESO NACIONAL DE LA INFRAESTRUCTURA\tCÁMARA COLOMBIANA DE LA INFRAESTRUCTURA",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión CONGRESO NACIONAL DE LA INFRAESTRUCTURA\tCÁMARA COLOMBIANA DE LA INFRAESTRUCTURA",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "CÁMARA COLOMBIANA DE LA INFRAESTRUCTURA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4213,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "10/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "10/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4212,
      "Title": "Forms",
      "Fecha_solicitud": "10/08/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 4212 - Compra de curso de extensión XVIII CONGRESO NACIONAL DE SALUD \tCONSULTOR SALUD",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión XVIII CONGRESO NACIONAL DE SALUD \tCONSULTOR SALUD",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "CONSULTOR SALUD",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4212,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "10/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "10/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4211,
      "Title": "Forms",
      "Fecha_solicitud": "10/08/2023",
      "Correo_solicitante": "memorale@bancolombia.com.co",
      "Nombre_solicitante": "Maria Paulina Echeverri Morales",
      "Nombre_iniciativa": "ID 4211 - Arrendamiento Casa Gabo Cartagena",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Requerimos alquilar La Casa Gabo en Cartagena, el día 17 de agosto para un coctel con clientes",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "USD 5.000",
      "Proveedores_conocidos": "INMOBILIARIA BUSTAMANTE S.A.S - NIT. 800.000.582-7",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Vicepresidencia de mercadeo - gerencia de fidelización",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4211,
      "Familias": "BTL",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "10/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "10/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4210,
      "Title": "Forms",
      "Fecha_solicitud": "10/08/2023",
      "Correo_solicitante": "carolmar@bancolombia.com.co",
      "Nombre_solicitante": "Carolina Marin Salazar",
      "Nombre_iniciativa": "ID 4210 - Renovación contrato Monotype CW2287958",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2287958",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere renovar el contrato CW2287958 Monotype que nos permite usar tipos de letra que se usan en la App Empresas",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "estamos en el proceso del CAE",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Monotype",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Distribución Digital Negocios",
      "Nombre_lider_EVC": "Millerley Gonzalez García",
      "SR_ARIBA": "SR4141206587",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Nicolas Quiceno Carmona",
      "Rol_asesor": "Monica Marcela Alzate Granda",
      "Observaciones": "Naty es renovación y proveedor riesgo 3 no va a PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "11/08/2023",
      "Fecha Asignación/Delegación": "11/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "10/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4209,
      "Title": "Forms",
      "Fecha_solicitud": "09/08/2023",
      "Correo_solicitante": "raymon.pichardo@banistmo.com",
      "Nombre_solicitante": "Raymon Jose Pichardo Noguera",
      "Nombre_iniciativa": "ID 4209 - Soporte L1 Sophos para Nequi Panamá",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Soporte de primer nivel en Finacle 11.11 para Nequi Panamá",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "16.000$",
      "Proveedores_conocidos": "Sophos",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "Nequi",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4140925571",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Fábricas de Negociación",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "10/08/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4208,
      "Title": "Forms",
      "Fecha_solicitud": "09/08/2023",
      "Correo_solicitante": "yequinte@bancolombia.com.co",
      "Nombre_solicitante": "Yenifer Quintero Quiceno",
      "Nombre_iniciativa": "ID 4208 - Patrocinio al municipio de Dabeiba Antioquia",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Hacer un pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor produce balones con la imagen de Bancolombia y los distribuye por todas las regiones",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Segundo Adán Neita Fonseca - Arcueros deportes Monguí CC: 4168847",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gobierno de Red - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4208,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "10/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "10/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4207,
      "Title": "Forms",
      "Fecha_solicitud": "09/08/2023",
      "Correo_solicitante": "iclondon@bancolombia.com.co",
      "Nombre_solicitante": "Isabel Cristina Londono Mesa",
      "Nombre_iniciativa": "ID 4207 - Revisar opción de migrarnos a SaaS para Clreditlens y para ALM",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2271032 - Credit lens y CW2244795- ALM",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere analizar si nos debemos ir a modalidad de SaaS, en lugar de licenciamiento instalado en nuestra infraestructura nube.\ncontratos CW2271032 - Credit lens y CW2244795- ALM",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "hoy contamos con el presupuesto de licencimiento , justo el análisis incluye el análisis de costos",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Moodys Analytics",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Gestión Integral de Riesgos , CC C103500214",
      "Nombre_lider_EVC": "Jhoana Cristina Garcia Valbuena e Isabel Cristina Londoño Mesa",
      "SR_ARIBA": "SR4140925557",
      "Familias": "Servicios SaaS",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Daniela Alvarez Montoya",
      "Rol_asesor": "Adriana Maria Arango Restrepo",
      "Observaciones": "Jose ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "18/08/2023",
      "Fecha Asignación/Delegación": "18/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "10/08/2023",
      "Fecha ok. PN": "10/08/2023",
      "sin equipo": "Continuidad",
      "Áreas pendientes": "17/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de plataformas",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4206,
      "Title": "Forms",
      "Fecha_solicitud": "09/08/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 4206 - Compra de curso de extensión CURSO DE ESPECIALIZACIÓN LA NUEVA GESTIÓN DEL APRENDIZAJE CORPORATIVO",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión CURSO DE ESPECIALIZACIÓN LA NUEVA GESTIÓN DEL APRENDIZAJE CORPORATIVO - B & T MEETINGS E.I.R.L.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "B & T MEETINGS E.I.R.L.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4206,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "10/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "10/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4205,
      "Title": "Forms",
      "Fecha_solicitud": "09/08/2023",
      "Correo_solicitante": "lauralva@bancolombia.com.co",
      "Nombre_solicitante": "Laura Alvarez Tamayo",
      "Nombre_iniciativa": "ID 4205 - Renovación Contratación servicios Ajedrez Blitz  CW2290025 - OS3",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2290025 - OS3",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovar CW2290025 - OS3. Servicio con Blitz para implementación del ajedrez de Banca en Movimiento. Depende de presupuesto por parte de VP Talento y Cultura al EVC Talento, Cultura y Serv. Adtivos. Actualmente el Proveedor ya nos presta servicio. \nEl proveedor ejecutará servicios de SFTP (Secure File Transfer Protocol) para integración BLITZ",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 10.08,
      "Proveedores_conocidos": "SIEENA - Blitz",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "VP Talento y Cultura",
      "Nombre_lider_EVC": "EVC Talento y Cultura",
      "SR_ARIBA": "SR4140835656",
      "Familias": "Servicios SaaS",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Andres Felipe Meneses Vergara",
      "Rol_asesor": "Adriana Maria Arango Restrepo",
      "Observaciones": "Jose ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "18/08/2023",
      "Fecha Asignación/Delegación": "18/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "10/08/2023",
      "Fecha ok. PN": "10/08/2023",
      "sin equipo": "Ciber",
      "Áreas pendientes": "16/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de plataformas",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4204,
      "Title": "Forms",
      "Fecha_solicitud": "09/08/2023",
      "Correo_solicitante": "anrendon@bancolombia.com.co",
      "Nombre_solicitante": "Ana Maria Rendon Lopez",
      "Nombre_iniciativa": "ID 4204 - Espacio de trabajo en equipo para el grupo directivo de Nequi",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "se realizará una actividad de un dia con el grupo primario de Nequi para profundizar el trabajo en equipo",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 6000000,
      "Proveedores_conocidos": "Palenque Tours",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "Talento humano C475000000",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4204,
      "Familias": "Servicios Profesionales de Bienestar al Personal",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4203,
      "Title": "Forms",
      "Fecha_solicitud": "09/08/2023",
      "Correo_solicitante": "jmpulgar@bancolombia.com.co",
      "Nombre_solicitante": "John Mauricio Pulgarin",
      "Nombre_iniciativa": "ID 4203 - COMPRA JUGUETERIA Y SELECCIÓN A TRAVES DE PLATAFORMA Y ENTREGA A LOS EMPLEADOS",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "ACTUALIZACION PROVEEDOR",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "COMPRA JUGUETERIA Y SELECCIÓN A TRAVES DE PLATAFORMA Y ENTREGA A LOS EMPLEADOS",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "ALMACENES MAXIMO SAS (PEPE GANGA) 860045854-7",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GERENCIA DE BIENESTAR C103200030",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4203,
      "Familias": "Eventos y Reconocimientos al Empleado",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4202,
      "Title": "Forms",
      "Fecha_solicitud": "09/08/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 4202 - Compra de curso de extensión STEP LATAM CONFERENCE 2023\tSTEP LATAM CONFERENCESUPPORT SERVICES INC",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión STEP LATAM CONFERENCE 2023\tSTEP LATAM CONFERENCESUPPORT SERVICES INC",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "STEP LATAM CONFERENCESUPPORT SERVICES INC",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "VALORES BANCOLOMBIA C502000000",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4202,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4201,
      "Title": "Forms",
      "Fecha_solicitud": "09/08/2023",
      "Correo_solicitante": "rgroldan@bancolombia.com.co",
      "Nombre_solicitante": "Ruben Gonzalo Roldan Agudelo",
      "Nombre_iniciativa": "ID 4201 - Renovación Tarifa Contrato Schneider Electric CW2252312",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2252312",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere renovar las tarifas del contrato CW2252312 Schneider Electric de Colombia SAS para la vigencia 2023 - 2024.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "$28'780.494,25 COP Mensual",
      "Proveedores_conocidos": "Schneider Electric de Colombia SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia Administración del Activo (GAA), CeCo: C104300029",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4139257981",
      "Familias": "HARD (Operadores de Mantenimiento)",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Carlos Andres Ramos Ospina",
      "Rol_asesor": "No aplica",
      "Observaciones": "Naty es renovación, proveedor riesgo 3 no va a PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "11/08/2023",
      "Fecha Asignación/Delegación": "11/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Facility Managment",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4200,
      "Title": "Forms",
      "Fecha_solicitud": "09/08/2023",
      "Correo_solicitante": "rgroldan@bancolombia.com.co",
      "Nombre_solicitante": "Ruben Gonzalo Roldan Agudelo",
      "Nombre_iniciativa": "ID 4200 - Renovación Contrato Vertiv CW2296429 (7215)",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2296429 (7215)",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere gestionar la renovación del contrato de prestación de servicios de mantenimiento preventivo y correctivo a equipos ups y otros equipos electromecánicos para el Centro Operativo Bancolombia y el edificio de Gestión. CW2296429 (7215)",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "$42'524.241,58 COP Mensual",
      "Proveedores_conocidos": "VERTIV COLOMBIA S.A.S",
      "Cuadrante_Proveedor": 3,
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia Administración del Activo (GAA), CeCo: C104300029",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4139249777",
      "Familias": "HARD (Operadores de Mantenimiento)",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Luis Guillermo Salcedo Valderrama",
      "Rol_asesor": "No aplica",
      "Observaciones": "Naty, es renovación, proveedor riesgo 3 no va a PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "11/08/2023",
      "Fecha Asignación/Delegación": "11/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Facility Managment",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4199,
      "Title": "Forms",
      "Fecha_solicitud": "09/08/2023",
      "Correo_solicitante": "scasalin@bancolombia.com.co",
      "Nombre_solicitante": "Scarlett De Jesus Casalins Pertuz",
      "Nombre_iniciativa": "ID 4199 - Alianza para participación activa en los eventos organizados por la cámara de comercio de cartagena",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "proceso de evalución,  generar OC y MIGO",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Alianza para participación activa en los eventos organizados por la cámara de comercio de cartagena - Año de de las relaciones",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "CAMARA DE COMERCIO DE CARTAGENA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GERENCIA DE GESTIÓN COMERCIAL CARIBE C102100403",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4199,
      "Familias": "Suscripciones",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios de Información",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4198,
      "Title": "Forms",
      "Fecha_solicitud": "09/08/2023",
      "Correo_solicitante": "NANURIBE@bancolombia.com.co",
      "Nombre_solicitante": "Nancy Milena Uribe Cardona",
      "Nombre_iniciativa": "ID 4198 - Reserva salones  en Palmira para talleres Hechos de Corazón región sur",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Reserva salones  en Palmira para talleres Hechos de Corazón región sur",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 0,
      "Proveedores_conocidos": "Club Campestre de Palmira",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Gerencia de Aprendizaje-C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4198,
      "Familias": "Otros Servicios Bienes Inmuebles - Muebles",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Gestión Inmobiliaria",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4197,
      "Title": "Forms",
      "Fecha_solicitud": "09/08/2023",
      "Correo_solicitante": "carlotru@bancolombia.com.co",
      "Nombre_solicitante": "Carlos Esteban Trujillo Jaramillo",
      "Nombre_iniciativa": "ID 4197 - Contratación de licencias CRM, Calidad y grabación de pantalla",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere contratar con el aliado emtelco el alquiler del licenciamiento necesario en CRM de asesor, plataforma de calidad para realizar valoraciones, grabación de pantalla  y reportes que no fueron contemplados desde el RFP y son necesarios para la operación del servicio Back Office de documentos.\nEs un alquiler de software que es necesario para operar el back Office",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "1.000.000.000",
      "Proveedores_conocidos": "Emtelco",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Distribución a distancia",
      "Nombre_lider_EVC": "Cristina Duque Jaramillo",
      "SR_ARIBA": "SR4139168653",
      "Familias": "Licenciamiento Mayor",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Ok PN, pero sin equipo",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Validando con Biatri y Diana, si lo debe atender procesos, para tener toda la trazabilidad del backoffice,.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "22/08/2023",
      "Fecha ok. PN": "22/08/2023",
      "sin equipo": "Ciber",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4196,
      "Title": "Forms",
      "Fecha_solicitud": "09/08/2023",
      "Correo_solicitante": "loblando@bancolombia.com.co",
      "Nombre_solicitante": "Lorena Patricia Blandon Acevedo",
      "Nombre_iniciativa": "ID 4196 - pago informacion soluciones solares",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "generar pedido es sap",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "pagar por informacion generada por solucion solar que hace parte de piloto en tenderos",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "CELSIA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "SOSTENIBILIDAD C102200063",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4196,
      "Familias": "Consultas Especializadas",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios de Información",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4195,
      "Title": "Forms",
      "Fecha_solicitud": "09/08/2023",
      "Correo_solicitante": "nigarcia@bancolombia.com.co",
      "Nombre_solicitante": "Nicolas Garcia Mejia",
      "Nombre_iniciativa": "ID 4195 - Proceso Facturación servicio Valoración Cobre",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Pago a proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor realizó la valoración de la compañía cobre y se debe realizar el pago de la cuenta de cobro generada",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Daniel josé Motta Díaz",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Innovación Abierta Centro de costos: C102200010",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4195,
      "Familias": "Consultorias Corporativas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "10/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "10/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Consultorias Corporativas",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4194,
      "Title": "Forms",
      "Fecha_solicitud": "09/08/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 4194 - Producción de Cuadernos para empleados Y conferencias sobre sensibilización en el uso del cuaderno",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Producción de Cuadernos para empleados Y conferencias sobre sensibilización en el uso del cuaderno - FUNDACION EDUCAMBIO",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "FUNDACION EDUCAMBIO",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Servicios de Talento y Cultura - Centro de costos que asume: C103200071",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4194,
      "Familias": "Servicios Profesionales Formación y Entrenamiento",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4193,
      "Title": "Forms",
      "Fecha_solicitud": "09/08/2023",
      "Correo_solicitante": "jagomez@bancolombia.com.co",
      "Nombre_solicitante": "Jaime Andres Gomez Cifuentes",
      "Nombre_iniciativa": "ID 4193 - Contratación de servicio de product owner para Nequi en proyecto de implementación de Herramienta de Tesorería",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Nequi está próximo a abordar el proyecto Core de tesorería con el proveedor Finastra y su sistema de operaciones de tesorería a través de la aplicación Kondor. En este punto se requiere el apoyo de un equipo de Oficina de Proyecto, así:\n• Project Manager\n• Consultor Funcional\n• Defect Manager",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 500000000,
      "Proveedores_conocidos": "NTT DATA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "C472000000",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4138434330",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Daniela Delgado Cadavid",
      "Rol_asesor": "Adriana Maria Arango Restrepo",
      "Observaciones": "Jose ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "18/08/2023",
      "Fecha Asignación/Delegación": "18/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "09/08/2023",
      "Fecha ok. PN": "09/08/2023",
      "sin equipo": "Ciber",
      "Áreas pendientes": "11/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4192,
      "Title": "Forms",
      "Fecha_solicitud": "08/08/2023",
      "Correo_solicitante": "jmpulgar@bancolombia.com.co",
      "Nombre_solicitante": "John Mauricio Pulgarin",
      "Nombre_iniciativa": "ID 4192 -  Renovación orden de servicio 1: CW2288618 - SIGESA aplicativo para administración del Sistema de Gestión en Seguridad y Salud en el",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2288618",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación orden de servicio 1: CW2288618 SIGESA aplicativo para administración del Sistema de Gestión en Seguridad y Salud en el Trabajo SG-SST",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "400.000.000",
      "Proveedores_conocidos": "PSICOLOGIA OCUPACIONAL S.A.S. 9004757293",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GERENCIA DE BIENESTAR C103200030",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4138981671",
      "Familias": "Servicios SaaS",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Katherine Sanchez Henao",
      "Rol_asesor": "Monica Marcela Alzate Granda",
      "Observaciones": "Naty ok PN\nEs de los licenciamientos menores, que están como un saas menor",
      "Comentarios BP": "",
      "Fecha MarketPlace": "25/08/2023",
      "Fecha Asignación/Delegación": "25/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "09/08/2023",
      "Fecha ok. PN": "10/08/2023",
      "sin equipo": "Ciber",
      "Áreas pendientes": "23/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de plataformas",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4191,
      "Title": "Forms",
      "Fecha_solicitud": "08/08/2023",
      "Correo_solicitante": "monmarin@bancolombia.com.co",
      "Nombre_solicitante": "Monica Alejandra Marin Hoyos",
      "Nombre_iniciativa": "ID 4191 - Renovación contrato CW2267779. Mtto locativo y eléctrico menor",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2267779",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación contrato CW2267779. Mtto locativo y eléctrico menor\nServicios de mantenimiento preventivo, correctivo de cableado eléctrico de oficinas, sedes administrativas y cajeros",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "120.000.000",
      "Proveedores_conocidos": "INVERSIONES FERNANDO IRAL  S.A.S.",
      "Cuadrante_Proveedor": 4,
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Direccion gestion del activo",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4138981589",
      "Familias": "HARD (Operadores de Mantenimiento)",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Juan Pablo Ramirez Cardenas",
      "Rol_asesor": "No aplica",
      "Observaciones": "Naty es renovación, proveedor riesgo 4 no va a PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "11/08/2023",
      "Fecha Asignación/Delegación": "11/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Facility Managment",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4190,
      "Title": "Forms",
      "Fecha_solicitud": "08/08/2023",
      "Correo_solicitante": "jmpulgar@bancolombia.com.co",
      "Nombre_solicitante": "John Mauricio Pulgarin",
      "Nombre_iniciativa": "ID 4190 - VENTA ACCESORIOS Y ASESORÍAS Y CHARLAS EN DEPORTE",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "VINCULAR AL PROVEEDOR",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "VENTA ACCESORIOS Y ASESORÍAS Y CHARLAS EN DEPORTE",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Ejercicio Inteligente Group SAS\t901715505-5",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GERENCIA DE BIENESTAR C103200030",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4190,
      "Familias": "Convenios y Beneficios",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4189,
      "Title": "Forms",
      "Fecha_solicitud": "08/08/2023",
      "Correo_solicitante": "NACEBALL@bancolombia.com.co",
      "Nombre_solicitante": "Natalia Ceballos Quintero",
      "Nombre_iniciativa": "ID 4189 - INTERVENCIÓN CONTRATOS MERCADO DE CAPITALES",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere hacer una intervención a los contratos de mercado de capitales, que incluya la revisión y conocimiento de los contratos, revisión de tarifas y vencimientos, modelo de gobierno",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Porque es una intervención a los contratos con el fin de conocer , organizar y revisar eficiencias",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "varios",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GERENCIA DE SERVICIOS MESA DE DINERO",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4138910792",
      "Familias": "Servicios Bursátiles",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Luis Guillermo Salcedo Valderrama",
      "Rol_asesor": "No aplica",
      "Observaciones": "Naty porfa valida si lo dejamos con esta familia.  No va a PN de acuerdo a tu solicitud.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "11/08/2023",
      "Fecha Asignación/Delegación": "11/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Mercados de Capitales",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4188,
      "Title": "Forms",
      "Fecha_solicitud": "08/08/2023",
      "Correo_solicitante": "clzuluag@bancolombia.com.co",
      "Nombre_solicitante": "Claudia Patricia Zuluaga Mora",
      "Nombre_iniciativa": "ID 4188 - Legalización de servicio Alianza SGP para inicio de facturación",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular al proveedor para que pueda radicar su facturación.",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere legalizar el servicio para cobro en etapa avanzada realizado con Alianza SGP para que exista como proveedor de Nequi y sea posible radicar sus facturas.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Alianza SGP",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "Gerencia de Conciliacion - C473000004",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR No requerido",
      "Familias": "",
      "Categoría": "",
      "¿Cómo se va a gestionar?": "Contención",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Ago. 08 Por Teams usuaria solicita sea cancelado este requerimiento que ya no lo requiere,",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "08/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "Retirado",
      "Estado": "",
      "Subcategoría_F": "",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4187,
      "Title": "Forms",
      "Fecha_solicitud": "08/08/2023",
      "Correo_solicitante": "cahiguit@bancolombia.com.co",
      "Nombre_solicitante": "Carlos Mauricio Higuita Niebles",
      "Nombre_iniciativa": "ID 4187 - Contratación de servicios profesionales de desarrollo en cajeros marca Diebold y Wincor",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere realizar la contratación de los servicios profesionales de desarrollo al proveedor Diebold Nixdorf el cual le da soporte a la red de cajeros marca Diebold y Wincor en los componentes de software de la aplicación y de los elementos como lo es Sistema Operativo y XFS del cajero, además de actividades como cierre de imágenes de los cajeros y soporte a la producción.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "300.000.000",
      "Proveedores_conocidos": "Diebold Nixdorf",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC de Distribución Física - C103500234",
      "Nombre_lider_EVC": "Jose Jaime Tilano Vega",
      "SR_ARIBA": "SR4138981573",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Santiago Zapata Serna",
      "Rol_asesor": "No aplica",
      "Observaciones": "Familia de TI, pero atiende canales. Dianis ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "18/08/2023",
      "Fecha Asignación/Delegación": "18/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "09/08/2023",
      "Fecha ok. PN": "09/08/2023",
      "sin equipo": "Ciber",
      "Áreas pendientes": "15/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4186,
      "Title": "Forms",
      "Fecha_solicitud": "08/08/2023",
      "Correo_solicitante": "danparra@bancolombia.com.co",
      "Nombre_solicitante": "Daniel Parra Mejia",
      "Nombre_iniciativa": "ID 4186 - Preparación para Certified Information Security Manager (CISM)",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Contrataremos la formación para la preparación del Certified Information Security Manager (CISM) del equipo de ciberseguridad para un equipo de 20 personas.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "10.000.000",
      "Proveedores_conocidos": "Maribel Mesa Cardona",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GCIA DE APRENDIZAJE CI03200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4186,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4185,
      "Title": "Forms",
      "Fecha_solicitud": "08/08/2023",
      "Correo_solicitante": "yequinte@bancolombia.com.co",
      "Nombre_solicitante": "Yenifer Quintero Quiceno",
      "Nombre_iniciativa": "ID 4185 - Formación técnica a candidatos a las alcaldías",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Talleres locales en las diferentes subregiones del departamento con profundización en varios temas que son claves al rededor de un plan de gobierno.\nIdentificamos 2 grupos: 1.Candidatos que por algún motivo no estuvieron en las charlas de Gobiernos Conscientes y 2.Un grupo de candidatos que si estuvieron en Gobiernos Conscientes con los que se generó un relacionamiento y existe la oportunidad de profundizar temas específicos de la región.\nEste tipo de talleres y contactos nos van a abrir mucho la puerta ante futuros mandatarios que se van a posicionar el 1ro de enero del 2024, con los que ya se inició una agenda de trabajo.\n\nEl acompañamiento de un proveedor como GOBS que tiene conocimiento, experiencia y relacionamiento nos permite poder realizar estos talleres a los candidatos de una manera clara y asertiva. Adicionalmente, se ajusta a nuestro presupuestos para los talleres \n\nDesde cumplimiento nos están pidiendo mínimo 2 cotizaciones, pero no conocemos otro proveedor que nos pueda prestar el servicio y se ajuste a nuestro presupuesto",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "19.000.000",
      "Proveedores_conocidos": "GOBS-Estrategías Públicas SAS NIT: 900747313 -",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gobierno de Red - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4185,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4184,
      "Title": "Forms",
      "Fecha_solicitud": "08/08/2023",
      "Correo_solicitante": "juadagon@bancolombia.com.co",
      "Nombre_solicitante": "Juan David Gonzalez Toro",
      "Nombre_iniciativa": "ID 4184 - Renovacion CW2268274 - ORDEN DE SERVICIO DE CONCILIACION Y COBRANZA ETAPA CASTIGADA PARA SUFI - EMERGIA",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2268274",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "se requiere la renovación de la orden de servicio sin cambios en el proceso o tarifas. CW2268274",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "154.000.000",
      "Proveedores_conocidos": "EMERGIA",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Servicio de apoyo al Negocio Sufi  C105000210",
      "Nombre_lider_EVC": "Liliana Maria Cano Orlas",
      "SR_ARIBA": "SR4138910811 (R)",
      "Familias": "Servicios de Conciliación y Cobranza SUFI",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Retirar Requerimiento",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Biatri ok PN\nAgo. 18 Biatri solicita retirarlo, habia alcanzo a llevarlo al MP.  Dice que la renovación es automática y solo se requiere una carta, que Mateo Gutierrez lo está gestionando en tiempo administrativo.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "18/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "09/08/2023",
      "Fecha ok. PN": "09/08/2023",
      "sin equipo": "Ciber",
      "Áreas pendientes": "15/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios de Conciliación y Cobranza",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4183,
      "Title": "Forms",
      "Fecha_solicitud": "08/08/2023",
      "Correo_solicitante": "YAOSORIO@bancolombia.com.co",
      "Nombre_solicitante": "Yamileth Osorio Raga",
      "Nombre_iniciativa": "ID 4183 - Evento Zona Cauca y Nariño Agosto 2023",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Desbloquear al proveedor, generar un pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Alquiler sitio del evento, alimentación y elementos audiovisuales",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "CORPORACION CLUB COLOMBIA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C102100313",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4183,
      "Familias": "Otros Servicios Bienes Inmuebles - Muebles",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "08/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "08/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Gestión Inmobiliaria",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4182,
      "Title": "Forms",
      "Fecha_solicitud": "08/08/2023",
      "Correo_solicitante": "andcamar@bancolombia.com.co",
      "Nombre_solicitante": "Andrea Paola Camargo Maldonado",
      "Nombre_iniciativa": "ID 4182 - Vinculacion Proveedor Actividad Sincelejo",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular Proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere vinculación de proveedor para realizar actividades en Sincelejo",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": 64547120,
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Bienestar  c 103200170",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4182,
      "Familias": "Convenios y Beneficios",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "08/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "08/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4181,
      "Title": "Forms",
      "Fecha_solicitud": "08/08/2023",
      "Correo_solicitante": "xbenavid@bancolombia.com.co",
      "Nombre_solicitante": "Ximena Carolina Benavides Ibarra",
      "Nombre_iniciativa": "ID 4181 - Charla de aprendizaje en +Digital",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "vincular al proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Charla de aprendizaje en +Digital",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "DIANAURIBE.FM S.A.S",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Formación virtual C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4181,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "08/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "08/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4180,
      "Title": "Forms",
      "Fecha_solicitud": "08/08/2023",
      "Correo_solicitante": "carbarre@bancolombia.com.co",
      "Nombre_solicitante": "Carolina Barrera Galvis",
      "Nombre_iniciativa": "ID 4180 - Comprar licencia de adobe",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "No lo conozco",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "A nuestro equipo de contenidos entró otra persona que necesita usar la suite de adobe. La misma que tienen los demás,  la que tienen Carolina Monsalve  y Felipe Muñoz.\n \nCreé en USM el pedido  ID:          2956607.\n \nLa persona que entró al equipo se llama Marian Johanna Piedrahita Ramirez",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 4000000,
      "Proveedores_conocidos": "Adobe",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Gerencia de contenidos C106500014",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4136828648",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "John Alexis Velasquez Garcia",
      "Rol_asesor": "Monica Marcela Alzate Granda",
      "Observaciones": "Naty por la característica de la solicitud y teniendo en cuenta  que ya se ha comprado recientemente estas licencias, no lo envié a PN.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "11/08/2023",
      "Fecha Asignación/Delegación": "11/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "08/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4179,
      "Title": "Forms",
      "Fecha_solicitud": "08/08/2023",
      "Correo_solicitante": "GEDELGAD@bancolombia.com.co",
      "Nombre_solicitante": "German Eduardo Delgado Pabon",
      "Nombre_iniciativa": "ID 4179 - Patrocinio para festival del tiple y la guabina del Municipio de Velez - Santander",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la compra de tiple profesional que será utilizado en la premiación del festival de la guabina y tiple del Municipio de Vélez",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 2000000,
      "Proveedores_conocidos": "Fundacion Alvaro Quiroga",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Gobierno region centro 2 - Centro de Cosotos c102100151",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4179,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "08/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "08/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4178,
      "Title": "Forms",
      "Fecha_solicitud": "08/08/2023",
      "Correo_solicitante": "anchalar@bancolombia.com.co",
      "Nombre_solicitante": "Andres Fernando Chalarca Correa",
      "Nombre_iniciativa": "ID 4178 - Consultoría para estrategia de gestión del cambio",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Servicio de consultoría para estrategia de gestión del cambio y despliegue de las experiencias grupales",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "17.000.000",
      "Proveedores_conocidos": "ENSO",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C103200070",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4136317656",
      "Familias": "Consultorias Corporativas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "08/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "08/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Consultorias Corporativas",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4177,
      "Title": "Forms",
      "Fecha_solicitud": "04/08/2023",
      "Correo_solicitante": "JULBETAN@bancolombia.com.co",
      "Nombre_solicitante": "Julian David Betancur Arcia",
      "Nombre_iniciativa": "ID 4177 - PROCESO SARLAFT PROVEEDOR (ABOGADO)",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Buenas Tardes, requiero actualizar en Banco al Proveedor Abogado Max Artunduaga CC. 79157013, el cual le prestó un servicio al Banco y está pendiente de realizarle un pago. Realizando las validaciones encontramos que el abogado ha prestado servicios al Banco y que esta pendiente la actualización el tema de Sarlaft",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 350,
      "Proveedores_conocidos": "Max Artunduaga CC. 79157013",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Evolución Digital  - Centro de Costos C104600005",
      "Nombre_lider_EVC": "Carolina Arias Ramirez",
      "SR_ARIBA": 4177,
      "Familias": "Servicios Legales",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "04/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "04/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios Profesionales Procesos del Negocio",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4176,
      "Title": "Forms",
      "Fecha_solicitud": "04/08/2023",
      "Correo_solicitante": "cegarzon@bancolombia.com.co",
      "Nombre_solicitante": "Claudia Elizabeth Garzon Pachon",
      "Nombre_iniciativa": "ID 4176 - Renovación CW2277617 Licencias Banrepública- Licencias SAC SafeNet Authentication Client",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2277617",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Cada 3 años se debe renovar contrato CW2277617 con el proveedor NETWORK SOLUTIONS COMPANY LTDA NE las licencias de Banco República. La última renovación fue en 2020 y se realizó por 74 licencias, para un valor total de $8.982.120. Vigencia:1/08/2020 -01/08/2023. Es necesario realizar la renovación de manera urgente, para esta nueva vigencia la cantidad de licencias aumenta a 101, pero el proveedor aún no nos ha indicado el valor actual por licencia.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "Cada una de las áres debe garantizar el presupuesto para asumir esta gasto. Estamos pendientes el proveedor nos confirme el valor de cada licencia.",
      "Proveedores_conocidos": "NETWORK SOLUTIONS COMPANY LTDA NE",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Dirección Servicios Mercado de Capitales (81 licencias) - Gerencia Servicios de Recaudos y pagos (12 licencias) - Gerencia Servicios Captaciones \t(5 licencias) - Gerencia de Servicios Electrónicos y Efectivo\t(3 licencias)",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4132932422",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Luis Guillermo Salcedo Valderrama",
      "Rol_asesor": "Monica Marcela Alzate Granda",
      "Observaciones": "Naty ok PN con equipo completo.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "11/08/2023",
      "Fecha Asignación/Delegación": "11/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "04/08/2023",
      "Fecha ok. PN": "08/08/2023",
      "sin equipo": "Ciber",
      "Áreas pendientes": "09/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4174,
      "Title": "Forms",
      "Fecha_solicitud": "04/08/2023",
      "Correo_solicitante": "jefvelas@bancolombia.com.co",
      "Nombre_solicitante": "Jeferson Velasquez Ortiz",
      "Nombre_iniciativa": "ID 4174 - Talentos conocimientos especificos iSeries",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Servicio de  5 talentos con conocimientos en iSeries",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "1.100.000.000",
      "Proveedores_conocidos": "Accenture",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Distribución Fisica, C103500235",
      "Nombre_lider_EVC": "Jose Jaime Tilano",
      "SR_ARIBA": "SR4132932408",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Daniel Jimenez Delgado",
      "Rol_asesor": "No aplica",
      "Observaciones": "Jose va sin PN de cuerdo a tu instrucción.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "11/08/2023",
      "Fecha Asignación/Delegación": "11/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "10/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4173,
      "Title": "Forms",
      "Fecha_solicitud": "04/08/2023",
      "Correo_solicitante": "danromer@bancolombia.com.co",
      "Nombre_solicitante": "Daniela Andrea Romero Perez",
      "Nombre_iniciativa": "ID 4173 - Servicio de Desayuno para evento con clientes",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "proveedor no activo, se solcita hacer proceso de sarlaft",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Servicio de Desayuno para evento con clientes, alquiler de salón y ayuda audiovisual",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "COMPAÑÍA HOTELERA CARTAGENA DE INDIAS S.A.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C102100403",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4173,
      "Familias": "BTL",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "04/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "04/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4172,
      "Title": "Forms",
      "Fecha_solicitud": "04/08/2023",
      "Correo_solicitante": "jmpulgar@bancolombia.com.co",
      "Nombre_solicitante": "John Mauricio Pulgarin",
      "Nombre_iniciativa": "ID 4172 - Renovar contrato CW2286465 Alquiler bicis y patinetas",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2286465",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "RENOVAR CONTRATO CW2286465 PROVEEDOR MUVERANG NOS PRESTA EL SERVICIO DE PATINETAS Y BICIS PARA MEDELLIN Y BOGOTA PARA LOS EMPLEADOS",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "sI",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "120.000.000",
      "Proveedores_conocidos": "P.A FIDUCIARA -P.A. MUVERANG NIT 8300545390",
      "Cuadrante_Proveedor": 4,
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GERENCIA DE BIENESTAR C103200030",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4132610353",
      "Familias": "Convenios y Beneficios",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "04/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "04/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4171,
      "Title": "Forms",
      "Fecha_solicitud": "03/08/2023",
      "Correo_solicitante": "NANURIBE@bancolombia.com.co",
      "Nombre_solicitante": "Nancy Milena Uribe Cardona",
      "Nombre_iniciativa": "ID 4171 - Contratación de salones para evento Sur Extraordinaria en Pasto",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Contratación de salones para evento Sur Extraordinaria en Pasto",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 0,
      "Proveedores_conocidos": "V1501 SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Gerencia de Aprendizaje-C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4171,
      "Familias": "Otros Servicios Bienes Inmuebles - Muebles",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "04/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "04/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Gestión Inmobiliaria",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4170,
      "Title": "Forms",
      "Fecha_solicitud": "03/08/2023",
      "Correo_solicitante": "lorrego@bancolombia.com.co",
      "Nombre_solicitante": "Leidy Cristina Orrego Martinez",
      "Nombre_iniciativa": "ID 4170 - Renovación contrato CW2277517 Infobip",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2277517-CM",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación CW2277517. Servicio de WhatsApp.\nportal de servicios para conectar con WhatsApp. esta herramienta permita gestionar las solicitudes de los clientes con los agentes asignados",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Es área funcional",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Infobip",
      "Cuadrante_Proveedor": 3,
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "SECCION SERVICIOS INTELIGENCIA COBRANZA - C104300481",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4132932383",
      "Familias": "Servicios SaaS",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Isabella Correa Valencia",
      "Rol_asesor": "No aplica",
      "Observaciones": "Dianis es renovación, riesgo 3 no va a PN, familia de TI, pero tema de tu categoría.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "11/08/2023",
      "Fecha Asignación/Delegación": "11/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "04/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de plataformas",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4169,
      "Title": "Forms",
      "Fecha_solicitud": "03/08/2023",
      "Correo_solicitante": "danicast@bancolombia.com.co",
      "Nombre_solicitante": "Daniela Castano Ballesteros",
      "Nombre_iniciativa": "ID 4169 - Premiacion comerciales Plink",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Solicitra material",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor nos apoya con el tema las premiaciones (bonos) al equipo comercial",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Gluky Group SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "C107500008 PLINK",
      "Nombre_lider_EVC": "Monica Palacio Angel",
      "SR_ARIBA": 4169,
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "04/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "04/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4168,
      "Title": "Forms",
      "Fecha_solicitud": "03/08/2023",
      "Correo_solicitante": "jobayona@bancolombia.com.co",
      "Nombre_solicitante": "Jonathan Antonio Bayona Del Ducca",
      "Nombre_iniciativa": "ID 4168 - Negociación reemplazo PORFIN - ADIN",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere iniciar proceso de negociación de tarifas de un nuevo servicio a ser contratado con proveedor Alcuadrado que reemplazara actual producto de mercado de capitales PORFIN. Este ultimo será jubilado (contrato anterior CW2221898)",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "350.000.000",
      "Proveedores_conocidos": "ALCUADRADO",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC INVERSIONES",
      "Nombre_lider_EVC": "JONATHAN BAYONA DEL DUCA",
      "SR_ARIBA": "SR4132610367",
      "Familias": "Licenciamiento Mayor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Andres Felipe Meneses Vergara",
      "Rol_asesor": "Monica Marcela Alzate Granda",
      "Observaciones": "Naty ok PN con equipo completo\nAgo. 11. En MP José indicó que al ser este proveedor, el tema es de él y cambia a Licenciamiento  Mayor.  Los PN se hicieron con Licencimiento menor.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "11/08/2023",
      "Fecha Asignación/Delegación": "11/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "08/08/2023",
      "Fecha ok. PN": "08/08/2023",
      "sin equipo": "Ciber",
      "Áreas pendientes": "09/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4167,
      "Title": "Forms",
      "Fecha_solicitud": "03/08/2023",
      "Correo_solicitante": "elquicen@bancolombia.com.co",
      "Nombre_solicitante": "Elizabeth Quiceno Osorio",
      "Nombre_iniciativa": "ID 4167 - Contrato Regional Buro de crédito",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "SR previamente asignado con PN realizados - SR3964778505 (ID 3351) - que se cancelo por temas de priorización pero se activará nuevamente\nSe requiere revisar con el Buro TU (transunion) la posibilidad de una negociación regional (Bancoagricola, BAM, Nequi y Bancolombia) donde podamos obtener ventajas competitivs en las tarifas y el acceso a nuevos productos y servicios y mayor eficiencia en los costos tarifarios.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "el objetivo de la solicitud es negociar el contrato y posterior a eso definir el valor requerido de ppto.",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "TransUnion",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C102300101 - Gcia Corporativa Riesgos De Credito",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4131317973",
      "Familias": "Consultas Especializadas",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Mateo Gutierrez Garcia",
      "Rol_asesor": "Adriana Maria Arango Restrepo",
      "Observaciones": "Biatri no va a PN porque ya se gestionó con el SR del req. 3351 que se canceló por no estar priorizado, el usuario quiere reabrirlo y solicita que la atienda Andrés.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "11/08/2023",
      "Fecha Asignación/Delegación": "11/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "03/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios de Información",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4166,
      "Title": "Forms",
      "Fecha_solicitud": "03/08/2023",
      "Correo_solicitante": "STOBON@bancolombia.com.co",
      "Nombre_solicitante": "Sirley Tobon Gomez",
      "Nombre_iniciativa": "ID 4166 - Renovación contrato CW2295960 Neoris",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2295960",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación contrato CW2295960 Neoris presta servicios profesionales, con perfiles de ciberseguridad para las LDC de Diseño de Ciberseguridad y SI.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "2.868.046.483",
      "Proveedores_conocidos": "Neoris",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "CDE CIBERSEGURIDAD Y SI (C104300560)",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4131280218",
      "Familias": "Perfiles Ciberseguridad",
      "Categoría": "Seguridad",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Yuri Andrea Ortega Davila",
      "Rol_asesor": "No aplica",
      "Observaciones": "Cata ok PN con equipo completo",
      "Comentarios BP": "",
      "Fecha MarketPlace": "11/08/2023",
      "Fecha Asignación/Delegación": "11/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "03/08/2023",
      "Fecha ok. PN": "03/08/2023",
      "sin equipo": "PDP",
      "Áreas pendientes": "10/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de seguridad",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4165,
      "Title": "Forms",
      "Fecha_solicitud": "03/08/2023",
      "Correo_solicitante": "STOBON@bancolombia.com.co",
      "Nombre_solicitante": "Sirley Tobon Gomez",
      "Nombre_iniciativa": "ID 4165 - Renovación contrato CW2287551 Indra",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2287551",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación contrato CW2287551 con Indra. presta servicios profesionales, con perfiles de ciberseguridad para las LDC de Diseño de Ciberseguridad y SI.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "2.868.046.483",
      "Proveedores_conocidos": "Indra",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "CDE CIBERSEGURIDAD Y SI (C104300560)",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4131178231",
      "Familias": "Perfiles Ciberseguridad",
      "Categoría": "Seguridad",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Yuri Andrea Ortega Davila",
      "Rol_asesor": "No aplica",
      "Observaciones": "Cata es renovación, proveedor riesgo 3 no va a PN",
      "Comentarios BP": "Llevar al MP y asignar a Andrea ortega",
      "Fecha MarketPlace": "04/08/2023",
      "Fecha Asignación/Delegación": "04/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "03/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de seguridad",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4163,
      "Title": "Forms",
      "Fecha_solicitud": "03/08/2023",
      "Correo_solicitante": "marialon@bancolombia.com.co",
      "Nombre_solicitante": "Mariana Karolain Londono Suarez",
      "Nombre_iniciativa": "ID 4163 - Vincular proveedor nuevo",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "generar pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Vincular al proveedor para pagarle honorarios de uno de nuestros influencer de agro (Guillo Vives)",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "MALENKA S.A.S.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GCIA MERCADEO ATRACCION Y PROFUNDIZACIÓN - C106500007",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4163,
      "Familias": "Contenidos Digitales",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "03/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "03/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4162,
      "Title": "Forms",
      "Fecha_solicitud": "03/08/2023",
      "Correo_solicitante": "marialon@bancolombia.com.co",
      "Nombre_solicitante": "Mariana Karolain Londono Suarez",
      "Nombre_iniciativa": "ID 4162 - Vincular proveedor",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "generar un pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Pagar activación agro con el municipio de Concordia",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "MUNICIPIO DE CONCORDIA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GCIA MERCADEO ATRACCION Y PROFUNDIZACIÓN - C106500007",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "4162 (R)",
      "Familias": "Patrocinios Mercadeo",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Ago. 09.  usuario solicita sea cancelado este req. a través de correo electrónico.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "03/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "03/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "Retirado",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4161,
      "Title": "Forms",
      "Fecha_solicitud": "03/08/2023",
      "Correo_solicitante": "ORACEVED@bancolombia.com.co",
      "Nombre_solicitante": "Orfy Yulie Acevedo Meneses",
      "Nombre_iniciativa": "ID 4161 - vincular proveedor para certificar a los Arquitectos de procesos",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Tengo 2 proveedores que son nuevos en el banco. Uno de ellos es Peruano y otro es nacional. Me gustaría saber que requisitos debo tener en cuenta como proveedor nuevo y extranjero, como me puedo ir documentando y si debo obtener un negociador para buscar descuentos con el proveedor.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 150000000,
      "Proveedores_conocidos": "Play consulting Digital  y  Egresados distrital",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Gobierno de procesos",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR No requerido",
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Contención",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Ago. 04  Por Teams, usuaria aclara que requiere un proceso de formación.  Se le indica que debe ir a Formación para validar el tema.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "08/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4160,
      "Title": "Forms",
      "Fecha_solicitud": "03/08/2023",
      "Correo_solicitante": "YZULUAGA@bancolombia.com.co",
      "Nombre_solicitante": "Yicela Andrea Zuluaga Toro",
      "Nombre_iniciativa": "ID 4160 - Cerramiento de monedas",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere adquirir el cerramiento de monedas para cajeros multifuncionales HYO",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "$62.810.540",
      "Proveedores_conocidos": "Belltech",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Distribución Fisica",
      "Nombre_lider_EVC": "Juan Camilo Moreno",
      "SR_ARIBA": 4160,
      "Familias": "Equipos de Oficina",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "03/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "03/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Activos Fijos",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4164,
      "Title": "Forms",
      "Fecha_solicitud": "02/08/2023",
      "Correo_solicitante": "lfarfan@bancolombia.com.co",
      "Nombre_solicitante": "Laura Camila Farfan Murcia",
      "Nombre_iniciativa": "ID 4164 - Cración de proveedor",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor presta un servicio de firmas de escrituras del negocios fiduciarios",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Los pagos a este proveedor depende de los honorarios y la cantidad de escrituras que remitan",
      "Valor_presupuesto": "$ 1.978.032",
      "Proveedores_conocidos": "GARCIA & VARON ASOCIADOS S.A.S",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Juridica C302400400",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4164,
      "Familias": "Servicios Legales",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "03/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "03/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios Profesionales Procesos del Negocio",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4159,
      "Title": "Forms",
      "Fecha_solicitud": "02/08/2023",
      "Correo_solicitante": "mmmartin@bancolombia.com.co",
      "Nombre_solicitante": "Monica Maria Martinez Medina",
      "Nombre_iniciativa": "ID 4159 - Registro proveedor para compra material promocional",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Registro proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Suministros material promocional, kit escolar",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "NORDEK SAS y GRABADOS ARTISTICOS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C104300263",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4159,
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "03/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "03/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4158,
      "Title": "Forms",
      "Fecha_solicitud": "02/08/2023",
      "Correo_solicitante": "cahiguit@bancolombia.com.co",
      "Nombre_solicitante": "Carlos Mauricio Higuita Niebles",
      "Nombre_iniciativa": "ID 4158 - Adquisión de licencia simulador de pruebas para tarjetas de la franquicia MasterCard proyecto Multivendor",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Realizar el pago al proveedor FIME por el uso de la licencia del simulador de pruebas para ATM del proyecto multivendor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Requerimos la compra de la licencia del simulador de pruebas para transacciones realizadas en cajeros Bancolombia con tarjetas de la franquicia MasterCard. El servicio o licencia ya fue entregado por el aliado FIME y lo que requerimos es legalizar el uso de la licencia y reconocer al aliado el pago por el uso de la licencia.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "FIME INC",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC de Distribución Física - C103500234",
      "Nombre_lider_EVC": "Jose Jaime Tilano Vega",
      "SR_ARIBA": "SR4130246245",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Carlos Andres Ramos Ospina",
      "Rol_asesor": "Monica Marcela Alzate Granda",
      "Observaciones": "Naty ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "18/08/2023",
      "Fecha Asignación/Delegación": "18/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "03/08/2023",
      "Fecha ok. PN": "03/08/2023",
      "sin equipo": "Continuidad,",
      "Áreas pendientes": "15/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4157,
      "Title": "Forms",
      "Fecha_solicitud": "02/08/2023",
      "Correo_solicitante": "gyate@bancolombia.com.co",
      "Nombre_solicitante": "Gilma Carolina Yate Guzman",
      "Nombre_iniciativa": "ID 4157 - Vinculacion proveedor",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Vinculación proveedor, elaboración de artículos para diferentes tipos de eventos",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 132000000,
      "Proveedores_conocidos": "CAFE SENSIA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GERENCIA DE GESTION COMERCIAL REGION CENTRO, C102100354",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4157,
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "03/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "03/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4156,
      "Title": "Forms",
      "Fecha_solicitud": "02/08/2023",
      "Correo_solicitante": "JARANDA@bancolombia.com.co",
      "Nombre_solicitante": "Juan Carlos Aranda Guerrero",
      "Nombre_iniciativa": "ID 4156 - RENOVACION CONTRATO CW2243329 SINERGY & LOWELLS SAS",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2243329",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "RENOVAR EL CONTRATO CW2243329 CON SINERGY & LOWELLS SAS. \nContrato de prestación de servicios de outsourcing de nómina para el procesamiento de nómina mensual de los pensionados de la Empresa de Energía de Bogotá",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "120.564.000",
      "Proveedores_conocidos": "SINERGY & LOWELLS SAS",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "SERCION SERVICIOS NEGOCIOS PARTICULARES BTA",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4130246225",
      "Familias": "Procesamiento de Información",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Jorge Mario Aguinaga Quiros",
      "Rol_asesor": "No aplica",
      "Observaciones": "Biatri ok PN con equipo completo",
      "Comentarios BP": "",
      "Fecha MarketPlace": "11/08/2023",
      "Fecha Asignación/Delegación": "11/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "03/08/2023",
      "Fecha ok. PN": "03/08/2023",
      "sin equipo": "Ciber",
      "Áreas pendientes": "09/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Back Office",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4155,
      "Title": "Forms",
      "Fecha_solicitud": "02/08/2023",
      "Correo_solicitante": "sarduque@bancolombia.com.co",
      "Nombre_solicitante": "Sara Victoria Duque Lopez",
      "Nombre_iniciativa": "ID 4155 - Actuazlaización de datos proveedor Alba González Castillo | 2 Inspiradas",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Actualizar datos del proveedor ya que está vinculado con cédula de extranjería y ya cuenta NIT para facturación electrónica",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Alba González nos presta servicios de alimentación y utilería para eventos de la Vicepresidencia de Mercadeo.\nElla es una proveedora antigua pero tuvo una actualización en su número de identidad y ahora factura electrónicamente",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Alba González Castillo - CE 484148 | Código SAP 37960",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C1065000000",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4155,
      "Familias": "BTL",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "02/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "02/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4154,
      "Title": "Forms",
      "Fecha_solicitud": "02/08/2023",
      "Correo_solicitante": "mobernal@bancolombia.com.co",
      "Nombre_solicitante": "Monica Yineth Bernal Gomez",
      "Nombre_iniciativa": "ID 4154 - PRG_2023_1250586 - PATROCINIO MUNICIPIO DE LA MERCED 2023 (2)",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular al proveedor y generar pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "organización y logistica de actividades deportivas en el marco de la celebración de la Municipalidad de La Merced por sus 50 años",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "GUSTAVO ANDRES SANCHEZ GALVIS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "PATROCINIOS GOBIERNO DE RED - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4154,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "02/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "02/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4153,
      "Title": "Forms",
      "Fecha_solicitud": "02/08/2023",
      "Correo_solicitante": "macastri@bancolombia.com.co",
      "Nombre_solicitante": "Maria Isabel Castrillon Elorza",
      "Nombre_iniciativa": "ID 4153 - Afiliación de Nequi a la ACRIP (Federación Colombiana de Gestión Humana)",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Vinculación de Nequi a la ACRIP (Federación Colombiana de Gestión Humana)",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 4000000,
      "Proveedores_conocidos": "ACRIP 860401674",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "C475000000 Talento Humano",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4153,
      "Familias": "Suscripciones",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "02/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "02/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios de Información",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4152,
      "Title": "Forms",
      "Fecha_solicitud": "02/08/2023",
      "Correo_solicitante": "jujarami@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Jaramillo Corrales",
      "Nombre_iniciativa": "ID 4152 - Renovación servicios profesionales BIG BANG DATA S.A.S",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2287604",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la renovación de las tarifas del proveedor BIG BANG DATA S.A.S por vencimiento de tarifas las cuales se evncen el 1/10/2023.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "N/A",
      "Proveedores_conocidos": "BIG BANG DATA S.A.S",
      "Cuadrante_Proveedor": 3,
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Administración de proveedores TI C103500002",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4136317633",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Diana Milena Arango Correa",
      "Rol_asesor": "No aplica",
      "Observaciones": "Jose proveedor riesgo 3 no va a PN- es renovación.\nAgo 08 (por error relacioné un SR errado, el del req. 4146, pero se corrige y da alcance a la asignación del correo informando el SR correcto, que es el que ya queda acá relacionado)",
      "Comentarios BP": "",
      "Fecha MarketPlace": "04/08/2023",
      "Fecha Asignación/Delegación": "04/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "02/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4151,
      "Title": "Forms",
      "Fecha_solicitud": "02/08/2023",
      "Correo_solicitante": "pmajana@bancolombia.com.co",
      "Nombre_solicitante": "Paula Andrea Majana Basilio",
      "Nombre_iniciativa": "ID 4151 - Certificación Fiba (Cumplimiento para colaborador Nequi)",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Un colaborador Nequi requiere hacer la certificación Fiba (Cumplimiento para colaborador Nequi)\nLa Certificación Fiba Amlca muestra que el funcionario ha manifestado una gran comprensión del conocimiento de AML y ha aceptado el desafío de mantenerse informado de las novedades en el campo contra el lavado de dinero",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "$ 1395 USD",
      "Proveedores_conocidos": "FIBA  https://fiba.site-ym.com/events/eventdetails.aspx?id=1763307",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "C475000000 Talento Humano",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4129391288",
      "Familias": "Suscripciones",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "John Alexis Velasquez Garcia",
      "Rol_asesor": "Monica Marcela Alzate Granda",
      "Observaciones": "Naty por la naturaleza de la solicitud no lo envié a PN, lo revisaría el equipo de licenciamiento menor.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "04/08/2023",
      "Fecha Asignación/Delegación": "04/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "02/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios de Información",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4150,
      "Title": "Forms",
      "Fecha_solicitud": "02/08/2023",
      "Correo_solicitante": "yequinte@bancolombia.com.co",
      "Nombre_solicitante": "Yenifer Quintero Quiceno",
      "Nombre_iniciativa": "ID 4150 - Patrocinio al municipio de San Carlos",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Hacer un pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor fabrica kits campesinos para las diferentes regiones del país",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "IMAGEN PERFECTA 7 - NIT 800208072",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gobierno de Red - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4150,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "02/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "02/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4148,
      "Title": "Forms",
      "Fecha_solicitud": "02/08/2023",
      "Correo_solicitante": "mobernal@bancolombia.com.co",
      "Nombre_solicitante": "Monica Yineth Bernal Gomez",
      "Nombre_iniciativa": "ID 4148 - PRG_2023_2356083 - MUNICIPIO DE CAICEDONIA 2023",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "GENERAR PEDIDO EN SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor presta servicios de Fotografía, diseño y grabación de videos publicitarios para las fiestas tradicionales del Municippio de Caicedonia.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "JHON ESTEBAN PEREZ RESTREPO",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "PATROCINIOS GOBIERNO DE RED - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4148,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "02/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "02/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4149,
      "Title": "Forms",
      "Fecha_solicitud": "01/08/2023",
      "Correo_solicitante": "sacarmon@bancolombia.com.co",
      "Nombre_solicitante": "Santiago Carmona Zapata",
      "Nombre_iniciativa": "ID 4149 - Orden de Servicio Gestión Documental - Nexura",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "De acuerdo a la alianza que se tiene desde Productos No Financieros con Nexura estamos requiriendo del apoyo para la revisión de una nueva Orden de Servicio con el aliado que nos permitirá ampliar el portafolio de productos y servicios para con los Municipios.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "75.000.000",
      "Proveedores_conocidos": "Nexura",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "C105500036",
      "Nombre_lider_EVC": "Gestion de Flujos",
      "SR_ARIBA": "SR4129389868",
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Luis Guillermo Salcedo Valderrama",
      "Rol_asesor": "No aplica",
      "Observaciones": "Diana en Ariba se dejó la nueva familia PORTALES DIGITALES GOBIERNO.\nOk PN con equipo completo",
      "Comentarios BP": "",
      "Fecha MarketPlace": "11/08/2023",
      "Fecha Asignación/Delegación": "11/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "02/08/2023",
      "Fecha ok. PN": "03/08/2023",
      "sin equipo": "Ciber, continuidad",
      "Áreas pendientes": "09/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4147,
      "Title": "Forms",
      "Fecha_solicitud": "01/08/2023",
      "Correo_solicitante": "mobernal@bancolombia.com.co",
      "Nombre_solicitante": "Monica Yineth Bernal Gomez",
      "Nombre_iniciativa": "ID 4147 - PRG_2023_2252482 - 2023 MUNICIPIO DE SANTACRUZ DE GUACHAVES",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Habilitar proveedor y Generar pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Proveedor suministra refrigerios.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "TIRSA ESPERANZA ZAMBRANO RIVERA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "PATROCINIOS GOBIERNO DE RED - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4147,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "01/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "01/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4146,
      "Title": "Forms",
      "Fecha_solicitud": "01/08/2023",
      "Correo_solicitante": "jmpulgar@bancolombia.com.co",
      "Nombre_solicitante": "John Mauricio Pulgarin",
      "Nombre_iniciativa": "ID 4146 - ENTREGA DE CUENTOS ATRAVES DEL WHATSAPP A LOS EMPLEADOS",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "VINCULAR AL PROVEEDOR",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "ENTREGA DE CUENTOS ATRAVES DEL WHATSAPP A LOS EMPLEADOS",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Cuéntame Historias SAS 9016320641",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GERENCIA DE BIENESTAR C103200030",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4129329114",
      "Familias": "Convenios y Beneficios",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "02/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "02/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4145,
      "Title": "Forms",
      "Fecha_solicitud": "01/08/2023",
      "Correo_solicitante": "mobernal@bancolombia.com.co",
      "Nombre_solicitante": "Monica Yineth Bernal Gomez",
      "Nombre_iniciativa": "ID 4145 - PRG_2023_1937707  - MUNICIPIO DE SUPIA 2023",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "GENERAR PEDIDO EN SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Empresa encargado de la organización de eventos recreativos y culturales en el Municipio de Supia.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "CORPORACIÓN COLOMBIANA PARA EL FOMENTO DE LA RECREACION POPULAR Y DE DESARROLLO HUMANO",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "PATROCINIOS GOBIERNO DE RED - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4145,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "01/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "01/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4144,
      "Title": "Forms",
      "Fecha_solicitud": "01/08/2023",
      "Correo_solicitante": "SANTRAMI@Bancolombia.com.co",
      "Nombre_solicitante": "Santiago Ramirez Betancur",
      "Nombre_iniciativa": "ID 4144 - RENOVACION CONTRATO CW2278568 DESCUENTO POR PRONTO PAGO",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2278568",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación contrato CW2278568. Este proveedor es el encargado de ayudarnos con toda la gestión de las facturas con los proveedores que requieren un adelanto en el pago de sus facturas, generando un descuento por pronto pago el cual es ingreso para Bancolombia y hace parte de la meta de ahorros de la Dirección, meta actual $3.500.000.000 al año",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "286.347.224",
      "Proveedores_conocidos": "LIBERA SUPPLY CHAIN FINANCE SAS",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Servicios contables administrativos - C104300235",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4129028116",
      "Familias": "Servicios SaaS",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Carlos Andres Ramos Ospina",
      "Rol_asesor": "No aplica",
      "Observaciones": "Jose ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "18/08/2023",
      "Fecha Asignación/Delegación": "18/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "02/08/2023",
      "Fecha ok. PN": "03/08/2023",
      "sin equipo": "continuidad",
      "Áreas pendientes": "15/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de plataformas",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4143,
      "Title": "Forms",
      "Fecha_solicitud": "01/08/2023",
      "Correo_solicitante": "SSERNA@bancolombia.com.co",
      "Nombre_solicitante": "Sara Lucia Serna Calle",
      "Nombre_iniciativa": "ID 4143 - Balanceo de servicios WhatsApp en Teleperformance- Cierre de servicios Chat y Chatbot -Sufi",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere balancear las interacciones que tenemos en el servicio de WhatsApp Sufi de clientes, entre los BPO TP y Konecta; actualmente el servicio se encuentra totalmente en Konecta, y se requiere que migre el 50% de las interacciones para que sean atendidas por Teleperformance\nAdicionalmente se requiere retirar el servicio que a hoy opera de chat y chatbot, el cual se encuentra en la página de Sufi.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "800.000.000",
      "Proveedores_conocidos": "Teleperformance",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC ESTRATEGIA DE CLIENTES SUFI - C105000235",
      "Nombre_lider_EVC": "Juliana Velasquez Velasquez",
      "SR_ARIBA": "SR4129028098",
      "Familias": "SMS y Otras Notificaciones",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Isabella Correa Valencia",
      "Rol_asesor": "No aplica",
      "Observaciones": "Dianis en Ariba quedó con la familia WHATSAPP. ok PN con equipo completo",
      "Comentarios BP": "",
      "Fecha MarketPlace": "11/08/2023",
      "Fecha Asignación/Delegación": "11/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "02/08/2023",
      "Fecha ok. PN": "03/08/2023",
      "sin equipo": "Ciber",
      "Áreas pendientes": "09/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Contactabilidad con Clientes",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4142,
      "Title": "Forms",
      "Fecha_solicitud": "01/08/2023",
      "Correo_solicitante": "mobernal@bancolombia.com.co",
      "Nombre_solicitante": "Monica Yineth Bernal Gomez",
      "Nombre_iniciativa": "ID 4142 - PRG_2023_2068310 - OPERACIÓN SONRISA 2023",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "generar pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "patrocinio otorgado al Departamento del Cauca, en apoyo al evento\nOPERACIÓN SONRISA, en donde el proveedor suministro el material y\nalimentos requeridos para los participantes del evento que se realiza\ncada año, por un valor total de $5.000.000 COPS",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "GRUPO PIO PIO SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "PATROCINIOS GOBIERNO DE RED - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4142,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "01/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "01/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4141,
      "Title": "Forms",
      "Fecha_solicitud": "01/08/2023",
      "Correo_solicitante": "SSERNA@bancolombia.com.co",
      "Nombre_solicitante": "Sara Lucia Serna Calle",
      "Nombre_iniciativa": "ID 4141 - Balanceo de servicios WhatsApp en Konecta - Licenciamiento directo de plataforma - Sufi",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere balancear las interacciones que tenemos en el servicio de WhatsApp Sufi de clientes, entre los BPO TP y Konecta; actualmente el servicio se encuentra totalmente en Konecta, adicionalmente se requiere que las licencias que a hoy están contratadas con Konecta y tercerizadas con Chattigo, sean administradas y pagadas directamente por el banco con Chattigo.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "800.000.000",
      "Proveedores_conocidos": "Konecta",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC ESTRATEGIA DE CLIENTES SUFI",
      "Nombre_lider_EVC": "Juliana Velasquez Velasquez",
      "SR_ARIBA": "SR4129028084",
      "Familias": "SMS y Otras Notificaciones",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Yohany Anibal Gaviria Quintero",
      "Rol_asesor": "Adriana Maria Arango Restrepo",
      "Observaciones": "Dianis en Ariba, está con la nueva familia: WHATSAPP.\nOk PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "18/08/2023",
      "Fecha Asignación/Delegación": "18/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "02/08/2023",
      "Fecha ok. PN": "02/08/2023",
      "sin equipo": "Continuidad",
      "Áreas pendientes": "15/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Contactabilidad con Clientes",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4140,
      "Title": "Forms",
      "Fecha_solicitud": "01/08/2023",
      "Correo_solicitante": "rmperez@bancolombia.com.co",
      "Nombre_solicitante": "Rene Mauricio Perez Forero",
      "Nombre_iniciativa": "ID 4140 - Mantenimiento equipos de Aire condicionado de la sala de arte, Ed. Atrio",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Realizar un RFP para la contratación para el mantenimiento de los equipos de aire acondicionado de la sala de arte ubicada en el piso 4° del Edificio Atrio",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "12MM",
      "Proveedores_conocidos": "Larco - Instalaire",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C104300023",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4127429840",
      "Familias": "HARD (Operadores de Mantenimiento)",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Juan Pablo Ramirez Cardenas",
      "Rol_asesor": "No aplica",
      "Observaciones": "Naty ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "18/08/2023",
      "Fecha Asignación/Delegación": "18/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "01/08/2023",
      "Fecha ok. PN": "02/08/2023",
      "sin equipo": "Continuidad",
      "Áreas pendientes": "15/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Facility Managment",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4139,
      "Title": "Forms",
      "Fecha_solicitud": "01/08/2023",
      "Correo_solicitante": "jucarvaj@bancolombia.com.co",
      "Nombre_solicitante": "Juan Carlos Carvajal Ossa",
      "Nombre_iniciativa": "ID 4139 - Solicitud material",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "solicitar material",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "pago de factura por un taller de Design sprint proyecto de innovación y salud mental.\nFactura número EL 1534",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "ESTRATEK",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "C102200051",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4139,
      "Familias": "Servicios Profesionales Formación y Entrenamiento",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "01/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "01/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4138,
      "Title": "Forms",
      "Fecha_solicitud": "01/08/2023",
      "Correo_solicitante": "jtsanche@bancolombia.com.co",
      "Nombre_solicitante": "July Tatiana Sanchez Agudelo",
      "Nombre_iniciativa": "ID 4138 - Renovación de tarifas Avisor CW2283739",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2283739",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiero renovar tarifas (renegociar) con el proveedor Avisor. CW2283739",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "100.000.000",
      "Proveedores_conocidos": "AVISOR TECHNOLOGIES S A S",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Gestión de Flujos",
      "Nombre_lider_EVC": "Juan Gonzalo Tobon",
      "SR_ARIBA": "SR4127429826",
      "Familias": "Pasarelas de Pago",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Angie Lorena Castrillon Palacio",
      "Rol_asesor": "No aplica",
      "Observaciones": "Dianis ok PN con equipo completo.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "11/08/2023",
      "Fecha Asignación/Delegación": "11/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "01/08/2023",
      "Fecha ok. PN": "03/08/2023",
      "sin equipo": "Ciber",
      "Áreas pendientes": "09/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Medios de Pago",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4137,
      "Title": "Forms",
      "Fecha_solicitud": "01/08/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 4137 - Compra de curso de extensión CONGRESO INTERNACIONAL DE TIC\tANDICOM - CINTEL",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión CONGRESO INTERNACIONAL DE TIC\tANDICOM - CINTEL",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "ANDICOM - CINTEL",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4137,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "01/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "01/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4136,
      "Title": "Forms",
      "Fecha_solicitud": "01/08/2023",
      "Correo_solicitante": "pmajana@bancolombia.com.co",
      "Nombre_solicitante": "Paula Andrea Majana Basilio",
      "Nombre_iniciativa": "ID 4136 - Participación de un colaborador en un curso de extensión de la Universidad Javeriana",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Requiero crear a la Universidad Javeriana como proveedor para que un colaborador pueda participar en un curso de extensión",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 1900000,
      "Proveedores_conocidos": "Universidad Javerina",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "C475000000 Talento Humano",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4136,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "01/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "01/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4135,
      "Title": "Forms",
      "Fecha_solicitud": "01/08/2023",
      "Correo_solicitante": "icorrea@bancolombia.com.co",
      "Nombre_solicitante": "Isabella Correa Valencia",
      "Nombre_iniciativa": "ID 4135 - OS Gest Documental",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "....",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 0,
      "Proveedores_conocidos": "Nexura",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "PNF",
      "Nombre_lider_EVC": "Luis CArlos",
      "SR_ARIBA": "SR No requerido",
      "Familias": "",
      "Categoría": "",
      "¿Cómo se va a gestionar?": "Contención",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Isa la creó por error para explicarle a un usuario como radicaba.  Notifica por correo. Ago. 01",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "01/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "Retirado",
      "Estado": "",
      "Subcategoría_F": "",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4134,
      "Title": "Forms",
      "Fecha_solicitud": "01/08/2023",
      "Correo_solicitante": "jtsanche@bancolombia.com.co",
      "Nombre_solicitante": "July Tatiana Sanchez Agudelo",
      "Nombre_iniciativa": "ID 4134 - Renovación tarifas Elevate. CW2294576",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2294576",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere renovar el anexo de tarifas del proveedor Elevate (asesorías a micro emprendedores). CW2294576",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "100.000.000",
      "Proveedores_conocidos": "Elevante Business SAS",
      "Cuadrante_Proveedor": 4,
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Gestión de Flujos",
      "Nombre_lider_EVC": "Juan Gonzalo Tobon",
      "SR_ARIBA": "SR4126912870",
      "Familias": "Servicios profesionales de Mercadeo",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Carlos Andres Ramos Ospina",
      "Rol_asesor": "No aplica",
      "Observaciones": "Naty es renovación, proveedor riesgo 4 no va a PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "04/08/2023",
      "Fecha Asignación/Delegación": "04/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "01/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4133,
      "Title": "Forms",
      "Fecha_solicitud": "01/08/2023",
      "Correo_solicitante": "majromer@bancolombia.com.co",
      "Nombre_solicitante": "Marcos Jimenez Romero",
      "Nombre_iniciativa": "ID 4133 - POC Identificación Biometría Facial METAMAP",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Bancolombia realizará una prueba de concepto utilizando los servicios de Metamap con el objetivo de evaluar la identificación de clientes que se encuentran en el extranjero y desean efectuar el desbloqueo de la clave dinámica. Este caso se realizará mediante la LES y será guiada por un asesor vía telefónica. Se definió un flujo en conjunto con expertos de Metamap para poder identificar los clientes y proceder con el desbloqueo solicitado. Se harán 50 identificaciones bajo el aprovechamiento de la bolsa negociada en el contrato actual con Wenia.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "Vamos a usar un % pequeño de un contrato de Wenia",
      "Proveedores_conocidos": "Metamap",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Gestión de Fraude C104300567",
      "Nombre_lider_EVC": "Mauricio Cano",
      "SR_ARIBA": "SR4126912855",
      "Familias": "Seguridad Canales y Productos",
      "Categoría": "Seguridad",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "01/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "01/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Gestión del Fraude",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4132,
      "Title": "Forms",
      "Fecha_solicitud": "31/07/2023",
      "Correo_solicitante": "apelaez@bancolombia.com.co",
      "Nombre_solicitante": "Alejandro Pelaez Salazar",
      "Nombre_iniciativa": "ID 4132 - Reserva Auditorio FIC48 - Gatech",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Solicitud de Material",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Reserva de auditorio en FIC48 por 1 hora para evento con Georgia Tech",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "ACEIS S.A.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Dirección de Innovación Abierta",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4132,
      "Familias": "BTL",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "01/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "01/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4131,
      "Title": "Forms",
      "Fecha_solicitud": "31/07/2023",
      "Correo_solicitante": "julmoral@bancolombia.com.co",
      "Nombre_solicitante": "Julian Morales Patino",
      "Nombre_iniciativa": "ID 4131 - Estudio Plataforma Confirming",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la integración con la plataforma con el objetivo de conectarnos directamente a sus pagadores y proveedores para el fondeo de sus facturas. La plataforma se integra al ERP de los clientes para tomar la información directamente y así facilitar el proceso para estos y después nos envían la información a través de H2H. La plataforma es un tercero con el cual trabajamos de la mano, en donde no se contrata pagando un fee por sus servicios, sino que ellos cobran unos puntos básicos sobre la tasa de las facturas descontadas a través de esta; ellos entran como un proveedor que nos permite una mejor integración de cara a pagadores y proveedores",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "La plataforma es un tercero con el cual trabajamos de la mano, en donde no se contrata pagando un fee por sus servicios, sino que ellos cobran unos puntos básicos sobre la tasa de las facturas descontadas a través de esta, razón por la cual no es necesario un presupuesto previo, dado que el pago se hará en forma de comisiones con forme estas se vayan generando",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "ECONFIRMING SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Nuevos Negocios",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4126912837",
      "Familias": "Servicios SaaS",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "01/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "01/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicio de plataformas",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4130,
      "Title": "Forms",
      "Fecha_solicitud": "31/07/2023",
      "Correo_solicitante": "dgzulua@bancolombia.com.co",
      "Nombre_solicitante": "David Galeano Zuluaga",
      "Nombre_iniciativa": "ID 4130 - Piloto Soluciones de Video",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere realizar el montaje de una demostración real en instalaciones Banco para conocer las capacidades funcionales, tecnológicas, analíticas y valores agregados a la organización de soluciones integrales de video.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Capacidades desde el área funcional asignadas, Pendiente definición CAE para asignación capacidades de TI. Solo se avanzará con pilotos que no requieran inversión.",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Axis, Scati, March Networks, Genetec, Hexagon, Motorola y Johnson Controls.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Seguridad Física  C104300571",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4126912823",
      "Familias": "Seguridad Física",
      "Categoría": "Seguridad",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Yuri Andrea Ortega Davila",
      "Rol_asesor": "No aplica",
      "Observaciones": "Cata ok PN",
      "Comentarios BP": "Llevar al MP y asignar a Andre",
      "Fecha MarketPlace": "18/08/2023",
      "Fecha Asignación/Delegación": "18/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "01/08/2023",
      "Fecha ok. PN": "01/08/2023",
      "sin equipo": "Continuidad",
      "Áreas pendientes": "15/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Gestión del Fraude",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4129,
      "Title": "Forms",
      "Fecha_solicitud": "31/07/2023",
      "Correo_solicitante": "jeberare@bancolombia.com.co",
      "Nombre_solicitante": "Jennifer Bergano Arenas",
      "Nombre_iniciativa": "ID 4129 - Freelance para Nequi, para contenido multimedia",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Diseñador multimedia para apoyo de contenido audiovisual en la agencia creativa",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Es segun disponibilidad y requerimiento",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Santiago Duque Garcia - Multimedia Audiovisual",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "C102200008",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4126912809",
      "Familias": "Servicios profesionales de Mercadeo",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "01/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "01/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4128,
      "Title": "Forms",
      "Fecha_solicitud": "31/07/2023",
      "Correo_solicitante": "yequinte@bancolombia.com.co",
      "Nombre_solicitante": "Yenifer Quintero Quiceno",
      "Nombre_iniciativa": "ID 4128 - Patrocinio al municipio de Guadalupe",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Hacer pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor produce balones con la imagen de Bancolombia",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Segundo Adán Neita Fonseca - Arcueros deportes Monguí",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gobierno de Red - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4128,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "31/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "31/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4127,
      "Title": "Forms",
      "Fecha_solicitud": "31/07/2023",
      "Correo_solicitante": "yequinte@bancolombia.com.co",
      "Nombre_solicitante": "Yenifer Quintero Quiceno",
      "Nombre_iniciativa": "ID 4127 - Patrocinio al Municipio de Sonsón",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular proveedor y hacer pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor suministra refrigerios para eventos realizados en el municipio de Sonsón Antioquia",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Gloria Montoya Alzate",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gobierno de Red - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4127,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "31/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "31/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4126,
      "Title": "Forms",
      "Fecha_solicitud": "31/07/2023",
      "Correo_solicitante": "catcebal@bancolombia.com.co",
      "Nombre_solicitante": "Catalina Ceballos Atehortua",
      "Nombre_iniciativa": "ID 4126 - Vinculación proveedores ATL",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vinculación proveedores de pauta ATL",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Pauta para campañas de mercadeo",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "FEDERACION COLOMBIANA DE PRODUCTORES DE PAPA FEDEPAPA  - SERVICIOS PUBLICITARIOS POC S.A.S  900336941-3 - MASS SOLUTIONS MEDIA S.A.S  900897828-5",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C106500018",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4126,
      "Familias": "Pautas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "31/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "31/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4125,
      "Title": "Forms",
      "Fecha_solicitud": "31/07/2023",
      "Correo_solicitante": "apelaez@bancolombia.com.co",
      "Nombre_solicitante": "Alejandro Pelaez Salazar",
      "Nombre_iniciativa": "ID 4125 - Desayuno Milky Tree",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Solicitar Material de proveedor existente",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "25 Desayunos para evento.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Milky Tree S.A.S",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Dirección de Innovación Abierta",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4125,
      "Familias": "BTL",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "31/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "31/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4124,
      "Title": "Forms",
      "Fecha_solicitud": "31/07/2023",
      "Correo_solicitante": "danromer@bancolombia.com.co",
      "Nombre_solicitante": "Daniela Andrea Romero Perez",
      "Nombre_iniciativa": "ID 4124 - Servicio de Desayuno para evento con clientes",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Actualziar proceso de Sarlaft",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Servicio de Desayuno para evento con clientes, alquiler de salón y ayuda audiovisual",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "COMPAÑÍA HOTELERA CARTAGENA DE INDIAS S.A.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Gestion Comercial Caribe C102100403",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4124,
      "Familias": "BTL",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "31/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "31/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4123,
      "Title": "Forms",
      "Fecha_solicitud": "31/07/2023",
      "Correo_solicitante": "anosorio@bancolombia.com.co",
      "Nombre_solicitante": "Ana Milena Osorio Sanmartin",
      "Nombre_iniciativa": "ID 4123 -  Definicion contable y material para el pago de facturas del proveedor Ilewa",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "contable y material para el pago de facturas del proveedor Ilewa",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor Ilewa diseño una experiencia y se encargo de la logistica (transporte) y diseño de la experiencia.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Ilewa",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Centro de excelencia de Innovación",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4123,
      "Familias": "BTL",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "31/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "31/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4122,
      "Title": "Forms",
      "Fecha_solicitud": "31/07/2023",
      "Correo_solicitante": "PALOAIZA@Bancolombia.com.co",
      "Nombre_solicitante": "Paula Andrea Loaiza Cadavid",
      "Nombre_iniciativa": "ID 4122 - Renovación contratos a cargo de Ariaxa. CW2298996 - CW2299425",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2298996 - CW2299425",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere renovar el contrato (CW2298996 - CW2299425) con el proveedor Ariaxa para los dos servicios relacionados por un año más, dado que a la fecha no hemos logrado el desarrollo que reemplazara esta herramienta, necesaria para la ejecución del control Certificación de Accesos Sox.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "219.000.000 apróximadamente anuales",
      "Proveedores_conocidos": "Ariaxa",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "ADC Administración Identidades y Accesos C104300554",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4126841257",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Luis Guillermo Salcedo Valderrama",
      "Rol_asesor": "Monica Marcela Alzate Granda",
      "Observaciones": "Naty ok PN con equipo completo\nNotificar asignación a Alison Builes Gil <albuile@bancolombia.com.co>",
      "Comentarios BP": "",
      "Fecha MarketPlace": "04/08/2023",
      "Fecha Asignación/Delegación": "04/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "01/08/2023",
      "Fecha ok. PN": "01/08/2023",
      "sin equipo": "",
      "Áreas pendientes": "02/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4121,
      "Title": "Forms",
      "Fecha_solicitud": "31/07/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 4121 - Compra de curso de extensión PPP AMÉRICAS 2023\tPANATICKETS",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión PPP AMÉRICAS 2023\tPANATICKETS",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "PANATICKETS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4121,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "31/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "31/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4120,
      "Title": "Forms",
      "Fecha_solicitud": "28/07/2023",
      "Correo_solicitante": "ntilano@bancolombia.com.co",
      "Nombre_solicitante": "Nahomy Daniela Tilano Diaz",
      "Nombre_iniciativa": "ID 4120 - Patrocinio al Municipio de Suan",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular a un proveedor y hacer pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor suministra el servicio de abastecimiento de meriendas y refrigerios, en el municipio de Suan",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Huver Jose Rivera Rodriguez",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "gobierno de red C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4120,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "28/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "28/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4119,
      "Title": "Forms",
      "Fecha_solicitud": "28/07/2023",
      "Correo_solicitante": "yequinte@bancolombia.com.co",
      "Nombre_solicitante": "Yenifer Quintero Quiceno",
      "Nombre_iniciativa": "ID 4119 - Patrocinio municipio de San Carlos",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vinculación de proveedor y pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor suministra refrigerios para eventos realizados en el municipio de San Carlos",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Diana Maria Giraldo Giraldo",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gobierno de Red - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4119,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "28/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "28/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4118,
      "Title": "Forms",
      "Fecha_solicitud": "28/07/2023",
      "Correo_solicitante": "juadagon@bancolombia.com.co",
      "Nombre_solicitante": "Juan David Gonzalez Toro",
      "Nombre_iniciativa": "ID 4118 - Nueva contratacion de servicio para proveedor AECSA subcontratacion de investigacion de bienes",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "se requiere la contratación del servicio de investigación de bienes para conciliación Sufí",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "25.000.000",
      "Proveedores_conocidos": "Aecsa",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Servicio de apoyo al Negocio Sufi",
      "Nombre_lider_EVC": "Liliana Maria Cano Orlas",
      "SR_ARIBA": "SR4121986456",
      "Familias": "Servicios de Investigación de Bienes",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Mateo Gutierrez Garcia",
      "Rol_asesor": "No aplica",
      "Observaciones": "Biatri ok PN con equipo completo",
      "Comentarios BP": "",
      "Fecha MarketPlace": "04/08/2023",
      "Fecha Asignación/Delegación": "04/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "28/07/2023",
      "Fecha ok. PN": "28/07/2023",
      "sin equipo": "",
      "Áreas pendientes": "02/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios de Conciliación y Cobranza",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4117,
      "Title": "MP MANUAL",
      "Fecha_solicitud": "28/07/2023",
      "Correo_solicitante": "myarce@bancolombia.com.co",
      "Nombre_solicitante": "Maria Antonia Yarce Villa",
      "Nombre_iniciativa": "ID 4117 - Herramienta tesrorería Nequi",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere de la compra de una herramienta para la gestión de tesorería de Nequi como entidad independiente de Bancolombia. La herramienta deberá permitir la negociación, operación, registro y valoración de inversiones obligatorias e inversiones temporales en titulos de mercado con el fin de dar cumplimiento a los requisitos regulatorios y permitir una gestión eficiente de los recursos líquidos de Nequi. Viene acompañando el proceso Sergio Humberto Ramirez.",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Aún no se ha gestionado un presupuesto específico ya que es una necesidad que surgió recientemente, y de forma urgente. Nequi se hará responsable de confirmar el presupuesto necesario para la adquisición de la herramienta.",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Murex, OyD, Makers",
      "Cuadrante_Proveedor": "2, 6 y 8",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Nequi, C102200015",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4121381994",
      "Familias": "Servicios SaaS",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Juan Esteban Franco Vargas",
      "Rol_asesor": "Adriana Maria Arango Restrepo",
      "Observaciones": "Revivir/crear nuevo SR, OK Prerrequisitos de Negociación con SR3760922898 y Forms %232383.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "28/07/2023",
      "Fecha Asignación/Delegación": "28/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "22/11/2022",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "22/11/2022",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicio de plataformas",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4116,
      "Title": "Forms",
      "Fecha_solicitud": "28/07/2023",
      "Correo_solicitante": "anbocane@bancolombia.com.co",
      "Nombre_solicitante": "Angie Juliana Bocanegra Canacue",
      "Nombre_iniciativa": "ID 4116 - Compra de Instrumentos Musicales - Patrocinio Región Bogotá",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Desde la Gcia de Gobierno Red; se requiere comprar instrumentos musicales para entregar como patrocinio al Municipio de Albán destinados a la Banda Marcial",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 2720000,
      "Proveedores_conocidos": ".",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Gobierno de R",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4116,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "28/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "28/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4115,
      "Title": "Forms",
      "Fecha_solicitud": "28/07/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 4115 - Compra de curso de extensión THEORY OF CREDIT RISK MODELS\tUDEMY",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión THEORY OF CREDIT RISK MODELS\tUDEMY",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "UDEMY",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4115,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "28/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "28/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4114,
      "Title": "Forms",
      "Fecha_solicitud": "28/07/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 4114 - Compra de curso de extensión OPEN FINANCE FELLOWSHIP\tLATAMFINTECH HUB",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión OPEN FINANCE FELLOWSHIP\tLATAMFINTECH HUB",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "LATAMFINTECH HUB",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4114,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "28/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "28/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4113,
      "Title": "Forms",
      "Fecha_solicitud": "28/07/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 4113 - Compra de curso de extensión CONGRESO NACIONAL DE AGENCIAS DE VIAJES Y TURISMO ASOCIACIÓN COLOMBIANA DE AGENCI",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión CONGRESO NACIONAL DE AGENCIAS DE VIAJES Y TURISMO\tASOCIACIÓN COLOMBIANA DE AGENCIAS DE VIAJES Y TURISMO - ANATO",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "ASOCIACIÓN COLOMBIANA DE AGENCIAS DE VIAJES Y TURISMO - ANATO",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4113,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "28/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "28/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },{
      "ID_lista": 4112,
      "Title": "Forms",
      "Fecha_solicitud": "28/07/2023",
      "Correo_solicitante": "ceamarin@bancolombia.com.co",
      "Nombre_solicitante": "Cesar Abelardo Marin Garcia",
      "Nombre_iniciativa": "ID 4112 - Vinculación del proveedor AVALUAR VALORES S.A.S",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la contratación del proveedor AVALUAR VALORES S.A.S, el cual nos apoyará con la realización de los avalúos comerciales de la GVGA.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Somos un área funcional",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "AVALUAR VALORES S.A.S",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia Valoración de Garantías y Activos C104300032",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4112,
      "Familias": "Honorarios Avalúos",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "31/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "31/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios Profesionales Procesos del Negocio",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4111,
      "Title": "Forms",
      "Fecha_solicitud": "28/07/2023",
      "Correo_solicitante": "BEESPINA@bancolombia.com.co",
      "Nombre_solicitante": "Beatriz Eugenia Lopez Espinal",
      "Nombre_iniciativa": "ID 4111 - Compra accesorios vehículo para Andrea Carolina Medina Brando",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular proveedor para generar pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere realizar el pago de los accesorios para el vehículo que se asignará a Andrea CArolina Medina Brando.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "TALLERES AUTORIZADOS S A  860519235 3",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C104300023",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4111,
      "Familias": "Transporte de Empleados",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "28/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "28/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios de viajes",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4110,
      "Title": "Forms",
      "Fecha_solicitud": "27/07/2023",
      "Correo_solicitante": "gyate@bancolombia.com.co",
      "Nombre_solicitante": "Gilma Carolina Yate Guzman",
      "Nombre_iniciativa": "ID 4110 - Contratacion proveedor",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Vinculación proveedor, organización y logística para evento",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 132000000,
      "Proveedores_conocidos": "CAMARA DE COMERCIO DEL HUILA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GERENCIA DE GESTION COMERCIAL REGION CENTRO- C102100354",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4110,
      "Familias": "BTL",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "27/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "27/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4109,
      "Title": "Forms",
      "Fecha_solicitud": "27/07/2023",
      "Correo_solicitante": "juanrami@bancolombia.com.co",
      "Nombre_solicitante": "Juan David Ramirez Ruiz",
      "Nombre_iniciativa": "ID 4109 - Aromatizacion Presidencia",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Adicional al servicio de aromatizacion Precidencia",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Adicional al servicio de aromatizacion Presidencia",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Myzent",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "c102000000",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4122023861",
      "Familias": "HARD (Operadores de Mantenimiento)",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Naty por Teams, indica que se delegue.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "31/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "31/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Facility Managment",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4108,
      "Title": "Forms",
      "Fecha_solicitud": "27/07/2023",
      "Correo_solicitante": "anrendon@bancolombia.com.co",
      "Nombre_solicitante": "Ana Maria Rendon Lopez",
      "Nombre_iniciativa": "ID 4108 - pago de inscripcion Gartner IT Symposium/Xp",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "se requiere realizar el pago de inscripción para que algunos directivos de Nequi puedan asistir a este evento en octubre",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 27000000,
      "Proveedores_conocidos": "Gartner",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "talento humano C475000000",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4108,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "27/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "27/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4107,
      "Title": "Forms",
      "Fecha_solicitud": "27/07/2023",
      "Correo_solicitante": "NANURIBE@bancolombia.com.co",
      "Nombre_solicitante": "Nancy Milena Uribe Cardona",
      "Nombre_iniciativa": "ID 4107 - Alquiler de espacios en Pereira para evento Sur Extraordinaria",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Alquiler de espacios en Pereira para evento Sur Extraordinaria",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 0,
      "Proveedores_conocidos": "Hotel Soratama SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Gerencia de Aprendizaje-C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4107,
      "Familias": "Otros Servicios Bienes Inmuebles - Muebles",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "27/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "27/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Gestión Inmobiliaria",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4106,
      "Title": "Forms",
      "Fecha_solicitud": "27/07/2023",
      "Correo_solicitante": "NANURIBE@bancolombia.com.co",
      "Nombre_solicitante": "Nancy Milena Uribe Cardona",
      "Nombre_iniciativa": "ID 4106 - Alquiler de espacios en Armenia para taller Sur Extraordinaria",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Alquiler de espacios en Armenia para taller Sur Extraordinaria",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 0,
      "Proveedores_conocidos": "Armenia Hotel",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Gerencia de Aprendizaje C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4106,
      "Familias": "Otros Servicios Bienes Inmuebles - Muebles",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "27/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "27/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Gestión Inmobiliaria",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4105,
      "Title": "Forms",
      "Fecha_solicitud": "27/07/2023",
      "Correo_solicitante": "NANURIBE@bancolombia.com.co",
      "Nombre_solicitante": "Nancy Milena Uribe Cardona",
      "Nombre_iniciativa": "ID 4105 - Alquiler de espacios en Armenia y Pereira",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Alquiler de espacios en Pereira",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 0,
      "Proveedores_conocidos": "Global hotelera",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Gerencia de Aprendizaje-C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4105,
      "Familias": "Otros Servicios Bienes Inmuebles - Muebles",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "27/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "27/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Gestión Inmobiliaria",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4104,
      "Title": "Forms",
      "Fecha_solicitud": "27/07/2023",
      "Correo_solicitante": "JUAPARDO@bancolombia.com.co",
      "Nombre_solicitante": "Juan David Pardo Cantor",
      "Nombre_iniciativa": "ID 4104 - Renovación contrato CW2250364. Aseguramiento de calidad",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2250364",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación contrato CW2250364. Servicios de consultoría en Aseguramiento de calidad en la atención de requerimientos de Clientes Bancolombia",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "175.648.728",
      "Proveedores_conocidos": "XPERIENCE DESIGN",
      "Cuadrante_Proveedor": 1,
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia Atención al Cliente - C103700150",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4119858741",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Luisa Fernanda Garcia Guzman",
      "Rol_asesor": "No aplica",
      "Observaciones": "Jose ok PN con equipo ocmpleto",
      "Comentarios BP": "",
      "Fecha MarketPlace": "04/08/2023",
      "Fecha Asignación/Delegación": "04/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "27/07/2023",
      "Fecha ok. PN": "27/07/2023",
      "sin equipo": "",
      "Áreas pendientes": "01/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4103,
      "Title": "Forms",
      "Fecha_solicitud": "27/07/2023",
      "Correo_solicitante": "jeberare@bancolombia.com.co",
      "Nombre_solicitante": "Jennifer Bergano Arenas",
      "Nombre_iniciativa": "ID 4103 - Empresa organizadora de eventos",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Empresa para organizar eventos en la macarena",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 50000000,
      "Proveedores_conocidos": "Camaleon Nation S.A.S",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "C102200008",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4103,
      "Familias": "BTL",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "27/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "27/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4102,
      "Title": "Forms",
      "Fecha_solicitud": "27/07/2023",
      "Correo_solicitante": "DIANLOPE@bancolombia.com.co",
      "Nombre_solicitante": "Diana Lopez Velasquez",
      "Nombre_iniciativa": "ID 4102 - Venta de cartera plural, cartera castigada",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere acompañamiento de Negociador experto (preferiblemente Andres Felipe Viana Casas con quien ya comenzamos la exploración y asesoría del tema) para desarrollo de proceso competitivo en la búsqueda y selección de compradores de cartera castigada de portafolios personas la venta sería aproximadamente de 1 billon.  Este sería el tercer proceso de venta de cartera castigada de este año.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "aproximadamente el 5% del portafolio",
      "Proveedores_conocidos": "necesitamos hacer proceso de competencia y exploración de mercado",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GCIA ESTRATEGIA COBRANZA AVANZADA Y BRP",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4121900909",
      "Familias": "Servicios de Recuperación Cartera Castigada",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Andres Felipe Viana Casas",
      "Rol_asesor": "No aplica",
      "Observaciones": "Jul 31. Asi sea venta, debe gestionar PN, (validado con Biatri)\nAgo. 02. Biatri ok PN con equipo completo.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "04/08/2023",
      "Fecha Asignación/Delegación": "04/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "31/07/2023",
      "Fecha ok. PN": "31/07/2023",
      "sin equipo": "",
      "Áreas pendientes": "02/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios de Conciliación y Cobranza",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4101,
      "Title": "Forms",
      "Fecha_solicitud": "27/07/2023",
      "Correo_solicitante": "stovar@bancolombia.com.co",
      "Nombre_solicitante": "Silvana Tovar Escobar",
      "Nombre_iniciativa": "ID 4101 - Pago de evento realizado por el fondo inmobiliario",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Solicitar material",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Coctel de presidencia con el fondo inmobiliario",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Brandex",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Vicepresidencia Negocios Corporativos y CC: C102000050",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4101,
      "Familias": "BTL",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "27/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "27/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4100,
      "Title": "Forms",
      "Fecha_solicitud": "27/07/2023",
      "Correo_solicitante": "fevelasc@bancolombia.com.co",
      "Nombre_solicitante": "Fernando Enrique Velasco Forero",
      "Nombre_iniciativa": "ID 4100 - Renovación servicio de soporte Panagon. contrato 4314 (CW2221538)",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": 4314,
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Actualmente Panagon  está en proceso de jubilación, se utiliza para consultas de referencia. EL contrato actual tiene un servicio de soporte sobre la aplicación de duración de 6 meses que finaliza en agosto. Se requiere renovarlo pero con un esquema de uso de horas por demanda mientras se finaliza la jubilación en Q3. contrato 4314 (CW2221538)",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Priorizado por el CAE",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "70.000.000",
      "Proveedores_conocidos": "GRUPO INTENT",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVOLUCION DIGITAL C103500106",
      "Nombre_lider_EVC": "Fernando Enrique Velasco Forero",
      "SR_ARIBA": "SR4119858726",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Nicolas Quiceno Carmona",
      "Rol_asesor": "Monica Marcela Alzate Granda",
      "Observaciones": "Naty ok PN con equipo completo",
      "Comentarios BP": "",
      "Fecha MarketPlace": "04/08/2023",
      "Fecha Asignación/Delegación": "04/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "27/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "28/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4099,
      "Title": "Forms",
      "Fecha_solicitud": "27/07/2023",
      "Correo_solicitante": "YUMONTOY@bancolombia.com.co",
      "Nombre_solicitante": "Yuliana Milena Montoya Quintero",
      "Nombre_iniciativa": "ID 4099 - Revisión renovación servicios Ariaxa para el aplicativo AyC. CW2252839",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2252839",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere revisar la renovación del contrato Marco y las ordenes de servicio adicionales que también estan proximas a vencerse para el proveedor Ariaxa . CW2252839",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Se debe revisar cuales ordenes se van a renovar y confirmar con las areas usuarias para el traslado presupuestal",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Ariaxa",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Otras Funciones de Apoyo - C103500008",
      "Nombre_lider_EVC": "Adriana Bustamante",
      "SR_ARIBA": "SR4119858699",
      "Familias": "Servicios SaaS",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Diana Milena Arango Correa",
      "Rol_asesor": "Monica Marcela Alzate Granda",
      "Observaciones": "Jose ok PN con equipo completo",
      "Comentarios BP": "",
      "Fecha MarketPlace": "04/08/2023",
      "Fecha Asignación/Delegación": "04/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "27/07/2023",
      "Fecha ok. PN": "27/07/2023",
      "sin equipo": "",
      "Áreas pendientes": "01/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de plataformas",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4098,
      "Title": "Forms",
      "Fecha_solicitud": "27/07/2023",
      "Correo_solicitante": "yequinte@bancolombia.com.co",
      "Nombre_solicitante": "Yenifer Quintero Quiceno",
      "Nombre_iniciativa": "ID 4098 - Patrocinio al municipio de Santa Rosa de Osos",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Hacer pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor suministra refrigerios para eventos realizado en el municipio de Santa Rosa de Osos Antioquia",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Hotel Cortejo Imperial S.A.S - NIT 811010486",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gobierno de Red - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4098,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "27/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "27/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4097,
      "Title": "Forms",
      "Fecha_solicitud": "27/07/2023",
      "Correo_solicitante": "ANGMAROD@bancolombia.com.co",
      "Nombre_solicitante": "Angela Maria Rodriguez Castano",
      "Nombre_iniciativa": "ID 4097 - Desloqueo de provedor Extras SA  NIT 890327120-1",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Desbloquear el proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveeedor extra S.A esta prestando los servicios en la gerencia como proveedor de temporales , se equiere desbloquear ara realizar el pago de los servicios prestados",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "EXTRAS.S.A",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Seccion de reclitamiento y seleccion C103200040",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4097,
      "Familias": "Servicios Temporales",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "27/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "27/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Atracción y desarrollo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4175,
      "Title": "Forms",
      "Fecha_solicitud": "26/07/2023",
      "Correo_solicitante": "ealjojoa@bancolombia.com.co",
      "Nombre_solicitante": "Edgar Andres Lopez Jojoa",
      "Nombre_iniciativa": "ID 4175 - ID 4088 - ACTUALIZACION TARIFAS AVALUO 2024. TINSA CW2286818",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2286818 - CW2285430",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Actualización de tarifas de avalúos para el periodo 2024. TINSA CW2286818  (APPRAISSER CW2285430)",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "7.717.000.000",
      "Proveedores_conocidos": "TINSA - APPRAISSER",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "C105500052",
      "Nombre_lider_EVC": "Juan Camilo Arango Aristizabal",
      "SR_ARIBA": "SR4117411021",
      "Familias": "Honorarios Avalúos",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Andrea Diaz Soto",
      "Rol_asesor": "No aplica",
      "Observaciones": "Biatri ok PN. (duplicar req. para generar otro SR son dos proveedores diferentes.  Nuevo SR= SR4121873365 para APPRAISSER.  Los PN se gestionan con el SR4117411021 de TINSA)",
      "Comentarios BP": "",
      "Fecha MarketPlace": "04/08/2023",
      "Fecha Asignación/Delegación": "04/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "26/07/2023",
      "Fecha ok. PN": "31/07/2023",
      "sin equipo": "",
      "Áreas pendientes": "01/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios Profesionales Procesos del Negocio",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4096,
      "Title": "Forms",
      "Fecha_solicitud": "26/07/2023",
      "Correo_solicitante": "cmzapata@bancolombia.com.co",
      "Nombre_solicitante": "Cindy Milena Zapata Cardona",
      "Nombre_iniciativa": "ID 4096 - Creación Proveedor único Pago",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "buen dia se solicita la creación del proveedor Carlos Manosalvas Silva- Cédula del Beneficiario: 1714555719\n\nAl cual se le realizara un pago según histórico en el correo aprobado por nuestro jurídico  con la siguiente información:\n\ncódigo material 5004574   COBRANZA BEG-HONORARIOS PROCESOS JURIDIC\nValor: $1500 USD\nCódigo material contable: 5004574           COBRANZA BEG-HONORARIOS PROCESOS JURIDIC\nNombre del Beneficiario: Carlos Manosalvas Silva\nCédula del Beneficiario: 1714555719\nNombre del Banco: Banco Pichincha\nCuenta Bancaria No: 4341051900\nSwift Code: PICHECEQ\nDirección del Banco: Av. Amazonas 4545 y Alfonso Pereira\nTeléfono del Banco: (+593) 22 980 980\nCorreo electrónico para Notificaciones: cmanosalvas@lawmpa.com, y mfcascante@lawmpa.com",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "no aplica",
      "Proveedores_conocidos": "Carlos Manosalvas Silva- Cédula del Beneficiario: 1714555719",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GERENCIA DE CONCILIACION CON CLIENTES CORPORATIVOS CENTRO DE COSTOS C10380000",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4096,
      "Familias": "Servicios de  Conciliación y Cobranza Preventiva",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "27/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "27/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios de Conciliación y Cobranza",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4095,
      "Title": "Forms",
      "Fecha_solicitud": "26/07/2023",
      "Correo_solicitante": "julmoral@bancolombia.com.co",
      "Nombre_solicitante": "Julian Morales Patino",
      "Nombre_iniciativa": "ID 4095 - Estudio Plataforma Confirming",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la integración con la plataforma con el objetivo de conectarnos directamente a sus pagadores y proveedores para el fondeo de sus facturas. La plataforma se integra al ERP de los clientes para tomar la información directamente y así facilitar el proceso para estos y después nos envían la información a través de H2H. La plataforma es un tercero con el cual trabajamos de la mano, en donde no se contrata pagando un fee por sus servicios, sino que ellos cobran unos puntos básicos sobre la tasa de las facturas descontadas a través de esta; ellos entran como un proveedor que nos permite una mejor integración de cara a pagadores y proveedores",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "La plataforma es un tercero con el cual trabajamos de la mano, en donde no se contrata pagando un fee por sus servicios, sino que ellos cobran unos puntos básicos sobre la tasa de las facturas descontadas a través de esta, razón por la cual no es necesario un presupuesto previo, dado que el pago se hará en forma de comisiones con forme estas se vayan generando",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "FYM TECHNOLOGY S.A.S.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Nuevos Negocios",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4118432952",
      "Familias": "Servicios SaaS",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Se delega, proque este servicio es para terceros.  definición dada por Diana con el primer req. de este usuario y del mismo tipo.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "27/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "27/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicio de plataformas",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4094,
      "Title": "Forms",
      "Fecha_solicitud": "26/07/2023",
      "Correo_solicitante": "yequinte@bancolombia.com.co",
      "Nombre_solicitante": "Yenifer Quintero Quiceno",
      "Nombre_iniciativa": "ID 4094 - Patrocinio al municipio de Concordia",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Hacer pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor suministra los kits campesinos con la imagen Bancolombia en todas las regiones",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "IMAGEN PERFECTA 7 ASESORES EN MARKETING S.A.S NIT 80020072",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gobierno de Red - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4094,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "26/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "26/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4093,
      "Title": "Forms",
      "Fecha_solicitud": "26/07/2023",
      "Correo_solicitante": "saravela@bancolombia.com.co",
      "Nombre_solicitante": "Sara Velasquez Bedoya",
      "Nombre_iniciativa": "ID 4093 - Catering para eventos",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular al proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Contratación de catering para eventos corporativos",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "GANSO & CASTOR SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C102000000 Gestión de Presidencia",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4093,
      "Familias": "BTL",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "26/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "26/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4091,
      "Title": "Forms",
      "Fecha_solicitud": "26/07/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 4091 - Compra de curso de extensión DIPLOMADO EN GERENCIA DE PROYECTOS - UNIVERSIDAD EIA",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión DIPLOMADO EN GERENCIA DE PROYECTOS - UNIVERSIDAD EIA",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "UNIVERSIDAD EIA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4091,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "26/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "26/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4090,
      "Title": "Forms",
      "Fecha_solicitud": "26/07/2023",
      "Correo_solicitante": "gyate@bancolombia.com.co",
      "Nombre_solicitante": "Gilma Carolina Yate Guzman",
      "Nombre_iniciativa": "ID 4090 - VINCULACION PROVEEDOR",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Vinculación proveedor, servicio restaurante para eventos con clientes",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "132.000.000",
      "Proveedores_conocidos": "EL FOGON",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GERENCIA DE GESTION COMERCIAL REGION CENTRO C102100354",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4090,
      "Familias": "BTL",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "26/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "26/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4089,
      "Title": "Forms",
      "Fecha_solicitud": "26/07/2023",
      "Correo_solicitante": "gyate@bancolombia.com.co",
      "Nombre_solicitante": "Gilma Carolina Yate Guzman",
      "Nombre_iniciativa": "ID 4089 - Vinculacion proveedor",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Vinculación proveedor, apoyo logístico en eventos",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 132000000,
      "Proveedores_conocidos": "INSITU GROUP",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GERENCIA DE GESTION COMERCIAL REGION CENTRO C102100354",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4089,
      "Familias": "BTL",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "26/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "26/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4088,
      "Title": "Forms",
      "Fecha_solicitud": "26/07/2023",
      "Correo_solicitante": "ealjojoa@bancolombia.com.co",
      "Nombre_solicitante": "Edgar Andres Lopez Jojoa",
      "Nombre_iniciativa": "ID 4088 - ACTUALIZACION TARIFAS AVALUO 2024. TINSA CW2286818",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2286818 - CW2285430",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Actualización de tarifas de avalúos para el periodo 2024. TINSA CW2286818  (APPRAISSER CW2285430)",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "7.717.000.000",
      "Proveedores_conocidos": "TINSA - APPRAISSER",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "C105500052",
      "Nombre_lider_EVC": "Juan Camilo Arango Aristizabal",
      "SR_ARIBA": "SR4117411021",
      "Familias": "Honorarios Avalúos",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Andrea Diaz Soto",
      "Rol_asesor": "No aplica",
      "Observaciones": "Biatri ok PN. (duplicar req. para generar otro SR son dos proveedores diferentes.  Nuevo SR= SR4121873365 para APPRAISSER.  Los PN se gestionan con el SR4117411021 de TINSA)",
      "Comentarios BP": "",
      "Fecha MarketPlace": "04/08/2023",
      "Fecha Asignación/Delegación": "04/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "26/07/2023",
      "Fecha ok. PN": "31/07/2023",
      "sin equipo": "",
      "Áreas pendientes": "01/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios Profesionales Procesos del Negocio",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4087,
      "Title": "Forms",
      "Fecha_solicitud": "26/07/2023",
      "Correo_solicitante": "ANGMAROD@bancolombia.com.co",
      "Nombre_solicitante": "Angela Maria Rodriguez Castano",
      "Nombre_iniciativa": "ID 4087 - VINCULAR AL PROVEDOR  MI PRODUCTORA S.A.S",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor prestara servicio Prestaremos Servicio de Producción Audiovisual  para marca empleadora y planeación del talento",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "340.000.000",
      "Proveedores_conocidos": "MI PRODUCTORA S.A.S",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "c103200040",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4087,
      "Familias": "Producción y Postproducción",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "26/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "26/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4086,
      "Title": "power_apps",
      "Fecha_solicitud": "25/07/2023",
      "Correo_solicitante": "mancebal@bancolombia.com.co",
      "Nombre_solicitante": "Manuela Ceballos Alzate",
      "Nombre_iniciativa": "ID 4086 - Pedido negociador para licencias adobe",
      "Tipo_Requerimiento": "Nueva contratación",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Licencia de adobe premiere",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "3.000.000",
      "Proveedores_conocidos": "Cymetria",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "VICEPRESIDENCIA CORP GRUPO BANCOLOMBIA",
      "Nombre_area_y_ceco": "Cultura y Gestión del Cambio C103200070",
      "Nombre_lider_EVC": "Ayda Viviana Diaz Mosquera",
      "SR_ARIBA": "SR4116648815",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "John Alexis Velasquez Garcia",
      "Rol_asesor": "Monica Marcela Alzate Granda",
      "Observaciones": "Naty ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "28/07/2023",
      "Fecha Asignación/Delegación": "28/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "26/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "26/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4085,
      "Title": "Forms",
      "Fecha_solicitud": "25/07/2023",
      "Correo_solicitante": "NANURIBE@bancolombia.com.co",
      "Nombre_solicitante": "Nancy Milena Uribe Cardona",
      "Nombre_iniciativa": "ID 4085 - Alquiler de salones para evento de Sur Extraordinaria en Manizales",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Alquiler de salones para evento de Sur Extraordinaria en Manizales",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 0,
      "Proveedores_conocidos": "HOTEL TERMALES EL OTOÑO",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Gerencia de Aprendizaje-C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4085,
      "Familias": "Otros Servicios Bienes Inmuebles - Muebles",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "25/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "25/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Gestión Inmobiliaria",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4084,
      "Title": "Forms",
      "Fecha_solicitud": "25/07/2023",
      "Correo_solicitante": "jusalaz@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Salazar Ortiz",
      "Nombre_iniciativa": "ID 4084 - Piloto emails automatizados con Sales Force",
      "Tipo_Requerimiento": "",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Contratariamos por valor cero (para el piloto) el marketing cloud de sales force con el fin de desarrollar los programas de email automatizados.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Porque es un piloto que realizaremos para luego evaluar viabilidad del proyecto.",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Sales Force",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Dirección soluciones digitales Mercadeo",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4116212096",
      "Familias": "Email",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Isabella Correa Valencia",
      "Rol_asesor": "No aplica",
      "Observaciones": "Dianis ok PN con equipo completo",
      "Comentarios BP": "",
      "Fecha MarketPlace": "04/08/2023",
      "Fecha Asignación/Delegación": "04/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "26/07/2023",
      "Fecha ok. PN": "26/07/2023",
      "sin equipo": "",
      "Áreas pendientes": "28/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Contactabilidad con Clientes",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4083,
      "Title": "Forms",
      "Fecha_solicitud": "25/07/2023",
      "Correo_solicitante": "fermesa@bancolombia.com.co",
      "Nombre_solicitante": "Fernando Mesa Rivera",
      "Nombre_iniciativa": "ID 4083 - Negociación tarifas CB móvil, corresponsales agregadores.",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere renegociar las tarifas del formato de corresponsalía móvil. Corresponsales agregadores.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "450.000.000",
      "Proveedores_conocidos": "Multipagas",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "ADC Corresponsales Bancarios",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4116212077",
      "Familias": "Corresponsales Agregadores",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Santiago Zapata Serna",
      "Rol_asesor": "No aplica",
      "Observaciones": "Dianis por la naturaleza de la solicitud no lo envio a PN.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "28/07/2023",
      "Fecha Asignación/Delegación": "28/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "25/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios Corresponsales Bancarios",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4082,
      "Title": "Forms",
      "Fecha_solicitud": "25/07/2023",
      "Correo_solicitante": "jcorrea@bancolombia.com.co",
      "Nombre_solicitante": "Juan David Correa Carmona",
      "Nombre_iniciativa": "ID 4082 - Membresía a Red Internacional de Estrategia - Outthinkers",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere inscripción a la Red Internacional de Estrategia Outthinker, la cual es una red global de ejecutivos de estrategia e innovación comprometidos a mantenerse a la vanguardia del ritmo de la disrupción. Los miembros obtienen acceso exclusivo a un grupo de pares global, líderes de pensamiento de clase mundial, aprendizaje curado, redes 1:1 e investigaciones y publicaciones sobre estrategia.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "3.000 USD",
      "Proveedores_conocidos": "Outthinker",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Dirección de Estrategia Corporativa  C102000014",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4082,
      "Familias": "Suscripciones",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "25/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "25/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios de Información",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4081,
      "Title": "Forms",
      "Fecha_solicitud": "25/07/2023",
      "Correo_solicitante": "geragome@bancolombia.com.co",
      "Nombre_solicitante": "Geraldine Gomez Ruiz",
      "Nombre_iniciativa": "ID 4081 - Vincular a Memory Corp como proveedor de la fiduciaria para los custodios",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la vinculación de memory corp en la fiduciaria ya que es la empresa encargada del custodio de pagarés electrónicos propuesta por varios clientes. Por lo tanto, se necesita radicar para la fiduciaria y no para un solo fideicomiso.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Los custodios son parte fundamental del proceso de estructuración y esta empresa se requiere para avanzar con otros negocios",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Memory Corp",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Dirección de estructuración de Negocios - C305200000",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4119449303",
      "Familias": "Servicios Gestión Documental",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Biatri solicita delegarlo y que la asesore Jorge mario.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "27/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "27/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Back Office",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4080,
      "Title": "Forms",
      "Fecha_solicitud": "25/07/2023",
      "Correo_solicitante": "criscard@bancolombia.com.co",
      "Nombre_solicitante": "Cristian Camilo Cardona Sanchez",
      "Nombre_iniciativa": "ID 4080 - Estudio Tendencias y Prácticas Compensación",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de un estudio de tendencias y prácticas de compensación en puestos digitales.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "22.000.000",
      "Proveedores_conocidos": "Mercer",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "Gerencia Talento Humano - C475000000",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4080,
      "Familias": "Investigaciones de Mercado",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "25/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "25/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4079,
      "Title": "Forms",
      "Fecha_solicitud": "25/07/2023",
      "Correo_solicitante": "geragome@bancolombia.com.co",
      "Nombre_solicitante": "Geraldine Gomez Ruiz",
      "Nombre_iniciativa": "ID 4079 - Vinculación de proveedores",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se solicita vincular el proveedor Durga Legal a la fiduciaria puesto que nos realizó un trabajo de traducción de contrato y el proceso fue excelente. Además, requerimos pagar por este trabajo y a la par vincularlo a la compañía. Muchas gracias.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Se necesitan los servicos para un tema puntual de una traducción de contrato",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Durga Legal S.A.S",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Dirección de estructuración de Negocios - C305200000",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4079,
      "Familias": "Consultorias Corporativas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "25/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "25/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Consultorias Corporativas",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4078,
      "Title": "Forms",
      "Fecha_solicitud": "25/07/2023",
      "Correo_solicitante": "lisezulu@bancolombia.com.co",
      "Nombre_solicitante": "Liset Vanessa Zuluaga Jimenez",
      "Nombre_iniciativa": "ID 4078 - Solicitud Domina diferenciar tarifas Preaprobados “Nuevos” y “Repotencializados”",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor Domina, realizo una solicitud por medio de una alerta sobre la poca efectividad que están presentando en las bases de datos de “Repotencializados” que tiene para el proceso de Preaprobados y esta  situación está afectando el modelo financiero  generando pérdidas financieras. Por lo anterior esta solicitando separar un espacio y revisar en conjunto la posibilidad de diferenciar tarifas para ambas clases de base de datos: “Nuevos” y “Repotencializados” con el fin de mejorar el margen en el proceso de Preaprobados y no generar pérdidas.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Cuando se solicito el presupuesto anual se realizo teniendo en cuenta un % general para todos los aliados y no como en este caso que es una solicitud puntual para el aliado DOMINA",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "DOMINA - Nombre actual",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Sección Servicios BPO - Centro de costos C505400123",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4114594122",
      "Familias": "Ventas Digitales",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Yohany Anibal Gaviria Quintero",
      "Rol_asesor": "No aplica",
      "Observaciones": "Dianis por la naturaleza de la solicitud no va a PN:_  por favor validar que la familia esté correcta.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "28/07/2023",
      "Fecha Asignación/Delegación": "28/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "25/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Modelos de Relacionamiento Integral",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4092,
      "Title": "Forms",
      "Fecha_solicitud": "24/07/2023",
      "Correo_solicitante": "ANIEBLES@bancolombia.com.co",
      "Nombre_solicitante": "Angel David Niebles Anzola",
      "Nombre_iniciativa": "ID 4092 - Renovación OS 015 Cirion CW2269667",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2269667",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación de esta Orden de Servicio 015 con el proveedor Cirion hasta diciembre del 2023. CW2269667",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "300 millones mes",
      "Proveedores_conocidos": "CIRION",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "ADC DISEÑO Y OPERACION TELCO TI - C103500100",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4117739030",
      "Familias": "Telecomunicaciones",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Madelyn Liceth Moya Osorio",
      "Rol_asesor": "No aplica",
      "Observaciones": "Hola José. Es renovación y proveedor no registra en riesgos, por lo tanto no va a PN.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "28/07/2023",
      "Fecha Asignación/Delegación": "28/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "26/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio telecomunicación",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4077,
      "Title": "Forms",
      "Fecha_solicitud": "24/07/2023",
      "Correo_solicitante": "jeberare@bancolombia.com.co",
      "Nombre_solicitante": "Jennifer Bergano Arenas",
      "Nombre_iniciativa": "ID 4077 - Proveedor de estampacion de camisetas",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Ya con el proveedor habiamos realizado un proceso de inscripción pero se vencio el tiempo, es para estampacion de camisetas",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 3000000,
      "Proveedores_conocidos": "Instantex S.A.S",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "C102200008",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4077,
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "25/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "25/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4076,
      "Title": "Forms",
      "Fecha_solicitud": "24/07/2023",
      "Correo_solicitante": "jeberare@bancolombia.com.co",
      "Nombre_solicitante": "Jennifer Bergano Arenas",
      "Nombre_iniciativa": "ID 4076 - Proveedor para experiencia de marca y marketing experencial",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Proveedor para realizar activaciones de marca en eventos",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 15000000,
      "Proveedores_conocidos": "TOP BRAND S.A.S.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "C102200008",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4076,
      "Familias": "BTL",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "25/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "25/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4075,
      "Title": "Forms",
      "Fecha_solicitud": "24/07/2023",
      "Correo_solicitante": "ADELGADO@bancolombia.com.co",
      "Nombre_solicitante": "Alejandra Delgado Alvarez",
      "Nombre_iniciativa": "ID 4075 - Asesoría para conocer material aplicable a una solped",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "solicitar material",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Realización de evento en las salas laboratorio del MAMM (Museo de Arte Moderno) ya el servicio fue prestado y en el alquiler de este espacio se incluyeron montaje y desmontaje y todo el mobiliario.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Museo de Arte Moderno de Medellín",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "C102200051",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4075,
      "Familias": "Otros Servicios Bienes Inmuebles - Muebles",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "24/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "24/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Gestión Inmobiliaria",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4074,
      "Title": "Forms",
      "Fecha_solicitud": "24/07/2023",
      "Correo_solicitante": "saravela@bancolombia.com.co",
      "Nombre_solicitante": "Sara Velasquez Bedoya",
      "Nombre_iniciativa": "ID 4074 - Catering para eventos",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Catering para eventos",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "QSINE S.A.S",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gestión de Presidencia C102000000",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4074,
      "Familias": "BTL",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "24/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "24/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4073,
      "Title": "Forms",
      "Fecha_solicitud": "24/07/2023",
      "Correo_solicitante": "saravela@bancolombia.com.co",
      "Nombre_solicitante": "Sara Velasquez Bedoya",
      "Nombre_iniciativa": "ID 4073 - Inmobiliaria para evento",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Proveedor de muebles para eventos",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Inmobiliaria Bustamante SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gestión de Presidencia C102000000",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4073,
      "Familias": "BTL",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "24/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "24/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4072,
      "Title": "Forms",
      "Fecha_solicitud": "24/07/2023",
      "Correo_solicitante": "yequinte@bancolombia.com.co",
      "Nombre_solicitante": "Yenifer Quintero Quiceno",
      "Nombre_iniciativa": "ID 4072 - Patrocinio al municipio de Jericó",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Hacer pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor suministra refrigerios para eventos realizados en el municipio de Jericó",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Juana Cano Córdoba CC 1001587391",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gobierno de Red - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4072,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "24/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "24/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4071,
      "Title": "Forms",
      "Fecha_solicitud": "24/07/2023",
      "Correo_solicitante": "yequinte@bancolombia.com.co",
      "Nombre_solicitante": "Yenifer Quintero Quiceno",
      "Nombre_iniciativa": "ID 4071 - Patrocinio al municipio de carolina del Príncipe",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Hacer pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor suministra refrigerios en eventos realizados en el municipio de Carolina del Príncipe",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Camilo López Hincapié - 1128459699",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gobierno de Red - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4071,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "24/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "24/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4070,
      "Title": "Forms",
      "Fecha_solicitud": "24/07/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 4070 - Compra de curso de extensión DIGITAL PRODUCT MANAGEMENT\tKURIOS",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión DIGITAL PRODUCT MANAGEMENT\tKURIOS",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "KURIOS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4070,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "24/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "24/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4069,
      "Title": "Forms",
      "Fecha_solicitud": "24/07/2023",
      "Correo_solicitante": "NANURIBE@bancolombia.com.co",
      "Nombre_solicitante": "Nancy Milena Uribe Cardona",
      "Nombre_iniciativa": "ID 4069 - Alquiler de espacios para evento Sur Extraordinaria en Pereira",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Alquiler de espacios para evento Sur Extraordinaria en Pereira",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 0,
      "Proveedores_conocidos": "Corporación Cultural y Deportiva del Comercio",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Gerencia de Aprendizaje C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4069,
      "Familias": "Otros Servicios Bienes Inmuebles - Muebles",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "24/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "24/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Gestión Inmobiliaria",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4068,
      "Title": "Forms",
      "Fecha_solicitud": "24/07/2023",
      "Correo_solicitante": "olserran@bancolombia.com.co",
      "Nombre_solicitante": "Oscar Leonel Serrano Nino",
      "Nombre_iniciativa": "ID 4068 - Aseguramiento de Instancias de almacenamiento S3 PARA EL GRUPO BANCOLOMBIA",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se solicita liberar RFP para el Aseguramiento de Instancias de almacenamiento S3 con el fin de proteger la información que se almacena en los Buckets S3 contra el Malware.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "50.0000 USD Licenciamiento y 10 Millones de AOM",
      "Proveedores_conocidos": "TrendMicro-OpsWat-Broadcom",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": 104300559,
      "Nombre_lider_EVC": "EVC Capacidades de Ciberseguridad",
      "SR_ARIBA": "SR4113296855",
      "Familias": "Prevención Ciberseguridad",
      "Categoría": "Seguridad",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Pablo Zapata Franco",
      "Rol_asesor": "Adriana Maria Arango Restrepo",
      "Observaciones": "Cata ok PN con equipo completo",
      "Comentarios BP": "Llevar al MP",
      "Fecha MarketPlace": "04/08/2023",
      "Fecha Asignación/Delegación": "04/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "24/07/2023",
      "Fecha ok. PN": "24/07/2023",
      "sin equipo": "",
      "Áreas pendientes": "03/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Ciberseguridad y seguridad de la información",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4067,
      "Title": "Forms",
      "Fecha_solicitud": "21/07/2023",
      "Correo_solicitante": "jmpulgar@bancolombia.com.co",
      "Nombre_solicitante": "John Mauricio Pulgarin",
      "Nombre_iniciativa": "ID 4067 - RENOVACION CONTRATO CW2256856 VITAS COMFAMA",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2256856",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Requerimos acompañamiento para la renovación del contrato CW2256856 Vitas Comfama, el cual es por 5 años y con un valor estimado de 1.000 Millones, creación de la nueva pagina de beneficios Vitas, a través de la cual, los empleados podrán registrarse, recibir clases sincrónicas y asincrónicas, solicitar citas con profesionales, reservar clases.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "$1.000.000.000",
      "Proveedores_conocidos": "CCF ANTIOQUIA COMFAMA NIT  890900841-9",
      "Cuadrante_Proveedor": 4,
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GERENCIA CALIDAD DE VIDA C103200030",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4110621773",
      "Familias": "Convenios y Beneficios",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Juan Pablo Ramirez Cardenas",
      "Rol_asesor": "No aplica",
      "Observaciones": "Naty, renovación, proveedor riesgo 4 no va a PN, pero por el monto, te lo envió, aunque es un tema delegable, me parece mejor tenerlo acá para mirar posibles eficiencias,.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "28/07/2023",
      "Fecha Asignación/Delegación": "28/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "24/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4066,
      "Title": "Forms",
      "Fecha_solicitud": "21/07/2023",
      "Correo_solicitante": "JULHINCA@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Hincapie Uribe",
      "Nombre_iniciativa": "ID 4066 - Diseño del proceso de vinculación de Agregadores de Servicios bancarios",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere revisar un proceso de vinculación de aliados tecnológicos que hoy utilizan nuestros productos transaccionales para desarrollar su modelo de negocio (agregadores bancarios)",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Estamos revisando la forma de negociar con estos aliados",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Pexto, Coplíquido, Moneda Colombia, Milio, Bitubi, Palomma",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia Nuevos Negocios C103800398",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4110505610",
      "Familias": "Canales Digitales",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Sara Quintero Perez",
      "Rol_asesor": "No aplica",
      "Observaciones": "Dianis ok PN con equipo completo",
      "Comentarios BP": "",
      "Fecha MarketPlace": "28/07/2023",
      "Fecha Asignación/Delegación": "28/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "25/07/2023",
      "Fecha ok. PN": "25/07/2023",
      "sin equipo": "",
      "Áreas pendientes": "27/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Canales Digitales",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4065,
      "Title": "Forms",
      "Fecha_solicitud": "21/07/2023",
      "Correo_solicitante": "yequinte@bancolombia.com.co",
      "Nombre_solicitante": "Yenifer Quintero Quiceno",
      "Nombre_iniciativa": "ID 4065 - Patrocinio al municipio de cañasgordas",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Generar pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor comercializa y fabrica placas industriales grabadas en metales, apliques y botones en Zamack, accesorios publicitarios y productos para premiaciones",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Mundo Herrajes - Acreedor Cod: 8164",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gobierno de Red - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4065,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "21/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "21/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4064,
      "Title": "Forms",
      "Fecha_solicitud": "21/07/2023",
      "Correo_solicitante": "yequinte@bancolombia.com.co",
      "Nombre_solicitante": "Yenifer Quintero Quiceno",
      "Nombre_iniciativa": "ID 4064 - Patrocinio al municipio de La Pintada",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Generar pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor suministra refrigerios para eventos en el municipio de La Pintada Antioquia",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Comfenalco Atioquia - NIT 8909008426",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gobierno de Red - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4064,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "21/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "21/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4063,
      "Title": "Forms",
      "Fecha_solicitud": "21/07/2023",
      "Correo_solicitante": "yequinte@bancolombia.com.co",
      "Nombre_solicitante": "Yenifer Quintero Quiceno",
      "Nombre_iniciativa": "ID 4063 - Patrocinio al municipio de Puerto Salgar",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vinculación de proveedor y realizar pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor suministra refrigerios para eventos realizados en el municipio de Puerto Salgar Cundinamarca",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Eslendy Palomo Calvo - CC: 2 0 8 2 9 9 5 6",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gobierno de Red - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4063,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "21/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "21/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4062,
      "Title": "Forms",
      "Fecha_solicitud": "21/07/2023",
      "Correo_solicitante": "yequinte@bancolombia.com.co",
      "Nombre_solicitante": "Yenifer Quintero Quiceno",
      "Nombre_iniciativa": "ID 4062 - Patrocinio al municipio de San Carlos",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "VInculación de proveedor y pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "EL proveedor suministra refrigerios para eventos realizados en el municipio de San Carlos Antioquia",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Beatriz Elena Giraldo Giraldo - CC 43782317",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gobierno de Red - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4062,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "21/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "21/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4061,
      "Title": "Forms",
      "Fecha_solicitud": "21/07/2023",
      "Correo_solicitante": "yequinte@bancolombia.com.co",
      "Nombre_solicitante": "Yenifer Quintero Quiceno",
      "Nombre_iniciativa": "ID 4061 - Patrocinio al municipio de Argelia",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Generar pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor confecciona y vende uniformes de fútbol y demás implementos deportivos",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "CONFECCIONES DEPORTES MUNDIAL - 901162161",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gobierno de Red - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4061,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "21/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "21/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4060,
      "Title": "Forms",
      "Fecha_solicitud": "21/07/2023",
      "Correo_solicitante": "yequinte@bancolombia.com.co",
      "Nombre_solicitante": "Yenifer Quintero Quiceno",
      "Nombre_iniciativa": "ID 4060 - Patrocinio municipio de Norcasia",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Generar un pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor confecciona y vende uniformes de fútbol",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "CONFECCIONES MUNDIAL S.A.S NIT 901162161",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gobierno de Red - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4060,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "21/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "21/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4059,
      "Title": "Forms",
      "Fecha_solicitud": "21/07/2023",
      "Correo_solicitante": "yequinte@bancolombia.com.co",
      "Nombre_solicitante": "Yenifer Quintero Quiceno",
      "Nombre_iniciativa": "ID 4059 - Patrocinio Muniipio de La Ceja Antioquia",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Generar un pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor vende bicicletas en el municipio de La Ceja Antioquia",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Libardo Soto Henao - Deportes El Pedalazo - La Ceja CC:15380679",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gobierno de Red - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4059,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "21/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "21/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4058,
      "Title": "Forms",
      "Fecha_solicitud": "21/07/2023",
      "Correo_solicitante": "GCGOMEZ@bancolombia.com.co",
      "Nombre_solicitante": "Gloria Cecilia Gomez Zapata",
      "Nombre_iniciativa": "ID 4058 - Renovación contrato BC SUPPORT, contrato CW2286662",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2286662",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación Orden de Servicio . servicios técnicos especializados para habilitar servicios y procesos de TI contrato CW2286662",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "N/A",
      "Proveedores_conocidos": "BC SUPPORT",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "ADMINISTRACION PROVEEDORES TI-C103500002",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4110358914",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Daniel Jimenez Delgado",
      "Rol_asesor": "No aplica",
      "Observaciones": "Jose ok PN con equipo completo.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "28/07/2023",
      "Fecha Asignación/Delegación": "28/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "21/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "26/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4057,
      "Title": "Forms",
      "Fecha_solicitud": "21/07/2023",
      "Correo_solicitante": "juadagon@bancolombia.com.co",
      "Nombre_solicitante": "Juan David Gonzalez Toro",
      "Nombre_iniciativa": "ID 4057 - Renovacion de CW2300325 - ACUERDO DE ENTENDIMIENTO PARA LA PRESTACION DE SERVICIOS ENTRE GRUPO MENSAJE DE VOZ",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2300325",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere continuar con la renovación del acuerdo de entendimiento por el mismo tiempo estipulado y las mismas condiciones pactadas, no se realizaran cambios adicionales al acuerdo ya firmado.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "30.000.000",
      "Proveedores_conocidos": "GRUPO MENSAJE DE VOZ S.A.S",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Servicio de apoyo al Negocio Sufi Centro de costos   C105000210",
      "Nombre_lider_EVC": "Liliana Maria Cano Orlas",
      "SR_ARIBA": "SR4110358896",
      "Familias": "Servicios de Conciliación y Cobranza SUFI",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "21/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "21/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios de Conciliación y Cobranza",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4056,
      "Title": "Forms",
      "Fecha_solicitud": "20/07/2023",
      "Correo_solicitante": "camescob@bancolombia.com.co",
      "Nombre_solicitante": "Camilo Escobar Mesa",
      "Nombre_iniciativa": "ID 4056 - Avalúo comercial Bodega Fase 1, Parque Logístico Constellation, Bogotá",
      "Tipo_Requerimiento": "Es un requerimiento del equipo de Renta y Uso de Leasing",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "En aplicativos de Leasing como Mercurio y/o Delfin",
      "Detalle_producto_o_servicio": "Se requiere la realización del avalúo comercial para el inmueble en proceso de adquisición de Renta y Uso: Bodega Fase 1, Parque Logístico Constellation, Bogotá",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 15000000,
      "Proveedores_conocidos": "LOGAN VALUACION SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Soluciones Leasing Renta y Uso",
      "Nombre_lider_EVC": "Juan Pablo Acosta Velez",
      "SR_ARIBA": 4056,
      "Familias": "Honorarios Avalúos",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "21/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "21/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios Profesionales Procesos del Negocio",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4055,
      "Title": "Forms",
      "Fecha_solicitud": "20/07/2023",
      "Correo_solicitante": "camescob@bancolombia.com.co",
      "Nombre_solicitante": "Camilo Escobar Mesa",
      "Nombre_iniciativa": "ID 4055 - Debida diligencia técnica Bodega Fase 1, Parque Logístico Constellation, Bogotá",
      "Tipo_Requerimiento": "Es un requerimiento del equipo de Renta y Uso de Leasing",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "En aplicativos de Leasing como Mercurio y/o Delfin",
      "Detalle_producto_o_servicio": "Se requiere la realización de una inspección física y debida diligencia técnica, para el inmueble en proceso de adquisición de Renta y Uso: Bodega Fase 1, Parque Logístico Constellation, Bogotá",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 75000000,
      "Proveedores_conocidos": "EPIC PROYECTOS SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Soluciones Leasing Renta y Uso",
      "Nombre_lider_EVC": "Juan Pablo Acosta Velez",
      "SR_ARIBA": 4055,
      "Familias": "Servicios de Investigación de Bienes",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "21/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "21/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios de Conciliación y Cobranza",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4054,
      "Title": "Forms",
      "Fecha_solicitud": "19/07/2023",
      "Correo_solicitante": "vedelgad@bancolombia.com.co",
      "Nombre_solicitante": "Veronica Delgado Taua",
      "Nombre_iniciativa": "ID 4054 - Renovación Contrato CW2302274 ERIKA VÁSQUEZ- Pestación de servicios freelance Campamentos de Futbol.",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2302274",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación en iguales  condiciones del contrato CW2302274 de Erika Vásquez como proveedor freelance a cargo del acompañamiento a campamentos de futbol con comunidades, dada su experiencia en gestión social y cultural.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "Lo que se especifica en el contrato actual. No debe cambiar.",
      "Proveedores_conocidos": "ERIKA VASQUEZ",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "DIRECCIÓN DE MARCA",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4110358879",
      "Familias": "Servicios profesionales de Mercadeo",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Katherine Sanchez Henao",
      "Rol_asesor": "No aplica",
      "Observaciones": "Julio 21 Usuario solicita que el req. sea asignado a negociador y no delegado. se retoma para asignarlo a kathe según indicación de Naty.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "24/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "24/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4053,
      "Title": "Forms",
      "Fecha_solicitud": "19/07/2023",
      "Correo_solicitante": "MIOROZCO@bancolombia.com.co",
      "Nombre_solicitante": "Maria Isabel Orozco Restrepo",
      "Nombre_iniciativa": "ID 4053 - Solicitud de Material para pago de factura",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "solicitar material para pago de factura al proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se contrato al proveedor FIERA S.A.S  NIT. 900072392-5 para prestar un servicio de promotores para una campaña que se realizó de tarjetas prepago Bancolombia, el servicio se prestó en las sucursales Laboratorio de Bogotá (8111) y Medellín (Tesoro)",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "FIERA S.A.S  NIT. 900072392-5",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Centro de costos: C102200051 Centro de excelencia de Innovación",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4053,
      "Familias": "BTL",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "21/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "21/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4052,
      "Title": "Forms",
      "Fecha_solicitud": "19/07/2023",
      "Correo_solicitante": "juarestr@bancolombia.com.co",
      "Nombre_solicitante": "Juan David Restrepo Cifuentes",
      "Nombre_iniciativa": "ID 4052 - Licencias de Jira. contrato CW2279419",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la compra de 200 licencias de Jira adicional a la renovación de las licencias próximas a vencer. contrato CW2279419",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "El crecimiento de Nequi nos ha llevado a demandar más licencias de Jira de las que tenemos hoy en día. Es un aplicativo critico para la gestión de incentes, requimientos y pasos a pdn los cuales son procesos BIA en Nequi.",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "BIT2BIT",
      "Cuadrante_Proveedor": 3,
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "C102200120",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4110196445",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "John Alexis Velasquez Garcia",
      "Rol_asesor": "Monica Marcela Alzate Granda",
      "Observaciones": "Naty ok PN con equipo completo",
      "Comentarios BP": "",
      "Fecha MarketPlace": "04/08/2023",
      "Fecha Asignación/Delegación": "04/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "21/07/2023",
      "Fecha ok. PN": "24/07/2023",
      "sin equipo": "",
      "Áreas pendientes": "02/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4051,
      "Title": "Forms",
      "Fecha_solicitud": "19/07/2023",
      "Correo_solicitante": "sevillad@bancolombia.com.co",
      "Nombre_solicitante": "Sergio Andres Villada Marin",
      "Nombre_iniciativa": "ID 4051 - Renovación PAM (CyberArk) contrato CW2267786",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2267786-CO",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere evaluar la renovación del servicio gestionado de la herramienta PAM con el proveedor EVOLUTION TECHNOLOGIES GROUP que tiene vencimiento en el mes de Noviembre del 2023. contrato CW2267786",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "En el presupuesto de este año si se contemplaron los recurrentes para 11 meses del contrato actual. En la revisión del presupuesto para 2024 se tendrá en cuenta como minimo vital, ya que la herramienta está en producción.",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "EVOLUTION TECHNOLOGIES GROUP",
      "Cuadrante_Proveedor": 1,
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "C104300554",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4110196428",
      "Familias": "Licenciamiento Ciberseguridad y Seguridad de la Información",
      "Categoría": "Seguridad",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Mateo Villada Rodriguez",
      "Rol_asesor": "No aplica",
      "Observaciones": "Cata ok PN con equipo completo",
      "Comentarios BP": "Llevar al MP y asignar a Mateo Villada",
      "Fecha MarketPlace": "04/08/2023",
      "Fecha Asignación/Delegación": "04/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "21/07/2023",
      "Fecha ok. PN": "24/07/2023",
      "sin equipo": "",
      "Áreas pendientes": "02/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Ciberseguridad y seguridad de la información",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4050,
      "Title": "Forms",
      "Fecha_solicitud": "19/07/2023",
      "Correo_solicitante": "JUARIAS@bancolombia.com.co",
      "Nombre_solicitante": "Juan Alejandro Arias Alzate",
      "Nombre_iniciativa": "ID 4050 - Renovacion Assis contrato CW2296697",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2296697",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación servicios desarrollo / contrato CW2296697 \nPor favor Asignar a Diana Milena Arango",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "N/A",
      "Proveedores_conocidos": "ASSIS",
      "Cuadrante_Proveedor": 1,
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Leasing Renta y Uso / C103500247",
      "Nombre_lider_EVC": "Juan Alejandro Arias alzate",
      "SR_ARIBA": "SR4110165899",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Diana Milena Arango Correa",
      "Rol_asesor": "No aplica",
      "Observaciones": "Jose ok PN con equipo completo",
      "Comentarios BP": "",
      "Fecha MarketPlace": "28/07/2023",
      "Fecha Asignación/Delegación": "28/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "21/07/2023",
      "Fecha ok. PN": "21/07/2023",
      "sin equipo": "",
      "Áreas pendientes": "25/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4049,
      "Title": "Forms",
      "Fecha_solicitud": "19/07/2023",
      "Correo_solicitante": "nhoyos@bancolombia.com.co",
      "Nombre_solicitante": "Nancy Hoyos Aristizabal",
      "Nombre_iniciativa": "ID 4049 -  Contrato de Prestación de servicios para la atención de acciones de Tutela Nequi",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la celebración de un contrato de prestación de servicios con la firma legal  \"ROBLEDO ABOGADOS\" para la atención de todas las acciones de tutela que estén relacionadas con la Filial Nequi. La administración del contrato estará a cargo del equipo legal de Procesos Judiciales de Bancolombia a través del modelo de centro de servicios compartidos.",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Actualmente se está revisando por el equipo NEQUI el presupuesto que se destinará para esta iniciativa.",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Robledo Abogados",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "Dirección Jurídica de Procesos - C102400080",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4109998496",
      "Familias": "Servicios Legales",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Daniela Delgado Cadavid",
      "Rol_asesor": "No aplica",
      "Observaciones": "Biatri, ok PN con equipo completo",
      "Comentarios BP": "",
      "Fecha MarketPlace": "11/08/2023",
      "Fecha Asignación/Delegación": "11/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "21/07/2023",
      "Fecha ok. PN": "21/07/2023",
      "sin equipo": "Ciber",
      "Áreas pendientes": "09/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios Profesionales Procesos del Negocio",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4048,
      "Title": "Forms",
      "Fecha_solicitud": "19/07/2023",
      "Correo_solicitante": "macastri@bancolombia.com.co",
      "Nombre_solicitante": "Maria Isabel Castrillon Elorza",
      "Nombre_iniciativa": "ID 4048 - Participación en Curso de Formación Externa",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Desbloquear al proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la inscripción a un evento de formación externa en el extranjero. El pago ya fue realizado, al ser proveedor extranjero se pagó con Tarjeta de Crédito, sin embargo al hacer el montaje en SAP, se encontró el proveedor bloqueado.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "DATABRICKS ACADEMY",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "C475000000 Talento Humano",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4048,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "21/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "21/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4047,
      "Title": "Forms",
      "Fecha_solicitud": "19/07/2023",
      "Correo_solicitante": "acsantia@bancolombia.com.co",
      "Nombre_solicitante": "Ana Cristina Santiago Rios",
      "Nombre_iniciativa": "ID 4047 - Renovación servicios profesionales SEVEN4N SA.S. contrato CW2281999",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2281999",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la renovación de tarifas para el proveedor SEVEN4N SA.S., las cuales tienen vencimiento el 2 de septiembre de 2023. contrato CW2281999",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "NA",
      "Proveedores_conocidos": "SEVEN4N SA.S.",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "ADMINISTRACION PROVEEDORES TI - C103500002",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4107189779",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Luisa Fernanda Garcia Guzman",
      "Rol_asesor": "No aplica",
      "Observaciones": "Jose ok PN con equipo completo",
      "Comentarios BP": "",
      "Fecha MarketPlace": "28/07/2023",
      "Fecha Asignación/Delegación": "28/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "19/07/2023",
      "Fecha ok. PN": "21/07/2023",
      "sin equipo": "",
      "Áreas pendientes": "25/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4046,
      "Title": "Forms",
      "Fecha_solicitud": "19/07/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 4046 - Compra de curso de extensiónXVI JORNADAS LATINOAMERICANAS DE AGILIDAD - CHAMONIX CONSULTORÍA Y PROYECTOS SAC",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión XVI JORNADAS LATINOAMERICANAS DE AGILIDAD - CHAMONIX CONSULTORÍA Y PROYECTOS SAC",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "CHAMONIX CONSULTORÍA Y PROYECTOS SAC",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4046,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "19/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "19/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4045,
      "Title": "Forms",
      "Fecha_solicitud": "19/07/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 4045 - Compra de curso de extensión VI ENCUENTRO NACIONAL DE VENTAS\tCÁMARA COLOMBIANA DE LA CONSTRUCCIÓN - PRESIDENCI",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión VI ENCUENTRO NACIONAL DE VENTAS\tCÁMARA COLOMBIANA DE LA CONSTRUCCIÓN - PRESIDENCIA",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "CÁMARA COLOMBIANA DE LA CONSTRUCCIÓN - PRESIDENCIA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4045,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "19/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "19/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4044,
      "Title": "Forms",
      "Fecha_solicitud": "19/07/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 4044 - Compra de curso de extensión 13 CONGRESO ASOBOLSA \tASOBOLSA",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión 13 CONGRESO ASOBOLSA \tASOBOLSA",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "ASOBOLSA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4044,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "19/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "19/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4043,
      "Title": "Forms",
      "Fecha_solicitud": "19/07/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 4043 - Compra de curso de extensión VIRTUAL ADVANCING NEGOTIATION SKILLS\tSCOTWORK",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión VIRTUAL ADVANCING NEGOTIATION SKILLS\tSCOTWORK",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "SCOTWORK LIMITED",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4043,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "19/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "19/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4042,
      "Title": "Forms",
      "Fecha_solicitud": "19/07/2023",
      "Correo_solicitante": "SCMARTIN@bancolombia.com.co",
      "Nombre_solicitante": "Silvia Catalina Martinez Amaya",
      "Nombre_iniciativa": "ID 4042 - Contratacion de Juan Fernando Torne",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Es un proveedor para la creación de campañas de comunicación internas desde la parte creativa",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 30000000,
      "Proveedores_conocidos": "Juan Fernando Torne",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "c102000023",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4042,
      "Familias": "Comunicaciones y Reputación",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "19/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "19/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4041,
      "Title": "Forms",
      "Fecha_solicitud": "19/07/2023",
      "Correo_solicitante": "jcuellar@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Cuellar Cardenas",
      "Nombre_iniciativa": "ID 4041 - Designacion Process Agent ara SLL Wells Fargo",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "la designación de Process agent se requiere como condición para la firma del sustainability linked loan que se esta negociando con el banco corresponsal Wells Fargo",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "USD 1500",
      "Proveedores_conocidos": "Law Debenture Corporate Services Inc",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia Corresponsales C102500170",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4106583223",
      "Familias": "Servicios Bursátiles",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Luis Guillermo Salcedo Valderrama",
      "Rol_asesor": "Monica Marcela Alzate Granda",
      "Observaciones": "Naty ok. PN con equipo completo.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "28/07/2023",
      "Fecha Asignación/Delegación": "28/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "19/07/2023",
      "Fecha ok. PN": "21/07/2023",
      "sin equipo": "",
      "Áreas pendientes": "24/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Mercados de Capitales",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4040,
      "Title": "Forms",
      "Fecha_solicitud": "19/07/2023",
      "Correo_solicitante": "NANURIBE@bancolombia.com.co",
      "Nombre_solicitante": "Nancy Milena Uribe Cardona",
      "Nombre_iniciativa": "ID 4040 - Alquiler de espacio para talleres región sur (Pereira)",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para alquiler de salón para taller en Pereira",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Alquiler de espacio para talleres región sur (Pereira)- INVERSIONES GIRALDO DUQUE SAS-900961418-2",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "INVERSIONES GIRALDO DUQUE SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Gerencia de Aprendizaje-C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4040,
      "Familias": "Otros Servicios Bienes Inmuebles - Muebles",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "19/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "19/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Gestión Inmobiliaria",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4039,
      "Title": "Forms",
      "Fecha_solicitud": "19/07/2023",
      "Correo_solicitante": "FETABORD@bancolombia.com.co",
      "Nombre_solicitante": "Ferney de Jesus Taborda Araque",
      "Nombre_iniciativa": "ID 4039 - Mandiant Security Validation",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "Renovar una suscripción",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Mandiant Security Validation es una solución que nos permite emular actores de amenazas y validar el estado real de los controles  y servicios",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "114.310  Dolares",
      "Proveedores_conocidos": "Mandiant",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Gerencia de Ciberinteligencia",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4106583206",
      "Familias": "Prevención Ciberseguridad",
      "Categoría": "Seguridad",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Mateo Villada Rodriguez",
      "Rol_asesor": "Adriana Maria Arango Restrepo",
      "Observaciones": "Cata ok PN con equipo completo.",
      "Comentarios BP": "Llevar al MP y asignar a Mate Villada",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "25/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "19/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "25/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Ciberseguridad y seguridad de la información",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4038,
      "Title": "Forms",
      "Fecha_solicitud": "19/07/2023",
      "Correo_solicitante": "mariboho@bancolombia.com.co",
      "Nombre_solicitante": "Maria Fernanda Bohorquez Camacho",
      "Nombre_iniciativa": "ID 4038 - Organización de eventos en Montería",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Desbloquear proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Desbloquear proveedor para pago de factura por organización de evento en Montería - Fiesta de polleras",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "CLARA EUGENIA GONZALEZ FUENTES - NIT: 34989225",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GCIA CALIDAD DE VIDA - C103200170",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4038,
      "Familias": "Eventos y Reconocimientos al Empleado",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "19/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "19/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4037,
      "Title": "Forms",
      "Fecha_solicitud": "19/07/2023",
      "Correo_solicitante": "shcastan@bancolombia.com.co",
      "Nombre_solicitante": "Shirley Castano Ortega",
      "Nombre_iniciativa": "ID 4037 - Analisis de llamadas de Cobranzas - Aliado Sentisis",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Generar un pedido en SAp para el pago de este servicio",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Dado que el proveedor indica que el servicio es netamente tecnología, es importante que para que se realice el pedido y Migo con los materiales correctos, pero sobre todo las retenciones correctas al proveedor, se debe radicar una necesidad a abastecimiento en el siguiente Link, con el fin de que asignen un negociador y me oriente en el proceso.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Proveedor Sentisis Inteligence",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Gerencia Mercadeo Uso C106500008",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4037,
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "31/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "31/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4036,
      "Title": "Forms",
      "Fecha_solicitud": "19/07/2023",
      "Correo_solicitante": "safranco@bancolombia.com.co",
      "Nombre_solicitante": "Santiago Franco Ramirez",
      "Nombre_iniciativa": "ID 4036 - Desarrollo de API para conectar remesadoras en Nequi",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Terrapay, un agregador de remesas, que cuenta con una relación comercial con Bancolombia y Nequi. Quiere poner a nuestra disposición (Nequi) sus desarrolladores y equipo de trabajo para desarrollar las APIs necesarias para conectar a cualquie remesadora (Terrapay como el primero conectado). Las API desarrolladas serán propedad de Nequi y así mismo quedarán abiertas y funcionales para conectar a cualquier otra remesadora. Nequi es un cliente prioritario para Terrapay y como actualmente no tenemos la capacidad, ellos pondran sus recursos a disposición.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Esta no es una necesidad que consuma presupuesto, es una necesidad contractual para poder tomar la oportunidad",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Terrapay",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "DIRECCION ESTRATEGIA Y DLLO NEGOCIO - C471500000",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4106583183",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Maria Fernanda Urrea Parra",
      "Rol_asesor": "Adriana Maria Arango Restrepo",
      "Observaciones": "Jose ok PN con equipo completo.  Ciber no aparece, pero usuaria me copio correo dónde está gestionando el tema con Ciber, les solicité lo relacionaran, pero se puede pasar a asignación.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "18/08/2023",
      "Fecha Asignación/Delegación": "18/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "19/07/2023",
      "Fecha ok. PN": "21/07/2023",
      "sin equipo": "Ciber",
      "Áreas pendientes": "09/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4035,
      "Title": "Forms",
      "Fecha_solicitud": "19/07/2023",
      "Correo_solicitante": "jmpulgar@bancolombia.com.co",
      "Nombre_solicitante": "John Mauricio Pulgarin",
      "Nombre_iniciativa": "ID 4035 - EXPERIENCIAS DE CAFÉ",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "ACTUALIZAR EL PROVEEDOR",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "EXPERIENCIAS DE CAFÉ",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "INVERSIONES HONESTAS SAS 900804184-2",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GERENCIA DE BIENESTAR C103200030",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4035,
      "Familias": "Convenios y Beneficios",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "19/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "19/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4034,
      "Title": "Forms",
      "Fecha_solicitud": "19/07/2023",
      "Correo_solicitante": "mariboho@bancolombia.com.co",
      "Nombre_solicitante": "Maria Fernanda Bohorquez Camacho",
      "Nombre_iniciativa": "ID 4034 - Actualización de proveedor para refrigerios bienvenida empleados",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Desbloquear proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere desbloquear al proveedor para generar pago por refrigerios para bienvenida nuevos empleados",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "ALBA MARINA AGAMEZ PAYARES - NIT: 34990616",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GCIA DE CALIDAD DE VIDA - C103200170",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4034,
      "Familias": "Convenios y Beneficios",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "19/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "19/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4033,
      "Title": "Forms",
      "Fecha_solicitud": "18/07/2023",
      "Correo_solicitante": "kbenjume@bancolombia.com.co",
      "Nombre_solicitante": "Kelly Yesenia Benjumea Valencia",
      "Nombre_iniciativa": "ID 4033 - Servicios de investigación y reclutamiento en Guatemala",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere el proveedor para que realice una investigación local que conste de aproximadamente de 75 entrevistas con instituciones, personas bancarizadas y no bancarizadas",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "6212 USD",
      "Proveedores_conocidos": "Sapiens Group S.A",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "Proyecto Quetzal, GT000001",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR No requerido",
      "Familias": "Investigaciones de Mercado",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Contención",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Requerimiento ya generado con el ID 3905 por Ana Maria Rendón.   se le indica a la usuaria por correo que gestionen ese y que este queda cancelado.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4032,
      "Title": "Forms",
      "Fecha_solicitud": "18/07/2023",
      "Correo_solicitante": "NANURIBE@bancolombia.com.co",
      "Nombre_solicitante": "Nancy Milena Uribe Cardona",
      "Nombre_iniciativa": "ID 4032 - Aquiler de espacio en Armenia para realización del taller Sur Extraordinaria",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere el alquiler de un salón para la realización del taller Hechos de Corazón (Sur Extraordinaria)",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 0,
      "Proveedores_conocidos": "Asociación Club Campestre de Armenia",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Gerencia de Aprendizaje-C13200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4032,
      "Familias": "Otros Servicios Bienes Inmuebles - Muebles",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "18/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "18/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Gestión Inmobiliaria",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4031,
      "Title": "Forms",
      "Fecha_solicitud": "18/07/2023",
      "Correo_solicitante": "psanabri@bancolombia.com.co",
      "Nombre_solicitante": "Paola Andrea Sanabria Linares",
      "Nombre_iniciativa": "ID 4031 - Asesoria externa juridica",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "se requieren los servicios de Pinilla, González & Prieto Abogados con el fin de evaluar la viabilidad jurídica de la modificación planteada por el Cliente desde el punto de vista urbanístico e inmobiliario y las actuaciones que deban adelantarse con los adquirentes en materia de consumidor respecto del Proyecto “Europa Condominio Campestre” localizado en el municipio de Ocaña – Santander (en adelante el “Proyecto",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "$15.000.000.00 + IVA",
      "Proveedores_conocidos": "Pinilla, González & Prieto Abogados",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nueva Compañía",
      "Nombre_area_y_ceco": "C303700100",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4031,
      "Familias": "Servicios Legales",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "18/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "18/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios Profesionales Procesos del Negocio",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4030,
      "Title": "Forms",
      "Fecha_solicitud": "18/07/2023",
      "Correo_solicitante": "clopez@bancolombia.com.co",
      "Nombre_solicitante": "Cesar Augusto Lopez Hernandez",
      "Nombre_iniciativa": "ID 4030 - Renovación Contrato",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2220634",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación de Contrato con Localiza, para el alquiler de vehículos a nivel nacional",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 110000000,
      "Proveedores_conocidos": "LOCALIZA RENT A CAR",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C10400571",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR No requerido",
      "Familias": "Transporte de Empleados",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Contención",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Julio 18. usuario ya había generado requerimiento para esta renovación, el 4006.  Por error lo radicó dos veces. se le notifica la cancelación de este.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "18/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios de viajes",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4029,
      "Title": "Forms",
      "Fecha_solicitud": "18/07/2023",
      "Correo_solicitante": "miarango@bancolombia.com.co",
      "Nombre_solicitante": "Miguel Arango Sarmiento",
      "Nombre_iniciativa": "ID 4029 - participación en los GRI Awards",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compraremos un cupo para participar en los GRI Infractructure Andean Awards 2023",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "10.000.000",
      "Proveedores_conocidos": "GRI American European LLC",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Clientes Corporativos - C105800005",
      "Nombre_lider_EVC": "Sara Mejia Uribe",
      "SR_ARIBA": 4029,
      "Familias": "Patrocinios Mercadeo",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "18/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "18/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4028,
      "Title": "Forms",
      "Fecha_solicitud": "17/07/2023",
      "Correo_solicitante": "msanin@bancolombia.com.co",
      "Nombre_solicitante": "Maria Adelaida Sanin Alvarez",
      "Nombre_iniciativa": "ID 4028 - Renovar contrato CW2278155 con REIV SAS",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación contrato CW2278155. prestación de los Servicios de asesoría, revisión y evaluación, seguimiento y control, de los costos y alcance de los servicios de Producciones de Contenidos Audiovisuales",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "NA",
      "Proveedores_conocidos": "CW2278155",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C106500001",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4104237092",
      "Familias": "Servicios profesionales de Mercadeo",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Carlos Andres Ramos Ospina",
      "Rol_asesor": "No aplica",
      "Observaciones": "naty es renovacion, proveedor riesgo 4 no va a PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "21/07/2023",
      "Fecha Asignación/Delegación": "21/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "18/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4027,
      "Title": "Forms",
      "Fecha_solicitud": "17/07/2023",
      "Correo_solicitante": "fevelasc@bancolombia.com.co",
      "Nombre_solicitante": "Fernando Enrique Velasco Forero",
      "Nombre_iniciativa": "ID 4027 - Renovación Contrato servicio de firmas Lleida",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2278587",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se necesita realiza las acciondes de cara a la próxima fecha de renovación del contrato con el proveedor.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Priorizado por el CAE",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 50000000,
      "Proveedores_conocidos": "Lleida",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Evolución Digital C103500106",
      "Nombre_lider_EVC": "Fernando Enrique Velasco Forero",
      "SR_ARIBA": "SR No requerido",
      "Familias": "Servicios SaaS",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Contención",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Julio 18. usuario ya había generado req. 3965 para intervención de contrato. y está recién asignado (julio 14) se le indica que con ese req. gestione la renovación con el mismo negociador asignado.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "18/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicio de plataformas",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4026,
      "Title": "Forms",
      "Fecha_solicitud": "17/07/2023",
      "Correo_solicitante": "ntilano@bancolombia.com.co",
      "Nombre_solicitante": "Nahomy Daniela Tilano Diaz",
      "Nombre_iniciativa": "ID 4026 - Patrocinio Municipio de Santiago de Tolú",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular a proveedor y hacer pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor prestara el servicio de elaboración de para soles, para los bicicleteros en el evento que se estará llevando a cabo en el municipio de Santiago de Tolú",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Alvaro Luis Gomez Fernandez",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Centro de costos gobierno de red C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4026,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "17/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "17/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4025,
      "Title": "Forms",
      "Fecha_solicitud": "17/07/2023",
      "Correo_solicitante": "fermesa@bancolombia.com.co",
      "Nombre_solicitante": "Fernando Mesa Rivera",
      "Nombre_iniciativa": "ID 4025 - Renovación contrato CW2291450. Plataforma de fidelización Somos Bancolombia",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2291450",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere renovación del contrato CW2291450 de la plataforma de fidelización de corresponsalía bancaria Somos Bancolombia",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "650.000.000",
      "Proveedores_conocidos": "Valemas - Valefiel",
      "Cuadrante_Proveedor": 3,
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "ADC Corresponsale Bancarios",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4102895651",
      "Familias": "Gestores de Red Corresponsales Bancarios",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Santiago Zapata Serna",
      "Rol_asesor": "No aplica",
      "Observaciones": "Dianis es renovación, proveedor riesgo 3 no va a PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "21/07/2023",
      "Fecha Asignación/Delegación": "21/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "17/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios Corresponsales Bancarios",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4024,
      "Title": "Forms",
      "Fecha_solicitud": "17/07/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 4024 - Compra de curso de extensión STEP LATAM CONFERENCE 2023\tSTEP",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión STEP LATAM CONFERENCE 2023\tSTEP",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "STEP",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4024,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "17/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "17/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4023,
      "Title": "Forms",
      "Fecha_solicitud": "17/07/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 4023 - Compra de curso de extensión WORLD BUSSINES FORUM\tWOBI",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión WORLD BUSSINES FORUM\tWOBI",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "WOBI",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4023,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "17/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "17/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4022,
      "Title": "Forms",
      "Fecha_solicitud": "17/07/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 4022 - Compra de curso de extensión CROSSTECH WORLD 2023\tIMTC",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión CROSSTECH WORLD 2023\tIMTC",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "IMTC",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4022,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "17/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "17/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4021,
      "Title": "Forms",
      "Fecha_solicitud": "17/07/2023",
      "Correo_solicitante": "vermejia@bancolombia.com.co",
      "Nombre_solicitante": "Veronica Mejia Pelaez",
      "Nombre_iniciativa": "ID 4021 - Modelo de gestión Comunicaciones Fundación",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Necesitamos que el proveedor nos preste el servicio de asesoría, coordinación e implementación de las necesidades de Comunicaciones de la Fundación. Actualmente las agencias prestan el servicio de implementación, ahora estamos solicitando que nos ofrezcan un modelo más integral que incluya la coordinación (esto podría ser con un comunicador in house).",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "25.000.000",
      "Proveedores_conocidos": "Infocus, Habla y Latir",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Fundación Bancolombia. Presupuesto propio",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4102416649",
      "Familias": "Agencias de Mercadeo",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Katherine Sanchez Henao",
      "Rol_asesor": "No aplica",
      "Observaciones": "naty ok PN con todos los contactos.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "21/07/2023",
      "Fecha Asignación/Delegación": "21/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "17/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "18/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4020,
      "Title": "Forms",
      "Fecha_solicitud": "17/07/2023",
      "Correo_solicitante": "luczulua@bancolombia.com.co",
      "Nombre_solicitante": "Lucas Zuluaga Perez",
      "Nombre_iniciativa": "ID 4020 - Renovación del contrato CW2287747 con el proveedor YesWeHack para el servicio de Bug Bounty",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2287747",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovar CW2287747. el programa de Bug Bounty, en el que recompensamos economicamente a un grupo selecto de Hackers internacionales por reportar vulnerabilidades técnicas contra los servicios transaccionales mas criticos del Grupo Bancolombia.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "25.500 USD",
      "Proveedores_conocidos": "proveedor:  YesWeHack",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "GCIA de Inteligencia y Respuesta de Ciberseguridad - CCC104300570",
      "Nombre_lider_EVC": "Ferney de Jesus Taborda Araque",
      "SR_ARIBA": "SR4102416583",
      "Familias": "Prevención Ciberseguridad",
      "Categoría": "Seguridad",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Mateo Villada Rodriguez",
      "Rol_asesor": "No aplica",
      "Observaciones": "Cata ok PN con todos los contactos.",
      "Comentarios BP": "Llevar al MarketPlace y asignar a Mateo Villada",
      "Fecha MarketPlace": "21/07/2023",
      "Fecha Asignación/Delegación": "21/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "17/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "18/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Ciberseguridad y seguridad de la información",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4019,
      "Title": "Forms",
      "Fecha_solicitud": "17/07/2023",
      "Correo_solicitante": "luczulua@bancolombia.com.co",
      "Nombre_solicitante": "Lucas Zuluaga Perez",
      "Nombre_iniciativa": "ID 4019 - Compra de Vouchers de Certificación de Ciberseguridad en sitio web.",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere compra de 11 Voucher de Certificación de Ciberseguridad en el sitio web: https://elearnsecurity.com/",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "5000 USD",
      "Proveedores_conocidos": "Elearnsecurity",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "GCIA de Inteligencia y Respuesta de Ciberseguridad -  Centro de costos:  C104300570",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4102297337",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Nicolas Quiceno Carmona",
      "Rol_asesor": "Monica Marcela Alzate Granda",
      "Observaciones": "naty ok PN con todos los contactos",
      "Comentarios BP": "",
      "Fecha MarketPlace": "21/07/2023",
      "Fecha Asignación/Delegación": "21/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "17/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "18/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4018,
      "Title": "Forms",
      "Fecha_solicitud": "17/07/2023",
      "Correo_solicitante": "jeberare@bancolombia.com.co",
      "Nombre_solicitante": "Jennifer Bergano Arenas",
      "Nombre_iniciativa": "ID 4018 - Patrocinio eventos Perros Criollos",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "patrocinio de Eventos perros criollos, para el refuerzo de marca de nequi",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 50000000,
      "Proveedores_conocidos": "Lokillo Entretenimiento S A S",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "C102200008",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4018,
      "Familias": "Patrocinios Mercadeo",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "17/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "17/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4017,
      "Title": "Forms",
      "Fecha_solicitud": "14/07/2023",
      "Correo_solicitante": "gyate@bancolombia.com.co",
      "Nombre_solicitante": "Gilma Carolina Yate Guzman",
      "Nombre_iniciativa": "ID 4017 - Vinculacion proveedor",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Vinculación proveedor, el cual realizo todo tipo de artesanías.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 132000000,
      "Proveedores_conocidos": "MANIFIESTA SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GERENCIA DE GESTION COMERCIAL REGION CENTRO-C102100354",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4017,
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "17/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "17/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4016,
      "Title": "Forms",
      "Fecha_solicitud": "14/07/2023",
      "Correo_solicitante": "carolmar@bancolombia.com.co",
      "Nombre_solicitante": "Carolina Marin Salazar",
      "Nombre_iniciativa": "ID 4016 - Renovación contrato Arus CW2280816",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2280816",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere renovar el servicio de Arus que ya hoy tenemos contratado en la EVC de Distribución Digital Negocios para el canal SVE - CW2280816",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "El presupuesto de definió desde el año pasado con el incremento del IPC",
      "Proveedores_conocidos": "ARUS",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Distribución Digital Negocios",
      "Nombre_lider_EVC": "Millerley Gonzalez",
      "SR_ARIBA": "SR4099516396",
      "Familias": "Canales Digitales",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Luisa Fernanda Londono Jimenez",
      "Rol_asesor": "No aplica",
      "Observaciones": "Dianis ok PN, ya todos los contactos en la herramienta; solo falta RO, pero es que el usuario debía seleccionar el contacto y no lo hizo, toca que lo valide por fuera.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "21/07/2023",
      "Fecha Asignación/Delegación": "21/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "14/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "18/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Canales Digitales",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4015,
      "Title": "Forms",
      "Fecha_solicitud": "14/07/2023",
      "Correo_solicitante": "sbotero@bancolombia.com.co",
      "Nombre_solicitante": "Sandra Milena Botero Ramirez",
      "Nombre_iniciativa": "ID 4015 - Inclusion de AXA como aseguridadora Aliada de Sufi para ofrecer polizas de vehiculos",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Por licitación de aseguradoras a partir del 01 de noviembre de 2023 se incluye la aseguradora AXA en el ramo de aseguradoras aliadas de SUFI para ofrecer pólizas de vehículos a los clientes que desembolsen créditos.",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Los clientes que contraten su Seguros de vehiculos con AXA se cobra este valor via credito como un cobro de un cargo fijo por poliza de vehiculo y de este dinero que paga el cliente se le realiza el pago a AXA y de descuenta la comision que le corresponde a Sufi.",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "ASEGURADORA COLSEGUROS S.A - AXA 860.002.184-6",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C105000009 de Seguros Sufi",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR No requerido",
      "Familias": "Seguros",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Contención",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Julio 14. Juan Pablo estuvo al frente de la licitación de seguros y el tema de Sufi está incluído.  No es necesario gestionar este req. él se encarga de todo.  Se le notificó al usuario por correo.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "14/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "GASTO NO GESTIONADO",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4014,
      "Title": "Forms",
      "Fecha_solicitud": "14/07/2023",
      "Correo_solicitante": "mariales@bancolombia.com.co",
      "Nombre_solicitante": "Maria Alejandra Sanchez Larrea",
      "Nombre_iniciativa": "ID 4014 - Se solicita la creción del Abogado Externo TOBON & ORTIZ ABOGADOS ASOCIADOS S.A.S  901471832",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Se solicita la vinculación del proveedor en el sistema para el pago de sus honorarios.",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Buenos Días\n\nSe solicita la creación del abogado para el de honorarios, bonificaciones y reintegros por los servicios prestados al banco.\nGracias",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "TOBON & ORTIZ ABOGADOS ASOCIADOS S.A.S  TOBON & ORTIZ ABOGADOS ASOCIADOS S.A.S  901471832",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Sección Servicios Administrativos de Cobranza y BRP",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4014,
      "Familias": "Servicios Legales",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "14/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "14/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios Profesionales Procesos del Negocio",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4013,
      "Title": "Forms",
      "Fecha_solicitud": "13/07/2023",
      "Correo_solicitante": "LINMAHEN@bancolombia.com.co",
      "Nombre_solicitante": "Lina Marcela Henao Perez",
      "Nombre_iniciativa": "ID 4013 - Implementación nuevo proveedor de firma electrónica",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere acompañamiento para iniciar negociaciones con nuevo proveedor de firma electrónica.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Priorizado por el CAE",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "1 mil millones",
      "Proveedores_conocidos": "Docusing",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Evc Evolución Digital - C104600005",
      "Nombre_lider_EVC": "Carolina Arias",
      "SR_ARIBA": "SR4099278391",
      "Familias": "Servicios SaaS",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Diana Milena Arango Correa",
      "Rol_asesor": "Monica Marcela Alzate Granda",
      "Observaciones": "Jose ok. PN con todas las áreas de contacto.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "28/07/2023",
      "Fecha Asignación/Delegación": "28/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "14/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "18/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de plataformas",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4012,
      "Title": "Forms",
      "Fecha_solicitud": "13/07/2023",
      "Correo_solicitante": "jmnino@bancolombia.com.co",
      "Nombre_solicitante": "Jenny Maritza Nino Robayo",
      "Nombre_iniciativa": "ID 4012 - Validación de firma de la última versión del anexo de Ciberseguridad y Acuerdo Confidencialidad en casas cobra",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere validar por favor que los aliados Aecsa, Contento, Teleperformance, Konecta, SGP, Emergia y Refinancia tengan firmada la última versión del anexo de ciberseguridad y seguridad de la información, así como el acuerdo de confidencialidad, dado que es un requisito a cumplir para que los aliados puedan gestionar clientes por el canal WA. Gracias!",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Es validación de un documento contractual",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Aecsa, Contento, Konecta, Teleperformance, Emergia, SGP y Refinancia",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Aliados de Cobranza CECO C104300374",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR No requerido",
      "Familias": "",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Contención",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Jul. 13.  Por correo se le indicó a la usuaria que esta consulta no se atiende por este flujo.  Se le escaló el tema a Beatriz para que confirme quien puede hacer las validaciones solicitadas.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "13/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "",
      "Subcategoría_F": "",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4011,
      "Title": "Forms",
      "Fecha_solicitud": "13/07/2023",
      "Correo_solicitante": "RICASALL@bancolombia.com.co",
      "Nombre_solicitante": "Ricardo Casallas Lopez",
      "Nombre_iniciativa": "ID 4011 - Estrategia de  comunicación",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Proveedor que va a prestar servicios en temas de comunicación ( videos. Campañas.)",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 30000000,
      "Proveedores_conocidos": "kitty hawk",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Vicepresidencia de cumplimiento C102600000",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR No requerido",
      "Familias": "Contenidos Digitales",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Contención",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Julio 18.  usuario indica por Teams que desistieron de la vinculación, que el req. debe ser cancelado.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "18/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4010,
      "Title": "Forms",
      "Fecha_solicitud": "13/07/2023",
      "Correo_solicitante": "heaguia@bancolombia.com.co",
      "Nombre_solicitante": "Henry Aguiar Ospina",
      "Nombre_iniciativa": "ID 4010 - Vinculación Proveedor nuevo",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la compra y adquisión de unos estuches para las sucursales , a través del proceso de compras de TI . El servicio es de insumos y bienes.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "29.000.000",
      "Proveedores_conocidos": "Inigenia Soluciones digitales SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Admon Financiera TI - C103500037",
      "Nombre_lider_EVC": "Claudia Valencia Alvarez",
      "SR_ARIBA": 4010,
      "Familias": "Hardware",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "13/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "13/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Activos Fijos",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4009,
      "Title": "Forms",
      "Fecha_solicitud": "13/07/2023",
      "Correo_solicitante": "LCCARDON@bancolombia.com.co",
      "Nombre_solicitante": "Laura Carolina Cardona Mesa",
      "Nombre_iniciativa": "ID 4009 - Solicitud de licencia MIRO",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se solicita una licencia de Miro que estará integrada dentro del pool de licencias que tiene el área de diseño",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "300 USD",
      "Proveedores_conocidos": "miro (antes real time board)",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "ESTRATEGIA Y ARTICULACION (C102000018)",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4098277595",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Nicolas Quiceno Carmona",
      "Rol_asesor": "Monica Marcela Alzate Granda",
      "Observaciones": "Naty ok. PN y tiene los contactos, excepto RO que lo debía elegir el usuario.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "21/07/2023",
      "Fecha Asignación/Delegación": "21/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "13/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "17/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4008,
      "Title": "Forms",
      "Fecha_solicitud": "13/07/2023",
      "Correo_solicitante": "catcebal@bancolombia.com.co",
      "Nombre_solicitante": "Catalina Ceballos Atehortua",
      "Nombre_iniciativa": "ID 4008 - Vinculación a proveedores ATL",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Servicios de pauta ATL para campañas de mercadeo",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Radio Reloj - MEDIAART - SERVICIOS PUBLICITARIOS POC S.A.S  -  INK 247 SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C106500018",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4008,
      "Familias": "Pautas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "13/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "13/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4007,
      "Title": "Forms",
      "Fecha_solicitud": "13/07/2023",
      "Correo_solicitante": "dgarcia@bancolombia.com.co",
      "Nombre_solicitante": "Diana Patricia Garcia Santa",
      "Nombre_iniciativa": "ID 4007 - Orden de servicio ambiente migración Makers Funds",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "En el proceso de implementación del nuevo core de Fondos, Makers Funds, se definió que es necesario tener un ambiente de migración con las mismas características técnicas del ambiente de pruebas actual y con el mismo precio hasta diciembre de 2023, con la diferencia de que este ambiente se usaría a demanda, es decir, cuando no se requieran pruebas de migración se “apaga” y se activa nuevamente a necesidad. Dado lo anterior, se requiere oficializar el tema con una orden de servicio que le permita al proveedor facturarnos este servicio. Cabe agregar que se tienen los recursos en el presupuesto de este año para asumir el costo.\nNota: Actualmente hay un proceso de contratación abierto y el negociador es Daniel Jiménez.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "$4.700 mm para el año y el costo máximo del ambiente sería de $70 mm para lo que resta del año.",
      "Proveedores_conocidos": "Makers Solutions",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC de Inversiones",
      "Nombre_lider_EVC": "Rafael Luna, del tema particular Juan David Henao",
      "SR_ARIBA": "SR4097977472",
      "Familias": "Servicios SaaS",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Daniel Jimenez Delgado",
      "Rol_asesor": "Adriana Maria Arango Restrepo",
      "Observaciones": "Jose ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "21/07/2023",
      "Fecha Asignación/Delegación": "21/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "13/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "13/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de plataformas",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4006,
      "Title": "Forms",
      "Fecha_solicitud": "13/07/2023",
      "Correo_solicitante": "clopez@bancolombia.com.co",
      "Nombre_solicitante": "Cesar Augusto Lopez Hernandez",
      "Nombre_iniciativa": "ID 4006 - Renovación contrato de Localiza. 5858 (CW2220634)",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "5858 (CW2220634)",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación Alquiler de vehículos a nivel nacional. contrato 5858 (CW2220634)",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "105.000.000",
      "Proveedores_conocidos": "LOCALIZA RENT A CAR",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia Seguridad de Personas e Infraestructura Física.",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4097710643",
      "Familias": "Transporte de Empleados",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Luis Guillermo Salcedo Valderrama",
      "Rol_asesor": "Adriana Maria Arango Restrepo",
      "Observaciones": "Naty ok PN con todos los contactos",
      "Comentarios BP": "",
      "Fecha MarketPlace": "21/07/2023",
      "Fecha Asignación/Delegación": "21/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "13/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "18/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios de viajes",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4005,
      "Title": "Forms",
      "Fecha_solicitud": "12/07/2023",
      "Correo_solicitante": "mobernal@bancolombia.com.co",
      "Nombre_solicitante": "Monica Yineth Bernal Gomez",
      "Nombre_iniciativa": "ID 4005 - PRG_2023_2132803 -  MUNICIPIO DE VILLAMARIA 2023",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Elaboración de uniformes sublimados",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 588000,
      "Proveedores_conocidos": "Francy Estela Jaramillo Garcia",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "PATROCINIOS GOBIERNO DE RED - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4005,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "13/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "13/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4004,
      "Title": "Forms",
      "Fecha_solicitud": "12/07/2023",
      "Correo_solicitante": "dizuluag@bancolombia.com.co",
      "Nombre_solicitante": "Diana Sofia Zuluaga Duque",
      "Nombre_iniciativa": "ID 4004 - Membresia Cámara de la Diversidad",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Membresía anual para entrar a la red, recibir sensibilización, formación, consultoría, entre otros, en temas relacionados con Divesidad en el país",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 12000000,
      "Proveedores_conocidos": "Cámara de la Diversidad",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Dirección de Diversidad, Equidad e Inclusión C102000019",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 4004,
      "Familias": "Suscripciones",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "13/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "13/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios de Información",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4003,
      "Title": "Forms",
      "Fecha_solicitud": "12/07/2023",
      "Correo_solicitante": "sansalda@bancolombia.com.co",
      "Nombre_solicitante": "Santiago Saldarriaga Nieto",
      "Nombre_iniciativa": "ID 4003 - Contrato de operación y mantenimiento soluciones solares Arrendamiento Operativo",
      "Tipo_Requerimiento": "Es un requerimiento del equipo de Renta y Uso de Leasing",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "En aplicativos de Leasing como Mercurio y/o Delfin",
      "Detalle_producto_o_servicio": "Contratación de los servicios de mantenimiento preventivo y correctivo para activos que se usan en proyectos de generación solar y se entregan a clientes Bancolombia bajo la modalidad de arrendamiento",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "1.894.000.000 (dentro de este presupuesto están un grupo de servicios que incluyen mttos, seguros) y due diligencies.",
      "Proveedores_conocidos": "Erco Energía",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC de activos LRyU, CECO C103808220",
      "Nombre_lider_EVC": "Alberto Echeverri Arcila",
      "SR_ARIBA": "SR4097710597",
      "Familias": "HARD (Operadores de Mantenimiento)",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "13/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "13/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Facility Managment",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4002,
      "Title": "Forms",
      "Fecha_solicitud": "12/07/2023",
      "Correo_solicitante": "SACALLE@bancolombia.com.co",
      "Nombre_solicitante": "Santiago Alberto Calle Fernandez",
      "Nombre_iniciativa": "ID 4002 - RFP Implementador SAP S4/Hana CLM Contract Lease Management IFRS16.",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere abrir RFP de implementador del módulo de SAP S4/Hana CLM Contract Lease Management IFRS16.",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "130.000 usd",
      "Proveedores_conocidos": "Hi-Tech, SAP, Otros.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "ECV Talento, Cultura y Administrativo",
      "Nombre_lider_EVC": "SANTIAGO ALBERTO CALLE FERNÁNDEZ",
      "SR_ARIBA": "SR4097710580",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Diana Milena Arango Correa",
      "Rol_asesor": "No aplica",
      "Observaciones": "Jose ok. PN y tiene los contactos, excepto RO que lo debía elegir el usuario.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "21/07/2023",
      "Fecha Asignación/Delegación": "21/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "13/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "17/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4001,
      "Title": "Forms",
      "Fecha_solicitud": "12/07/2023",
      "Correo_solicitante": "fevelasc@bancolombia.com.co",
      "Nombre_solicitante": "Fernando Enrique Velasco Forero",
      "Nombre_iniciativa": "ID 4001 - desarrollos nuevas funcionalidades servicio Certicamara S.A contrato 8917 (CW2221493)",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "8917 (CW2221493)",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere solicitar al proveedor ajustes y mejoras en el servicio que implican desarrollos por parte del mismo. contrato 8917 (CW2221493)",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Priorizado por el CAE",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "50.000.000",
      "Proveedores_conocidos": "CERTICAMARA S.A",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVOLUCION DIGITAL",
      "Nombre_lider_EVC": "Fernando Enrique Velasco Forero",
      "SR_ARIBA": "SR4097621123",
      "Familias": "Servicios Gestión Documental",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "Lina Maria Monsalve Burgos",
      "Rol_asesor": "",
      "Observaciones": "Jose ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "13/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "13/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "13/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Back Office",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 4000,
      "Title": "Forms",
      "Fecha_solicitud": "12/07/2023",
      "Correo_solicitante": "SANMILAL@bancolombia.com.co",
      "Nombre_solicitante": "Sandra Milena Alvarez Martinez",
      "Nombre_iniciativa": "ID 4000 - Nuevo canal de recaudos Sufi",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Necesitamos que el proveedor nos habilite un nuevo canal presencial de recaudo para los clientes de Sufi.\nes un nuevo canal que queremos habilitar que la empresa se llama PTM y funciona como un corresponsal, en tiendas de barrio",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "$180.000.000 al año",
      "Proveedores_conocidos": "Empresa se llama PTM  y el nit es 900294369-8  la razon social de la empresa es Comercial Card SAS dueño Sebastián Tobón Palacio",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC estrategia de clientes- C105000004",
      "Nombre_lider_EVC": "Juliana velasquez velasquez",
      "SR_ARIBA": "SR4097621105",
      "Familias": "Corresponsales Agregadores",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Dianis OK PN y tiene todos los contactos.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "13/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "17/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios Corresponsales Bancarios",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3999,
      "Title": "Forms",
      "Fecha_solicitud": "12/07/2023",
      "Correo_solicitante": "egvilla@bancolombia.com.co",
      "Nombre_solicitante": "Esteban Gomez Villa",
      "Nombre_iniciativa": "ID 3999 - Adquirir 30 licencias de opsgenie adicionales a las 30 actuales.",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2302191",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere comprar 30 licencias adicionales de opsgenie con el fin de dar acceso a 30 usuarios mas para que puedan utilizar la herramienta.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "10100 USD",
      "Proveedores_conocidos": "Atlassian",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "Gerencia de Plataformas y Disponibilidad",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4096434858",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Nicolas Quiceno Carmona",
      "Rol_asesor": "Adriana Maria Arango Restrepo",
      "Observaciones": "naty ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "14/07/2023",
      "Fecha Asignación/Delegación": "14/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "12/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "13/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3998,
      "Title": "Forms",
      "Fecha_solicitud": "12/07/2023",
      "Correo_solicitante": "saravela@bancolombia.com.co",
      "Nombre_solicitante": "Sara Velasquez Bedoya",
      "Nombre_iniciativa": "ID 3998 - Catering para eventos Presidencia",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Vinculación de proveedor para atender eventos, reuniones de Presidencia",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "INVERLEOKA S.A.S",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C102000000 Gestión de Presidencia",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3998,
      "Familias": "BTL",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "12/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "12/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3997,
      "Title": "Forms",
      "Fecha_solicitud": "12/07/2023",
      "Correo_solicitante": "DAPENAGO@bancolombia.com.co",
      "Nombre_solicitante": "David Penagos Echeverri",
      "Nombre_iniciativa": "ID 3997 - Patrocinio Formación Talento TI - Código 13",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular el proveedor para poder procesar la factura de nuestra vinculación al programa",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Desde la VP de innovación y sostenibilidad vamos a adquirir dos paquetes para becar a dos mujeres para que estudien desarrollo de software en el programa Código 13 de Medellín.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Mi Palenque Records SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C102200000",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3997,
      "Familias": "Patrocinios Mercadeo",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "12/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "12/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3996,
      "Title": "Forms",
      "Fecha_solicitud": "11/07/2023",
      "Correo_solicitante": "johpiedr@bancolombia.com.co",
      "Nombre_solicitante": "John Edison Piedrahita Arias",
      "Nombre_iniciativa": "ID 3996 - Nuevo rl del tesorero Escuela de negocios corporativo",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la vinculación del proveedor para la formación del equipo comercial corporativa en temas asociados a los nuevos roles de los tesoreros y las implicaciones en el negocio",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 120000000,
      "Proveedores_conocidos": "NIMMÖK S.A.S",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Aprendizaje C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3996,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "12/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "12/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3995,
      "Title": "Forms",
      "Fecha_solicitud": "11/07/2023",
      "Correo_solicitante": "lumesa@bancolombia.com.co",
      "Nombre_solicitante": "Luis Gabriel Mesa Betancur",
      "Nombre_iniciativa": "ID 3995 - Consultoría para proyecto de estimación de capacidad de pago",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular proveedor (en caso que aplique). Firmar NDA. Pagar factura.",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "• Se construirá un modelo que estime la capacidad de pago, involucrando un elemento de cálculo\nfinanciero tradicional y otro elemento de inteligencia artificial, en el cual se reconocen perfiles de\ncapacidad de pago a partir de la información sociodemográfica, información en centrales de riesgo y otra\ninformación exógena disponible.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Amautas Analytics SAS NIT 901 507 484 -7",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "GERENCIA RIESGO DE CREDITO\tC473000001",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4096423966",
      "Familias": "Consultorias Corporativas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "12/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "12/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Consultorias Corporativas",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3994,
      "Title": "Forms",
      "Fecha_solicitud": "11/07/2023",
      "Correo_solicitante": "loblando@bancolombia.com.co",
      "Nombre_solicitante": "Lorena Patricia Blandon Acevedo",
      "Nombre_iniciativa": "ID 3994 - Proyectos solares con clientes tenderos",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Validar si es proveedor vinculado de Bancolombia  y conocer el material para hacer el pago por SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Pagamos por obtener información sobre el funcionamiento de unas soluciones solares que instalamos con Celsia",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "CELSIA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "CDE Sostenibilidad CENTRO DE COSTOS C102200063",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3994,
      "Familias": "Consultorias Corporativas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Ago. 17. Usuaria solicita cancelar este req ya que le quedó doble cn uno radicado posteriormente 4196 el 09 de agosto.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "12/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "12/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "Retirado",
      "Estado": "Consultorias Corporativas",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3993,
      "Title": "Forms",
      "Fecha_solicitud": "11/07/2023",
      "Correo_solicitante": "jjgirald@bancolombia.com.co",
      "Nombre_solicitante": "Jennifer Johanna Giraldo Contreras",
      "Nombre_iniciativa": "ID 3993 - GASTO NOTARIA",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Solicita Material",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Apostillar certificación comercial para cliente",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "NOTARIA 23",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "VP INFRAESTRUCTURA Y RECURSOS NATURALES",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3993,
      "Familias": "Servicios Legales",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "12/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "12/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios Profesionales Procesos del Negocio",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3992,
      "Title": "Forms",
      "Fecha_solicitud": "11/07/2023",
      "Correo_solicitante": "ehidalgo@bancolombia.com.co",
      "Nombre_solicitante": "Erwin Hidalgo Cardenas",
      "Nombre_iniciativa": "ID 3992 - Servicio de garabaciones y pruebas de codigo refactorizado",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "requerimos crear un servicio DaaS con Accenture para el proyecto Neon, con una capacidad similar a la de tener 6 FTE, pero que se facturarán tan pronto adquieran la curva de aprendizaje. El servicio consta de generar grabaciones funcionales del aplicativo leasing Delfin en iseries, y posterior a eso la recepción del codigo refactorizado con ejecución de automatizaciones. El proceso tardará aproximadamente 7 meses.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "462.000.000",
      "Proveedores_conocidos": "Accenture",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Neon modernización de la tecnologia EVC00036",
      "Nombre_lider_EVC": "Maria Elsy Giraldo Rendon",
      "SR_ARIBA": "SR4096320906",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Diana Milena Arango Correa",
      "Rol_asesor": "No aplica",
      "Observaciones": "Jose ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "21/07/2023",
      "Fecha Asignación/Delegación": "21/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "12/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "13/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3991,
      "Title": "Forms",
      "Fecha_solicitud": "11/07/2023",
      "Correo_solicitante": "JULBETAN@bancolombia.com.co",
      "Nombre_solicitante": "Julian David Betancur Arcia",
      "Nombre_iniciativa": "ID 3991 - Negociación Tarifas Proveedor Atica Industria Ambiental",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2298072",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere el manejo de los documentos fisicos que se generan a través de nuestros Proveedores Iron Mountiain, Carvajal, Datafile. Este Proveedor Atica se encarga de destruir los documentos que cumple el tiempo de custodía en nuestros repositorios fisicos.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "Con este Proveedor recibimos Ingresos. Atica nos paga por las cajas y documentos eliminados",
      "Proveedores_conocidos": "Atica Industria Ambiental",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Evolución Digital - C104600005",
      "Nombre_lider_EVC": "Carolina Arias Ramirez",
      "SR_ARIBA": "SR4095567108",
      "Familias": "SOFT (Operadores de Aseo)",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Luis Guillermo Salcedo Valderrama",
      "Rol_asesor": "",
      "Observaciones": "Naty ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "14/07/2023",
      "Fecha Asignación/Delegación": "14/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "12/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "12/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Facility Managment",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3990,
      "Title": "Forms",
      "Fecha_solicitud": "11/07/2023",
      "Correo_solicitante": "lvillega@bancolombia.com.co",
      "Nombre_solicitante": "Laura Villegas Grajales",
      "Nombre_iniciativa": "ID 3990 - Detalles empleados",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Es un proveedor con el que haremos producción de material para momentos especiales de celebración de nequi o de los empleados",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 15000000,
      "Proveedores_conocidos": "BH Group",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "Talento Humano Nequi",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3990,
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "11/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "11/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3989,
      "Title": "Forms",
      "Fecha_solicitud": "11/07/2023",
      "Correo_solicitante": "JAANROJA@bancolombia.com.co",
      "Nombre_solicitante": "Jaider Andres Rojas Vanegas",
      "Nombre_iniciativa": "ID 3989 - Equipos celulares para pruebas en ambientes preproductivos en TI",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Número de dispositivos\tDispositivo Solicitado\tVersión dispositivo\n2\tIphone \t14 Plus, 13 Pro\n2\tXiaomi\t12, x5\n4\tSamsung \ts23 ultra, A54, M54, S22\n2\tMotorola \tg60, edge 30\n2\tHuawei(P40, NOVA 9)\t12\n1\tIphone 11 \t11\n3\tSamsung A32\t12\n1\tIphone XR \tOS 15.5\n1\tGoogle Pixel 7 Gvu6c 8gb 128gb\tOS: ‎Android 13\n1\tMotorola aruba (moto e20)\tOS: ‎Android 11\n1\tHUAWEI nova 10 Pro\tOS:  EMUI 12",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Es una necesidad que surge de las pruebas que se realizan actualmente y que se estan haciendo desde equipos personales.  Se buscara aprobacion con comite financiero.",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "El proveedor lo maneja el area de abastecimiento",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "C102200039",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4132235705",
      "Familias": "Hardware",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Angie Lorena Castrillon Palacio",
      "Rol_asesor": "Adriana Maria Arango Restrepo",
      "Observaciones": "Julio 19. Se le indicó al usuario que con el proveedor Kobiton consigue los equipos en alquiler, pues estos equipos no se deben comprar, ya que cuando hagan actualizaciones de software quedan obsoletos y nos encartamos con ellos. Se remitió con Luz Emerida Ospina Mazo, quien administra la relación con el proveedor para alquiler de equipos para pruebas en producción.\n\nAgosto 02. usuario indica que ese servicio ya no se presta. entonces se remite a category para evaluarlo en el MP No pasa por PN.  Buscar granja de equipos para pruebas",
      "Comentarios BP": "",
      "Fecha MarketPlace": "04/08/2023",
      "Fecha Asignación/Delegación": "04/08/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "03/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Activos Fijos",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3988,
      "Title": "Forms",
      "Fecha_solicitud": "11/07/2023",
      "Correo_solicitante": "natalvar@bancolombia.com.co",
      "Nombre_solicitante": "Natalia Fernanda Alvarez Arenas",
      "Nombre_iniciativa": "ID 3988 - Planeación Dirección de Cultura, FOrmas de Trabajo y Bienestar",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Experiencia artesanal",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Priorizado por el CAE",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 7000000,
      "Proveedores_conocidos": "Potterapy",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Vicepresidencia de Talento y Cultura C103200000",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3988,
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "11/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "11/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3987,
      "Title": "Forms",
      "Fecha_solicitud": "11/07/2023",
      "Correo_solicitante": "danromer@bancolombia.com.co",
      "Nombre_solicitante": "Daniela Andrea Romero Perez",
      "Nombre_iniciativa": "ID 3987 - Alianza con CORPORACION AGENCIA DE PROMOCION DE INVERSION CARTAGENA DE INDIAS",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Alianza con CORPORACION AGENCIA DE PROMOCION DE INVERSION CARTAGENA DE INDIAS (INVEST INN CARTAGENA) para participar en los diferentes eventos que organiza la entidad.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 6000000,
      "Proveedores_conocidos": "CORPORACION AGENCIA DE PROMOCION DE INVERSION CARTAGENA DE INDIAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Gestion Comercial caribe C102100403",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3987,
      "Familias": "Suscripciones",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "12/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "12/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios de Información",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3986,
      "Title": "Forms",
      "Fecha_solicitud": "11/07/2023",
      "Correo_solicitante": "mobernal@bancolombia.com.co",
      "Nombre_solicitante": "Monica Yineth Bernal Gomez",
      "Nombre_iniciativa": "ID 3986 - PRG_2023_763664 - SEMANA SANTA POPAYAN 2023",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Servicios de catering para la Alcaldía de Popayán, en la celebración de la Semana Santa 2023",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 5000000,
      "Proveedores_conocidos": "Ana Fernanda Vejarano Mosquera",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "PATROCINIOS GOBIERNO DE RED - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3986,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "11/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "11/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3985,
      "Title": "Forms",
      "Fecha_solicitud": "11/07/2023",
      "Correo_solicitante": "juanvasq@bancolombia.com.co",
      "Nombre_solicitante": "Juan Carlos Vasquez Velasquez",
      "Nombre_iniciativa": "ID 3985 - Compra de perifericos adicionales para las diademas adquiridas recientemente.",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "se requiere la compra de periféricos adicionales para las diademas corporativas adquiridas recientemente, con la marca jabra y el canal software one.  Perifericos como. cables, almohadillas, repuestos de micrófonos...\n\nEl compañero: Carlos Andres Ramos ya esta enterado del proceso inicial y seria adecuado que siguiera con esta segunda solicitud.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "25.000$",
      "Proveedores_conocidos": "Software One - jabra",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "C103500100",
      "Nombre_lider_EVC": "EQU0699",
      "SR_ARIBA": "SR4094400474",
      "Familias": "Hardware",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Carlos Andres Ramos Ospina",
      "Rol_asesor": "No aplica",
      "Observaciones": "Naty ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "14/07/2023",
      "Fecha Asignación/Delegación": "14/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "11/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "12/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Activos Fijos",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3984,
      "Title": "Forms",
      "Fecha_solicitud": "11/07/2023",
      "Correo_solicitante": "anosorio@bancolombia.com.co",
      "Nombre_solicitante": "Ana Milena Osorio Sanmartin",
      "Nombre_iniciativa": "ID 3984 - Fundación Social Afrocolombiana",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Asistencia a una charla en el museo de la historia de Quibdó,  para un trabajo de campo que se esta realizando en la región",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 350000,
      "Proveedores_conocidos": "Fundación Social Afrocolombiana",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Centro de excelencia de innovación",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3984,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "11/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "11/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3983,
      "Title": "Forms",
      "Fecha_solicitud": "11/07/2023",
      "Correo_solicitante": "ntilano@bancolombia.com.co",
      "Nombre_solicitante": "Nahomy Daniela Tilano Diaz",
      "Nombre_iniciativa": "ID 3983 - Patrocinio al municipio de Puerto Colombia",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular a un proveedor y hacer pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor presta servicios de diseño y confección de uniformes deportivos , escolares, empresariales etc en Barranquilla.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Nestor Galvis Hernandez",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "gobierno de red C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3983,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "11/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "11/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3982,
      "Title": "Forms",
      "Fecha_solicitud": "10/07/2023",
      "Correo_solicitante": "anarbole@bancolombia.com.co",
      "Nombre_solicitante": "Angela Maria Arboleda Munoz",
      "Nombre_iniciativa": "ID 3982 - Taller en salud Mental",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere talleres y asesoría en salud mental para empleados Nequi",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 4000000,
      "Proveedores_conocidos": "Santiago Duque",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "Talento Humano",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4094272161",
      "Familias": "Servicios Profesionales de Bienestar al Personal",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "11/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "11/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3981,
      "Title": "Forms",
      "Fecha_solicitud": "10/07/2023",
      "Correo_solicitante": "anarbole@bancolombia.com.co",
      "Nombre_solicitante": "Angela Maria Arboleda Munoz",
      "Nombre_iniciativa": "ID 3981 - Consutoria plan de emergencias",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere una consultoría para el plan de emergencias en Nequi, necesito una adhesión al contrato que a tiene Banco con el proveedor.",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "4.000.000",
      "Proveedores_conocidos": "D&M PRODUCTOS Y SERVICIOS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "Talento Humano",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4094272140",
      "Familias": "Servicios Profesionales de Bienestar al Personal",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "11/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "11/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3980,
      "Title": "Forms",
      "Fecha_solicitud": "10/07/2023",
      "Correo_solicitante": "jeberare@bancolombia.com.co",
      "Nombre_solicitante": "Jennifer Bergano Arenas",
      "Nombre_iniciativa": "ID 3980 - Merch para marca",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "el proveedor ya se encuentra registrado en el banco pero se debe registrar de nuevo para que quede como proveedor de nequi, ellos tienen diferente merch para poner marca",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 2400000,
      "Proveedores_conocidos": "PRESENCIA EMPRESARIAL S.A.S.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "C102200008",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3980,
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "11/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "11/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3979,
      "Title": "Forms",
      "Fecha_solicitud": "10/07/2023",
      "Correo_solicitante": "jeberare@bancolombia.com.co",
      "Nombre_solicitante": "Jennifer Bergano Arenas",
      "Nombre_iniciativa": "ID 3979 - MERCH POPSOCKETS DE MARCA",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Proveedor de POPSOCKETS para merch de marca nequi",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 3000000,
      "Proveedores_conocidos": "POPSOCKETS COLOMBIA S.A.S",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "C102200008",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3979,
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "11/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "11/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3978,
      "Title": "Forms",
      "Fecha_solicitud": "10/07/2023",
      "Correo_solicitante": "mancasta@bancolombia.com.co",
      "Nombre_solicitante": "Manuela Castano Agudelo",
      "Nombre_iniciativa": "ID 3978 - Cambio en el pago a redeban. contrato CW2234847",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se revisará a nivel contractual que se debe modificar para realizar el pago a redeban de las instalaciones vía comisión. contrato CW2234847",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "41.000.000.000",
      "Proveedores_conocidos": "Redeban",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC distribución física",
      "Nombre_lider_EVC": "Dorian Arcangel Gutierrez",
      "SR_ARIBA": "SR4094623749",
      "Familias": "Redes",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Enviar al category",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Dianis por la naturaleza de la solicitud, no lo envío a PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "12/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Medios de Pago",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3977,
      "Title": "Forms",
      "Fecha_solicitud": "10/07/2023",
      "Correo_solicitante": "aoalvar@bancolombia.com.co",
      "Nombre_solicitante": "Andrea Ospina Alvarez",
      "Nombre_iniciativa": "ID 3977 - Asignación material para Inversiones CFNS",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Solicitar material",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere el material para procesar el pago de la factura al proveedor 108 CARVAJAL TECNOLOGIA Y SERVICIOS S.A, quienes son los proveedores del servicio de facturación electrónica para la compañía Inversiones CFNS. El material anterior era el 5005004 pero lo bloquearon por una revisión de materiales BPO",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "108 CARVAJAL TECNOLOGIA Y SERVICIOS S.A",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Dirección Contabilidad. C420000000",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR No requerido",
      "Familias": "",
      "Categoría": "",
      "¿Cómo se va a gestionar?": "Contención",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Julio 10.  por correo se remitió la consulta al Centro de desembolsos (Sandra Echeverri) ya que es una duda puntual del reemplazo de un material y no se requiere gestionar la caja de herramientas. Se le copio a la usuaria para que le den respuesta directamente a ella.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "",
      "Subcategoría_F": "",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3976,
      "Title": "Forms",
      "Fecha_solicitud": "10/07/2023",
      "Correo_solicitante": "lvillega@bancolombia.com.co",
      "Nombre_solicitante": "Laura Villegas Grajales",
      "Nombre_iniciativa": "ID 3976 - Momentos especiales de los empleados",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Es un proveedor con el que haremos producción de material para momentos especiales de celebración de nequi o de los empleados",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 30000000,
      "Proveedores_conocidos": "Bh group",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "Talento Humano Nequi",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "3976 (R)",
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Retirar Requerimiento",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Julio 10.  Luego de haberlo delegado, la usuaria, a través de correo.  solicita retirarlo porque lo radicó por error.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "11/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "11/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3975,
      "Title": "Forms",
      "Fecha_solicitud": "10/07/2023",
      "Correo_solicitante": "johpiedr@bancolombia.com.co",
      "Nombre_solicitante": "John Edison Piedrahita Arias",
      "Nombre_iniciativa": "ID 3975 - Speaker graduación escuela de negocios",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la vinculación de este proveedor ya que será el posible speaker en un evento de gradaución en el mes de septiembre de la iniciativa Esceulas de negocio",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 15000000,
      "Proveedores_conocidos": "RADDAR LIMITADA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de aprendizaje C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3975,
      "Familias": "Eventos y Servicios Formación y Entrenamiento",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "11/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "11/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3974,
      "Title": "Forms",
      "Fecha_solicitud": "10/07/2023",
      "Correo_solicitante": "juacarmo@bancolombia.com.co",
      "Nombre_solicitante": "Juan Camilo Carmona Botero",
      "Nombre_iniciativa": "ID 3974 - Proveedor para debida diligencia - sarlaft en venta de BRPs",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere un proveedor o la suscripción a una herramienta que permita consultar en listas de control, antecedentes penales y medios de comunicación los compradores interesados en los Bienes Recibidos en Pago. Por recomendación de cumplimiento se debe hacer una mayor debida diligencia y estamos evaluando la alternativa de tercerizar dicho proceso a través de un aliado como Truora, Smart Law Tech o cualquier otro que pueda prestar esos servicios. Sabemos que algunos ya tienen contrato con el Banco pero desconocemos el proceso para aprovechar sus servicios.",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Luego de tener una cotización se debe escalar a nivel Gerente o Director para elegir el proveedor.",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Truora; Smart Law Tech",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia Estrategia de BRP C101000045",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4093883539",
      "Familias": "BRP (Bienes Recibidos en Pago)",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Mateo Gutierrez Garcia",
      "Rol_asesor": "No aplica",
      "Observaciones": "Biatri ok PN",
      "Comentarios BP": "Negociador debe ponerlo como administrativo",
      "Fecha MarketPlace": "04/08/2023",
      "Fecha Asignación/Delegación": "04/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "11/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "12/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios de Conciliación y Cobranza",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3973,
      "Title": "Forms",
      "Fecha_solicitud": "10/07/2023",
      "Correo_solicitante": "marriago@bancolombia.com.co",
      "Nombre_solicitante": "Mariana Riano Gonzalez",
      "Nombre_iniciativa": "ID 3973 - Solicitud de incremento tarifa FTE servicio Independientes - Domina contrato CW2238223",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2238223",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere renovación de tarifas por solicitud del aliado: Cordialmente solicitamos de tu ayuda para revisar solicitud de incremento de tarifa FTE de nuestro servicio de Independientes, estuve hablando con Santiago Zapata y me compartió que debemos revisar el tema contigo ya que estás a cargo del proceso y en la actualidad el FTE que hemos estado facturando es con la tarifa del año 2022 por valor de $4.916.410 y tenemos pendiente el incremento del año 2023. \ncontrato CW2238223",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "183.457 MM es el ppto total del BPO para 2023",
      "Proveedores_conocidos": "Domina",
      "Cuadrante_Proveedor": 0,
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Sección Servicios BPO - C505400123",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4093883522",
      "Familias": "Televenta",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Yohany Anibal Gaviria Quintero",
      "Rol_asesor": "No aplica",
      "Observaciones": "Dianis ok PN con equipo completo",
      "Comentarios BP": "",
      "Fecha MarketPlace": "28/07/2023",
      "Fecha Asignación/Delegación": "28/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "11/07/2023",
      "Fecha ok. PN": "21/07/2023",
      "sin equipo": "",
      "Áreas pendientes": "26/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Modelos de Relacionamiento Integral",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3972,
      "Title": "Forms",
      "Fecha_solicitud": "10/07/2023",
      "Correo_solicitante": "MARTRUJI@bancolombia.com.co",
      "Nombre_solicitante": "Mariluz Trujillo Perez",
      "Nombre_iniciativa": "ID 3972 - Vinculación Proveedor AROCA VIVES ABOGADOS S.A.S",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vncular proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Realizará capacitación de gestión patrimonial para la escuela de negocios énfasis inversiones.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "AROCA VIVES ABOGADOS S.A.S",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3972,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "11/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "11/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3971,
      "Title": "Forms",
      "Fecha_solicitud": "10/07/2023",
      "Correo_solicitante": "jssosa@bancolombia.com.co",
      "Nombre_solicitante": "John Sebastian Sosa Suarez",
      "Nombre_iniciativa": "ID 3971 - Legalizacion pago al proveedor VASAVA ARTWORKS S.L.",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Solicitar Material",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere hacer el pago de los servicios prestados por el proveedor VASAVA ARTWORKS S.L. para la  Campaña Marca Empleadora.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "VASAVA ARTWORKS S.L.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C103200040",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3971,
      "Familias": "Eventos y Compras Selección al personal",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "11/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "11/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Atracción y desarrollo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3970,
      "Title": "Forms",
      "Fecha_solicitud": "10/07/2023",
      "Correo_solicitante": "jaazapat@bancolombia.com.co",
      "Nombre_solicitante": "Jackeline Arango Zapata",
      "Nombre_iniciativa": "ID 3970 - Diseño de Zona Cero",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Generar pedido para solicitar material y luego tener MIGO y Solped",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Diseño de zona Cero",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Cabeza Rota SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Innovación Abierta - C102200000",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3970,
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "11/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "11/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3969,
      "Title": "Forms",
      "Fecha_solicitud": "10/07/2023",
      "Correo_solicitante": "jssosa@bancolombia.com.co",
      "Nombre_solicitante": "John Sebastian Sosa Suarez",
      "Nombre_iniciativa": "ID 3969 - Legalización pago de servicios prestados por el proveedor Alcubo",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Solicitar material para realizar el pago",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere solicitar el material para realizar el pago de los servicios prestados por el proveedor Alcubo",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "ALCUBO PRODUCCIONES SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C103200040",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3969,
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "11/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "11/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3968,
      "Title": "Forms",
      "Fecha_solicitud": "10/07/2023",
      "Correo_solicitante": "AVILLADA@bancolombia.com.co",
      "Nombre_solicitante": "Alejandra Maria Villada",
      "Nombre_iniciativa": "ID 3968 - Reintrego de arrendamiento",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular proveedor para pago único",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se debe realizar al proveedor un reintregro por valor de $13.170.000.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "INVERSIONES L.E.G S.A.S",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Sección Administración del Portafolio CECO C104300026",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3968,
      "Familias": "Arrendamiento Bienes Inmuebles",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "11/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "11/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Gestión Inmobiliaria",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3967,
      "Title": "Forms",
      "Fecha_solicitud": "10/07/2023",
      "Correo_solicitante": "lvillega@bancolombia.com.co",
      "Nombre_solicitante": "Laura Villegas Grajales",
      "Nombre_iniciativa": "ID 3967 - Detalles para empleados",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Actualizar al proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Nos prestará servicios de orquideas en momentos de vida del empleado tales como perdida de un ser querido, nacimiento de un hijo, entre otros.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Restrepo Orquideas",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "Talento humano Nequi",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3967,
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "11/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "11/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3966,
      "Title": "Forms",
      "Fecha_solicitud": "07/07/2023",
      "Correo_solicitante": "rolando.henriquez@banistmo.com",
      "Nombre_solicitante": "Rolando Antonio Henriquez Gonzalez",
      "Nombre_iniciativa": "ID 3966 - Renovación de Tarifas CW2292728    CW2264661",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2292728    CW2264661",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Legalización del aumento del IPC de los ID de contrato CW2292728    CW2264661\n-Legalización renovación servicios Portal de contenidos IBM\n-PCR No. 29 Mantenimiento y Soporte del Sitio de Contenidos.    Sitio de contenidos Banistmo",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "177,264.00",
      "Proveedores_conocidos": "IBM DE COLOMBIA SAS",
      "Cuadrante_Proveedor": 0,
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Transformación y Soporte - 2401",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4092729012",
      "Familias": "Contenidos Digitales",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Carlos Andres Ramos Ospina",
      "Rol_asesor": "No aplica",
      "Observaciones": "Jul 24.  Naty hola, este req. JuanPa lo puso a gestionar PN, en mi ausencia, pero al ser de Banistmo, creo que a ellos les aplica diferente y como es renovación, mejor decido enviártelo.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "28/07/2023",
      "Fecha Asignación/Delegación": "28/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "11/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "24/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3965,
      "Title": "Forms",
      "Fecha_solicitud": "07/07/2023",
      "Correo_solicitante": "fevelasc@bancolombia.com.co",
      "Nombre_solicitante": "Fernando Enrique Velasco Forero",
      "Nombre_iniciativa": "ID 3965 - Contratación Desarrollos en la plataforma Lleida CW2278587",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2278587",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere solicitar unos ajustes a nivel de desarrollo a la plataforma de firma digital Lleida . Es un servicio SAS que se tiene contratado actualmente. Lo anterior implicará horas de desarrollo y valor hora. CW2278587",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Priorizado por el CAE",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "50.000.000",
      "Proveedores_conocidos": "Lleida",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Evolución digital C103500106",
      "Nombre_lider_EVC": "Fernand Enrique Velasco Forero",
      "SR_ARIBA": "SR4092728994",
      "Familias": "Servicios SaaS",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Diana Milena Arango Correa",
      "Rol_asesor": "Adriana Maria Arango Restrepo",
      "Observaciones": "Jose ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "14/07/2023",
      "Fecha Asignación/Delegación": "14/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "11/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "12/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de plataformas",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3964,
      "Title": "Forms",
      "Fecha_solicitud": "07/07/2023",
      "Correo_solicitante": "CROMAN@bancolombia.com.co",
      "Nombre_solicitante": "Carolina Roman Bran",
      "Nombre_iniciativa": "ID 3964 - Validación material 5500237",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Validación material 5500237",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere validar la usabilidad y la cuenta contable del material  5500237",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "No Aplica",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3964,
      "Familias": "Administración Servicios a Instalaciones (ASI)",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Contención",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Jul 21 Juanpa lo habia delegado, pero con un correo que envió la usuaria se validó de nuevo y se determinó que es una ocnsulta sobre el uso de materiales, se le indica a la usuaria que hable con Sandra Eccheverri",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "11/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "11/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Facility Managment",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3963,
      "Title": "Forms",
      "Fecha_solicitud": "07/07/2023",
      "Correo_solicitante": "macastri@bancolombia.com.co",
      "Nombre_solicitante": "Maria Isabel Castrillon Elorza",
      "Nombre_iniciativa": "ID 3963 - Formación Externa para equipo de Marketing Nequi",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la formación del equipo de marketing en diversos temas. El proveedor desarrollará habilidades en las personas del equipo.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "25.000.000",
      "Proveedores_conocidos": "The Automation Lab SAS Nit 901604814-1",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "Talento Humano  C475000000",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3963,
      "Familias": "Servicios Profesionales Formación y Entrenamiento",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "11/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "11/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3962,
      "Title": "Forms",
      "Fecha_solicitud": "07/07/2023",
      "Correo_solicitante": "SACALLE@bancolombia.com.co",
      "Nombre_solicitante": "Santiago Alberto Calle Fernandez",
      "Nombre_iniciativa": "ID 3962 - Solución Preselección de Hojas de Vida",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere contratar una nueva solución para evolucionar la experiencia en el inicio de las contrataciones de Gestión Humana en el banco y tener el mejor talento en el menor tiempo posible.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "500.000.000",
      "Proveedores_conocidos": "SAP/Eightfold y Talenta",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Talento, Cultura y Administrativo",
      "Nombre_lider_EVC": "Santiago A. Calle Fernández",
      "SR_ARIBA": "SR4092728975",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Madelyn Liceth Moya Osorio",
      "Rol_asesor": "Adriana Maria Arango Restrepo",
      "Observaciones": "Jose ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "14/07/2023",
      "Fecha Asignación/Delegación": "14/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "11/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "12/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3961,
      "Title": "Forms",
      "Fecha_solicitud": "07/07/2023",
      "Correo_solicitante": "trlondon@bancolombia.com.co",
      "Nombre_solicitante": "Trinidad Estella Londono Quiceno",
      "Nombre_iniciativa": "ID 3961 - Contratación internacional",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere contratar a Deel para la contratación de talento con conocimiento experto en el exterior",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "35.000.000",
      "Proveedores_conocidos": "LETSDEEL COLOMBIA SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C103500002",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3961,
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Se le pone esta familia para que no le exija PN, dado que ya lo hizo con el req. anterior del mismo tema, que le tocó volver a montar porque el proveedor no entregó documentación a tiempo.  Familia correcta: Serv Selecc de pnal. (req. anteriores 2782. 3703)",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "12/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "12/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3960,
      "Title": "Forms",
      "Fecha_solicitud": "07/07/2023",
      "Correo_solicitante": "DARCORRE@bancolombia.com.co",
      "Nombre_solicitante": "Dary Astrid Correa Valencia",
      "Nombre_iniciativa": "ID 3960 - Renovar pantallas en Centro de Formación",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Alquilar pantallas todo de uno con Datecsa para los Centros de Formación en Bogotá, Cali, Barranquilla, Bucaramanga",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "$400.000.000",
      "Proveedores_conocidos": "Datecsa",
      "Cuadrante_Proveedor": 4,
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia Servicios de Talento y Cultura",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4092628958",
      "Familias": "Hardware",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Juan Pablo Ramirez Cardenas",
      "Rol_asesor": "Adriana Maria Arango Restrepo",
      "Observaciones": "Naty no va a PN, criticidad 4 de proveedor",
      "Comentarios BP": "",
      "Fecha MarketPlace": "28/07/2023",
      "Fecha Asignación/Delegación": "28/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "11/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Activos Fijos",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3959,
      "Title": "Forms",
      "Fecha_solicitud": "07/07/2023",
      "Correo_solicitante": "CROMAN@bancolombia.com.co",
      "Nombre_solicitante": "Carolina Roman Bran",
      "Nombre_iniciativa": "ID 3959 - Validación usabilidad materiales",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Se requiere hacer la revisión del material 1000055 FORMACION Y ENTRENAMIENTO-ARRENDAMIENTOS. donde estamos pagando un servicio de sodexo por una administración de unas salas.",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere hacer la revisión del material 1000055 FORMACION Y ENTRENAMIENTO-ARRENDAMIENTOS. donde estamos pagando un servicio de sodexo por una administración de unas salas.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Sodexo",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C103200014",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3959,
      "Familias": "Administración Servicios a Instalaciones (ASI)",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Contención",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Jul 21 Juanpa lo habia delegado, pero con un correo que envió la usuaria se validó de nuevo y se determinó que es una ocnsulta sobre el uso de materiales, se le indica a la usuaria que hable con Sandra Eccheverri",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "11/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "11/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Facility Managment",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3958,
      "Title": "Forms",
      "Fecha_solicitud": "07/07/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 3958 - Compra de curso de extensión PPP AMÉRICAS 2023 - PANATICKETS",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión PPP AMÉRICAS 2023 - PANATICKETS",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "PANATICKETS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3958,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "11/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "11/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3957,
      "Title": "Forms",
      "Fecha_solicitud": "07/07/2023",
      "Correo_solicitante": "YACano@Bancolombia.com.co",
      "Nombre_solicitante": "Yenni Andrea Cano Giraldo",
      "Nombre_iniciativa": "ID 3957 - es una prueba",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "es una prueba !!!!",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 100,
      "Proveedores_conocidos": "Pepito",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "c103500003",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR No requerido",
      "Familias": "",
      "Categoría": "",
      "¿Cómo se va a gestionar?": "Contención",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "",
      "Subcategoría_F": "",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3956,
      "Title": "Forms",
      "Fecha_solicitud": "07/07/2023",
      "Correo_solicitante": "alcruz@Bancolombia.com.co",
      "Nombre_solicitante": "Alejandra Cruz Gaviria",
      "Nombre_iniciativa": "ID 3956 - Consultoria para proyecto Interno de la VP Financiera",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Queremos hacer con el proveedor una POC, en la cual el tome un proceso de la Vicepresidencia Financiera y nos apoye desde el entendimiento de que podemos evolucionar en dicho proceso hasta la implementación de la mejora con Herramientas del ecosistema analitico.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "20.000.000",
      "Proveedores_conocidos": "www.enfoqueestrategico.co",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C102500007",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4092628918",
      "Familias": "Consultorías Financieras y Contables",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "Lina Maria Monsalve Burgos",
      "Rol_asesor": "",
      "Observaciones": "Biatri ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "13/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "10/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "12/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios Profesionales Procesos del Negocio",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3955,
      "Title": "Forms",
      "Fecha_solicitud": "07/07/2023",
      "Correo_solicitante": "anbocane@bancolombia.com.co",
      "Nombre_solicitante": "Angie Juliana Bocanegra Canacue",
      "Nombre_iniciativa": "ID 3955 - Compra masiva de kits campesinos - Patrocinios Región Bogotá y Cundinamarca",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Desde la Gcia de Gobierno Red; se requiere comprar kits campesinos que serán entregados como patrocinios durante el resto del año a los municipios de Región Bogotá y Cundinamarca",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "15.000.000",
      "Proveedores_conocidos": ".",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gcia de Gobierno Red - Región Bogotá y Cundinamarca",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3955,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "10/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "10/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3954,
      "Title": "Forms",
      "Fecha_solicitud": "07/07/2023",
      "Correo_solicitante": "catcebal@bancolombia.com.co",
      "Nombre_solicitante": "Catalina Ceballos Atehortua",
      "Nombre_iniciativa": "ID 3954 - Actualización de cuenta bancaria para proveedor Adbid",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Actualizar cuenta bancaria proveedor adbid",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor requiere cambiar la cuenta bancaria",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Adbid Latinoamerica SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C106500018",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3954,
      "Familias": "Servicios profesionales de Mercadeo",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "10/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "10/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3953,
      "Title": "Forms",
      "Fecha_solicitud": "07/07/2023",
      "Correo_solicitante": "BEESPINA@bancolombia.com.co",
      "Nombre_solicitante": "Beatriz Eugenia Lopez Espinal",
      "Nombre_iniciativa": "ID 3953 - Cancelación contratos empresas de taxi CW2220631 - CW2239425 - CW2220604",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "Flota Bernal: CW2220631 *Taxis libres: CW2239425 RTA taxi: CW2220604",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Cancelación contratos empresas de taxi con los 3 proveedores.  DEfinición autorizada por Calidad de vida y revisada previamente con Cadena de abastecimiento. Flota Bernal: CW2220631 *Taxis libres: CW2239425 RTA taxi: CW2220604",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "N/A",
      "Proveedores_conocidos": "Flota BErnal, Taxis libres RTA. taxi",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "SECCION LOGISTICA Y DISTRIBUCION   C104300281",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4089613255",
      "Familias": "Transporte de Empleados",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "Lina Maria Monsalve Burgos",
      "Rol_asesor": "",
      "Observaciones": "Naty no va a PN, criticidad 4 de proveedores, requieren acompañamiento para terminar contratos.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "10/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios de viajes",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3952,
      "Title": "Forms",
      "Fecha_solicitud": "06/07/2023",
      "Correo_solicitante": "monmarin@bancolombia.com.co",
      "Nombre_solicitante": "Monica Alejandra Marin Hoyos",
      "Nombre_iniciativa": "ID 3952 - Se requiere RFP para SERVICIOS SEGURIDAD ELECTRÓNICA DE MANTENIMIENTO CORRECTIVO SEDES ADMINISTRA CW2255939",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2255939",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere  realizar RFP para SERVICIOS SEGURIDAD ELECTRÓNICA DE MANTENIMIENTO CORRECTIVO SEDES ADMINISTRATIVAS CW2255939",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "N/A",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "G4S, DIVIX, BI",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gestion del activo inmobiliario",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4089613238",
      "Familias": "Equipos Seguridad Electrónica",
      "Categoría": "Seguridad",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Yuri Andrea Ortega Davila",
      "Rol_asesor": "No aplica",
      "Observaciones": "Cata no va a PN, se requiere RFP y criticidad 3 de proveedor actual",
      "Comentarios BP": "Llevar al MP",
      "Fecha MarketPlace": "21/07/2023",
      "Fecha Asignación/Delegación": "21/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "10/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Activos Fijos",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3951,
      "Title": "Forms",
      "Fecha_solicitud": "06/07/2023",
      "Correo_solicitante": "monmarin@bancolombia.com.co",
      "Nombre_solicitante": "Monica Alejandra Marin Hoyos",
      "Nombre_iniciativa": "ID 3951 - Actualizacion de tarifa CW2299030",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2299030",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere renovar contrato y asignar zona al proveedor CW2299030",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "120.000.000",
      "Proveedores_conocidos": "Consegur S.A.S",
      "Cuadrante_Proveedor": 3,
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gestion del activo",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4089613218",
      "Familias": "Equipos Pesado de Seguridad",
      "Categoría": "Seguridad",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Yuri Andrea Ortega Davila",
      "Rol_asesor": "No aplica",
      "Observaciones": "Cata no va a PN, por criticidad 3 del proveedor",
      "Comentarios BP": "Llevar al MP",
      "Fecha MarketPlace": "21/07/2023",
      "Fecha Asignación/Delegación": "21/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "10/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Activos Fijos",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3950,
      "Title": "Forms",
      "Fecha_solicitud": "06/07/2023",
      "Correo_solicitante": "monmarin@bancolombia.com.co",
      "Nombre_solicitante": "Monica Alejandra Marin Hoyos",
      "Nombre_iniciativa": "ID 3950 - Se requiere renovar tarifas del contrato de seguridad pesada CW2299027",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2299027",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación de tarifas, Contrato de Suministro y Mantenimiento de Equipo Pesado a nivel - BLINDAR CW2299027",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "120.000.000",
      "Proveedores_conocidos": "Blindar Security",
      "Cuadrante_Proveedor": 3,
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gestion del activo",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4089613200",
      "Familias": "Equipos Pesado de Seguridad",
      "Categoría": "Seguridad",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Yuri Andrea Ortega Davila",
      "Rol_asesor": "No aplica",
      "Observaciones": "Cata no va a PN, criticidad 3 de proveedor",
      "Comentarios BP": "Llevar al MP",
      "Fecha MarketPlace": "14/07/2023",
      "Fecha Asignación/Delegación": "14/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "09/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "10/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Activos Fijos",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3949,
      "Title": "Forms",
      "Fecha_solicitud": "06/07/2023",
      "Correo_solicitante": "marcamgi@bancolombia.com.co",
      "Nombre_solicitante": "Maria Camila Gil Gomez",
      "Nombre_iniciativa": "ID 3949 - Terminación Contrato CW2295304",
      "Tipo_Requerimiento": "Es un escalamiento (reclamación a un proveedor por un incumplimiento contractual)",
      "CW_a_renovar": "CW2295304",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Terminación Contrato CW2295304",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "",
      "Nombre_area_y_ceco": "",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR No requerido",
      "Familias": "Honorarios Avalúos",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Escalamiento",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Le llega el acta a la usuaria para terminación de contrato, si se requiere capacidad e negociador, se pide radicar necesidad como requerimiento nuevo para terminación de contrato.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "06/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios Profesionales Procesos del Negocio",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3948,
      "Title": "Forms",
      "Fecha_solicitud": "06/07/2023",
      "Correo_solicitante": "camoba@bancolombia.com.co",
      "Nombre_solicitante": "Camilo Obando Betancur",
      "Nombre_iniciativa": "ID 3948 - Souvenirs para empleados que nos acompañaron en campaña de Orgullo LGBT.",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Queremos saber el número de material para montar la solicitud de pedido a SAP y luego gestionar la orden de compra.",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compramos con el proveedor nueve cartucheras y nueve pines para entregar de souvenir.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "NEGOCIOS DIGITALES COLOMBIA S.A.S.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Diversidad, equidad e Inclusión C102000019",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3948,
      "Familias": "Eventos y Reconocimientos al Empleado",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3947,
      "Title": "Forms",
      "Fecha_solicitud": "06/07/2023",
      "Correo_solicitante": "npolo@bancolombia.com.co",
      "Nombre_solicitante": "Natalia Andrea Polo Mejia",
      "Nombre_iniciativa": "ID 3947 - Anticipación de pagos genesys cloud",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere revisar la anticipación de pagos de nuevas licencias sobre la plataforma de genesys cloud, por temas presupuestales",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "5.000.000",
      "Proveedores_conocidos": "GNS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Distribución a distancia",
      "Nombre_lider_EVC": "Cristina Duque Jaramillo",
      "SR_ARIBA": "SR4089613183 (R)",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Retirar Requerimiento",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Dianis no va a PN, requerimiento lo llevo Santi Zapata en Marzo para revisar modelo.\nJulio 12.  Diana indica por Teams que el tema no es viable y solicita cancelarlo.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "13/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "10/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3946,
      "Title": "Forms",
      "Fecha_solicitud": "06/07/2023",
      "Correo_solicitante": "dbgavir@bancolombia.com.co",
      "Nombre_solicitante": "Daniela Botero Gaviria",
      "Nombre_iniciativa": "ID 3946 - Vinculación de Aliado WWF",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "se requiere revisar si WWF Colombia está vinculado como proveedor del banco y sino hacer el proceso de vinculación para proyecto de sostenibilidad donde ellos serán el aliado operador del proyecto. NIT: 901285046",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "500 millones",
      "Proveedores_conocidos": "Fondo Mundial para la naturaleza Colombia - WWF Colombia",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C106500001",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3946,
      "Familias": "Consultorias Corporativas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Consultorias Corporativas",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3945,
      "Title": "Forms",
      "Fecha_solicitud": "06/07/2023",
      "Correo_solicitante": "marango@bancolombia.com.co",
      "Nombre_solicitante": "Maria Paulina Arango Lopez",
      "Nombre_iniciativa": "ID 3945 - Renovación dominio con Networsolutions",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "Orden de compra",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere renovar el dominio  bancolombia-cayman.com  con el proveedor  Networksolutions",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "184.95 USDX",
      "Proveedores_conocidos": "Networksolutions",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "MDO01042 EVC: LDC FC SITIO DE CONTENIDOS",
      "Nombre_lider_EVC": "Juliana Rodriguez Jaramillo",
      "SR_ARIBA": 3945,
      "Familias": "Suscripciones",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios de Información",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3944,
      "Title": "Forms",
      "Fecha_solicitud": "06/07/2023",
      "Correo_solicitante": "rgroldan@bancolombia.com.co",
      "Nombre_solicitante": "Ruben Gonzalo Roldan Agudelo",
      "Nombre_iniciativa": "ID 3944 - Renovacion Contrato Jardín Botánico (7671)",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": 7671,
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere realizar la renovación del contrato mediate el cual se presta el servicio de jardinería en el DataCenter COB, para esta oportunidad se requiere ampliar el alcance con un servicio adicional de poda de setos a una altura mayor a la originalmente pactada. CW 7671",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "$ COP 5'335.942,48 Mensual a partir del mes de Agosto del 2023",
      "Proveedores_conocidos": "Fundación Jardín Botánico",
      "Cuadrante_Proveedor": 4,
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia Administración del Activo (GAA), CeCo: C104300029",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4089354639",
      "Familias": "HARD (Operadores de Mantenimiento)",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Mauricio Jimenez Rico",
      "Rol_asesor": "No aplica",
      "Observaciones": "Naty no va a PN, proveedor riesgo 4",
      "Comentarios BP": "",
      "Fecha MarketPlace": "14/07/2023",
      "Fecha Asignación/Delegación": "14/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "07/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Facility Managment",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3943,
      "Title": "Forms",
      "Fecha_solicitud": "06/07/2023",
      "Correo_solicitante": "gyate@bancolombia.com.co",
      "Nombre_solicitante": "Gilma Carolina Yate Guzman",
      "Nombre_iniciativa": "ID 3943 - CONTRATO PROVEEDOR",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Contratación proveedor, nos brinda servicios logísticos para todo tipo de eventos.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "132.000.000",
      "Proveedores_conocidos": "Eventos Maravilloso",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C102100354, Gerencia de gestion comercial region centro",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3943,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "07/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "07/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3942,
      "Title": "Forms",
      "Fecha_solicitud": "06/07/2023",
      "Correo_solicitante": "jtsanche@bancolombia.com.co",
      "Nombre_solicitante": "July Tatiana Sanchez Agudelo",
      "Nombre_iniciativa": "ID 3942 - Actualización Proveedor SIMPLE (Fondo Nacional del Ahorro)",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular - Actualizar el proveedor para proceder con el pago de la factura por el servicio prestado",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor recauda cesantías para el cliente fondo nacional del ahorro y el banco liquida el valor correspondiente a esas transacciones",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Simple S.A",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Gestión de Flujos",
      "Nombre_lider_EVC": "Juan GOnzalo",
      "SR_ARIBA": 3942,
      "Familias": "Pasarelas de Pago",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "07/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "07/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Medios de Pago",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3941,
      "Title": "Forms",
      "Fecha_solicitud": "06/07/2023",
      "Correo_solicitante": "mimarist@bancolombia.com.co",
      "Nombre_solicitante": "Miguel Mejia Aristizabal",
      "Nombre_iniciativa": "ID 3941 - Creación de Orden de Servicio de diseño de experiencia para proveedor PRAGMA",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se solicita crear una orden de servicio para el proveedor Pragma incluyendo el servicio de diseño de experiencia insourcing",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "75.000.000",
      "Proveedores_conocidos": "PRAGMA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Diseño de Experiencia",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4089354583",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Daniel Jimenez Delgado",
      "Rol_asesor": "No aplica",
      "Observaciones": "José OK PN.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "14/07/2023",
      "Fecha Asignación/Delegación": "14/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "07/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "11/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3940,
      "Title": "Forms",
      "Fecha_solicitud": "06/07/2023",
      "Correo_solicitante": "scasalin@bancolombia.com.co",
      "Nombre_solicitante": "Scarlett De Jesus Casalins Pertuz",
      "Nombre_iniciativa": "ID 3940 - Consultoría en talleres para mejorar la experiencia en los atributos de asesorÍa experta y actitud",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": 30811,
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere consultoría talleres para mejorar la experiencia en los atributos de asesoría experta y actitud",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "10.927.132",
      "Proveedores_conocidos": "MEDRA CONSULTORES EU",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GERENCIA DE GESTION COMERCIAL CARIBE C102100403",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3940,
      "Familias": "Servicios Profesionales Formación y Entrenamiento",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "07/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "07/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3939,
      "Title": "Forms",
      "Fecha_solicitud": "06/07/2023",
      "Correo_solicitante": "ADARAMIR@bancolombia.com.co",
      "Nombre_solicitante": "Ada Susana Ramirez Restrepo",
      "Nombre_iniciativa": "ID 3939 - Finalización Orden de Servicio para proveedor Netw Consulting CW2286605",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Importante Tener en cuenta que NO es una nueva negociación, se selecciona esta debido a que no hay una opción para la necesidad actual que es el cierre de la Orden de Servicio actual que tenemos con el proveedor NetwConsulting.\nSe requiere apoyo de abastecimiento(negociador) para realizar todas las actividades requeridas para ese cierre teniendo en cuenta que la renovación de dicha OS está para el 30 de Agosto 2023 al igual que el vencimiento de tarifas. CW2286605",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "$0000",
      "Proveedores_conocidos": "Netw Consulting",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Administración de Proveedores de TI 1000C103500002",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4088767959",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "José es terminación de Orden de servicio, piden capacidad de negociador para legalizar y acompañar la finalización y si es el caso activar a riesgos para la información que contienen de banco",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "07/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "07/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3938,
      "Title": "Forms",
      "Fecha_solicitud": "06/07/2023",
      "Correo_solicitante": "ntilano@bancolombia.com.co",
      "Nombre_solicitante": "Nahomy Daniela Tilano Diaz",
      "Nombre_iniciativa": "ID 3938 - Patrocinio al municipio de Arboletes",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular un proveedor y hacer pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor es un grupo musical de porro, que suministra el servicio de toques en el municipio de Arboletes.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Luz Amparo Fuentes Pereira",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gobierno de red C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3938,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "07/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "07/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3937,
      "Title": "Forms",
      "Fecha_solicitud": "05/07/2023",
      "Correo_solicitante": "scasalin@bancolombia.com.co",
      "Nombre_solicitante": "Scarlett De Jesus Casalins Pertuz",
      "Nombre_iniciativa": "ID 3937 - Patrocinio en la noche de elegidos de Caribe Exponencial - año de las relaciones",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular al proveedor para generar OC y MIGO",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Patrocinio Caribe Exponencial: Exposición de logo en la Noche de Elegidos, participación VIP de directivos",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "FUNDACION SANTO DOMINGO- FSD",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GERENCIA DE GESTION CARIBE C102100403",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3937,
      "Familias": "Patrocinios Mercadeo",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "07/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "07/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3936,
      "Title": "Forms",
      "Fecha_solicitud": "05/07/2023",
      "Correo_solicitante": "cmurillo@bancolombia.com.co",
      "Nombre_solicitante": "Claudia Patricia Murillo Duque",
      "Nombre_iniciativa": "ID 3936 - IMPLEMENTACION ENTRADA FE",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Recepción de facturación electrónica con controles y validaciones legales y comerciales\n\nPor favor asignar a JORGE AGUINAGA quien viene trabajando con el proceso desde mitad del año pasado",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "50.000.000",
      "Proveedores_conocidos": "CARVAJAL TECNOLOGIA Y SERVICIOS S.A.S. BIC",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC TALENTO CULTURA Y SERVICIOS ADTVOS",
      "Nombre_lider_EVC": "MAGNOLIA ECHEVERRI CORREA",
      "SR_ARIBA": "SR4089161777",
      "Familias": "Procesamiento de Información",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Andrea Diaz Soto",
      "Rol_asesor": "No aplica",
      "Observaciones": "Biatri ok PN\nJulio 14. en el Mp se define cambiar la familia de  consultoría financiera y contable a procesamiento.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "14/07/2023",
      "Fecha Asignación/Delegación": "14/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "07/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "12/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Back Office",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3935,
      "Title": "Forms",
      "Fecha_solicitud": "05/07/2023",
      "Correo_solicitante": "DIANLOPE@bancolombia.com.co",
      "Nombre_solicitante": "Diana Lopez Velasquez",
      "Nombre_iniciativa": "ID 3935 - Venta de cartera individual",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere acompañamiento de Negociador experto (preferiblemente Andres Felipe Viana Casas con quien ya comenzamos la exploración y asesoría del tema) para desarrollo de proceso competitivo en la búsqueda y selección de compradores de cartera castigada de portafolios empresariales y pymes con alto endeudamiento (mayor a 2.500 millones). Este sería el segundo proceso de venta de cartera castigada de este año.  \nEste sería el segundo de tres procesos de venta de cartera castigada planteados parar este año!",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "por ser un proceso de venta lo que se tiene es un estimado del valor del portafolio de 200 mil millones aproximadamente",
      "Proveedores_conocidos": "necesitamos hacer proceso de competencia y exploración de mercado",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GCIA ESTRATEGIA COBRANZA AVANZADA Y BRP",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4087687444",
      "Familias": "Servicios de Recuperación Cartera Castigada",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Andres Felipe Viana Casas",
      "Rol_asesor": "No aplica",
      "Observaciones": "No va a PN por proceso de compra para definir proponente. Andrés Viana Teams 06/07/2023",
      "Comentarios BP": "",
      "Fecha MarketPlace": "07/07/2023",
      "Fecha Asignación/Delegación": "07/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "06/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios de Conciliación y Cobranza",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3934,
      "Title": "Forms",
      "Fecha_solicitud": "05/07/2023",
      "Correo_solicitante": "almurill@bancolombia.com.co",
      "Nombre_solicitante": "Alejandro Murillo Puerta",
      "Nombre_iniciativa": "ID 3934 - CW2267597 - Orden de servicio 06. Servicio de SIM Segura",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2267597",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere renovar el servicio con el proveedor TIGO. CW2267597",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "7.120.000",
      "Proveedores_conocidos": "Colombia Movil",
      "Cuadrante_Proveedor": 3,
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia Operacion Digital",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4087687409",
      "Familias": "Servicios de Móviles y Modem",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "Lina Maria Monsalve Burgos",
      "Rol_asesor": "",
      "Observaciones": "Biatri no va PN, criticidad de proveedor 3",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "07/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "06/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Insumos y Servicios Logísticos",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3933,
      "Title": "Forms",
      "Fecha_solicitud": "05/07/2023",
      "Correo_solicitante": "cpmartin@bancolombia.com.co",
      "Nombre_solicitante": "Carol Patricia Martinez Collazos",
      "Nombre_iniciativa": "ID 3933 - INTERVENCIÓN CONTRATO ASI CON SODEXO CW2293448",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2293448-ANA MARIA GOMEZ HENAO",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Intervención de toda la capa de facility donde se incluye el modelo de integración vertical. CW2293448",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 0,
      "Proveedores_conocidos": "SODEXO",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GERENCIA DE GESTIÓN INMOBILIARIA",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4087622354",
      "Familias": "SOFT (Operadores de Aseo)",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Juan Esteban Franco Vargas",
      "Rol_asesor": "No aplica",
      "Observaciones": "naty ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "14/07/2023",
      "Fecha Asignación/Delegación": "14/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "06/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "12/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Facility Managment",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3932,
      "Title": "Forms",
      "Fecha_solicitud": "05/07/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 3932 - Compra de curso de extensión REINVENT\tAMAZON WEB SERVICE",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión REINVENT\tAMAZON WEB SERVICE",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "AMAZON WEB SERVICE",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3932,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "06/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "06/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3931,
      "Title": "Forms",
      "Fecha_solicitud": "05/07/2023",
      "Correo_solicitante": "marriago@bancolombia.com.co",
      "Nombre_solicitante": "Mariana Riano Gonzalez",
      "Nombre_iniciativa": "ID 3931 - Emergia - Solicitud de incremento de tarifas CW2242969",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2242969",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor EMERGIA, esta solicitando incremento de tarifas – IPC - en los productos que son desembolso por millón, indica que se debió realizar desde enero. Este tema lo estamos trabajando con Yohany Anibal Gaviria Quintero <YGAVIRIA@BANCOLOMBIA.COM.CO> CW2242969",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "183.457 MM es el ppto total del BPO",
      "Proveedores_conocidos": "Emergia",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Sección Servicios BPO - C505400123",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4087556333",
      "Familias": "Televenta",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Yohany Anibal Gaviria Quintero",
      "Rol_asesor": "No aplica",
      "Observaciones": "Dianis ok PN con equipo completo",
      "Comentarios BP": "",
      "Fecha MarketPlace": "28/07/2023",
      "Fecha Asignación/Delegación": "28/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "06/07/2023",
      "Fecha ok. PN": "21/07/2023",
      "sin equipo": "",
      "Áreas pendientes": "26/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Modelos de Relacionamiento Integral",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3930,
      "Title": "Forms",
      "Fecha_solicitud": "05/07/2023",
      "Correo_solicitante": "marriago@bancolombia.com.co",
      "Nombre_solicitante": "Mariana Riano Gonzalez",
      "Nombre_iniciativa": "ID 3930 - Solicitud de incremento de tarifas - BRM (9279 - CW2221105)",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": 9279,
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor BRM, esta solicitando incremento de tarifas – IPC - en los productos que son desembolso por millón, indica que se debió realizar desde enero. Esto lo venimos conversando con Yohany Anibal Gaviria Quintero <YGAVIRIA@BANCOLOMBIA.COM.CO>. (Contrato 9279 - CW2221105)",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "183.457 MM - Valor del ppto total BPO",
      "Proveedores_conocidos": "BRM",
      "Cuadrante_Proveedor": 3,
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Sección Servicios BPO - C505400123",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4087556281",
      "Familias": "Televenta",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Yohany Anibal Gaviria Quintero",
      "Rol_asesor": "No aplica",
      "Observaciones": "Dianis no va a PN, proveedor criticidad 3",
      "Comentarios BP": "",
      "Fecha MarketPlace": "07/07/2023",
      "Fecha Asignación/Delegación": "07/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "06/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Modelos de Relacionamiento Integral",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3929,
      "Title": "Forms",
      "Fecha_solicitud": "05/07/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 3929 - Compra de curso de extensión XVII CONGRESO DE DERECHO CONCURSAL\tINSTITUTO IBEROAMERICANO DE DERECHO CONCURSAL",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión XVII CONGRESO DE DERECHO CONCURSAL\tINSTITUTO IBEROAMERICANO DE DERECHO CONCURSAL",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "INSTITUTO IBEROAMERICANO DE DERECHO CONCURSAL",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3929,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "06/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "06/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3928,
      "Title": "Forms",
      "Fecha_solicitud": "05/07/2023",
      "Correo_solicitante": "mariato@bancolombia.com.co",
      "Nombre_solicitante": "Ana Maria Torres Garcia",
      "Nombre_iniciativa": "ID 3928 - Renovación del servicio CW2295822",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2295822",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Proveedor para facturación electrónica - CW2295822",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "250.000.000",
      "Proveedores_conocidos": "EDN - Ecosistemas Digitales",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Evc factoring",
      "Nombre_lider_EVC": "Jorge Valderrama Betancur",
      "SR_ARIBA": "SR4087309227 (R)",
      "Familias": "Servicios de  Plataformas",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Retirar Requerimiento",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Se cancela requerimiento ya que es duplicado y se renueva el mismo contrato en el ID 3841. Asignado a Luisa Fernanda García Guzman. Teams 07/07/2023",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "07/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "06/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicio de plataformas",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3927,
      "Title": "Forms",
      "Fecha_solicitud": "05/07/2023",
      "Correo_solicitante": "caarendo@bancolombia.com.co",
      "Nombre_solicitante": "Camilo Andres Alvarez Rendon",
      "Nombre_iniciativa": "ID 3927 - Renovacion Contratos de Sas grid, ifrs9, mrm, aml CW2282716",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2282716",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requerie la renovacion de los contratos de SAS para la plataforma grid, ifrs9, mrm, aml, solicitamos hacer esta negociacion antes del mes de agosto, la premura esta en función de decisiones que hemos tomado como no ir a sas viya como reemplazo del grid y desincentivar el crecimiento de usuarios y de flujos en este mismo y cambio del comercial del sas",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "el contrato vence en diciembre con ejecucion presupuestal 2024, hay que justificar esta cifra para conseguir el ppto con la financiera para el 2024",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Sas",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Evc Datos Analitica e IA C103500327",
      "Nombre_lider_EVC": "Hector Ivan Ramirez/Camilo Andres Alvarez",
      "SR_ARIBA": "SR4087056851",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Diana Milena Arango Correa",
      "Rol_asesor": "Adriana Maria Arango Restrepo",
      "Observaciones": "José OK PN.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "14/07/2023",
      "Fecha Asignación/Delegación": "14/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "06/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "11/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3926,
      "Title": "Forms",
      "Fecha_solicitud": "05/07/2023",
      "Correo_solicitante": "drcasas@bancolombia.com.co",
      "Nombre_solicitante": "Daniela Restrepo Casas",
      "Nombre_iniciativa": "ID 3926 - Asesoría proceso de inscripción a gremio de experiencia del cliente",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Queremos afiliarnos al Gremio Colombiano de la Experiencia, es una entidad gremial de carácter permanente, sin ánimo de lucro, independiente, autónoma y de utilidad común.  Estará integrada por todas las empresas, organismos e instituciones que trabajan en las distintas áreas de gestión que confluyen en la disciplina de Experiencia del cliente, colaborador,  distribuidor, proveedor, ciudadano, paciente, accionista y todos aquellos que interactúan en la  cadena de valor de la empresa.\n\nEsta agremiación nos da acceso a las fuentes de conocimiento de la gestión de la experiencia de clientes y empleados\na partir de informes, investigaciones, estudios sectoriales y programas de formación.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "13.550.000",
      "Proveedores_conocidos": "Gremio Colombia de la Experiencia",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Dirección Experiencia de Clientes - CC107200200",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3926,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "06/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "06/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3925,
      "Title": "Forms",
      "Fecha_solicitud": "05/07/2023",
      "Correo_solicitante": "ntilano@bancolombia.com.co",
      "Nombre_solicitante": "Nahomy Daniela Tilano Diaz",
      "Nombre_iniciativa": "ID 3925 - Patrocinio al municipio de Galapa",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincula proveedor y hacer pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor suministra el servicio de capacitación y transferencia del conocimiento en temas relacionados con la gestión financiera publica, régimen de contabilidad presupuestal publica y programación del presupuesto.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "CENTRO NACIONAL PARA EL DESARROLLO DE LA ADMINISTRACION PUBLICA S.A.S",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gobierno de Red - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3925,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "06/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "06/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3924,
      "Title": "Forms",
      "Fecha_solicitud": "05/07/2023",
      "Correo_solicitante": "johpiedr@bancolombia.com.co",
      "Nombre_solicitante": "John Edison Piedrahita Arias",
      "Nombre_iniciativa": "ID 3924 - Programa nuevo rol CFO - Escuela de negocios corporativa",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere contratar el proveedor ya que cumole con las caratcteristicas de conocimiento para implementar el programa nuevo rol del tesorero para la escuela de negocios corporativo, la cual abarca los gerentes de relación del segmento corporativa y busca potenciar su conocimieento.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "120.000.000",
      "Proveedores_conocidos": "Nimmök S.A.S",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3924,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "06/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "06/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3923,
      "Title": "Forms",
      "Fecha_solicitud": "04/07/2023",
      "Correo_solicitante": "jhserna@bancolombia.com.co",
      "Nombre_solicitante": "Jhon Alexander Serna Montoya",
      "Nombre_iniciativa": "ID 3923 - Ajuste monitoreo operacion con aliado TCS CW2233500",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2233500",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Contar con un servicio de monitoreo integrado para servicios e infraestructura de Bancolombia\nque se encuentre alineado con los avances y transformaciones del entorno tecnológico del\nbanco y abarque el ecosistema híbrido (Cloud y Tierra).\nse requiere tener el monitoreo de los servicios, Gestión alertas y creación de eventos, Notificación de Incidentes. CW2233500",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "120.000.000",
      "Proveedores_conocidos": "el aliado actual es TCS, Juan esteban franco vargas comenzo el acompañamiento y ya tiene el contexto",
      "Cuadrante_Proveedor": 0,
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": 10350091,
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4087111120",
      "Familias": "Servicios de  Plataformas",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Juan Esteban Franco Vargas",
      "Rol_asesor": "Adriana Maria Arango Restrepo",
      "Observaciones": "José OK PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "14/07/2023",
      "Fecha Asignación/Delegación": "14/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "06/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "11/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de plataformas",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3922,
      "Title": "Forms",
      "Fecha_solicitud": "04/07/2023",
      "Correo_solicitante": "danicast@bancolombia.com.co",
      "Nombre_solicitante": "Daniela Castano Ballesteros",
      "Nombre_iniciativa": "ID 3922 - Prestacion de servicio para eventos QR",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "requiero material",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor nos proporciono paletas para dar a los asistentes al evento",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "SER PRODUCCIONES LTDA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "PAGOS SIN FRICCION  C107500005",
      "Nombre_lider_EVC": "Santiago Ceballos",
      "SR_ARIBA": 3922,
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "06/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "06/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3921,
      "Title": "Forms",
      "Fecha_solicitud": "04/07/2023",
      "Correo_solicitante": "HIRAMIRE@bancolombia.com.co",
      "Nombre_solicitante": "Hector Ivan Ramirez Ramirez",
      "Nombre_iniciativa": "ID 3921 - Renovación SAM Informatica CW2299437",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2299437",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere renovar el SAM de Informatica para los productos de MDM y sus relacionados. CW2299437",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "USD 650.000",
      "Proveedores_conocidos": "Informatica Software de Mexico",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Datos, Analita, IA, Blockchain - C103500320",
      "Nombre_lider_EVC": "Hector Ivan Ramirez Ramirez",
      "SR_ARIBA": "SR4085956319",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Daniela Alvarez Montoya",
      "Rol_asesor": "No aplica",
      "Observaciones": "José no va a PN por criticidad 3 del proveedor.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "14/07/2023",
      "Fecha Asignación/Delegación": "14/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "06/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3920,
      "Title": "Forms",
      "Fecha_solicitud": "04/07/2023",
      "Correo_solicitante": "gasanche@Bancolombia.com.co",
      "Nombre_solicitante": "Gerlin Albeiro Sanchez Henao",
      "Nombre_iniciativa": "ID 3920 - Renovación contrato CW2221760",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2221760",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se solicita renovar el contrato \"Servicios de estudio de títulos y Legalización de daciones en pago\" del aliado Gómez Pineda Abogados. CW2221760",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "$ 33.000.000.000",
      "Proveedores_conocidos": "N/A",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia Estrategia de BRP - C104300378",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4085933511",
      "Familias": "Honorarios Avalúos",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Laura Serna Rodriguez",
      "Rol_asesor": "No aplica",
      "Observaciones": "Biatri ok. PN con equipo completo.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "04/08/2023",
      "Fecha Asignación/Delegación": "04/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "05/07/2023",
      "Fecha ok. PN": "27/07/2023",
      "sin equipo": "",
      "Áreas pendientes": "28/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios Profesionales Procesos del Negocio",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3919,
      "Title": "Forms",
      "Fecha_solicitud": "04/07/2023",
      "Correo_solicitante": "DAPENAGO@bancolombia.com.co",
      "Nombre_solicitante": "David Penagos Echeverri",
      "Nombre_iniciativa": "ID 3919 - Suscripción Ellen MacArthur Foundation",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Realizar la creación del proveedor en ARIBA",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Vamos a comprar la suscripción como Partner de la Ellen MacArthur Foundation para el banco.  \nTendremos beneficios de acceso a la plataforma, networking, contactos, información, uso de marca, asesorías personalizadas, entre otras.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Ellen Macarthur Foundation",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia Gestión VP Innovación y Sostenibilidad - C102200000",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3919,
      "Familias": "Suscripciones",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "05/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "05/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios de Información",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3918,
      "Title": "Forms",
      "Fecha_solicitud": "04/07/2023",
      "Correo_solicitante": "gyate@bancolombia.com.co",
      "Nombre_solicitante": "Gilma Carolina Yate Guzman",
      "Nombre_iniciativa": "ID 3918 - Contratacion proveedor",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Contratación proveedor, ofrece servicio logístico para eventos",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "132.000.000",
      "Proveedores_conocidos": "Eventos catering",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de gestion comercial region centro,C102100354",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3918,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "05/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "05/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3917,
      "Title": "Forms",
      "Fecha_solicitud": "04/07/2023",
      "Correo_solicitante": "anfemont@bancolombia.com.co",
      "Nombre_solicitante": "Andres Felipe Montoya Torres",
      "Nombre_iniciativa": "ID 3917 - Asesoria para revisión nuevas tarifas del contrato de tokenización CW2285355",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2285355",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere asesoría para la revisión/aprobación/renegociación del contrato de tokenización de Medios de Pago con el proveedor Thales, quien recientemente hizo una actualización de sus tarifas. CW2285355",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "Pendiente",
      "Proveedores_conocidos": "No se requieren contrataciones nuevas",
      "Cuadrante_Proveedor": 1,
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Medios De Pago",
      "Nombre_lider_EVC": "Luisa Fernanda Monsalve Upegui",
      "SR_ARIBA": "SR4085356050",
      "Familias": "Pasarelas de Pago",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Sara Quintero Perez",
      "Rol_asesor": "Andres Osorio Castano",
      "Observaciones": "Dianis OK PN.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "07/07/2023",
      "Fecha Asignación/Delegación": "07/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "05/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "06/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Medios de Pago",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3916,
      "Title": "Forms",
      "Fecha_solicitud": "04/07/2023",
      "Correo_solicitante": "apulgari@bancolombia.com.co",
      "Nombre_solicitante": "Alejandro Pulgarin Aristizabal",
      "Nombre_iniciativa": "ID 3916 - Formalizar licenciamiento adicional Salesforce R2",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "SOW001 Umbrella",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la activación de 216 licencias adicionales para cubrir la población de usuarios que se activarán con el release 2 (Persona Jurídica) y que se suman a las actuales. (SOW001)",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "USD 54.329",
      "Proveedores_conocidos": "Salesforce",
      "Cuadrante_Proveedor": 3,
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Conocimiento del Cliente",
      "Nombre_lider_EVC": "Alejandro Pulgarin Aristizabal / Diana Cristina Trujillo",
      "SR_ARIBA": "SR4084936868",
      "Familias": "Licenciamiento Mayor",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Juan Esteban Franco Vargas",
      "Rol_asesor": "Andres Osorio Castano",
      "Observaciones": "José no va a PN, por criticidad 3 del proveedor",
      "Comentarios BP": "",
      "Fecha MarketPlace": "07/07/2023",
      "Fecha Asignación/Delegación": "07/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "05/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3915,
      "Title": "Forms",
      "Fecha_solicitud": "04/07/2023",
      "Correo_solicitante": "PAUARIAS@bancolombia.com.co",
      "Nombre_solicitante": "Paulo Andres Arias Esguerra",
      "Nombre_iniciativa": "ID 3915 - Solicitud acompañamiento incluir nuevo servicio a un contrato (Prexus)",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere contratar un servicio de soporte y acompañamiento con el proveedor Prexus para la integración de la herramienta PGP con las aplicaciones de Bancolombia.\n\nLa idea es revisar y negociar la propuesta que nos envió Prexus. Comparto link de propuesta: https://nam10.safelinks.protection.outlook.com/?url=https%3A%2F%2Fdocs.google.com%2Fdocument%2Fd%2F1UE5t6mEUzdc9NcU7D7yVuzlCS-58KpWql4nCSw5i8V0%2Fedit&data=05%7C01%7CPAUARIAS%40bancolombia.com.co%7C2a33e46b10ec435b39fb08db7c999806%7Cb5e244bdc492495b8b1061bfd453e423%7C0%7C0%7C638240771355450517%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C3000%7C%7C%7C&sdata=7OE92uIuO8m7ja9kWy%2Fml8X5krUIUWcZjHru6JZvKEI%3D&reserved=0\n\nEn la EVC de Pricing se realizo una restructuración y de la cual contamos con presupuesto interno para negociar esta propuesta.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "175.000.000",
      "Proveedores_conocidos": "Prexus",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Pricing -C103500245-",
      "Nombre_lider_EVC": "Paulo Andres Arias Esguerra",
      "SR_ARIBA": "SR4085114491",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Sara Quintero Perez",
      "Rol_asesor": "No aplica",
      "Observaciones": "José OK PN.\nJulio 14. en el MP se definió una familia nueva, son SERV. PROF. DE TI, no un SaaS",
      "Comentarios BP": "",
      "Fecha MarketPlace": "14/07/2023",
      "Fecha Asignación/Delegación": "14/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "05/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "05/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3914,
      "Title": "Forms",
      "Fecha_solicitud": "04/07/2023",
      "Correo_solicitante": "andreper@bancolombia.com.co",
      "Nombre_solicitante": "Andres Felipe Perez Martinez",
      "Nombre_iniciativa": "ID 3914 - Apoyo para reemplazo de herramienta de AB testing",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Yo como Usuario de Analitica necesito una herramienta que nos birnde la capacidad de hacer ejercicios deA/B Testing en los activos digitales (web, APP) para evaluar el comportamiento de diferentes audiencias que me permita realizar cambios de manera oportuna y contextual del mercado.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Alerta de reemplazo de herramienta llegó este año (cierre de herramienta de AB testing usada actualmente)",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "RFP: Optimizely, AB Tasty, Visual Website Optimizer",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "LDC Growth Hacking C106500028",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4085732739",
      "Familias": "Licenciamiento Mayor",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Sara Quintero Perez",
      "Rol_asesor": "Adriana Maria Arango Restrepo",
      "Observaciones": "José OK PN.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "14/07/2023",
      "Fecha Asignación/Delegación": "14/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "05/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "12/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3913,
      "Title": "Forms",
      "Fecha_solicitud": "04/07/2023",
      "Correo_solicitante": "clopez@bancolombia.com.co",
      "Nombre_solicitante": "Cesar Augusto Lopez Hernandez",
      "Nombre_iniciativa": "ID 3913 - Renovación contrato de Vigilancia CW2251842",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2251842",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere renovación del contrato de vigilancia, para la empresa Sevicol Ltda, prestadora del servicio. CW2251842",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "$ 5.700.000.000",
      "Proveedores_conocidos": "SEVICOL LTDA",
      "Cuadrante_Proveedor": 3,
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Geerencia Seguridad de Personas e Infraestructura Física.",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4084222119",
      "Familias": "Seguridad Física",
      "Categoría": "Seguridad",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Yuri Andrea Ortega Davila",
      "Rol_asesor": "No aplica",
      "Observaciones": "Cata no va a PN. Criticidad del proveedor 3",
      "Comentarios BP": "LLevar al MP y asignar a Andrea Ortega",
      "Fecha MarketPlace": "07/07/2023",
      "Fecha Asignación/Delegación": "07/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "04/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Gestión del Fraude",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3912,
      "Title": "Forms",
      "Fecha_solicitud": "04/07/2023",
      "Correo_solicitante": "clopez@bancolombia.com.co",
      "Nombre_solicitante": "Cesar Augusto Lopez Hernandez",
      "Nombre_iniciativa": "ID 3912 - Renovación contratos de Vigilancia CW2251614",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2251614",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la renovación del contrato de vigilancia para la empresa Andina de Seguridad del Valle, prestadora del mismo. CW2251614",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "$ 5.500.000.000´00",
      "Proveedores_conocidos": "ANDINA DE SEGURIDAD DEL VALLE.",
      "Cuadrante_Proveedor": 3,
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia Seguridad de Personas e Infraestructura Física",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4084222099",
      "Familias": "Seguridad Física",
      "Categoría": "Seguridad",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Yuri Andrea Ortega Davila",
      "Rol_asesor": "No aplica",
      "Observaciones": "Cata no va a PN. Proveedor criticidad 3",
      "Comentarios BP": "Llevar al MP y asignar a Andrea Ortega",
      "Fecha MarketPlace": "07/07/2023",
      "Fecha Asignación/Delegación": "07/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "04/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Gestión del Fraude",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3911,
      "Title": "Forms",
      "Fecha_solicitud": "01/07/2023",
      "Correo_solicitante": "DICCORTE@bancolombia.com.co",
      "Nombre_solicitante": "Diana Cristina Cortes Orozco",
      "Nombre_iniciativa": "ID 3911 - Renovación contrato CW2284643  Servicio AVP IBM Sterling H2H",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2284643",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación contrato CW2284643 - IBM proveerá los servicios denominados IBM Accelerated Value Program (AVP ) Es un soporte premium y personalizado sobre los componentes, además, acompañamiento a la evolución y buenas prácticas.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "242.289.671",
      "Proveedores_conocidos": "IBM",
      "Cuadrante_Proveedor": 0,
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Distribucion Digital Negocios C103500304",
      "Nombre_lider_EVC": "Millerley Gonzalez",
      "SR_ARIBA": "SR4084222076",
      "Familias": "Licenciamiento Mayor",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Diana Milena Arango Correa",
      "Rol_asesor": "No aplica",
      "Observaciones": "Jose ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "14/07/2023",
      "Fecha Asignación/Delegación": "14/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "04/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "12/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3910,
      "Title": "Forms",
      "Fecha_solicitud": "30/06/2023",
      "Correo_solicitante": "anzuleta@bancolombia.com.co",
      "Nombre_solicitante": "Andres Zuleta Alvarino",
      "Nombre_iniciativa": "ID 3910 - Agregación Bancaria CW2277410",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2277410",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Desde la EVC Bienestar Financiero tenemos actualmente un servicio con un proveedor llamado Dinerio, quienes prestan servicios SaaS para habilitar la funcionalidad de Agregación Bancaria. Recientemente desde el área juridica nos pidieron generar un Otrosí para ese contrato con el fin de agregar un contrato de transmisión de datos. Durante la iniciativa hemos sido acompañados por Yohany Anibal Gaviria. requerimos su apoyo para realizar la firma del contrato con el proveedor. CW2277410",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Priorizado por el CAE",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "1.800.000",
      "Proveedores_conocidos": "Dinerio",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Bienestar Financiero, C107500004",
      "Nombre_lider_EVC": "Andres David Chica",
      "SR_ARIBA": "SR4084142444",
      "Familias": "Canales Digitales",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Luisa Fernanda Londono Jimenez",
      "Rol_asesor": "Andres Osorio Castano",
      "Observaciones": "Dianis OK PN.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "07/07/2023",
      "Fecha Asignación/Delegación": "07/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "04/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "05/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Canales Digitales",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3909,
      "Title": "Forms",
      "Fecha_solicitud": "30/06/2023",
      "Correo_solicitante": "MARTJARA@bancolombia.com.co",
      "Nombre_solicitante": "Martha Gladys Jaramillo Rincon",
      "Nombre_iniciativa": "ID 3909 - Renovacion Contrato provedor VIVERO Y ARTESANIAS JARDIN DEL LLANO S.A.S. (CW2284651)",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2284651",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere renovar el contrato CW2284651 correspondiente a Servicios de Mantenimiento Preventivo y Correctivo de Jardinería",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "20.000.000",
      "Proveedores_conocidos": "VIVERO Y ARTESANÍAS JARDÍN DEL LLANO S.A.S",
      "Cuadrante_Proveedor": 4,
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C104300023",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4084142427",
      "Familias": "HARD (Operadores de Mantenimiento)",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "Lina Maria Monsalve Burgos",
      "Rol_asesor": "",
      "Observaciones": "Naty no va a PN por criticidad 4 del proveedor",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "05/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "04/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Facility Managment",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3908,
      "Title": "Forms",
      "Fecha_solicitud": "30/06/2023",
      "Correo_solicitante": "JEHENAO@bancolombia.com.co",
      "Nombre_solicitante": "Jessica Alexandra Henao Arboleda",
      "Nombre_iniciativa": "ID 3908 - Modificación de tarifas en contrato (Contrato 58615 - CW2297691)",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "58615 - CW2297691",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere modificar tarifas con el proveedor. (Contrato 58615 - CW2297691)",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "300,000,000",
      "Proveedores_conocidos": "Efectivo",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Evolución de Canales Gestionado por terceros C105000235",
      "Nombre_lider_EVC": "Juliana Velasquez Velasquez",
      "SR_ARIBA": "SR4083940268",
      "Familias": "Corresponsales Retail",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Sara Quintero Perez",
      "Rol_asesor": "No aplica",
      "Observaciones": "Saris no va a PN, proveedor criticidad 4",
      "Comentarios BP": "",
      "Fecha MarketPlace": "07/07/2023",
      "Fecha Asignación/Delegación": "07/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "04/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios Corresponsales Bancarios",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3907,
      "Title": "Forms",
      "Fecha_solicitud": "30/06/2023",
      "Correo_solicitante": "lgrodrig@bancolombia.com.co",
      "Nombre_solicitante": "Luisa Constanza Gomez Rodriguez",
      "Nombre_iniciativa": "ID 3907 - Producción de contenidos con Mariete",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Vamos a desarrollar un proyecto específico con Mariete para construir contenidos audiovisuales con los cuales seguiremos impulsando la presencia de Bancolombia en la opinión pública y en terrenos de interés de la organización.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "70.000.000",
      "Proveedores_conocidos": "Virgen de Medianoche y Cia S en C",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Dirección de Reputación y Comunicaciones C102000020",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4083940214",
      "Familias": "Contenidos Digitales",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "04/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "04/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3906,
      "Title": "Forms",
      "Fecha_solicitud": "29/06/2023",
      "Correo_solicitante": "jdarguel@bancolombia.com.co",
      "Nombre_solicitante": "Juan David Arguello Plata",
      "Nombre_iniciativa": "ID 3906 - Negociación caso iTextPDF",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se necesita revisoría jurídica y renegociación de los términos de la empresa Apryse sobre el software iTextPDF para evitar el pago de, aproximadamente, dos millones de dólares por parte del banco.",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Porque se espera renegociar el valor de la multa presentado",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Apryse",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Ingeniería de Software DevExp",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4083940231",
      "Familias": "Licenciamiento Mayor",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Juan Esteban Franco Vargas",
      "Rol_asesor": "Adriana Maria Arango Restrepo",
      "Observaciones": "No va a PN. Herramienta Open Source, validación con José 04/07/2023",
      "Comentarios BP": "",
      "Fecha MarketPlace": "28/07/2023",
      "Fecha Asignación/Delegación": "28/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "04/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3905,
      "Title": "Forms",
      "Fecha_solicitud": "29/06/2023",
      "Correo_solicitante": "anrendon@bancolombia.com.co",
      "Nombre_solicitante": "Ana Maria Rendon Lopez",
      "Nombre_iniciativa": "ID 3905 - Servicio de reclutamiento para muestra de investigacion en Guatemala",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere un Servicio de reclutamiento para generar una muestra de investigación en Guatemala para la implementación de la iniciativa de Nequi",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "6212 USD",
      "Proveedores_conocidos": "Sapiens Group SA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "Orden interna GT000001",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4079447485",
      "Familias": "Investigaciones de Mercado",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Jul. 18  al revisar PN noté que la familia estaba errada.  no es una consultoría, sino una investigación de mercados. se redefine la familia y se le solicita al usuario que diligencie de nuevo  los PN pero con delegación.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "18/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "30/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "18/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3904,
      "Title": "Forms",
      "Fecha_solicitud": "29/06/2023",
      "Correo_solicitante": "YUMONTOY@bancolombia.com.co",
      "Nombre_solicitante": "Yuliana Milena Montoya Quintero",
      "Nombre_iniciativa": "ID 3904 - Compra de licencia para el aplicativo Hopex CW2306999",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2306999",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere adquirir una licencia con el proveedor Mega para la aplicación Hopex CW2306999",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "6920 usd",
      "Proveedores_conocidos": "PROVEEDOR MEGA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC OFA - Cege: C103532",
      "Nombre_lider_EVC": "Adriana Bustamante",
      "SR_ARIBA": "SR4079104065",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Luis Guillermo Salcedo Valderrama",
      "Rol_asesor": "Andres Osorio Castano",
      "Observaciones": "Naty OK PN.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "07/07/2023",
      "Fecha Asignación/Delegación": "07/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "30/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "04/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3903,
      "Title": "Forms",
      "Fecha_solicitud": "29/06/2023",
      "Correo_solicitante": "anosorio@bancolombia.com.co",
      "Nombre_solicitante": "Ana Milena Osorio Sanmartin",
      "Nombre_iniciativa": "ID 3903 - taller para desarrollar nuevos habitos en los funcionarios que trabajan en la sucursal de Quibdó",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "taller para desarrollar nuevos habitos en los funcionarios que trabajan en la sucursal de Quibdó para  un proyecto de mejoramiento de la atención a los clientes de la ciudad de quibdó.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "10.000.000",
      "Proveedores_conocidos": "Creario",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Centro de excelencia de innovación C102200050",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3903,
      "Familias": "Servicios Profesionales Formación y Entrenamiento",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "30/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "30/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3902,
      "Title": "Forms",
      "Fecha_solicitud": "29/06/2023",
      "Correo_solicitante": "anosorio@bancolombia.com.co",
      "Nombre_solicitante": "Ana Milena Osorio Sanmartin",
      "Nombre_iniciativa": "ID 3902 - realizar un trabajo de campo y observación en el municipio de Quibdó",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El servicio que vamos a contratar es la logistica de desplazamiento y  la realización de citas con comunidades afro del municipio de quibdo, para conocer sus neecesidad, para desarrollas un servicio que queremos llevar a las comunidades rurales",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "10.000.000",
      "Proveedores_conocidos": "Ilewa",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "C102200050",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3902,
      "Familias": "Eventos y Servicios Formación y Entrenamiento",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "30/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "30/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3901,
      "Title": "Forms",
      "Fecha_solicitud": "29/06/2023",
      "Correo_solicitante": "lvnaran@bancolombia.com.co",
      "Nombre_solicitante": "Liliana Valencia Naranjo",
      "Nombre_iniciativa": "ID 3901 - Asignación de ICR",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere custodia de documento control de inversión con el proveedor datafile",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Priorizado por el CAE",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "presupuesto depende de la cotización de custodia y se gestiona con el gestor de gastos de la EVC",
      "Proveedores_conocidos": "Datafile",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Financiación y Consumo, 105500015",
      "Nombre_lider_EVC": "David Gonzalo Pelaez",
      "SR_ARIBA": "SR4079104027",
      "Familias": "Servicios Gestión Documental",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Laura Serna Rodriguez",
      "Rol_asesor": "No aplica",
      "Observaciones": "Biatri OK PN.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "07/07/2023",
      "Fecha Asignación/Delegación": "07/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "30/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "05/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Back Office",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3900,
      "Title": "Forms",
      "Fecha_solicitud": "29/06/2023",
      "Correo_solicitante": "emrivas@bancolombia.com.co",
      "Nombre_solicitante": "Emily Rivas Ochoa",
      "Nombre_iniciativa": "ID 3900 - Cambio de plan SURVIO CW2306899",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2306899",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere mejorar el plan de la plataforma SURVIO que sirve para realizar encuestas corporativas, ya que el plan que compramos inicialmente no tiene todas las modalidades que requerimos. CW2306899",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "1.000.000",
      "Proveedores_conocidos": "Survio",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de gestión de innovación y sostenibilidad - C102200000",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4077002626",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Luis Guillermo Salcedo Valderrama",
      "Rol_asesor": "Andres Osorio Castano",
      "Observaciones": "Naty OK PN.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "30/06/2023",
      "Fecha Asignación/Delegación": "30/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "29/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "29/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3899,
      "Title": "Forms",
      "Fecha_solicitud": "29/06/2023",
      "Correo_solicitante": "ednarvae@bancolombia.com.co",
      "Nombre_solicitante": "Eddy Johanna Narvaez Garzon",
      "Nombre_iniciativa": "ID 3899 - CURSO DE GASTRONOMIA Y EXPERIENCIAS DE COCINA PASTO",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor nos ofrece servicios de gastronomía, donde los empleados van aprender a realizar diferentes platos, adicional la idea es poder generar experiencia con los equipos",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "5.000.000",
      "Proveedores_conocidos": "empresa: Sublime local S.A.S NIT 901676238-5 Representante legal Maria Paula Luna Lopez c.c. 1015448634, Contacto comercial Maria Paula Luna Lopez c.c. 1015448634 celular 3167532026  Pais Colombia direccion calle 18b %23 42 a 04  condominio manaca casa 38 ciudad pasto barrio Valle de atriz correo electronico marialunapaula@gmail.com",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "gerencia de bienestar C 103200030",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3899,
      "Familias": "Eventos y Reconocimientos al Empleado",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "29/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "29/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3898,
      "Title": "Forms",
      "Fecha_solicitud": "29/06/2023",
      "Correo_solicitante": "jhsaboga@bancolombia.com.co",
      "Nombre_solicitante": "Jhoan Sebastian Sabogal Moncada",
      "Nombre_iniciativa": "ID 3898 - Sello B - Anticipar avaluos",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere realizar la negociación de la prestación de servicio para la realización de avalúos por fuera del proceso de financiación con el objetivo único de que el proveedor haga el análisis técnico del inmueble, valide si cumple con las políticas y condiciones banco para ser una garantía en un proceso de financiación. El proveedor seleccionado actualmente presta servicios en el flujo de soluciones inmobiliarias, se llama APPRAISER.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Priorizado por el CAE",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "No tiene presupuesto, dado que los costos finales son asumidos por el cliente",
      "Proveedores_conocidos": "APPRAISER",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC INMOBILIARIA - C105500050",
      "Nombre_lider_EVC": "Juan Camilo Arango",
      "SR_ARIBA": "SR4077002589",
      "Familias": "Honorarios Avalúos",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Laura Serna Rodriguez",
      "Rol_asesor": "No aplica",
      "Observaciones": "Beatriz OK PN.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "07/07/2023",
      "Fecha Asignación/Delegación": "07/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "29/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "29/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios Profesionales Procesos del Negocio",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3897,
      "Title": "Forms",
      "Fecha_solicitud": "28/06/2023",
      "Correo_solicitante": "matherna@bancolombia.com.co",
      "Nombre_solicitante": "Mateo Hernandez Restrepo",
      "Nombre_iniciativa": "ID 3897 - implemnetacion nuevo producto de seguro Cardif - MEGACOMBO",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Seguro MEGACOMBO - permitirá apalancar la colocacion de seguros en los equipos BPO, ya que al tener una propuesta adicional con beneficios y coberturas diferentes a las que hoy tenemos nos ayudara al manejo de objeciones y aumentar la particiopación de dichos productos, para esto es necesario realizar un alcance en los equipos BPO de venta directa, puntualmente en el tarifario de costos para definir cual va ser el pago que se va asumir por la venta de este nuevo seguro",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "el presupuesto es asumido directacmente por CARDIF",
      "Proveedores_conocidos": "KONECTA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Personas e Independientes",
      "Nombre_lider_EVC": "Luisa Fernanda Estrada Castro",
      "SR_ARIBA": "SR4076914630",
      "Familias": "Televenta",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "Lina Maria Monsalve Burgos",
      "Rol_asesor": "",
      "Observaciones": "Dianis OK PN.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "07/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "29/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "05/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Modelos de Relacionamiento Integral",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3896,
      "Title": "Forms",
      "Fecha_solicitud": "28/06/2023",
      "Correo_solicitante": "jeberare@bancolombia.com.co",
      "Nombre_solicitante": "Jennifer Bergano Arenas",
      "Nombre_iniciativa": "ID 3896 - Proveedor de Café",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Proveedor de café. y merch",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "2.200.000",
      "Proveedores_conocidos": "INVERSIONES HONESTAS S.A.S.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "C102200008",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3896,
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "A la espera de confirmación de usuaria",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "29/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "29/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3895,
      "Title": "Forms",
      "Fecha_solicitud": "28/06/2023",
      "Correo_solicitante": "jeberare@bancolombia.com.co",
      "Nombre_solicitante": "Jennifer Bergano Arenas",
      "Nombre_iniciativa": "ID 3895 - VALLAS COLOMBIANAS S.A.",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Producción de publicidad exterior",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "10.000.000",
      "Proveedores_conocidos": "VALLAS COLOMBIANAS S.A.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "C102200008",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3895,
      "Familias": "Pautas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "29/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "29/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3894,
      "Title": "Forms",
      "Fecha_solicitud": "28/06/2023",
      "Correo_solicitante": "glocasta@bancolombia.com.co",
      "Nombre_solicitante": "Gloria Elena Castano Soto",
      "Nombre_iniciativa": "ID 3894 - Programa Behavioral Economics",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Se requiere vincular el proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El servicio que ofrece este proveedor son programas de formación",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Evidentia University",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Aprendizaje C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3894,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "29/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "29/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3893,
      "Title": "Forms",
      "Fecha_solicitud": "28/06/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 3893 - Compra de curso de extensión REAL ESTATE E - PROPERTY MANAGEMENT \tHERBERT BUSINESS SCHOOL OF MIAMI",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión REAL ESTATE E - PROPERTY MANAGEMENT \tHERBERT BUSINESS SCHOOL OF MIAMI",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "HERBERT BUSINESS SCHOOL OF MIAMI",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3893,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "29/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "29/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3892,
      "Title": "Forms",
      "Fecha_solicitud": "28/06/2023",
      "Correo_solicitante": "marriago@bancolombia.com.co",
      "Nombre_solicitante": "Mariana Riano Gonzalez",
      "Nombre_iniciativa": "ID 3892 - Caídas aplicativo APM",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El aliado Konecta nos esta realizando un escalamiento por indisponibilidad de una herramienta de Banco que es necesaria para Operar, así mismo nos esta trasladando el costo por el tiempo en el que sus asesores estuvieron improductivos por causa de esta herramienta.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "No tenemos presupuestado un pago adicional a los aliados por indisponibilidad de una herramienta, solo para el pago de sus servicios prestados",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Konecta",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Sección Servicios BPO - C505400123",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4085956336",
      "Familias": "Líneas de Entrada",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Sergio Humberto Ramirez Tobon",
      "Rol_asesor": "No aplica",
      "Observaciones": "Dianis no va a PN por naturaleza. Se validó requisisto con escalamientos anteriores de Daniela Goméz y es un requerimiento nuevo.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "07/07/2023",
      "Fecha Asignación/Delegación": "07/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "06/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios Canal Telefónico",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3891,
      "Title": "Forms",
      "Fecha_solicitud": "28/06/2023",
      "Correo_solicitante": "mariales@bancolombia.com.co",
      "Nombre_solicitante": "Maria Alejandra Sanchez Larrea",
      "Nombre_iniciativa": "ID 3891 - Se solicita realizar la actualización del acreedor2270   Julian Serrano Silva",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Se requiere la actualización del proveedor en el sistema.",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor mensualmente se le realiza pagos de honorarios, bonificaciones y reintegros como abogado.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Julian Serrano Silva acreedor Acreedor 2270",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Sección Servicios Administrativos de Cobranza",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3891,
      "Familias": "Servicios Legales",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "28/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "28/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios Profesionales Procesos del Negocio",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3890,
      "Title": "Forms",
      "Fecha_solicitud": "27/06/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 3890 - Compra de curso de extensión XLIV CONGRESO COLOMBIANO DE DERECHO PROCESAL\tINSTITUTO COLOMBIANO DE DERECHO PROC",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión XLIV CONGRESO COLOMBIANO DE DERECHO PROCESAL\tINSTITUTO COLOMBIANO DE DERECHO PROCESAL",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "INSTITUTO COLOMBIANO DE DERECHO PROCESAL",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3890,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "28/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "28/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3889,
      "Title": "Forms",
      "Fecha_solicitud": "27/06/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 3889 - Compra de curso de extensión PPRO POWER PROFESIONAL \tDATA CENTRE DYNAMICS SPAIN, S. L. (DC PROFESSIONAL DEVELO",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión PPRO POWER PROFESIONAL \tDATA CENTRE DYNAMICS SPAIN, S. L.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "DATA CENTRE DYNAMICS SPAIN, S. L. (DC PROFESSIONAL DEVELOPMENT)",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3889,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "28/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "28/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3888,
      "Title": "Forms",
      "Fecha_solicitud": "27/06/2023",
      "Correo_solicitante": "dggil@bancolombia.com.co",
      "Nombre_solicitante": "Daniela Gomez Gil",
      "Nombre_iniciativa": "ID 3888 - Negociar escalamiento 2 de Konecta CW2237080",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere realizar la negociación de un nuevo escalamiento del proveedor Konecta hacia el Banco, en esta ocasión por el tiempo entre el proceso de conocimiento del empleado del proveedores antes de registrarlos. Para esto, ya se tuvieron algunas conversaciones con Yohany Gaviria quien estará acompañando el proceso. Re revisa CW2237080",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Priorizado por el CAE",
      "Justificación_sin_presupuesto": "No aplica",
      "Valor_presupuesto": 10,
      "Proveedores_conocidos": "Multienlace / Konecta",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Gerencia estrategia de abastecimiento",
      "Nombre_lider_EVC": "Angela María Sierra",
      "SR_ARIBA": "SR4073613415",
      "Familias": "Líneas de Entrada",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Sergio Humberto Ramirez Tobon",
      "Rol_asesor": "No aplica",
      "Observaciones": "No se va a PN por la naturaleza de la solicitud. Requerimiento generado desde el área de Iván Loaiza, se pide asignar a Yohany, escalamiento a la inversa por parte del proveedor",
      "Comentarios BP": "",
      "Fecha MarketPlace": "07/07/2023",
      "Fecha Asignación/Delegación": "07/07/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "27/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios Canal Telefónico",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3887,
      "Title": "Forms",
      "Fecha_solicitud": "27/06/2023",
      "Correo_solicitante": "erestrep@bancolombia.com.co",
      "Nombre_solicitante": "Elba Ines Restrepo Orrego",
      "Nombre_iniciativa": "ID 3887 - Debemos actualizar este proveedor RODRIGO, ELIAS & MEDRANO ABOGADOS SOCIEDAD CIVIL DE RESPONSABILIDAD LIMITADA",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Desbloquearlo y para poderle pagar una factura",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se debe pagar una factura al proveedor RODRIGO, ELIAS & MEDRANO ABOGADOS SOCIEDAD CIVIL DE RESPONSABILIDAD LIMITADA, ya que nos prestó un servicio de consultoría y nos informan que esta desactualizado.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "RODRIGO, ELIAS & MEDRANO ABOGADOS SOCIEDAD CIVIL DE RESPONSABILIDAD LIMITADA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GIRALDO VELEZ ANDRES\tDIRECTOR/A\tDIRECCION CORP GRANDES EXPOSICIONES\t centro de costos C102300001",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3887,
      "Familias": "Consultorias Corporativas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "27/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "27/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Consultorias Corporativas",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3886,
      "Title": "Forms",
      "Fecha_solicitud": "26/06/2023",
      "Correo_solicitante": "egonzale@bancolombia.com.co",
      "Nombre_solicitante": "Elizabeth Gonzalez Vega",
      "Nombre_iniciativa": "ID 3886 - Renovacion contrato y adquirir servicio - CW2278817 Servicio SAAS",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2278817",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Actualmente se tiene contratado el proveedor INFOBIP para las entidades Banco y Valores, se cuenta con usuarios de acceso a whatssap para asesoría a clientes (Answer), sin embargo, la minoría de estos usuarios está inactivos por no uso. Por otra parte, Infobip nos esa ofrece un servicio más funcional Answers S (Plataforma de creación de Bots) que sería un servicio de negociación verificable para el cierre de operaciones. CW2278817 Servicio SAAS",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 545.382,
      "Proveedores_conocidos": "INFOBIP",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C502000000 VICEPRESIDENCIA COME",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4073532364",
      "Familias": "Servicios SaaS",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Isabella Correa Valencia",
      "Rol_asesor": "Adriana Maria Arango Restrepo",
      "Observaciones": "Se envía recordatorio PN 04/07/2023. Ya se le había retirado el Requerimiento 3578 por no gestionar PN el 08/06/2023.\nJulio 17.  Se le escribe al jefe. por si alguien mas puede hacer la gestión.\nAgo. 11. Riesgos autorizó avanzar en la renovación sin gestión de PN pero con el compromiso de hacerlo durante la gestión.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "18/08/2023",
      "Fecha Asignación/Delegación": "18/08/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "27/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "11/08/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de plataformas",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3885,
      "Title": "Forms",
      "Fecha_solicitud": "26/06/2023",
      "Correo_solicitante": "crgutier@bancolombia.com.co",
      "Nombre_solicitante": "Cristian Roberto Gutierrez Ricardo",
      "Nombre_iniciativa": "ID 3885 - \"Servicios De Asesoria Integral En La Colocacion De Cartera Agropecuaria\" CW2221709",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2221709",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Servicio de asesoría en la estructuración de operación de credito en cartera agropecuaria Finagro, de nuestros clientes del sector Agro. CW2221709",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "No se paga con presupuesto del administrador del contrato.",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "GRUPO MEGAG SAS",
      "Cuadrante_Proveedor": 3,
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "no aplica",
      "Nombre_lider_EVC": "Pala andrea velez",
      "SR_ARIBA": "SR4073532275",
      "Familias": "Honorarios Avalúos",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Laura Serna Rodriguez",
      "Rol_asesor": "No aplica",
      "Observaciones": "Biatri proveedor no va a PN por criticidad de cuadrante 3",
      "Comentarios BP": "",
      "Fecha MarketPlace": "30/06/2023",
      "Fecha Asignación/Delegación": "30/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "27/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios Profesionales Procesos del Negocio",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3884,
      "Title": "Forms",
      "Fecha_solicitud": "26/06/2023",
      "Correo_solicitante": "jtsanche@bancolombia.com.co",
      "Nombre_solicitante": "July Tatiana Sanchez Agudelo",
      "Nombre_iniciativa": "ID 3884 - Actualización Proveedores (Fondo Nacional de Ahorro)",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular-Actualizar para poder pagar la factura",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Los proveedores recaudan las cesantías como ahorro de empleados de diferentes empresas.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "900319291 ASOPAGOS S.A. --- 900322123 SIMPLE SOLUTIONS S.A.S.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Gestión de Flujos",
      "Nombre_lider_EVC": "Juan Gonzalo Tobon Arrubla",
      "SR_ARIBA": 3884,
      "Familias": "Pasarelas de Pago",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "27/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "27/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Medios de Pago",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3883,
      "Title": "Forms",
      "Fecha_solicitud": "26/06/2023",
      "Correo_solicitante": "lzapata@bancolombia.com.co",
      "Nombre_solicitante": "Laura Zapata Alvarez",
      "Nombre_iniciativa": "ID 3883 - Pago de stand en evento de Startco en marzo del 2023.",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular al proveedor para generar el pedido en SAP y hacer el pago",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere vincular al proveedor, este no completó la información a tiempo y se venció, lo requerimos de forma urgente porque la factura es de marzo y se encuentra vencida.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "INTER EXPO S.A.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC CLIENTES PYMES Y EMPRESAS - C105900008",
      "Nombre_lider_EVC": "Paula Velez",
      "SR_ARIBA": 3883,
      "Familias": "BTL",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "26/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "26/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3882,
      "Title": "Forms",
      "Fecha_solicitud": "26/06/2023",
      "Correo_solicitante": "RICASALL@bancolombia.com.co",
      "Nombre_solicitante": "Ricardo Casallas Lopez",
      "Nombre_iniciativa": "ID 3882 - Aceptación de propuesta asesorias en temas de FATCA & CRS",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "contratación era de bajo monto se legalizó por orden de compra",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la firma de la nueva propuesta para las asesorias en temas de FATCA y CRS ya que se modifico la propuesta del año 2022 ya que no sera con un cobro mensual fijo sino por las horas que se pidan.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "6.000.000",
      "Proveedores_conocidos": "KPMG ADVISORY, TAX & LEGAL Nit 860522381-1",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "LDC FC SARLAFT FATCA CRS C102600007",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR3945835205",
      "Familias": "Consultorias Corporativas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Se toma SR de requerimiento 3279, dado que es delegado y se acordó con Beatriz y Jorge, dado que la compra se gestiona con pedido de SAP. Este requerimiento se da para legalizar la negociación. Temas Jorge Aguinaga 26/06/2023",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "26/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "26/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Consultorias Corporativas",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3881,
      "Title": "Forms",
      "Fecha_solicitud": "26/06/2023",
      "Correo_solicitante": "andcamar@bancolombia.com.co",
      "Nombre_solicitante": "Andrea Paola Camargo Maldonado",
      "Nombre_iniciativa": "ID 3881 - Vincular a proveedor para actividad en Monteria",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular Proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere vincular proveedor para realizar actividades de Bienestar en monteria",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Alba Marina Agamez Payares  cc 34990616",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "c103200170 Gerencia Calidad de Vida",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3881,
      "Familias": "Convenios y Beneficios",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "26/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "26/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3880,
      "Title": "Forms",
      "Fecha_solicitud": "26/06/2023",
      "Correo_solicitante": "ednarvae@bancolombia.com.co",
      "Nombre_solicitante": "Eddy Johanna Narvaez Garzon",
      "Nombre_iniciativa": "ID 3880 - Experiencia Gastronomica (curso de concina Pasto)",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "realizar experiencia con los equipos de trabajo, realizando cursos de cocina y alimentos saludables",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "5.000.000",
      "Proveedores_conocidos": "Nombre de la empresa: Sublime Local SAS NIT 901676238-5, Nombre representante legal MARIA PAULA LUNA LOPEZ C.C. 1015448634 son los mismos datos del contacto comercial, celulara 3167532026, direccion call 18b %2342a 04  condomino manaca casa 38 barrio Valle de  atriz, ciudad Pasto, correo electronico marialunapaula@gmail.com",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Bienestar c103200030",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3880,
      "Familias": "Eventos y Reconocimientos al Empleado",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "26/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "26/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3879,
      "Title": "Forms",
      "Fecha_solicitud": "23/06/2023",
      "Correo_solicitante": "andcamar@bancolombia.com.co",
      "Nombre_solicitante": "Andrea Paola Camargo Maldonado",
      "Nombre_iniciativa": "ID 3879 - Vincular proveedor",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular Proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere vincular proveedor para hacer actividades de Bienestar",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Maria Alejandra Vives Paez cc\t1082979589",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Bienestar c103200170",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3879,
      "Familias": "Convenios y Beneficios",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "23/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "23/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3878,
      "Title": "Forms",
      "Fecha_solicitud": "23/06/2023",
      "Correo_solicitante": "juanrami@bancolombia.com.co",
      "Nombre_solicitante": "Juan David Ramirez Ruiz",
      "Nombre_iniciativa": "ID 3878 - Carro de monedas",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Actualmente tenemos un posible carro de monedas este lo suministra importaciones Sheel, en algunos casos solucionamos necesidades de transporte de efectivo internamente en sucursales, pero la Gcia de Bienestar NO lo autorizo por temas de ergonomía. Nos dice que existe este carro (imagen) el cua Sí cumple con los estandar, actualmente lo manejan las transportadoras.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "1.000.000",
      "Proveedores_conocidos": "NO TENEMOS CONOCIMIENTO",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C104300023",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR No requerido",
      "Familias": "Mobiliario",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Contención",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Esta es una compra menor que atiende Mónica Martínez, se le indica al usuario que se atiende por correo.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "23/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Activos Fijos",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3877,
      "Title": "Forms",
      "Fecha_solicitud": "23/06/2023",
      "Correo_solicitante": "andcamar@bancolombia.com.co",
      "Nombre_solicitante": "Andrea Paola Camargo Maldonado",
      "Nombre_iniciativa": "ID 3877 - Vincular Proveedor Zuana en Santa Marta",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular Proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere vincular proveedor para realizar actividades de bienestar",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "C.B. HOTELES Y RESORTS S.A. NIT 8190009868",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Bienestar c103200170",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3877,
      "Familias": "Convenios y Beneficios",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "23/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "23/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3876,
      "Title": "Forms",
      "Fecha_solicitud": "23/06/2023",
      "Correo_solicitante": "suslopez@bancolombia.com.co",
      "Nombre_solicitante": "Susana Lopez Echeverri",
      "Nombre_iniciativa": "ID 3876 - Cuenta de cobro valoración Civico",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Generar pedido y MIGO para la factura",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Servicio de valoración de la empresa Civico para actualizar valor en libros de la inversión",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Daniel José Motta Díaz",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Direccion Innovacion Abierta C102200010",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3876,
      "Familias": "Servicios Legales",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "23/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "23/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios Profesionales Procesos del Negocio",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3875,
      "Title": "Forms",
      "Fecha_solicitud": "23/06/2023",
      "Correo_solicitante": "AFRendon@Bancolombia.com.co",
      "Nombre_solicitante": "Andres Felipe Rendon Marin",
      "Nombre_iniciativa": "ID 3875 - Reemplazo plataforma Sungard",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Queremos ampliar el alcance de la iniciativa para reemplazar al proveedor Fidessa, aprovechando las capacidades existentes  economía de escala, para reemplazar también la plataforma de Sungard (Fis Global). La idea es aprovechar que en la etapa inicial ya se realizaron las validaciones de Ciber, SOX y Riesgo operativo con la plataforma de CMA y que adicionalmente tampoco se vió necesidad de utilizar las respectivas pólizas con el proveedor.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "65 millones COP",
      "Proveedores_conocidos": "CMA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Inversiones EVC00012",
      "Nombre_lider_EVC": "Rafael Alberto Luna",
      "SR_ARIBA": "SR4069097522",
      "Familias": "Servicios SaaS",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Luis Guillermo Salcedo Valderrama",
      "Rol_asesor": "Andres Osorio Castano",
      "Observaciones": "José OK PN.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "07/07/2023",
      "Fecha Asignación/Delegación": "07/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "23/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "27/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de plataformas",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3874,
      "Title": "Forms",
      "Fecha_solicitud": "23/06/2023",
      "Correo_solicitante": "estrios@bancolombia.com.co",
      "Nombre_solicitante": "Esteban Rios Bonilla",
      "Nombre_iniciativa": "ID 3874 - Consultoria para proyecto de reportería enriquecida",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere el acompañamiento por parte de Cadena de Abastecimiento para la exploración de posibles aliados para implementación de una herramienta denominada reportes enriquecidos, la cual busca mejorar la experiencia de conciliación de nuestros clientes a partir de la información de los productos. Se espera explorar con Fintechs y posibles empresas de tecnología expertas en conciliación y analítica. Nos está acompañando Mastercard en una consultaría pero necesitamos de la capacidad de abastecimiento para los lineamientos y apoyo en el RFI",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Priorizado por el CAE",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "Pendiente de la estimación con el mercado",
      "Proveedores_conocidos": "Simetrik es un posible aliado",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Gestión de Flujos C105500048",
      "Nombre_lider_EVC": "Juan Gonzalo Tobon Arrubla",
      "SR_ARIBA": "SR4069195961",
      "Familias": "Licenciamiento Mayor",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Katherine Sanchez Henao",
      "Rol_asesor": "Adriana Maria Arango Restrepo",
      "Observaciones": "José OK PN.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "14/07/2023",
      "Fecha Asignación/Delegación": "14/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "26/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "12/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3873,
      "Title": "Forms",
      "Fecha_solicitud": "23/06/2023",
      "Correo_solicitante": "juanrami@bancolombia.com.co",
      "Nombre_solicitante": "Juan David Ramirez Ruiz",
      "Nombre_iniciativa": "ID 3873 - Bimbos y mobiliarios especiales sedes",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular al proveedor con el cual se inicio negociacion con cotizacion",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Muebles y biombos.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "CERACE MOBILIARIO S.A.S.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C104300023",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3873,
      "Familias": "Mobiliario",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "23/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "23/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Activos Fijos",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3872,
      "Title": "MP Manual",
      "Fecha_solicitud": "23/06/2023",
      "Correo_solicitante": "",
      "Nombre_solicitante": "Paola Andrea Angel Palacio",
      "Nombre_iniciativa": "ID 3872 -",
      "Tipo_Requerimiento": "Requerimiento Nuevo",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Intervención ACH como parte de OLA 2",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "",
      "Nombre_area_y_ceco": "Gestion de Flujos",
      "Nombre_lider_EVC": "Juan Gonzalo Tobon",
      "SR_ARIBA": "SR4057353530",
      "Familias": "Canales Digitales",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Andres Felipe Viana Casas",
      "Rol_asesor": "No aplica",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "23/06/2023",
      "Fecha Asignación/Delegación": "23/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Canales Digitales",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3871,
      "Title": "MP Manual",
      "Fecha_solicitud": "23/06/2023",
      "Correo_solicitante": "",
      "Nombre_solicitante": "Maribet Sepulveda Marin",
      "Nombre_iniciativa": "ID 3871 -",
      "Tipo_Requerimiento": "Requerimiento Nuevo",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere hacer entrega al aliado Agilitix de la administración del modelo AOM para el servicio EPA (Endpoint Analisys) y ZTAR (Zero trust) en acceso remoto. Esto teniendo en cuenta que Agilitix es quien actualmente administra todo el AOM de conexion acceso remoto como aliado directo de telecomunicaciones.\n\nSe espera entonces mantener una orden de servicio independiente para ciberseguridad y con ANS diferentes a los del contrato macro que se tiene con telecomunicaciones y la asignacion de 1 recurso dedicado al proceso",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "20.000.000 mensuales maximo por la prestacion del servicio",
      "Proveedores_conocidos": "Agilitix",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "",
      "Nombre_area_y_ceco": "Ciberseguridad",
      "Nombre_lider_EVC": ".",
      "SR_ARIBA": "SR4068329241",
      "Familias": "Controles de Ciberseguridad",
      "Categoría": "Seguridad",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Mateo Villada Rodriguez",
      "Rol_asesor": "No aplica",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "23/06/2023",
      "Fecha Asignación/Delegación": "23/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Ciberseguridad y seguridad de la información",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3870,
      "Title": "MP Manual",
      "Fecha_solicitud": "23/06/2023",
      "Correo_solicitante": "",
      "Nombre_solicitante": "Indira Catalina Perez Ariza",
      "Nombre_iniciativa": "ID 3870 -",
      "Tipo_Requerimiento": "Renovación",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere ingresar el servicio de financiación de polizas en GLIA dentro de la orden de servicio CW2295476 y ajustar los ANS de acuerdo a este nuevo producto. \nAdicional. Se renovarán tarifas.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "No tengo presupuesto aprobado",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Atento",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "",
      "Nombre_area_y_ceco": "EVC estrategia de cliente - Centro de Costos: C105000000",
      "Nombre_lider_EVC": "Juliana Velasquez",
      "SR_ARIBA": "SR4068329258",
      "Familias": "Venta en Campo",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Santiago Zapata Serna",
      "Rol_asesor": "No aplica",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "23/06/2023",
      "Fecha Asignación/Delegación": "23/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Modelos de Relacionamiento Integral",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3868,
      "Title": "Forms",
      "Fecha_solicitud": "23/06/2023",
      "Correo_solicitante": "CAMILRES@bancolombia.com.co",
      "Nombre_solicitante": "Camilo Restrepo Saldarriaga",
      "Nombre_iniciativa": "ID 3868 - Salesforce Frente Servicio",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Con el fin de darle continuidad a la evolución y masificación de Salesforce, se requiere invitar proveedores a participar en el reto de implementar el frente de Servicio (quejas, reclamos, aclaraciones y solicitudes). La idea es que sean estos terceros quienes implementen, sobre la base de lo ya construido en anteriores releases.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "1.200.000.000",
      "Proveedores_conocidos": "NTT Data, S4G, Deloitte, Capgemini, TCS, Globant, Accenture e IBM",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Conocimiento del Cliente, C102100019",
      "Nombre_lider_EVC": "Camilo Restrepo Saldarriaga",
      "SR_ARIBA": "SR4068802046",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Juan Esteban Franco Vargas",
      "Rol_asesor": "No aplica",
      "Observaciones": "José OK PN.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "14/07/2023",
      "Fecha Asignación/Delegación": "14/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "23/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "11/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3867,
      "Title": "power_apps",
      "Fecha_solicitud": "23/06/2023",
      "Correo_solicitante": "marclope@bancolombia.com.co",
      "Nombre_solicitante": "Marcela Lopez Rendon",
      "Nombre_iniciativa": "ID 3867 - Renovación consola Apple para aplicativos moviles Bancolombia",
      "Tipo_Requerimiento": "Renovación",
      "CW_a_renovar": "AJ19697857",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación de la consola administrativa de todos los aplicativos moviles Bancolombia (Aplicaciones Digitales) del proveedor Apple (CW2298716??)",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "$99 dolares",
      "Proveedores_conocidos": "Apple",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "VICEPRESIDENCIA NEGOCIOS PERSN PYME EMP",
      "Nombre_area_y_ceco": "EVC Distribución Digital Personas - C105400003",
      "Nombre_lider_EVC": "Saida Catalina Castano Echavarria",
      "SR_ARIBA": "SR4068559708",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "John Alexis Velasquez Garcia",
      "Rol_asesor": "Andres Osorio Castano",
      "Observaciones": "NATY OK pn",
      "Comentarios BP": "",
      "Fecha MarketPlace": "30/06/2023",
      "Fecha Asignación/Delegación": "30/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "23/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "23/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3869,
      "Title": "Forms",
      "Fecha_solicitud": "22/06/2023",
      "Correo_solicitante": "juarestr@bancolombia.com.co",
      "Nombre_solicitante": "Juan David Restrepo Cifuentes",
      "Nombre_iniciativa": "ID 3869 - Renovación Licencias Appgate SDP. CW2295619",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2295619",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación 60 licencias de SDP adicionales que vencen el 13 de julio . CW2295619",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "2646 dolares",
      "Proveedores_conocidos": "Easy Solutions",
      "Cuadrante_Proveedor": 1,
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "C102200120",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4068802029",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Nicolas Quiceno Carmona",
      "Rol_asesor": "Andres Osorio Castano",
      "Observaciones": "Naty OK PN.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "30/06/2023",
      "Fecha Asignación/Delegación": "30/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "23/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "27/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3866,
      "Title": "Forms",
      "Fecha_solicitud": "22/06/2023",
      "Correo_solicitante": "johrios@bancolombia.com.co",
      "Nombre_solicitante": "Johan David Rios Ruiz",
      "Nombre_iniciativa": "ID 3866 - Pago de servicios a GRUPO PROTECCION A.T.C S.A.S (AquaShield)",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular al proveedor GRUPO PROTECCION A.T.C S.A.S para pagarle por los servicios prestados a Sufi Bancolombia",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor AquaShield (GRUPO PROTECCION A.T.C S.A.S) es un establecimiento que presta los servicios de lavado de carros y motos. Con ellos realizamos un acuerdo para entregar beneficios a los clientes de vehículo Sufi.\nEl Banco va a pagar el 100% de los servicios, es una acción de Fidelización para ''consentir'' a los clientes que son rentables y retener a aquellos que se quieren ir para otro Banco",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "GRUPO PROTECCION A.T.C S.A.S",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Ciclo de Vida y Mercadeo (Gerencia de Mercadeo Sufi) C105000007",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3866,
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "23/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "23/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3865,
      "Title": "Forms",
      "Fecha_solicitud": "22/06/2023",
      "Correo_solicitante": "juarestr@bancolombia.com.co",
      "Nombre_solicitante": "Juan David Restrepo Cifuentes",
      "Nombre_iniciativa": "ID 3865 - Renovación TECH AND SOLVE SAS CW2285737",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2285737",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Servicios profesionales FTE. Renovación contrato CW2285737",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Porque es una negociación y debe revisarse el aumento en el valor de las tarifas del servicio",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "TECH AND SOLVE SAS",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "C102200031",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4067817900",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Daniel Jimenez Delgado",
      "Rol_asesor": "No aplica",
      "Observaciones": "José OK PN.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "30/06/2023",
      "Fecha Asignación/Delegación": "30/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "23/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "27/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3864,
      "Title": "Forms",
      "Fecha_solicitud": "22/06/2023",
      "Correo_solicitante": "ntilano@bancolombia.com.co",
      "Nombre_solicitante": "Nahomy Daniela Tilano Diaz",
      "Nombre_iniciativa": "ID 3864 - Patrocinio al municipio de Suan",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular a proveedor y hacer pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor es una entidad suministra alimentos, en el cual prestara el servicio de refrigerios al municipio de Suan.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Huver Jose Rivera Rodriguez",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3864,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "22/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "22/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3863,
      "Title": "Forms",
      "Fecha_solicitud": "22/06/2023",
      "Correo_solicitante": "eeescude@bancolombia.com.co",
      "Nombre_solicitante": "Eric Emiro Escudero Almeida",
      "Nombre_iniciativa": "ID 3863 - Consultoria para mejora del control AntiDDos",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Ciberseguridad requiere una solución que permita de manera proactiva generar automatización en la activación de la mitigación en caso de un evento de seguridad catalogado específicamente DDoS, actualmente en la exploración estamos validando el fabricante Radware, quien por medio de Cirion provee dicha solución.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Actualmente estoy a la espera de asignacion del presupuesto para el 2024",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Cirion - Radware",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Capacidades de Ciberseguridad C104300559",
      "Nombre_lider_EVC": "Andres Felipe Rivas Gonzalez",
      "SR_ARIBA": "SR4067581192",
      "Familias": "Controles de Ciberseguridad",
      "Categoría": "Seguridad",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Pablo Zapata Franco",
      "Rol_asesor": "Andres Osorio Castano",
      "Observaciones": "Cata OK PN.",
      "Comentarios BP": "Llevar al MP",
      "Fecha MarketPlace": "30/06/2023",
      "Fecha Asignación/Delegación": "30/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "22/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "27/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Ciberseguridad y seguridad de la información",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3862,
      "Title": "Forms",
      "Fecha_solicitud": "22/06/2023",
      "Correo_solicitante": "julmoral@bancolombia.com.co",
      "Nombre_solicitante": "Julian Morales Patino",
      "Nombre_iniciativa": "ID 3862 - Estudio Plataforma Confirming",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la integración con la plataforma con el objetivo de conectarnos directamente a sus pagadores y proveedores para el fondeo de sus facturas. La plataforma se integra al ERP de los clientes para tomar la información directamente y así facilitar el proceso para estos y después nos envían la información a través de H2H. La plataforma es un tercero con el cual trabajamos de la mano, en donde no se contrata pagando un fee por sus servicios, sino que ellos cobran unos puntos básicos sobre la tasa de las facturas descontadas a través de esta; ellos entran como un proveedor que nos permite una mejor integración de cara a pagadores y proveedores.",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "La plataforma es un tercero con el cual trabajamos de la mano, en donde no se contrata pagando un fee por sus servicios, sino que ellos cobran unos puntos básicos sobre la tasa de las facturas descontadas a través de esta, razón por la cual no es necesario un presupuesto previo, dado que el pago se hará en forma de comisiones con forme estas se vayan generando.”",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Divisa S.A.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Nuevos Negocios",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4067581210",
      "Familias": "Servicios SaaS",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "22/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "22/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "22/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicio de plataformas",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3861,
      "Title": "Forms",
      "Fecha_solicitud": "22/06/2023",
      "Correo_solicitante": "fevelasc@bancolombia.com.co",
      "Nombre_solicitante": "Fernando Enrique Velasco Forero",
      "Nombre_iniciativa": "ID 3861 - Renovación orden de servicios PARADOC. CW2278565 (6437)",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2278565 CODIGO 6437",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se solicita realizar renovación de la orden e servicio para el proveedor PARADOC. Generación de extractos. CW2278565 (6437)",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Priorizado por el CAE",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "1000 mm",
      "Proveedores_conocidos": "PARADIGMA",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Evolución Digital C103500156",
      "Nombre_lider_EVC": "Fernando Enrique Velasco Forero",
      "SR_ARIBA": "SR4067817883",
      "Familias": "Licenciamiento Mayor",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Daniel Jimenez Delgado",
      "Rol_asesor": "No aplica",
      "Observaciones": "En Ariba la familia es de las nuevas - LICENCIAMIENTO ARRENDAMIENTO SOFTWARE.\nJOSE OK PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "30/06/2023",
      "Fecha Asignación/Delegación": "30/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "23/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "23/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3860,
      "Title": "Forms",
      "Fecha_solicitud": "22/06/2023",
      "Correo_solicitante": "saravela@bancolombia.com.co",
      "Nombre_solicitante": "Sara Velasquez Bedoya",
      "Nombre_iniciativa": "ID 3860 - Pago a pagina web consultoría LinkedIn",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular a proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Pago para analítica LinkedIn red Presidencia",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Shield Analytics for LinkedIn",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Gestión C102000000",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4067486295",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Leidy Tatiana Tangarife Gonzalez",
      "Rol_asesor": "Andres Osorio Castano",
      "Observaciones": "Naty OK PN.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "30/06/2023",
      "Fecha Asignación/Delegación": "30/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "22/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "27/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3859,
      "Title": "Forms",
      "Fecha_solicitud": "22/06/2023",
      "Correo_solicitante": "ANFELOPE@bancolombia.com.co",
      "Nombre_solicitante": "Andres Felipe Lopez Estrada",
      "Nombre_iniciativa": "ID 3859 - Conexion Datacenter con nubes publicas (Multicloud) CW2275976",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2275976",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación. Conexion Datacenter con nubes publicas (Multicloud) CW2275976",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "$ 185.000.000 COP Mes",
      "Proveedores_conocidos": "Cirion",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "ADC DISEÑO Y OPERACION TELCO TI - C103500100",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4067486278",
      "Familias": "Telecomunicaciones",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Andres Felipe Meneses Vergara",
      "Rol_asesor": "No aplica",
      "Observaciones": "jose ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "07/07/2023",
      "Fecha Asignación/Delegación": "07/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "22/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "23/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio telecomunicación",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3858,
      "Title": "Forms",
      "Fecha_solicitud": "22/06/2023",
      "Correo_solicitante": "ANFELOPE@bancolombia.com.co",
      "Nombre_solicitante": "Andres Felipe Lopez Estrada",
      "Nombre_iniciativa": "ID 3858 - Internet Corporativo. CW2290838",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2290838",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación. Salida a internet de la organizacion. CW2290838",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "$ 140.000.000 COP Mes",
      "Proveedores_conocidos": "Cirion",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "ADC DISEÑO Y OPERACION TELCO TI - C103500100",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4067396659",
      "Familias": "Telecomunicaciones",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Andres Felipe Meneses Vergara",
      "Rol_asesor": "No aplica",
      "Observaciones": "Jose ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "14/07/2023",
      "Fecha Asignación/Delegación": "14/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "22/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "23/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio telecomunicación",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3857,
      "Title": "Forms",
      "Fecha_solicitud": "22/06/2023",
      "Correo_solicitante": "ANFELOPE@bancolombia.com.co",
      "Nombre_solicitante": "Andres Felipe Lopez Estrada",
      "Nombre_iniciativa": "ID 3857 - Conexion con Redes Externas Cirion CW2279014",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2279014",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación.. Conexion con entidades externas al Banco CW2279014",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "$ 49.000.000 COP Mes",
      "Proveedores_conocidos": "Cirion",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "ADC DISEÑO Y OPERACION TELCO TI - C103500100",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4067396642",
      "Familias": "Telecomunicaciones",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Andres Felipe Meneses Vergara",
      "Rol_asesor": "No aplica",
      "Observaciones": "Jose ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "07/07/2023",
      "Fecha Asignación/Delegación": "07/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "22/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "23/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio telecomunicación",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3856,
      "Title": "Forms",
      "Fecha_solicitud": "22/06/2023",
      "Correo_solicitante": "ANFELOPE@bancolombia.com.co",
      "Nombre_solicitante": "Andres Felipe Lopez Estrada",
      "Nombre_iniciativa": "ID 3856 - Conectividad de sitios principales con el anillo del proveedor CLARO. CW2265540",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2265540",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación.. Conectividad de sitios principales con el anillo del proveedor CLARO. CW2265540",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "$ 188.000.000 COP Mes",
      "Proveedores_conocidos": "CLARO - TELMEX",
      "Cuadrante_Proveedor": 0,
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "ADC DISEÑO Y OPERACION TELCO TI - C103500100",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4067396625",
      "Familias": "Telecomunicaciones",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Andres Felipe Meneses Vergara",
      "Rol_asesor": "No aplica",
      "Observaciones": "Jose ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "07/07/2023",
      "Fecha Asignación/Delegación": "07/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "22/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "23/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio telecomunicación",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3855,
      "Title": "Forms",
      "Fecha_solicitud": "22/06/2023",
      "Correo_solicitante": "danicast@bancolombia.com.co",
      "Nombre_solicitante": "Daniela Castano Ballesteros",
      "Nombre_iniciativa": "ID 3855 - POC con Ozone para BaaS",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Solicitar material para gestionar el pago al proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "La presente propuesta considera una integración completa con la plataforma de Ozone API, permitiendo que\nBancolombia pueda conocer y entender de manera práctica cómo será operar y exponer sus APIs de Open Finance a\ntravés de nuestra plataforma.\nLa idea es hacer pruebas y generar algún caso de uso en un ambiente de Sandbox, de esa manera van a poder\nentender mejor las funcionalidades y módulos que vamos a poner a su disposición.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Finerio",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "BaaS, C107500011",
      "Nombre_lider_EVC": "Carolina Giraldo Giraldo",
      "SR_ARIBA": "SR No requerido",
      "Familias": "",
      "Categoría": "",
      "¿Cómo se va a gestionar?": "Contención",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Junio 21. Confirmado con usuaria por Teams. es un tema que se atendió con negociador, entonces se le indicó que contactara al negociador para gestionar completo el tema.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "22/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "",
      "Subcategoría_F": "",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3854,
      "Title": "Forms",
      "Fecha_solicitud": "22/06/2023",
      "Correo_solicitante": "sauarang@bancolombia.com.co",
      "Nombre_solicitante": "Sara Uribe Arango",
      "Nombre_iniciativa": "ID 3854 - Taller Promujer",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular un proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor va a facilitar un taller con empleados del banco para fortalecer la propuesta de valor de negocio que tenemos en la organización con enfoque de género",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Promujer",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Dirección de Diversidad, Equidad e Inclusión C102000019",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3854,
      "Familias": "Servicios Profesionales Formación y Entrenamiento",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "22/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "22/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3853,
      "Title": "Forms",
      "Fecha_solicitud": "22/06/2023",
      "Correo_solicitante": "gyate@bancolombia.com.co",
      "Nombre_solicitante": "Gilma Carolina Yate Guzman",
      "Nombre_iniciativa": "ID 3853 - Vinculacion proveedor",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Vinculación proveedor, nos ofrece servicios de alimentos para eventos",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 132000000,
      "Proveedores_conocidos": "martha c",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C102100354, gerencia de gestion comercial region centro",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3853,
      "Familias": "BTL",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "22/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "22/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3852,
      "Title": "Forms",
      "Fecha_solicitud": "22/06/2023",
      "Correo_solicitante": "gyate@bancolombia.com.co",
      "Nombre_solicitante": "Gilma Carolina Yate Guzman",
      "Nombre_iniciativa": "ID 3852 - VINCULACION PROVEEDOR",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Vinculación proveedor, brinda servicio de refrigerios",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 132000000,
      "Proveedores_conocidos": "4 estaciones",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C102100354, gerencia de gestion comercial region centro",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3852,
      "Familias": "BTL",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "22/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "22/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3851,
      "Title": "Forms",
      "Fecha_solicitud": "22/06/2023",
      "Correo_solicitante": "stcardon@bancolombia.com.co",
      "Nombre_solicitante": "Stefany Cardona Cano",
      "Nombre_iniciativa": "ID 3851 - Patrocinio Evento comercial con aliado",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de patrocinio: vamos a participar de un evento de relacionamiento comercial  con restauranteros, como marca patrocinadora, por lo que debemos pagarle al organizador del evento que es un aliado de nuestros productos.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "50.000.000",
      "Proveedores_conocidos": "Frubana SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "Gerencia de Crecimiento - C102200017",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3851,
      "Familias": "Patrocinios Mercadeo",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "22/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "22/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3850,
      "Title": "Forms",
      "Fecha_solicitud": "21/06/2023",
      "Correo_solicitante": "brmonsal@bancolombia.com.co",
      "Nombre_solicitante": "Bryan Camilo Monsalve Arango",
      "Nombre_iniciativa": "ID 3850 - Renegociación contrato CW2281355. AWS vista holística",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2281355",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere análisis de renegociación con AWS, buscando una vista holística, contemplando factores como migración iSeries, J2O Base de datos, Entrenamiento, J2C países, Proserv, Marketplace y EDP (descuento 18%) En conversación con el category, se acuerda no aplicar prerrequisitos de negociación.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Etapa exploración",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "AWS",
      "Cuadrante_Proveedor": 1,
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "CdeE Gobierno Nube CBO.",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4067396596",
      "Familias": "Servicios de  Plataformas",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Daniela Alvarez Montoya",
      "Rol_asesor": "No aplica",
      "Observaciones": "No va a PN por exploración del servicio. José Teams 28/06/2023",
      "Comentarios BP": "",
      "Fecha MarketPlace": "30/06/2023",
      "Fecha Asignación/Delegación": "30/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "22/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "28/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de plataformas",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3849,
      "Title": "Forms",
      "Fecha_solicitud": "21/06/2023",
      "Correo_solicitante": "MARECHEV@bancolombia.com.co",
      "Nombre_solicitante": "Mariluz de la Inmaculada Echeverri Garrido",
      "Nombre_iniciativa": "ID 3849 - HCL - Contrato de Uso Ilimitado de Programas. renovación contrato CW2278461",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2278461",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "renovación contrato CW2278461. Actualmente se tiene el contrato firmado por 3 anos hasta agosto de 20223, pero también existe una clausula que se puede extender por un año más hasta Agostos de 2024 con las mismas tarifas que venimos manejando.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "592.800 USD",
      "Proveedores_conocidos": "HCL",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Ventas digitales y tec de mercadeo",
      "Nombre_lider_EVC": "Mariluz Echeverri Garrido",
      "SR_ARIBA": "SR4067396579",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Daniela Alvarez Montoya",
      "Rol_asesor": "Andres Osorio Castano",
      "Observaciones": "José OK PN. En Ariba contrato marco y OS están como licenciamiento menor pero atendido desde la categoría de TI.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "07/07/2023",
      "Fecha Asignación/Delegación": "07/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "22/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "27/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3848,
      "Title": "Forms",
      "Fecha_solicitud": "21/06/2023",
      "Correo_solicitante": "GJALVARE@bancolombia.com.co",
      "Nombre_solicitante": "Gabriel Jaime Alvarez Correa",
      "Nombre_iniciativa": "ID 3848 - CONSULTORIA PARA ADHESION PROTOCOLOS ISDA - FACTURACION",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "DESBLOQUEAR AL PROVEEDOR",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Sobre el contexto, para poder ajustar los contratos a las actualizaciones legales de los diferentes países, ISDA ha creado la posibilidad de suscribir protocolos bajo los cuales se puede modificar los contratos multilateralmente con solo la firma de dicho documento. Lo anterior es fundamental, pues para poder operar con las contrapartes, los contratos deben estar conforme a la normatividad de cada país, lo cual se logra justamente con el protocolo.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "500 USD",
      "Proveedores_conocidos": "ISDA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C107000034",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3848,
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Familia correcta es CONSULTORIA pero para efectos de desbloqueo se le coloca una familia que no le exiga ir a PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "22/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "22/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3847,
      "Title": "Forms",
      "Fecha_solicitud": "21/06/2023",
      "Correo_solicitante": "alejrodr@bancolombia.com.co",
      "Nombre_solicitante": "Alejandro Rodriguez Vahos",
      "Nombre_iniciativa": "ID 3847 - Debida diligencia legal para la inversión de Quipu por parte de Bancolombia Ventures",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Gestionar material contable, número de pedido y MIGO.",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Servicios legales para adelantar la evaluación y debida diligencia de la compañía Quipu con el fin de concretar una inversión estratégica por parte de Bancolombia Ventures.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "URIBE HENAO ABOGADOS S.A.S.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Dirección Innovación Abierta - C102200010",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3847,
      "Familias": "Servicios Legales",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "21/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "21/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios Profesionales Procesos del Negocio",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3846,
      "Title": "Forms",
      "Fecha_solicitud": "21/06/2023",
      "Correo_solicitante": "glocasta@bancolombia.com.co",
      "Nombre_solicitante": "Gloria Elena Castano Soto",
      "Nombre_iniciativa": "ID 3846 - Relanzamiento Escuela EPB",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "vincular un proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "se requiere el acompañamiento del proveedor para el relanzamiento de la Escuela",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Juan David Cocina S.A.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Aprendizaje C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3846,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "21/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "21/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3845,
      "Title": "Forms",
      "Fecha_solicitud": "21/06/2023",
      "Correo_solicitante": "saravela@bancolombia.com.co",
      "Nombre_solicitante": "Sara Velasquez Bedoya",
      "Nombre_iniciativa": "ID 3845 - Patrocinio LA TRIADA, COMUNICACION Y MERCADEO SOCIAL SAS",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Patrocinio al proyecto Soya Maíz",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "LA TRIADA, COMUNICACION Y MERCADEO SOCIAL SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gestión de Presidencia C102000000",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3845,
      "Familias": "Patrocinios Mercadeo",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "21/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "21/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3844,
      "Title": "Forms",
      "Fecha_solicitud": "21/06/2023",
      "Correo_solicitante": "vedelgad@bancolombia.com.co",
      "Nombre_solicitante": "Veronica Delgado Taua",
      "Nombre_iniciativa": "ID 3844 - Renovación vinculación o contrato 242 CW2282392",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2282392",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Empresa de contenidos con quien trabajamos varias estrategias de Mercadeo. CW2282392",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "depende de los formatos pero cada área tiene presupuesto asignado para continuar con las estrategias.",
      "Proveedores_conocidos": "242 Grupo",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "MARCA Y SOLUCIONES DIGITALES",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4065728746",
      "Familias": "Producción y Postproducción",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Katherine Sanchez Henao",
      "Rol_asesor": "No aplica",
      "Observaciones": "Naty hola. No va a PN por familia y proveedor.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "30/06/2023",
      "Fecha Asignación/Delegación": "30/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "21/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3843,
      "Title": "Forms",
      "Fecha_solicitud": "21/06/2023",
      "Correo_solicitante": "vedelgad@bancolombia.com.co",
      "Nombre_solicitante": "Veronica Delgado Taua",
      "Nombre_iniciativa": "ID 3843 - Renovación en iguales condiciones YEAH CW2282394",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2282394",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Post producción audiovisual (Renovación) CW2282394",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Es por licitación. Y en su momento se tendrá el ppto.",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "N/A",
      "Cuadrante_Proveedor": 4,
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Dirección de Marca",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4065728720",
      "Familias": "Producción y Postproducción",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Katherine Sanchez Henao",
      "Rol_asesor": "No aplica",
      "Observaciones": "Naty es renovación proveedor cuadrante 4, no requiere PN.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "30/06/2023",
      "Fecha Asignación/Delegación": "30/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "21/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3842,
      "Title": "Forms",
      "Fecha_solicitud": "21/06/2023",
      "Correo_solicitante": "MARCGUTI@bancolombia.com.co",
      "Nombre_solicitante": "Marcela Gutierrez Lopez",
      "Nombre_iniciativa": "ID 3842 - Implementación de los nuevos recaudos  con el proveedor SMART TMT con Municipio de Soacha",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Generar un pedido en SAP y definición contable",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Pago del servicio de implementación de los nuevos recaudos  con el proveedor SMART TMT con Municipio de Soacha",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "SMART TMT S.A.S",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Gestión de Flujos-C105500036",
      "Nombre_lider_EVC": "Juan Gonzalo Tobón",
      "SR_ARIBA": 3842,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "21/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "21/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3841,
      "Title": "Forms",
      "Fecha_solicitud": "21/06/2023",
      "Correo_solicitante": "JORGVALD@Bancolombia.com.co",
      "Nombre_solicitante": "Jorge Valderrama Betancur",
      "Nombre_iniciativa": "ID 3841 - Renovación Contrato EDN CW2295822",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2295822",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El contrato Orden de servicio Radian - Factoring está próximo a vencer (Renovación). CW2295822",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "20 millones mensuales",
      "Proveedores_conocidos": "EDN",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Factoring C103500007",
      "Nombre_lider_EVC": "Factoring",
      "SR_ARIBA": "SR4065728702",
      "Familias": "Servicios de  Plataformas",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Luisa Fernanda Garcia Guzman",
      "Rol_asesor": "Andres Osorio Castano",
      "Observaciones": "Jose OK PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "30/06/2023",
      "Fecha Asignación/Delegación": "30/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "21/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "23/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de plataformas",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3840,
      "Title": "Forms",
      "Fecha_solicitud": "21/06/2023",
      "Correo_solicitante": "mariag@bancolombia.com.co",
      "Nombre_solicitante": "Ana Maria Gomez Henao",
      "Nombre_iniciativa": "ID 3840 - RFP PARA CAFE EN DIRECCIÓN GENERAL, TS",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Realizar RFP para seleccionar un proveedor para un café en el lobby de torre sur, y se extienda a las otras dos sedes TN y TO",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 0,
      "Proveedores_conocidos": "HONESTO-URBANIA-LABORATORIO DE CAFE-CAMPESINOS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GERENCIA DE GESTION INMOBILIARIA-ANA MARIA GOMEZ",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4065148726",
      "Familias": "Obra Civil y Eléctrica",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Maria Alejandra Delgado Leon",
      "Rol_asesor": "No aplica",
      "Observaciones": "Naty hola no va a PN de acuerdo a nuestra conversación por Teams, ya que es el mismo requerimiento para otro edificio.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "23/06/2023",
      "Fecha Asignación/Delegación": "23/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "21/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de adecuaciones",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3839,
      "Title": "Forms",
      "Fecha_solicitud": "21/06/2023",
      "Correo_solicitante": "marialon@bancolombia.com.co",
      "Nombre_solicitante": "Mariana Karolain Londono Suarez",
      "Nombre_iniciativa": "ID 3839 - Vinculación de proveedor",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Generar pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Patrocinio en evento de la cooperativa",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "COOPERATIVA DE CAFICULTORES DEL QUINDIO",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GCIA MERCADEO ATRACCION Y PROFUNDIZACIÓN - C106500007",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3839,
      "Familias": "Patrocinios Mercadeo",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "21/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "21/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3838,
      "Title": "Forms",
      "Fecha_solicitud": "21/06/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 3838 - Compra de curso de extensión 13er CONGRESO ASOMICROFINANZAS\tASOMICROFINANZAS",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión 13er CONGRESO ASOMICROFINANZAS -\tASOMICROFINANZAS",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "ASOMICROFINANZAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3838,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "21/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "21/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3837,
      "Title": "Forms",
      "Fecha_solicitud": "21/06/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 3837 - Compra de curso de extensión CENCO 2023\t- FENALCO",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión CENCO 2023\tFENALCO",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "FENALCO",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3837,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "21/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "21/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3836,
      "Title": "Forms",
      "Fecha_solicitud": "21/06/2023",
      "Correo_solicitante": "marialon@bancolombia.com.co",
      "Nombre_solicitante": "Mariana Karolain Londono Suarez",
      "Nombre_iniciativa": "ID 3836 - Vinculación de nuevo proveedor",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Generar un pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "al proveedor debemos pagarle por la producción de material publicitario (camisas)",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "URBANROCK GROUP S.A.S.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GCIA MERCADEO ATRACCION Y PROFUNDIZACIÓN - C106500007",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3836,
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "21/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "21/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3835,
      "Title": "Forms",
      "Fecha_solicitud": "21/06/2023",
      "Correo_solicitante": "mtlopez@bancolombia.com.co",
      "Nombre_solicitante": "Maria Teresa Lopez Duenas",
      "Nombre_iniciativa": "ID 3835 - Otro SI Personalsoft CW2294508",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "el Otrosí 01 a la ORDEN DE SERVICIO No 04. Integración para la Operación - Personal Soft, CW2294508.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "7.000.000 mensuales",
      "Proveedores_conocidos": "Personalsoft",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Servicios Integración y APIS C103500281",
      "Nombre_lider_EVC": "Marco Antonio Estrada",
      "SR_ARIBA": "SR4065148743",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Daniel Jimenez Delgado",
      "Rol_asesor": "No aplica",
      "Observaciones": "Jose ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "23/06/2023",
      "Fecha Asignación/Delegación": "23/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "21/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "21/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3834,
      "Title": "Forms",
      "Fecha_solicitud": "21/06/2023",
      "Correo_solicitante": "JULIAROD@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Rodriguez Jaramillo",
      "Nombre_iniciativa": "ID 3834 - Upgrade licencia Monday",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2297611",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Con el proveedor Takum se tiene contratada una licencia para el uso de la herramienta Monday.  La licencia se debe renovar en Julio pero estamos interesados en cambiar de plan y queremos empezar a dimensionar el costo desde ya para saber si vamos a poder contar con ese presupuesto en octubre.   Contamos con el presupuesto para la renovación, queremos validar si nos da para el upgrade.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "150.000.000",
      "Proveedores_conocidos": "Takum-Monday",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Ventas Digitales y Tecnologia de Mercadeo   C106500025",
      "Nombre_lider_EVC": "Maria Fernanda Scarpetta",
      "SR_ARIBA": "SR4065148695",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Nicolas Quiceno Carmona",
      "Rol_asesor": "Andres Osorio Castano",
      "Observaciones": "naty ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "23/06/2023",
      "Fecha Asignación/Delegación": "23/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "21/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "22/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3833,
      "Title": "Forms",
      "Fecha_solicitud": "20/06/2023",
      "Correo_solicitante": "apelaez@bancolombia.com.co",
      "Nombre_solicitante": "Alejandro Pelaez Salazar",
      "Nombre_iniciativa": "ID 3833 - Pago Auditorio FIC48 - Georgia Tech",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Solicitar Material",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se alquiló el auditorio del FIC48 para un evento de Georgia Tech.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "ACEIS SA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "DIRECCIÓN DE INNOVACIÓN ABIERTA - C102200010",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3833,
      "Familias": "Otros Servicios Bienes Inmuebles - Muebles",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "21/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "21/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Gestión Inmobiliaria",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3832,
      "Title": "Forms",
      "Fecha_solicitud": "20/06/2023",
      "Correo_solicitante": "MARCGUTI@bancolombia.com.co",
      "Nombre_solicitante": "Marcela Gutierrez Lopez",
      "Nombre_iniciativa": "ID 3832 - Adquisición de licencias de gmail a través del aliado 1cero1",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la compra de licencias de Gmail soportadas por el aliado 1cero1",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "500.000.000",
      "Proveedores_conocidos": "1cero1",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Gestión de Flujos",
      "Nombre_lider_EVC": "Juan Gonzalo Tobón",
      "SR_ARIBA": "SR4063908472",
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Isabella Correa Valencia",
      "Rol_asesor": "No aplica",
      "Observaciones": "Saris ok. PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "30/06/2023",
      "Fecha Asignación/Delegación": "30/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "21/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "22/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3831,
      "Title": "Forms",
      "Fecha_solicitud": "20/06/2023",
      "Correo_solicitante": "apino@bancolombia.com.co",
      "Nombre_solicitante": "Ana Maria Pino Restrepo",
      "Nombre_iniciativa": "ID 3831 - Firma de Contrato de servicios de recolección de activos de Tecnología",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la firma del contrato de servicios de recolección de activos de tecnología con un nuevo proveedor, este servicio será prestado una vez las operaciones de arrendamiento finalicen y los clientes decidan devolver.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "No se requiere tener un presupuesto asignado , ya que el servicio es pagado por los clientes",
      "Valor_presupuesto": 19600000,
      "Proveedores_conocidos": "CONFIANZA SOLUTIONS SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Activos",
      "Nombre_lider_EVC": "Alberto Echeverry",
      "SR_ARIBA": "SR No requerido",
      "Familias": "",
      "Categoría": "",
      "¿Cómo se va a gestionar?": "Contención",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Junio 20. usuario radicó el mismo req,. dos veces. el 3827 y este.  se le indica por tems que este se cancela y siga adelante con el otro.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "20/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "",
      "Subcategoría_F": "",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3830,
      "Title": "Forms",
      "Fecha_solicitud": "20/06/2023",
      "Correo_solicitante": "vavgomez@bancolombia.com.co",
      "Nombre_solicitante": "Valentina Velasquez Gomez",
      "Nombre_iniciativa": "ID 3830 - Programa de formación Curso APIOwner  para la vicepresidencia de negocios - innovación y clientes y empleados",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular al proveedor para relizar programa de formación Razón social: Cloudappi SL NIT: 901551820-5",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Vincular al proveedor para relizar programa de formación Razón social: Cloudappi SL NIT: 901551820-5",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Razón social: Cloudappi SL NIT: 901551820-5 Contacto: Ernesto Correa Soto Celular: 320.346.01.49 Correo: ernesto.correa@cloudappi.net",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GERENCIA APRENDIZAJE C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3830,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "20/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "20/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3829,
      "Title": "Forms",
      "Fecha_solicitud": "20/06/2023",
      "Correo_solicitante": "yequinte@bancolombia.com.co",
      "Nombre_solicitante": "Yenifer Quintero Quiceno",
      "Nombre_iniciativa": "ID 3829 - Patrocinio municipio de Santa Fe de Antioquia",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular proveedor y hacer pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor suministra refrigerios en eventos realizados en el municipio de Santa Fe de Antioquia",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Tatiana Andrea Salas",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gobierno de Red - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3829,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "20/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "20/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3828,
      "Title": "Forms",
      "Fecha_solicitud": "20/06/2023",
      "Correo_solicitante": "jimflore@bancolombia.com.co",
      "Nombre_solicitante": "Jimmy Arlex Florez Posada",
      "Nombre_iniciativa": "ID 3828 - Apoyo Nubiral para migracion Jenkins a Azure. Servicio para nequi,.",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere iniciar conversaciones con el Aliado Nubiral, partner de Microsoft, con el objetivo de llevar a cabo la migracion de pipelines desde la herramienta Jenkins a Azure DevOps. Al dia de hoy contamos con unas horas suministradas por Microsoft pero el ejecutor será Nubiral.   Servicio para nequi,.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Inicialmente el cubrimiento de esta ejecución, esta economicamente a cargo de Microsoft.",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Nubiral",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "Gerencia Arquitectura y IDI - C471000024",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4063802767",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Leidy Tatiana Tangarife Gonzalez",
      "Rol_asesor": "No aplica",
      "Observaciones": "José OK PN.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "14/07/2023",
      "Fecha Asignación/Delegación": "14/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "20/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "27/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3827,
      "Title": "Forms",
      "Fecha_solicitud": "20/06/2023",
      "Correo_solicitante": "apino@bancolombia.com.co",
      "Nombre_solicitante": "Ana Maria Pino Restrepo",
      "Nombre_iniciativa": "ID 3827 - Firma de Otro si al contrato de Suministro SIPI. CW2271998",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2271998",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la firma de un Otro si al contrato CW2271998 de suministro existente con el proveedor ya que se requiere contratar un servicio de recolección a domicilio de los activos de tecnología.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "La negociación no requiere un presupuesto asignado",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "BTR COLOMBIA S.A.S",
      "Cuadrante_Proveedor": 4,
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Activos",
      "Nombre_lider_EVC": "Alberto Echeverry",
      "SR_ARIBA": "SR4063802750",
      "Familias": "Hardware",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Carlos Andres Ramos Ospina",
      "Rol_asesor": "No aplica",
      "Observaciones": "Naty OK PN.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "30/06/2023",
      "Fecha Asignación/Delegación": "30/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "20/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "27/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Activos Fijos",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3826,
      "Title": "Forms",
      "Fecha_solicitud": "20/06/2023",
      "Correo_solicitante": "osacosta@bancolombia.com.co",
      "Nombre_solicitante": "Oscar Ricardo Acosta Jaramillo",
      "Nombre_iniciativa": "ID 3826 - Reclamación a Konecta - Caso: VILMA YANETH SINISTERRA OBANDO - 66743495 - $ 132,651,936.00",
      "Tipo_Requerimiento": "Es un escalamiento (reclamación a un proveedor por un incumplimiento contractual)",
      "CW_a_renovar": "CW2237080",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "",
      "Nombre_area_y_ceco": "",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR No requerido",
      "Familias": "",
      "Categoría": "",
      "¿Cómo se va a gestionar?": "Escalamiento",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "20/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "",
      "Subcategoría_F": "",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3825,
      "Title": "Forms",
      "Fecha_solicitud": "20/06/2023",
      "Correo_solicitante": "osacosta@bancolombia.com.co",
      "Nombre_solicitante": "Oscar Ricardo Acosta Jaramillo",
      "Nombre_iniciativa": "ID 3825 - Convenio Hablemos Medellín",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere firmar un convenio de colaboración entre Teleperformance y Banco para desarrollar un Telemercadeo que se llama \"Hablemos Medellín\" como parte de un apoyo en conjunto con la Universidad EAFIT para entregar un informe sobre aspectos de lo que opinan sectores de la ciudad sobre temas de interés público.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "20 ML",
      "Proveedores_conocidos": "Teleperformance",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Fundación Bancolombia",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4063737398",
      "Familias": "Investigaciones de Mercado",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "21/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "21/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3824,
      "Title": "Forms",
      "Fecha_solicitud": "20/06/2023",
      "Correo_solicitante": "megirald@bancolombia.com.co",
      "Nombre_solicitante": "Maria Elsy Giraldo Rendon",
      "Nombre_iniciativa": "ID 3824 - Incremento tarifas PCR41 CW2292015-OT1",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2292015-OT1",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El aliado nos informa de ajuste de tarifas estimado para el servicio de Modernización de aplicaciones legadas, donde se tiene definido un equipo Core a precio fijo mensual y unos perfiles a demanda. CW2292015-OT1",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "200millones",
      "Proveedores_conocidos": "IBM",
      "Cuadrante_Proveedor": 0,
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Neon (Modernizacion de Tecnologia)",
      "Nombre_lider_EVC": "María Elsy Giraldo Rendón",
      "SR_ARIBA": "SR4063471316",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Daniel Jimenez Delgado",
      "Rol_asesor": "No aplica",
      "Observaciones": "Jose ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "23/06/2023",
      "Fecha Asignación/Delegación": "23/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "20/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "20/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3823,
      "Title": "power_apps",
      "Fecha_solicitud": "20/06/2023",
      "Correo_solicitante": "ANGMAROD@bancolombia.com.co",
      "Nombre_solicitante": "Angela Maria Rodriguez Castano",
      "Nombre_iniciativa": "ID 3823 - Renovacion LINKEDIN IRELAND UNLIMITED COMPANY",
      "Tipo_Requerimiento": "Renovación",
      "CW_a_renovar": "CW2280789",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Suscripcion Renovacion LINKEDIN IRELAND UNLIMITED COMPANY",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "60.000.000",
      "Proveedores_conocidos": "LINKEDIN IRELAND UNLIMITED COMPANY",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "VICEPRESIDENCIA GESTION HUMANA",
      "Nombre_area_y_ceco": "Seccion de reclutamiento y seleccion C103200040",
      "Nombre_lider_EVC": "Eliana del Pilar Restrepo Sanchez",
      "SR_ARIBA": "SR no requerido",
      "Familias": "",
      "Categoría": "",
      "¿Cómo se va a gestionar?": "Contención",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Se verifica con la usuaria y el requerimiento se encuentra duplicado con el ID 3791 que ya se encuentra en PN. Se sigue la solicitud con dicho ID y se acuerda con usuario cancelar este por teams. 20/06/2023",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "20/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "",
      "Subcategoría_F": "",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3822,
      "Title": "Forms",
      "Fecha_solicitud": "16/06/2023",
      "Correo_solicitante": "valet@bancolombia.com.co",
      "Nombre_solicitante": "Valentina Torres Orozco",
      "Nombre_iniciativa": "ID 3822 - Asesoria uso de materiales",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Solicitar Material para generar el pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere una consultoría para el uso de material con el fin de cancelar una factura de abogados del contrato de la FCF.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "MarquezRobledo",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Juliana Rodriguez Jaramillo C106500024",
      "Nombre_lider_EVC": "Jose Hernan Montoya",
      "SR_ARIBA": 3822,
      "Familias": "Servicios Legales",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "20/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "20/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios Profesionales Procesos del Negocio",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3821,
      "Title": "Forms",
      "Fecha_solicitud": "16/06/2023",
      "Correo_solicitante": "danicast@bancolombia.com.co",
      "Nombre_solicitante": "Daniela Castano Ballesteros",
      "Nombre_iniciativa": "ID 3821 - Renovar servicios RPiedrahita para Negocios Digitales CW2274225",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2274225",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovar con Rpriedrahita es proveedor de servicios contables y de tesoreria para Negocios Digitales 830006973. contrato CW2274225",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "165.000.000",
      "Proveedores_conocidos": "Rpiedrahita",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nueva Compañía",
      "Nombre_area_y_ceco": "Negocios Digitales Colomibia - 830006973",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4058764467",
      "Familias": "Consultorias Corporativas",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Andrea Diaz Soto",
      "Rol_asesor": "No aplica",
      "Observaciones": "Biatri OK PN. En Ariba está con la familia consultorías para procesos del negocio.  pero acá no podemos usar las nuevas familias aún.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "07/07/2023",
      "Fecha Asignación/Delegación": "07/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "16/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "04/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Consultorias Corporativas",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3820,
      "Title": "Forms",
      "Fecha_solicitud": "16/06/2023",
      "Correo_solicitante": "LINEIRA@bancolombia.com.co",
      "Nombre_solicitante": "Liliana Marcela Neira Agudelo",
      "Nombre_iniciativa": "ID 3820 - Actividades para proceso de vinculación menores de edad y embargos",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Necesitamos consultar con ustedes sobre un proveedor (Carvajal) que en banco realiza unos procesos y este BPO nos puede servir para realizar unos procesos que debemos implementar en Nequi.  La Lider del proceso en el banco nos sugirió preguntar bien, porque entiende que este proveedor va de salida con el Banco. Actividades del proceso de embargos y proceso de vinculación de menores de edad, como volver liquida una información de un documento y radicar ticket.",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Es un presupuesto compartido con la gerencia de desarrollo de producto que se esta revisando",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Carvajal (Revisar otros)",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "Gerencia conociiento de usuarios, depositos y prestamos (70005797)",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4063297398",
      "Familias": "Procesamiento de Información",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Laura Serna Rodriguez",
      "Rol_asesor": "Andres Osorio Castano",
      "Observaciones": "Biatri OK PN.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "30/06/2023",
      "Fecha Asignación/Delegación": "30/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "20/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "27/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Back Office",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3819,
      "Title": "MP Manual",
      "Fecha_solicitud": "16/06/2023",
      "Correo_solicitante": "",
      "Nombre_solicitante": "Juan Sebastian Aristizabal Aguado",
      "Nombre_iniciativa": "ID 3819 -",
      "Tipo_Requerimiento": "Requerimiento Nuevo",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "GMF Entidades financieras",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "N/A",
      "Valor_presupuesto": 0,
      "Proveedores_conocidos": "Varios",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "",
      "Nombre_area_y_ceco": "EVC depositos y cuentas especiales",
      "Nombre_lider_EVC": "Santiago Perez Posada",
      "SR_ARIBA": "SR4057353513",
      "Familias": "Servicios SaaS",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Sara Quintero Perez",
      "Rol_asesor": "No aplica",
      "Observaciones": "Se asigna manual y luego se envia a PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "16/06/2023",
      "Fecha Asignación/Delegación": "16/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "21/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicio de plataformas",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3818,
      "Title": "Forms",
      "Fecha_solicitud": "16/06/2023",
      "Correo_solicitante": "cmachado@bancolombia.com.co",
      "Nombre_solicitante": "Carolina Machado Ospina",
      "Nombre_iniciativa": "ID 3818 - Consultoría para matriz legal",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Contactamos a una experta en SST y Laboral para actualizar y proponer la nueva matriz legal del Grupo en Colombia",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "3 Salarios Mínimos Legales Mensuales Vigentes",
      "Proveedores_conocidos": "Luz Maria Arbelaez",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C103200100 Relaciones Laborales",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4058939680",
      "Familias": "Consultorias Corporativas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "16/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "16/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Consultorias Corporativas",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3817,
      "Title": "Forms",
      "Fecha_solicitud": "16/06/2023",
      "Correo_solicitante": "irmonsal@bancolombia.com.co",
      "Nombre_solicitante": "Irene Monsalve Buenahora",
      "Nombre_iniciativa": "ID 3817 - Compra de Moto para Iniciativa Crecimiento",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere comprar una moto para una campaña promocional que se va desarrollar desde crecimiento",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "10.908.700 (IVA Incluido)",
      "Proveedores_conocidos": "INCOLMOTOS YAMAHA S.A",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "Crecimiento C102200017",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3817,
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "16/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "16/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3816,
      "Title": "Forms",
      "Fecha_solicitud": "16/06/2023",
      "Correo_solicitante": "saravela@bancolombia.com.co",
      "Nombre_solicitante": "Sara Velasquez Bedoya",
      "Nombre_iniciativa": "ID 3816 - Pago a Tienda Bancolombia",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de productos de la Tienda Bancolombia",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "NEGOCIOS DIGITALES COLOMBIA S.A.S.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gestión de Presidencia",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3816,
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "16/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "16/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3815,
      "Title": "Forms",
      "Fecha_solicitud": "15/06/2023",
      "Correo_solicitante": "danicast@bancolombia.com.co",
      "Nombre_solicitante": "Daniela Castano Ballesteros",
      "Nombre_iniciativa": "ID 3815 - Suscripción de Hubspot para envío de notificaciones",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Para la empresa Negocios Digitales Colombia NIT 830006973 se requiere apoyo de un negociador para la compra de una suscripción de Hubspot para el envio de notificaciones,",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "10.000.000",
      "Proveedores_conocidos": "Hubspot",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nueva Compañía",
      "Nombre_area_y_ceco": "Negocios Digitales - 830006973",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4058470426 (R)",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Retirar Requerimiento",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Se retira requerimiento usuario no confirma gestión de PN´s y pide retirarlo.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "16/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3814,
      "Title": "Forms",
      "Fecha_solicitud": "15/06/2023",
      "Correo_solicitante": "luisanch@bancolombia.com.co",
      "Nombre_solicitante": "Luis Alfonso Sanchez Sandoval",
      "Nombre_iniciativa": "ID 3814 - Tercerización del servicio de Gestion de Subsidios Inmobiliarios",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Llevar a un outsourcing todo el procesamiento de subsidios de compra de vivienda.  Inicialmente el foco será MI Casa Ya, pero a futuro, debe ser la plataforma para cualquier subsidio asociado a la compra de vivienda",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Es una necesidad que surge a partir del cambio normatuvo sobre el tema y se abre la posibilidad de generar eficiencias y flexibilidad a futuro",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "IQ outsourcing, TESSI",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Negocio Inmobiliario",
      "Nombre_lider_EVC": "Juan Camilo Arango Aristizabal",
      "SR_ARIBA": "SR4059010789",
      "Familias": "Procesamiento de Información",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Jorge Mario Aguinaga Quiros",
      "Rol_asesor": "No aplica",
      "Observaciones": "Biatri ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "23/06/2023",
      "Fecha Asignación/Delegación": "23/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "16/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "20/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Back Office",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3813,
      "Title": "Forms",
      "Fecha_solicitud": "15/06/2023",
      "Correo_solicitante": "mobernal@bancolombia.com.co",
      "Nombre_solicitante": "Monica Yineth Bernal Gomez",
      "Nombre_iniciativa": "ID 3813 - PRG_2023_1318825 - MUNICIPIO DE MARSELLA",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular y Generar pedido SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Gustavo Albeiro Gomez proveedor que suministra los dulces y los detalles del niño.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Gustavo Albeiro Gomez proveedor que suministra los dulces y los detalles del niño.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "PATROCINIOS GOBIERNO DE RED - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3813,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "16/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "16/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3812,
      "Title": "Forms",
      "Fecha_solicitud": "15/06/2023",
      "Correo_solicitante": "johpiedr@bancolombia.com.co",
      "Nombre_solicitante": "John Edison Piedrahita Arias",
      "Nombre_iniciativa": "ID 3812 - Proveedor Escuela de Negocios - Inversiones",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la vinculación de la  Pontifica universidad Javeriana como formador del programa  Introducción a la ciencia de datos y la inteligencia artificial, como parte de la Escuela de Negocios - Inversiones en la que particpan los comerciales de este negocio.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 20000000,
      "Proveedores_conocidos": "Pontificia Universidad Javeriana",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3812,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "16/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "16/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3811,
      "Title": "Forms",
      "Fecha_solicitud": "15/06/2023",
      "Correo_solicitante": "anarbole@bancolombia.com.co",
      "Nombre_solicitante": "Angela Maria Arboleda Munoz",
      "Nombre_iniciativa": "ID 3811 - Asistencia empleados Nequi a la carrera de las Rosas",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Pagarle al proveedor la participación de los nequis que reciben el beneficio.",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor es el organizador de la carrera de las rosas para la prevención de cáncer femenino y Nequi patrocinará la participación de algunos Nequi",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "grupojao",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "C475000000",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3811,
      "Familias": "Patrocinios Mercadeo",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "16/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "16/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3810,
      "Title": "Forms",
      "Fecha_solicitud": "15/06/2023",
      "Correo_solicitante": "macastri@bancolombia.com.co",
      "Nombre_solicitante": "Maria Isabel Castrillon Elorza",
      "Nombre_iniciativa": "ID 3810 - Participación X Cumbre INCP",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la participación de 2 colaboradores Nequi en el Evento X Cumbre INCP",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 1560000,
      "Proveedores_conocidos": "Instituto Nacional de Contadores Públicos INCP Nit 860.013.744-8",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "Talento Humano C475000000",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3810,
      "Familias": "Suscripciones",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "16/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "16/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios de Información",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3809,
      "Title": "Forms",
      "Fecha_solicitud": "15/06/2023",
      "Correo_solicitante": "klotero@bancolombia.com.co",
      "Nombre_solicitante": "Katerinne Lotero Gonzalez",
      "Nombre_iniciativa": "ID 3809 - Evento de lanzamiento MAX herramienta para l apractica de diseño",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Actualizar el proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "proveedor Inversiones Publicitarias Correa  nit 901180758-3 se ke requiere pagar unas crispetas que ya se consumieron",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Inversiones Publicitarias Correa  nit 901180758-3",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Gobierno de procesos C103700012",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3809,
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "15/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "15/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3808,
      "Title": "Forms",
      "Fecha_solicitud": "15/06/2023",
      "Correo_solicitante": "olondono@bancolombia.com.co",
      "Nombre_solicitante": "Oscar Dario Londono Villegas",
      "Nombre_iniciativa": "ID 3808 - RFP Servicio SOC e Inteligencia",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere realizar RFP para el servicios de Detección, Orquestación, Automatización, Respuesta, Análisis de Comportamiento de Red, entidades, Contenidos de Defensa e Inteligencia de ciberseguridad.",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Dado que este servicio actualmente se ejecuta en Bancolombia con presupuesto asignado para la operacion, con este RFP se podrian tener ajustes presupuestales que se ejecutaran en el 2024 y que se podria solicitar alguna adicion presupuestal para el 2023.",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "INDRA - TELEFONICA - TCS - IBM",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Inteligencia y Reaccion de Ciberserguridad (Entorno de Ciberseguridad Corporativa) - C104300570",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4057148216",
      "Familias": "Prevención Ciberseguridad",
      "Categoría": "Seguridad",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Pablo Zapata Franco",
      "Rol_asesor": "No aplica",
      "Observaciones": "Cata OK PN.",
      "Comentarios BP": "llevar al MP, asignar a Pablo",
      "Fecha MarketPlace": "23/06/2023",
      "Fecha Asignación/Delegación": "23/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "15/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "20/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Ciberseguridad y seguridad de la información",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3807,
      "Title": "Forms",
      "Fecha_solicitud": "15/06/2023",
      "Correo_solicitante": "msanin@bancolombia.com.co",
      "Nombre_solicitante": "Maria Adelaida Sanin Alvarez",
      "Nombre_iniciativa": "ID 3807 - Contratar nueva agencia de BTL",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Agencia de eventos",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "El presupuesto sale de cada área que requiera el evento",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Paramo Lab",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C106500001",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4057071339",
      "Familias": "BTL",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Retirar Requerimiento",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Kathe de acuerdo a lo conversado le das RETIRAR para que CRLOS aNDRES LO ATIENDA POR FUERA DEL mp.-",
      "Comentarios BP": "Hola Moni. Este requerimiento se retira del Marketplace porque Carlos Andres lo manejara dentro de sus horas administrativas, ya negoció con el proveedor en un SR anterior el cual ya finalizó, se activa este nuevo SR para realizar el contrato, en el pasado el proveedor no dio respuesta y por esta razón no se alcanzo a crear el contrato.",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "15/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "15/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "Retirado",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3806,
      "Title": "Forms",
      "Fecha_solicitud": "15/06/2023",
      "Correo_solicitante": "YZULUAGA@bancolombia.com.co",
      "Nombre_solicitante": "Yicela Andrea Zuluaga Toro",
      "Nombre_iniciativa": "ID 3806 - Licencias Multivendor Diebold",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere revisar con el proveedor el escalamiento que están realizando por la cantidad de licencias a comprar en el 2023",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Priorizado por el CAE",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "NA",
      "Proveedores_conocidos": "Diebold",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Distribucion fisica",
      "Nombre_lider_EVC": "Juan Camilo Moreno",
      "SR_ARIBA": "SR4057148179",
      "Familias": "Licenciamiento Mayor",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Santiago Zapata Serna",
      "Rol_asesor": "No aplica",
      "Observaciones": "Dianis de acuerdo a lo conversado no va a PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "16/06/2023",
      "Fecha Asignación/Delegación": "16/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "15/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3805,
      "Title": "Forms",
      "Fecha_solicitud": "15/06/2023",
      "Correo_solicitante": "avbetanc@bancolombia.com.co",
      "Nombre_solicitante": "Alejandra Victoria Betancourt Latorre",
      "Nombre_iniciativa": "ID 3805 - Piloto EjoyHQ",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Centralizar la información asociada a las investigaciones de Diseño",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "USD12000",
      "Proveedores_conocidos": "EnjoyHQ",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Gestión Diseño de Experiencia CC107200221",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4058470444",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Nicolas Quiceno Carmona",
      "Rol_asesor": "Andres Osorio Castano",
      "Observaciones": "Naty OK PN.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "23/06/2023",
      "Fecha Asignación/Delegación": "23/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "16/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "20/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3804,
      "Title": "Forms",
      "Fecha_solicitud": "15/06/2023",
      "Correo_solicitante": "xiramire@bancolombia.com.co",
      "Nombre_solicitante": "Xiomara Ramirez Posada",
      "Nombre_iniciativa": "ID 3804 - Renovación Contrato Green Light. CW2293455",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2293455",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación Servicio de AOM para la herramienta Qjrn y Controler   CW2293455",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "$ 54,639,000 mensual",
      "Proveedores_conocidos": "Green Light",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Capacidades de Ciberseguridad - 104300559",
      "Nombre_lider_EVC": "Andres Felipe Rivas Gonzalez",
      "SR_ARIBA": "SR4057071321",
      "Familias": "Controles de Ciberseguridad",
      "Categoría": "Seguridad",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Mateo Villada Rodriguez",
      "Rol_asesor": "Andres Osorio Castano",
      "Observaciones": "Cata OK PN.",
      "Comentarios BP": "Llevar a MP y asignar a Mateo Villada",
      "Fecha MarketPlace": "23/06/2023",
      "Fecha Asignación/Delegación": "23/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "15/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "20/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Ciberseguridad y seguridad de la información",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3803,
      "Title": "Forms",
      "Fecha_solicitud": "15/06/2023",
      "Correo_solicitante": "gyate@bancolombia.com.co",
      "Nombre_solicitante": "Gilma Carolina Yate Guzman",
      "Nombre_iniciativa": "ID 3803 - Vinculacion proveedor",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Vinculación proveedor, brinda servicios logísticos y de transporte",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 132000000,
      "Proveedores_conocidos": "Viajando.co",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GERENCIA DE GESTION COMERCIAL REGION CENTRO,C102100354",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3803,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "15/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "15/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3802,
      "Title": "Forms",
      "Fecha_solicitud": "15/06/2023",
      "Correo_solicitante": "MARCGUTI@bancolombia.com.co",
      "Nombre_solicitante": "Marcela Gutierrez Lopez",
      "Nombre_iniciativa": "ID 3802 - Contratar piloto portales web municipios con el proveedor CS3",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere contratar un piloto  para implementar el servicio de portales web para los municipios con el proveedor CS3",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "60.000.000",
      "Proveedores_conocidos": "Comercializadora de software CS3",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Gestion de Flujos-C105500036",
      "Nombre_lider_EVC": "Juan Gonzalo Tobon",
      "SR_ARIBA": "SR4057071356",
      "Familias": "Servicios SaaS",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Isabella Correa Valencia",
      "Rol_asesor": "No aplica",
      "Observaciones": "Saris OK PN.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "23/06/2023",
      "Fecha Asignación/Delegación": "23/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "15/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "20/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de plataformas",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3801,
      "Title": "Forms",
      "Fecha_solicitud": "15/06/2023",
      "Correo_solicitante": "gyate@bancolombia.com.co",
      "Nombre_solicitante": "Gilma Carolina Yate Guzman",
      "Nombre_iniciativa": "ID 3801 - Vinculacion proveedor",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Contratación proveedor servicios alimentarios",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 132000000,
      "Proveedores_conocidos": "Crocante Yopal",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GERENCIA DE GESTION COMERCIAL REGION CENTRO, C102100354",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3801,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "15/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "15/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3800,
      "Title": "Forms",
      "Fecha_solicitud": "15/06/2023",
      "Correo_solicitante": "",
      "Nombre_solicitante": "Juan Camilo Patino Ramirez",
      "Nombre_iniciativa": "ID 3800 - Negociación de categoría de servicios Ingeniería Devops",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Negociación de categoría de servicios Ingeniería Devops con el proveedor SETI",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "No Aplica",
      "Proveedores_conocidos": "SETI S.A SERVICIOS ESP DE TECN.E I",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "ADMINISTRACION PROVEEDORES TI CC C103500002",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4058470383",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Luisa Fernanda Garcia Guzman",
      "Rol_asesor": "No aplica",
      "Observaciones": "Jose ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "23/06/2023",
      "Fecha Asignación/Delegación": "23/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "16/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "20/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3799,
      "Title": "Forms",
      "Fecha_solicitud": "14/06/2023",
      "Correo_solicitante": "julmoral@bancolombia.com.co",
      "Nombre_solicitante": "Julian Morales Patino",
      "Nombre_iniciativa": "ID 3799 - Actualización Información Plataforma Confirming",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere actualizar la información financiera de la plataforma de confirming con la que ya estamos integrados.",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "no hay presupuesto asignado porque este servicio no tiene un fee fijo mensual o anual, sino que se trabaja por medio de comisiones sobre las facturas negociadas en el mes a través de la plataforma.",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Klym S.A.S",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Nuevos Negocios",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3799,
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Junio 16. El proveedor es de SERVICIOS SAAS, pero como solo se requiere actualizar datos se le pone una familia que no requiera análisis del riesgo.  confirmado con el usuario por Teams que solo es actualizar al proveedor.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "16/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "16/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3798,
      "Title": "Forms",
      "Fecha_solicitud": "14/06/2023",
      "Correo_solicitante": "ntilano@bancolombia.com.co",
      "Nombre_solicitante": "Nahomy Daniela Tilano Diaz",
      "Nombre_iniciativa": "ID 3798 - Patrocinio al municipio de Sahagún",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular un proveedor y hacer pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor es una entidad que presta servicios de diseño grafico el cual suministra el servicio para la elaboración de trofeos personalizados en el municipio de Sahagún.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Jose Alfredo Ramos",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Centro de costos gobierno de red C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3798,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "15/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "15/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3796,
      "Title": "Forms",
      "Fecha_solicitud": "14/06/2023",
      "Correo_solicitante": "LVERGARA@bancolombia.com.co",
      "Nombre_solicitante": "Lina Maria Vergara Villarraga",
      "Nombre_iniciativa": "ID 3796 - Renovación de ATS y tarifas de servicios profesionales para Agosto y Septiembre de Infosys CW2298915",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2298915",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la asignación del Negociador para lograr la renovación del contrato de soporte y mantenimiento (ATS) que vence en Agosto y también la renovación de tarifas de servicios profesionales para Septiembre. Ambos servicios con el proveedor Infosys.   CW2298915",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "2.000.000 USD",
      "Proveedores_conocidos": "Infosys",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Gestión de Flujos - CC C103500249",
      "Nombre_lider_EVC": "Lina Maria Vergara Villarraga",
      "SR_ARIBA": "SR4056714236",
      "Familias": "Licenciamiento Mayor",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Maria Fernanda Urrea Parra",
      "Rol_asesor": "Andres Osorio Castano",
      "Observaciones": "José ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "23/06/2023",
      "Fecha Asignación/Delegación": "23/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "15/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "21/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3795,
      "Title": "Forms",
      "Fecha_solicitud": "14/06/2023",
      "Correo_solicitante": "juaardil@bancolombia.com.co",
      "Nombre_solicitante": "Juan Esteban Ardila Jimenez",
      "Nombre_iniciativa": "ID 3795 - Firma control de cambios nuevas funcionalidades Invesbot/Inversí Allfunds. CW2272904",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2272904",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere acompañamiento por parte de abastecimiento para la revisión y firma del change request enviado por Allfunds para iniciar con la implementación de unos nuevos desarrollos en los aplicativos Invesbot e Inversí segun contrato CW2272904",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "250.000.000",
      "Proveedores_conocidos": "Allfunds",
      "Cuadrante_Proveedor": 3,
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Inversiones",
      "Nombre_lider_EVC": "Rafael Alberto Luna Uribe",
      "SR_ARIBA": "SR4056714196",
      "Familias": "Consultorías TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Andres Felipe Meneses Vergara",
      "Rol_asesor": "Andres Osorio Castano",
      "Observaciones": "Jose ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "23/06/2023",
      "Fecha Asignación/Delegación": "23/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "15/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "20/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3794,
      "Title": "Forms",
      "Fecha_solicitud": "14/06/2023",
      "Correo_solicitante": "mobernal@bancolombia.com.co",
      "Nombre_solicitante": "Monica Yineth Bernal Gomez",
      "Nombre_iniciativa": "ID 3794 - PRG_2023_867473 - MUNICIPIO DE CHINCHINÁ 2023",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "VINCULAR Y GENERAR PEDIDO EN SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "ORGANIZACIÓN Y SUMINISTRO DE MATERIALES PARA EL EVENTO DE EL CUMPLEAÑOS 166 del Municipio de Chinchiná Caldas",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "CASA DE LA CULTURA CHINCHINA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "PATROCINIOS GOBIERNO DE RED - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3794,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "15/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "15/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3793,
      "Title": "Forms",
      "Fecha_solicitud": "14/06/2023",
      "Correo_solicitante": "lizortiz@bancolombia.com.co",
      "Nombre_solicitante": "Lizeth De Grey Ortiz Lopez",
      "Nombre_iniciativa": "ID 3793 - Compra Formación Sociedades Patrimoniales",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra Formación Sociedades Patrimoniales",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra Formación Sociedades Patrimoniales",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "KPMG ADVISORY TAX & LEGAL S.A.S",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C103200060 Gerencia de Formación y Entrenamiento",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3793,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "15/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "15/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3792,
      "Title": "Forms",
      "Fecha_solicitud": "14/06/2023",
      "Correo_solicitante": "paoanper@bancolombia.com.co",
      "Nombre_solicitante": "Paola Andrea Perez Taborda",
      "Nombre_iniciativa": "ID 3792 - consuloria proceso reexpedición de tarjetas debito en kioscos",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Presentar dentro del canal Kioscos, propiamente en el flujo de experiencia, una opción por medio de un botón para poder obtener su nuevo plástico de la tarjeta debito MasterCard clásica.",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "314.000.000",
      "Proveedores_conocidos": "Belltech, pero queremos revisar mas posibilidades, con la ayuda de ustedes",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "DISTRIBUCIÓN FISICA",
      "Nombre_lider_EVC": "JUAN CAMILO MORENO",
      "SR_ARIBA": "SR4054955751",
      "Familias": "Multifuncionales",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Saris OK PN. Requerimiento se delega a solicitud de Saris - Teams 21/06/2023",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "22/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "15/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "22/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Autoservicios",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3791,
      "Title": "Forms",
      "Fecha_solicitud": "14/06/2023",
      "Correo_solicitante": "ANGMAROD@bancolombia.com.co",
      "Nombre_solicitante": "Angela Maria Rodriguez Castano",
      "Nombre_iniciativa": "ID 3791 - Renovacion  LINKEDIN IRELAND UNLIMITED COMPANY TALENTS INSIGHTSD. CW2280789",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2280789",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere renovar la licencia con el provedor   LINKEDIN IRELAND UNLIMITED COMPANY TALENTS INSIGHTSD. CW2280789",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "150.000.000",
      "Proveedores_conocidos": "LinkedIn Ireland",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C103200040",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4054955735",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Leidy Tatiana Tangarife Gonzalez",
      "Rol_asesor": "Andres Osorio Castano",
      "Observaciones": "Naty ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "23/06/2023",
      "Fecha Asignación/Delegación": "23/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "14/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "20/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3790,
      "Title": "Forms",
      "Fecha_solicitud": "14/06/2023",
      "Correo_solicitante": "iraceved@bancolombia.com.co",
      "Nombre_solicitante": "Iris Yadira Acevedo Blanco",
      "Nombre_iniciativa": "ID 3790 - Licencia Exporte Masivo de Grabacion de Llamadas - Contrato 10059 (CW2222272)",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "La Gerencia de Servicios de Pisos Financieros en cabeza de Frank Alexis Parra nos solicita la adquisición de una licencia para exporte masivo de llamadas grabadas en la plataforma ACS como complemento de procesos de riegos. Esta licencia se debe adquirir por medio de Unify bajo el contrato actual que se tiene con el proveedor. Contrato 10059 (CW2222272)",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "2700 USD",
      "Proveedores_conocidos": "Unify",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "LdC FC Ing Telefonía y Video TI C103500100",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4055391964",
      "Familias": "Telecomunicaciones",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Madelyn Liceth Moya Osorio",
      "Rol_asesor": "Andres Osorio Castano",
      "Observaciones": "Jose ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "23/06/2023",
      "Fecha Asignación/Delegación": "23/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "14/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "21/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio telecomunicación",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3789,
      "Title": "Forms",
      "Fecha_solicitud": "14/06/2023",
      "Correo_solicitante": "MVPIEDRA@bancolombia.com.co",
      "Nombre_solicitante": "Maria Victoria Piedrahita Castaneda",
      "Nombre_iniciativa": "ID 3789 - Wobi Education",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Realizar pago a proveedor ya existente",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Formación a colaboradores",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Wobi",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de aprendizaje",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3789,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "14/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "14/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3797,
      "Title": "Forms",
      "Fecha_solicitud": "13/06/2023",
      "Correo_solicitante": "tramirez@bancolombia.com.co",
      "Nombre_solicitante": "Tomas Ramirez Osorio",
      "Nombre_iniciativa": "ID 3797 - Realidad aumentada-planeación",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Proyecto de realidad aumentada para planeación de mercado",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "17.400.000",
      "Proveedores_conocidos": "Look&Film",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Consumer Insight 00902",
      "Nombre_lider_EVC": "Juan Gonazlo Aristizabal",
      "SR_ARIBA": 3797,
      "Familias": "Servicios profesionales de Mercadeo",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "15/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "15/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3788,
      "Title": "Forms",
      "Fecha_solicitud": "13/06/2023",
      "Correo_solicitante": "mobernal@bancolombia.com.co",
      "Nombre_solicitante": "Monica Yineth Bernal Gomez",
      "Nombre_iniciativa": "ID 3788 - PRG_2023_1250586 - PATROCINIO MUNICIPIO DE LA MERCED 2023",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "VINCULAR Y GENERAR PEDIDO EN SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Proveedor organiza actividades culturales y deportivas de la celebración de la Municipalidad de La Merced",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "GUSTAVO ANDRES SANCHEZ GALVIS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gobierno de Red - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3788,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "13/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "13/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3787,
      "Title": "Forms",
      "Fecha_solicitud": "13/06/2023",
      "Correo_solicitante": "jrcarden@bancolombia.com.co",
      "Nombre_solicitante": "Juan Pablo Ramirez Cardenas",
      "Nombre_iniciativa": "ID 3787 - Actualización Proveedor Frisby",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra y suministro de Bonos para regalos corporativos",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "2.080.000",
      "Proveedores_conocidos": "Frisby S.A",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Abastecimiento - Apoyo al Negocio C104300365",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3787,
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "13/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "13/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3786,
      "Title": "Forms",
      "Fecha_solicitud": "13/06/2023",
      "Correo_solicitante": "almurill@bancolombia.com.co",
      "Nombre_solicitante": "Alejandro Murillo Puerta",
      "Nombre_iniciativa": "ID 3786 - Renovación Contrato de Monitoreo Líneas Celulares entre Masivian y Bancolombia Contrato CW2281494",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2281494",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación Contrato de Monitoreo Líneas Celulares entre Masivian y Bancolombia: Aviso de Vencimiento de Contrato CW2281494",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "5.000.000",
      "Proveedores_conocidos": "Masivian",
      "Cuadrante_Proveedor": 3,
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "00000394",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4053770030",
      "Familias": "Consultas Especializadas",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "John Alexis Velasquez Garcia",
      "Rol_asesor": "Monica Marcela Alzate Granda",
      "Observaciones": "Biatri es renovación, proveedor riesgo 3 no va a PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "16/06/2023",
      "Fecha Asignación/Delegación": "16/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "13/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios de Información",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3785,
      "Title": "Forms",
      "Fecha_solicitud": "13/06/2023",
      "Correo_solicitante": "amlujan@bancolombia.com.co",
      "Nombre_solicitante": "Alejandra Maria Lujan Ledesma",
      "Nombre_iniciativa": "ID 3785 - Vinculación digital PJ",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2300406",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Actualmente se tienen un contrato con el proveedor  ARUS  para desarrollar y exponer la experiencia de vinculación a potenciales clientes. \nNos encontramos en etapa de implementación  e identificamos que hay que hacer cambios en algunos servicios y esto nos lleva a hacer un otro si al contrato, pero además reevaluar las cantidades de vinculaciones contratadas, y valor contratado.",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Priorizado por el CAE",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "648,000",
      "Proveedores_conocidos": "ARUS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC conocimiento del cliente CC C102100019",
      "Nombre_lider_EVC": "Camilo Restrepo",
      "SR_ARIBA": "SR4053770047 (R)",
      "Familias": "Procesamiento de Información",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Retirar Requerimiento",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Se retira requerimiento usuario no confirma gestión de PN´s",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "13/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Back Office",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3784,
      "Title": "Forms",
      "Fecha_solicitud": "13/06/2023",
      "Correo_solicitante": "jdhinest@bancolombia.com.co",
      "Nombre_solicitante": "Juan Jose Duque Hinestrosa",
      "Nombre_iniciativa": "ID 3784 - Contratación Fluvip en países",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Requerimos que el contrato CW2300329 que actualmente se tiene en Colombia (Bancolombia) con Fluvip sea también creado para los demás países de Grupo Bancolombia, entendiendo que no será una adhesión al mismo tiempo, requerimos sea una contratación independiente iniciando por Bam.\nSe tiene guia del contrato con Bancolombia, y la idea es usarlo como guía para Bam junto al gestor de abastecimiento que corresponda para el caso en este país.\nEl proveedor provee una herramienta, SAAS  (software as a service) para que los empleados compartan contenido del banco en sus redes sociales.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "USD 2400",
      "Proveedores_conocidos": "Fluvip",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Dirección de Reputación y Comunicaciones",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4054955718",
      "Familias": "Servicios SaaS",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Luis Guillermo Salcedo Valderrama",
      "Rol_asesor": "Andres Osorio Castano",
      "Observaciones": "Naty OK PN, en Ariba, la familia es Saas Menor, que funciona como un licenciamiento menor, por eso está en nuestra categoría.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "23/06/2023",
      "Fecha Asignación/Delegación": "23/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "14/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "20/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de plataformas",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3783,
      "Title": "Forms",
      "Fecha_solicitud": "13/06/2023",
      "Correo_solicitante": "JAANROJA@bancolombia.com.co",
      "Nombre_solicitante": "Jaider Andres Rojas Vanegas",
      "Nombre_iniciativa": "ID 3783 - Contrato Sonar Cloud para GITHUB. Servicio para Nequi",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se debe contratar el servicio de Sonar Cloud para GITHUB, actualmente se tiene para Azure.  Servicio para Nequi",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "3000 EUR",
      "Proveedores_conocidos": "SonarCloud",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "C102200039",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4055391939",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Daniela Delgado Cadavid",
      "Rol_asesor": "Monica Marcela Alzate Granda",
      "Observaciones": "Naty ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "21/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "14/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "21/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3782,
      "Title": "Forms",
      "Fecha_solicitud": "13/06/2023",
      "Correo_solicitante": "lmmadrig@bancolombia.com.co",
      "Nombre_solicitante": "Lina Marcela Madrigal Arrieta",
      "Nombre_iniciativa": "ID 3782 - Tarifa servicio mensual Belltech",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Negociación de tarifa para tener recursos dedicados 100% en Kioscos y manejar nosotros la asignación de desarrollos",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 268427600,
      "Proveedores_conocidos": "Belltech",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Distribucción Fisica C103500272",
      "Nombre_lider_EVC": "Jose Jaime Tilano",
      "SR_ARIBA": "SR4055433783",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Santiago Zapata Serna",
      "Rol_asesor": "No aplica",
      "Observaciones": "Saris OK PN.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "30/06/2023",
      "Fecha Asignación/Delegación": "30/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "14/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "27/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3781,
      "Title": "Forms",
      "Fecha_solicitud": "13/06/2023",
      "Correo_solicitante": "dizuluag@bancolombia.com.co",
      "Nombre_solicitante": "Diana Sofia Zuluaga Duque",
      "Nombre_iniciativa": "ID 3781 - Membresía Cámara Diversidades",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Actualizar proveedor y pagar membresía",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Actualizar proveedor y pagar membresía a la Cámara de las Diversidades por un año con el fin de recibir acompañamiento y poder participar en diferentes espacios relevantes en temas de Diversidad, Equidad e Inclusión",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "ASOCIACIÓN CÁMARA DE COMERCIANTES LGBT DE COLOMBIA - 47440 - NIT 900.601.082-8",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Dirección de Diversidad, Equidad e Inclusión - C102000019",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3781,
      "Familias": "Suscripciones",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "13/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "13/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios de Información",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3780,
      "Title": "Forms",
      "Fecha_solicitud": "13/06/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 3780 - Compra de curso de extensión SEMINARIOS ONLINE DE NEGOCIACIÓN\tJOSE I. TOBON CONSULTORES S.A.S.",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión SEMINARIOS ONLINE DE NEGOCIACIÓN\tJOSE I. TOBON CONSULTORES S.A.S.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "JOSE I. TOBON CONSULTORES S.A.S.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3780,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "13/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "13/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3779,
      "Title": "Forms",
      "Fecha_solicitud": "13/06/2023",
      "Correo_solicitante": "CLAUDUQU@bancolombia.com.co",
      "Nombre_solicitante": "Claudia Marcela Duque Cruz",
      "Nombre_iniciativa": "ID 3779 - Pago Factura Honorarios Revisoria fiscal",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "solicitar material y generar pedido",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Ya se recibieron las facturas Nos. 49936 y 49937  de l proveedor PWC CONTADORES Y AUDITORES S.A.S  Nit. 900943048 - 4,  por concepto de Honorarios de Revisoría Fiscal 2022 negocio requerido por la Superintendencia Financiera de Colombia- P.A CANCUN CLUB  y P.A. GREEN OFFICE.  SEREQUIERE MATRIAL PARA LEGALIZARLA PEDIDO Y MIGO.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "PWC CONTADORES Y AUDITORES S.A.S  Nit. 900943048 - 4",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C303700100 FIDUCIA PRIVADA",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3779,
      "Familias": "Revisoría Fiscal",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "13/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "13/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios Profesionales Procesos del Negocio",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3778,
      "Title": "Forms",
      "Fecha_solicitud": "13/06/2023",
      "Correo_solicitante": "CLAUDUQU@bancolombia.com.co",
      "Nombre_solicitante": "Claudia Marcela Duque Cruz",
      "Nombre_iniciativa": "ID 3778 - Factura visita obra",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "solicitar material y generar pedido",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Ya se recibió la factura No.  No. CMAA 7259  CASTILLO MEDINA ARQUITECTOS AVALUADORES SAS  NIT 900.076.923-4  POR CONCEPTO DE INSPECCIONES PROYECTO BALCONES DE SANTA CECILIA ET 1 -2.CRA 12 N° 147 08/16 BARRIO EL SALADO.  SE REQUIERE MATERIAL PARA LEGALIZARLA PEDIDO Y MIGO. esta solicitud es para la sociedad fiduciaria 3.000",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "CASTILLO MEDINA ARQUITECTOS AVALUADORES SAS Nit. NIT 900.076.923-4",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C303700100 FIDUCIA PRIVADA",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3778,
      "Familias": "Honorarios Avalúos",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "13/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "13/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios Profesionales Procesos del Negocio",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3777,
      "Title": "Forms",
      "Fecha_solicitud": "09/06/2023",
      "Correo_solicitante": "natzapat@bancolombia.com.co",
      "Nombre_solicitante": "Natalia Andrea Zapata Oviedo",
      "Nombre_iniciativa": "ID 3777 - Diseño de curso virtual para plataforma de conectados",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere contratar a un proveedor para diseñar un curso virtual para la plataforma de conectados. Esto se ha trabajado de forma centralizada con el área de formación",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "33.000.000",
      "Proveedores_conocidos": "Euno Consulting SAS",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Clientes Corporativos C105800001",
      "Nombre_lider_EVC": "Sara Mejía Uribe",
      "SR_ARIBA": "SR4057148198",
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "15/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "15/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3776,
      "Title": "Forms",
      "Fecha_solicitud": "09/06/2023",
      "Correo_solicitante": "dggil@bancolombia.com.co",
      "Nombre_solicitante": "Daniela Gomez Gil",
      "Nombre_iniciativa": "ID 3776 - Negociar escalamiento de Konecta CW2237080",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "CW2237080",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere realizar la negociación de un escalamiento del proveedor Konecta hacia el Banco por la no disponibilidad de los accesos a los empleados de dicho proveedor, debido al congelamiento de HCM y la salida a producción de Conectados. Para esto, ya se tuvieron algunas conversaciones con Yohany Gaviria quien estará acompañando el proceso. Re revisa CW2237080",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Es un escalamiento que no se tuvo posibilidad de prever",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Multienlace / Konecta",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nueva Compañía",
      "Nombre_area_y_ceco": "Gerencia Estrategia Abastecimiento",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4052960900",
      "Familias": "Líneas de Entrada",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Yohany Anibal Gaviria Quintero",
      "Rol_asesor": "No aplica",
      "Observaciones": "No se va a PN por la naturaleza de la solicitud. Requerimiento generado desde el área de Iván Loaiza, se pide asignar a Yohany.",
      "Comentarios BP": "Si es posible, crear flujo de escalamiento, si no es posible no crear SR, lo crea el negociador...",
      "Fecha MarketPlace": "16/06/2023",
      "Fecha Asignación/Delegación": "16/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "13/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios Canal Telefónico",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3775,
      "Title": "Forms",
      "Fecha_solicitud": "09/06/2023",
      "Correo_solicitante": "anzuleta@bancolombia.com.co",
      "Nombre_solicitante": "Andres Zuleta Alvarino",
      "Nombre_iniciativa": "ID 3775 - Firma contrato transmisión de datos Finerio",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2277410",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Hola!. Con el Proveedor Finerio/Dinerio, con quien la organización tiene un Contrato API scraping para obtener datos financieros de clientes, requerimos la firma de un nuevo componente: Contrato de trasmisión de datos, luego de validaciones realizadas por el equipo juridico y de cumplimiento.",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Priorizado por el CAE",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "NO APLICA",
      "Proveedores_conocidos": "NO APLICA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Bienestar Financiero - C107500004",
      "Nombre_lider_EVC": "Andres David Chica Villa",
      "SR_ARIBA": "SR4048311319 (R)",
      "Familias": "Canales Digitales",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Retirar Requerimiento",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Junio 21.  Usuario no gestionó PN, se le notifica la cancelación.. se le habia recordado desde el 16",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "21/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "09/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Canales Digitales",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3774,
      "Title": "Forms",
      "Fecha_solicitud": "09/06/2023",
      "Correo_solicitante": "stcastan@bancolombia.com.co",
      "Nombre_solicitante": "Stepahnie Castano Betancur",
      "Nombre_iniciativa": "ID 3774 - Contratación del BPO para atención de clientes B2B Nequi",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere un BPO para la atención de los requerimientos de los clientes B2B de Nequi, estamos en un piloto con LikeU que finaliza este mes y es necesario revisar a nivel contractual el paso a seguir.\nLa negociadora que nos está acompañando es Daniela Delgado.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "30.298.000",
      "Proveedores_conocidos": "LikeU",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "Aliados y Clientes B2B - C102200018",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4048311298",
      "Familias": "Líneas de Entrada",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Daniela Delgado Cadavid",
      "Rol_asesor": "Monica Marcela Alzate Granda",
      "Observaciones": "Dianis OK PN.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "16/06/2023",
      "Fecha Asignación/Delegación": "16/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "09/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "13/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios Canal Telefónico",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3773,
      "Title": "Forms",
      "Fecha_solicitud": "09/06/2023",
      "Correo_solicitante": "ANGMAROD@bancolombia.com.co",
      "Nombre_solicitante": "Angela Maria Rodriguez Castano",
      "Nombre_iniciativa": "ID 3773 - Vinculacion del provedor CLOUDING LA SAS",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Recibir el pago del patrocinio para el evento  AWS Community Day",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "20.000.000",
      "Proveedores_conocidos": "CLOUDING LA SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "c103200040",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3773,
      "Familias": "Patrocinios Mercadeo",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3772,
      "Title": "Forms",
      "Fecha_solicitud": "09/06/2023",
      "Correo_solicitante": "valet@bancolombia.com.co",
      "Nombre_solicitante": "Valentina Torres Orozco",
      "Nombre_iniciativa": "ID 3772 - Vinculacion Señora Constanza Avila",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere  la vinculación de Constanza Avila Pinto para proyecto especial de entrevistas en profundidad/investigación, para el proyecto COMETA del Banco.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "42.500.000",
      "Proveedores_conocidos": "Constanza Avila Pinto",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Veronica Delgado Taua C106500001 Direccion de Marca",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4067177466",
      "Familias": "Investigaciones de Mercado",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Junio 09. Se le solicita a la usuaria por correo, la autorización de socio estratégico y gerente de gestión de su vicepresidencia, para contratar persona naturales.   Una vez entregue las autorizaciones, se retoma el requerimiento y se define con el category si se delega o se asigna negociador\nJunio 10.  usuario remite autorización de GH. se le delega porque en la autorización hablan de una contratación muy puntual por 7 semanas.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "22/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "22/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3771,
      "Title": "Forms",
      "Fecha_solicitud": "09/06/2023",
      "Correo_solicitante": "fholguin@bancolombia.com.co",
      "Nombre_solicitante": "Francisco Holguin Rico",
      "Nombre_iniciativa": "ID 3771 - RFI Automatización Flujos Documentales - Herramienta APPIAN",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere explorar en el marcado la solución que permita Integrar la administración del ciclo de vida del documento y los flujos documentales involucrados, orquestando los servicios que conforman el ciclo de vida del documento, desde su creacion hasta su disposición final, que aseguren la recolección, el mantenimiento, clasificación/Jerarquización, almacenamiento, custodia, disposición, depuración y trazabilidad de la información física y digital.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "2.000.000.000",
      "Proveedores_conocidos": "EY, DELOITTE",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVOLUCION DIGITAL / C104600005",
      "Nombre_lider_EVC": "Carolina Arias Ramirez",
      "SR_ARIBA": "SR4048017813",
      "Familias": "Licenciamiento Mayor",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Daniel Jimenez Delgado",
      "Rol_asesor": "Andres Osorio Castano",
      "Observaciones": "José OK PN.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "07/07/2023",
      "Fecha Asignación/Delegación": "07/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "13/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "23/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3770,
      "Title": "Forms",
      "Fecha_solicitud": "09/06/2023",
      "Correo_solicitante": "RICASALL@bancolombia.com.co",
      "Nombre_solicitante": "Ricardo Casallas Lopez",
      "Nombre_iniciativa": "ID 3770 - Afiliación/Convenio a Corporación Transpariencia por Colombia",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Afiliación a esta organización no gubernamental para conocer investigaciones que realiza esta organización, participar en eventos corporativos que de esta entidad y en los que el banco y sus colaboradores puedan aprender, ver informes y noticias de actualidad sobre temas de corrupción y como evitarla y reconocerla",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "30.000.000",
      "Proveedores_conocidos": "Corporación Transparencia por Colombia Nit 830052844",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "LDC FC ETICA PAF ANTICORRUPCION Ceco C102600011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4048017797",
      "Familias": "Suscripciones",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios de Información",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3769,
      "Title": "Forms",
      "Fecha_solicitud": "09/06/2023",
      "Correo_solicitante": "mobernal@bancolombia.com.co",
      "Nombre_solicitante": "Monica Yineth Bernal Gomez",
      "Nombre_iniciativa": "ID 3769 - MUNICIPIO DE SEVILLA 2023 - PRG_2023_1274970",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "VINCULAR Y GENERAR PEDIDO EN SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Organizador de la logística del evento FIESTAS ANIVERSARIAS SEVILLA 120 AÑOS",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "SEVILLA DE RUMBA S.A.S",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gobierno de Red - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3769,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3768,
      "Title": "Forms",
      "Fecha_solicitud": "09/06/2023",
      "Correo_solicitante": "CAHRAMIR@bancolombia.com.co",
      "Nombre_solicitante": "Carlos Hernando Ramirez Escobar",
      "Nombre_iniciativa": "ID 3768 - Vinculacion nuevo aliado de cobranzas para piloto de cartera vencida sufi",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la vinculación de aliado de cobranzas para toda la labor de cobranza de los productos sufi, lo cual se realizara inicialmente con un piloto de 3 o 4 meses",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "$20.000.000",
      "Proveedores_conocidos": "Servicebots",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "ADC Estrategia Conciliacion Sufi -  C105000225",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4048017780",
      "Familias": "Servicios de Conciliación y Cobranza SUFI",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Mateo Gutierrez Garcia",
      "Rol_asesor": "No aplica",
      "Observaciones": "Biatri ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "23/06/2023",
      "Fecha Asignación/Delegación": "23/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "09/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "23/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios de Conciliación y Cobranza",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3767,
      "Title": "Forms",
      "Fecha_solicitud": "09/06/2023",
      "Correo_solicitante": "rgroldan@bancolombia.com.co",
      "Nombre_solicitante": "Ruben Gonzalo Roldan Agudelo",
      "Nombre_iniciativa": "ID 3767 - Renovacion Contrato Larco periodo 2023 - 2024, contrato 7434 (CW2220478)",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": 7434,
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación contrato 7434 (CW2220478) bajo el cual se prestan la prestación de servicios mantenimiento Preventivo y Correctivo del Sistema de Aire Acondicionado en la sede Niquia",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "$531'000.000",
      "Proveedores_conocidos": "Larco",
      "Cuadrante_Proveedor": 3,
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia Administracion del Activo (GAA) CeCo: C104300029",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4047781761",
      "Familias": "HARD (Operadores de Mantenimiento)",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "John Alexis Velasquez Garcia",
      "Rol_asesor": "No aplica",
      "Observaciones": "Kathe es renovación, proveedor riesgo 3 no va a PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "16/06/2023",
      "Fecha Asignación/Delegación": "16/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "13/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Facility Managment",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3766,
      "Title": "Forms",
      "Fecha_solicitud": "08/06/2023",
      "Correo_solicitante": "catcebal@bancolombia.com.co",
      "Nombre_solicitante": "Catalina Ceballos Atehortua",
      "Nombre_iniciativa": "ID 3766 - Vinculación o actualización a prorveedor de pauta ATL",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vinculación/Actualización",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Servicios de pauta ATL para campañas de mercadeo",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "SOCIEDAD DE TELEVISION DE ANTIOQUIA LTDA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C106500018",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3766,
      "Familias": "Pautas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3765,
      "Title": "Forms",
      "Fecha_solicitud": "08/06/2023",
      "Correo_solicitante": "catcebal@bancolombia.com.co",
      "Nombre_solicitante": "Catalina Ceballos Atehortua",
      "Nombre_iniciativa": "ID 3765 - Vinculación o actualización a prorveedor de pauta ATL",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vinculación/Actualización",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Servicios de pauta ATL para campañas de mercadeo",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "QUANTA TELECOMUNICACIONES S.A.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C106500018",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "3765 (R)",
      "Familias": "Pautas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Retirar Requerimiento",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Junio 09. En llamada telefónica con la usuaria se convino que usaría un requerimiento para gestionar a 5 proveddores y así no generar req. por cada uno, pues le toca gestionar igualmente análisis del riesgo de cada uno y no se justica, porque PN no es por proveedor sino por el servicio",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3764,
      "Title": "Forms",
      "Fecha_solicitud": "08/06/2023",
      "Correo_solicitante": "catcebal@bancolombia.com.co",
      "Nombre_solicitante": "Catalina Ceballos Atehortua",
      "Nombre_iniciativa": "ID 3764 - Vinculación o actualización a prorveedor de pauta ATL",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vinculación/Actualización",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Servicios de pauta ATL para campañas de mercadeo",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "PUBLIK TECNOLOGIAS INFORMACION COMUNICACIONES Y MEDIO AMBIENTE S.A.S. EN REORGANIZACION",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C106500018",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "3764 (R)",
      "Familias": "Pautas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Retirar Requerimiento",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Junio 09. En llamada telefónica con la usuaria se convino que usaría un requerimiento para gestionar a 5 proveddores y así no generar req. por cada uno, pues le toca gestionar igualmente análisis del riesgo de cada uno y no se justica, porque PN no es por proveedor sino por el servicio",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3763,
      "Title": "Forms",
      "Fecha_solicitud": "08/06/2023",
      "Correo_solicitante": "catcebal@bancolombia.com.co",
      "Nombre_solicitante": "Catalina Ceballos Atehortua",
      "Nombre_iniciativa": "ID 3763 - Vinculación o actualización a prorveedor de pauta ATL",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vinculación/Actualización",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Servicios de pauta ATL para campañas de mercadeo",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "OMV PUBLICIDAD SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C106500018",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "3763 (R)",
      "Familias": "Pautas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Retirar Requerimiento",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Junio 09. En llamada telefónica con la usuaria se convino que usaría un requerimiento para gestionar a 5 proveddores y así no generar req. por cada uno, pues le toca gestionar igualmente análisis del riesgo de cada uno y no se justica, porque PN no es por proveedor sino por el servicio",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3762,
      "Title": "Forms",
      "Fecha_solicitud": "08/06/2023",
      "Correo_solicitante": "catcebal@bancolombia.com.co",
      "Nombre_solicitante": "Catalina Ceballos Atehortua",
      "Nombre_iniciativa": "ID 3762 - Vinculación o actualización a prorveedor de pauta ATL",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vinculación/Actualización",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Servicios de pauta ATL para campañas de mercadeo",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "MEDIA BUSINESS COLOMBIA SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C106500018",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3762,
      "Familias": "Pautas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3761,
      "Title": "Forms",
      "Fecha_solicitud": "08/06/2023",
      "Correo_solicitante": "catcebal@bancolombia.com.co",
      "Nombre_solicitante": "Catalina Ceballos Atehortua",
      "Nombre_iniciativa": "ID 3761 - Vinculación o actualización a prorveedor de pauta ATL",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vinculación/Actualización",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Servicios de pauta ATL para campañas de mercadeo",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "ESTRELLA GRUPO EMPRESARIAL S.A.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C106500018",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "3761 (R)",
      "Familias": "Pautas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Retirar Requerimiento",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Junio 09. En llamada telefónica con la usuaria se convino que usaría un requerimiento para gestionar a 5 proveddores y así no generar req. por cada uno, pues le toca gestionar igualmente análisis del riesgo de cada uno y no se justica, porque PN no es por proveedor sino por el servicio",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "Retirado",
      "Estado": "Mercadeo",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3760,
      "Title": "Forms",
      "Fecha_solicitud": "08/06/2023",
      "Correo_solicitante": "catcebal@bancolombia.com.co",
      "Nombre_solicitante": "Catalina Ceballos Atehortua",
      "Nombre_iniciativa": "ID 3760 - Vinculación o actualización a prorveedor de pauta ATL",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vinculación/Actualización",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Servicios de pauta ATL para campañas de mercadeo",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "EQUIPAMIENTOS URBANOS NACIONALES DE COLOMBIA SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C106500018",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3760,
      "Familias": "Pautas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3759,
      "Title": "Forms",
      "Fecha_solicitud": "08/06/2023",
      "Correo_solicitante": "catcebal@bancolombia.com.co",
      "Nombre_solicitante": "Catalina Ceballos Atehortua",
      "Nombre_iniciativa": "ID 3759 - Vinculación o actualización a prorveedor de pauta ATL",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vinculación/Actualización",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Servicios de pauta ATL para campañas de mercadeo",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "EL HERALDO S.A.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C106500018",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "3759 (R)",
      "Familias": "Pautas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Retirar Requerimiento",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Junio 09. En llamada telefónica con la usuaria se convino que usaría un requerimiento para gestionar a 5 proveddores y así no generar req. por cada uno, pues le toca gestionar igualmente análisis del riesgo de cada uno y no se justica, porque PN no es por proveedor sino por el servicio",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "Retirado",
      "Estado": "Mercadeo",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3758,
      "Title": "Forms",
      "Fecha_solicitud": "08/06/2023",
      "Correo_solicitante": "catcebal@bancolombia.com.co",
      "Nombre_solicitante": "Catalina Ceballos Atehortua",
      "Nombre_iniciativa": "ID 3758 - Vinculación o actualización a prorveedor de pauta ATL",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vinculación/Actualización",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Servicios de pauta ATL para campañas de mercadeo",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "CADENA MELODIA DE COLOMBIA SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C106500018",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3758,
      "Familias": "Pautas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3757,
      "Title": "Forms",
      "Fecha_solicitud": "08/06/2023",
      "Correo_solicitante": "catcebal@bancolombia.com.co",
      "Nombre_solicitante": "Catalina Ceballos Atehortua",
      "Nombre_iniciativa": "ID 3757 - Vinculación o actualización a prorveedor de pauta ATL",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vinculación/Actualización",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Servicios de pauta ATL para campañas de mercadeo",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "AMOBLA S.A.S",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C106500018",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3757,
      "Familias": "Pautas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3756,
      "Title": "Forms",
      "Fecha_solicitud": "08/06/2023",
      "Correo_solicitante": "catcebal@bancolombia.com.co",
      "Nombre_solicitante": "Catalina Ceballos Atehortua",
      "Nombre_iniciativa": "ID 3756 - Vinculación o actualización a prorveedor de pauta ATL",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vinculación/Actualización",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Servicios de pauta ATL para campañas de mercadeo",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "MASS SOLUTIONS MEDIA SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C106500018",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3756,
      "Familias": "Pautas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3755,
      "Title": "Forms",
      "Fecha_solicitud": "08/06/2023",
      "Correo_solicitante": "catcebal@bancolombia.com.co",
      "Nombre_solicitante": "Catalina Ceballos Atehortua",
      "Nombre_iniciativa": "ID 3755 - Vinculación o actualización a prorveedor de pauta ATL",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vinculación/Actualización",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Servicios de pauta ATL para campañas de mercadeo",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "REI & BATTLE MEDIOS Y EVENTOS S.A.S.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C106500018",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3755,
      "Familias": "Pautas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3754,
      "Title": "Forms",
      "Fecha_solicitud": "08/06/2023",
      "Correo_solicitante": "catcebal@bancolombia.com.co",
      "Nombre_solicitante": "Catalina Ceballos Atehortua",
      "Nombre_iniciativa": "ID 3754 - Vinculación o actualización a prorveedor de pauta ATL",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vinculación/Actualización",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Servicios de pauta ATL para campañas de mercadeo",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "LOGROS PUBLICITARIOS S.A.S",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C106500018",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "3754 (R)",
      "Familias": "Pautas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Retirar Requerimiento",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Junio 09. En llamada telefónica con la usuaria se convino que usaría un requerimiento para gestionar a 5 proveddores y así no generar req. por cada uno, pues le toca gestionar igualmente análisis del riesgo de cada uno y no se justica, porque PN no es por proveedor sino por el servicio",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "Retirado",
      "Estado": "Mercadeo",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3753,
      "Title": "Forms",
      "Fecha_solicitud": "08/06/2023",
      "Correo_solicitante": "catcebal@bancolombia.com.co",
      "Nombre_solicitante": "Catalina Ceballos Atehortua",
      "Nombre_iniciativa": "ID 3753 - Vinculación o actualización a prorveedor de pauta ATL",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vinculación/Actualización",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Servicios de pauta ATL para campañas de mercadeo",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "ORGANIZACIÓN RADIAL OLIMPICA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C106500018",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "3753 (R)",
      "Familias": "Pautas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Retirar Requerimiento",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Junio 09. En llamada telefónica con la usuaria se convino que usaría un requerimiento para gestionar a 5 proveddores y así no generar req. por cada uno, pues le toca gestionar igualmente análisis del riesgo de cada uno y no se justica, porque PN no es por proveedor sino por el servicio",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "Retirado",
      "Estado": "Mercadeo",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3752,
      "Title": "Forms",
      "Fecha_solicitud": "08/06/2023",
      "Correo_solicitante": "catcebal@bancolombia.com.co",
      "Nombre_solicitante": "Catalina Ceballos Atehortua",
      "Nombre_iniciativa": "ID 3752 - Vinculación o actualización a prorveedor de pauta ATL",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vinculación/Actualización",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Servicios de pauta ATL para campañas de mercadeo",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "J & M COMUNICACIONES LTDA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C106500018",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "3752 (R)",
      "Familias": "Pautas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Retirar Requerimiento",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Junio 09. En llamada telefónica con la usuaria se convino que usaría un requerimiento para gestionar a 5 proveddores y así no generar req. por cada uno, pues le toca gestionar igualmente análisis del riesgo de cada uno y no se justica, porque PN no es por proveedor sino por el servicio",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "Retirado",
      "Estado": "Mercadeo",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3751,
      "Title": "Forms",
      "Fecha_solicitud": "08/06/2023",
      "Correo_solicitante": "catcebal@bancolombia.com.co",
      "Nombre_solicitante": "Catalina Ceballos Atehortua",
      "Nombre_iniciativa": "ID 3751 - Vinculación o actualización a prorveedor de pauta ATL",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vinculación/Actualización",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Servicios de pauta ATL para campañas de mercadeo",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "ICO MEDIOS SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C106500018",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3751,
      "Familias": "Pautas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3750,
      "Title": "Forms",
      "Fecha_solicitud": "08/06/2023",
      "Correo_solicitante": "catcebal@bancolombia.com.co",
      "Nombre_solicitante": "Catalina Ceballos Atehortua",
      "Nombre_iniciativa": "ID 3750 - Vinculación o actualización a prorveedor de pauta ATL",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vinculación/Actualización",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Servicios de pauta ATL para campañas de mercadeo",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "ICO MEDIOS SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C106500018",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "3750 (R)",
      "Familias": "Pautas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Retirar Requerimiento",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Junio 09. En llamada telefónica con la usuaria se convino que usaría un requerimiento para gestionar a 5 proveddores y así no generar req. por cada uno, pues le toca gestionar igualmente análisis del riesgo de cada uno y no se justica, porque PN no es por proveedor sino por el servicio",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "Retirado",
      "Estado": "Mercadeo",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3749,
      "Title": "Forms",
      "Fecha_solicitud": "08/06/2023",
      "Correo_solicitante": "catcebal@bancolombia.com.co",
      "Nombre_solicitante": "Catalina Ceballos Atehortua",
      "Nombre_iniciativa": "ID 3749 - Vinculación o actualización a prorveedor de pauta ATL",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vinculación/Actualización",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Servicios de pauta ATL para campañas de mercadeo",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "CASA EDITORIAL EL TIEMPO S.A.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C106500018",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "3749 (R)",
      "Familias": "Pautas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Retirar Requerimiento",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Junio 09. En llamada telefónica con la usuaria se convino que usaría un requerimiento para gestionar a 5 proveddores y así no generar req. por cada uno, pues le toca gestionar igualmente análisis del riesgo de cada uno y no se justica, porque PN no es por proveedor sino por el servicio",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "Retirado",
      "Estado": "Mercadeo",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3748,
      "Title": "Forms",
      "Fecha_solicitud": "08/06/2023",
      "Correo_solicitante": "catcebal@bancolombia.com.co",
      "Nombre_solicitante": "Catalina Ceballos Atehortua",
      "Nombre_iniciativa": "ID 3748 - Vinculación o actualización a prorveedor de pauta ATL",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vinculación/Actualización",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Servicios de pauta ATL para campañas de mercadeo",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "CARACOL TELEVISION S.A",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C106500018",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3748,
      "Familias": "Pautas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3747,
      "Title": "Forms",
      "Fecha_solicitud": "08/06/2023",
      "Correo_solicitante": "rgroldan@bancolombia.com.co",
      "Nombre_solicitante": "Ruben Gonzalo Roldan Agudelo",
      "Nombre_iniciativa": "ID 3747 - Compra para renovación dispositivos de acceso, detección y anunciación de Incendios COB",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere el suministro e instalación de los dispositivos de control de acceso, detección de incendio, anunciación de incendio correspondiente al 50% de los dispositivos de estos sistemas del COB, los cuales se encuentran pendientes de renovación por cumplimiento de su vida útil. Eta actividad corresponde a Etapa 2 de la renovación iniciada en el año 2022",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "$ 417'863.280",
      "Proveedores_conocidos": "Sotelcom",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia Administración del Activo (GAA) CeCo: AF743113",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4047781744",
      "Familias": "HARD (Operadores de Mantenimiento)",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Carlos Andres Ramos Ospina",
      "Rol_asesor": "No aplica",
      "Observaciones": "Kathe OK PN.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "16/06/2023",
      "Fecha Asignación/Delegación": "16/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "09/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "13/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Facility Managment",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3746,
      "Title": "Forms",
      "Fecha_solicitud": "08/06/2023",
      "Correo_solicitante": "dppulido@bancolombia.com.co",
      "Nombre_solicitante": "Diana Patricia Pulido Garcia",
      "Nombre_iniciativa": "ID 3746 - Pago Process Agent - Tender",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Designación de agente de proceso para el contrato entre JP Morgan y Bancolombia por la operación de recompra de los bonos ordinarios USD 2025. Este servicio se pide como parte de la operación de recompra que se realizará de unos bonos ordinarios que tenemos denominados en USD. Dicha transacción se encuentra aprobada y en ejecución. Este intermediario, Law Debenture, se necesita como intermediario internacional y se encargará de recibir y transmitir notificaciones de dicha transacción a las partes involucadas. Este proveedor ya se encuentra aprobado por el Banco, por lo cual no necesita ningún negociador ni área involucrada. Desde el área de Bancos corresponsales ya han hecho el procedimiento anteriormente",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "1500 usd",
      "Proveedores_conocidos": "200002076 – LAW DEBENTURE CORPORATE SERVICES, INC",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia Operaciones Estructuradas",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3746,
      "Familias": "Servicios Bursátiles",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "A la usuaria le tocó repetir proceso, dado que el primero lo hizo errado en el paso de conocimiento de proveedores.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercados de Capitales",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3745,
      "Title": "Forms",
      "Fecha_solicitud": "08/06/2023",
      "Correo_solicitante": "rgroldan@bancolombia.com.co",
      "Nombre_solicitante": "Ruben Gonzalo Roldan Agudelo",
      "Nombre_iniciativa": "ID 3745 - Suministros Asociados a Proyecto Capacidades Analiticas",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere apoyo en la negociación de los suministros de cableado estructurado y cableado eléctricos asociado al proyecto de capacidades analíticas.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "1000.000.000",
      "Proveedores_conocidos": "Promontajes",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia Administración del Activo (GAA) CeCo: C104300029",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4046554993",
      "Familias": "Obra Civil y Eléctrica",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Kathe OK PN.\nJunio 21.  Luisgui solicita que este requerimiento sea delegado, segun lo conversó con Naty.\nJunio 26. SR pasa a delegado según comentarios y confirmación de Luisgui y Naty",
      "Comentarios BP": "",
      "Fecha MarketPlace": "16/06/2023",
      "Fecha Asignación/Delegación": "21/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "08/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "21/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de adecuaciones",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3744,
      "Title": "Forms",
      "Fecha_solicitud": "08/06/2023",
      "Correo_solicitante": "ntilano@bancolombia.com.co",
      "Nombre_solicitante": "Nahomy Daniela Tilano Diaz",
      "Nombre_iniciativa": "ID 3744 - Patrocinio municipio de Ariguaní",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular proveedor y hacer pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor suministra servicios de elaboración de esculturas en resinas, pintadas al oleo.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Sebastian Garcia Garcia",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gobierno de Red - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3744,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "08/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "08/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3743,
      "Title": "Forms",
      "Fecha_solicitud": "08/06/2023",
      "Correo_solicitante": "jmpulgar@bancolombia.com.co",
      "Nombre_solicitante": "John Mauricio Pulgarin",
      "Nombre_iniciativa": "ID 3743 - VENTA DE PASAPORTES A LA DIVERSION",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "VINCULAR AL PROVEEDOR",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "VENTA DE PASAPORTES A LA DIVERSION",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "GRUPO YAMBA SAS NIT 901292322-7",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GERENCIA DE BIENESTAR C103200030",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3743,
      "Familias": "Convenios y Beneficios",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "08/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "08/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3742,
      "Title": "Forms",
      "Fecha_solicitud": "08/06/2023",
      "Correo_solicitante": "stovar@bancolombia.com.co",
      "Nombre_solicitante": "Silvana Tovar Escobar",
      "Nombre_iniciativa": "ID 3742 - Asesoria juridica para proyecto Qatar",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Solicitar el material para poder generar la factura en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Revisión potenciales conflictos de interés de miembros de Junta Directiva en la creación\ngestor de fondos y vinculación al fondo inmobiliario colombia",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Jaime Restrepo Pinzon",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Esteban Gaviria Vasquez - CK: C102000050",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3742,
      "Familias": "Servicios Legales",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "08/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "08/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios Profesionales Procesos del Negocio",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3741,
      "Title": "Forms",
      "Fecha_solicitud": "08/06/2023",
      "Correo_solicitante": "estrios@bancolombia.com.co",
      "Nombre_solicitante": "Esteban Rios Bonilla",
      "Nombre_iniciativa": "ID 3741 - Documento para oficializar negociación de compra de efectivo al grupo Éxito",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW 2280111",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere formalizar por medio de una carta la negociación que se logró con el Grupo Éxito, con la cual se disminuye la tarifa a la que le compramos dinero en efectivo y adicionalmente se pacta que para el año 2024 se deja de comprarle efectivo al Éxito, logrando una eficiencia proyectada de más de 1.300 millones",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "Es una eficiencia proyectada de más de 1.300 millones para 2024, por menor gasto",
      "Proveedores_conocidos": "Grupo Éxito",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Gestión de Flujos",
      "Nombre_lider_EVC": "Juan Gonzalo Tobón",
      "SR_ARIBA": "SR4046183946",
      "Familias": "Servicios de Transporte de Valores",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Transporte de Valores",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3740,
      "Title": "Forms",
      "Fecha_solicitud": "08/06/2023",
      "Correo_solicitante": "valet@bancolombia.com.co",
      "Nombre_solicitante": "Valentina Torres Orozco",
      "Nombre_iniciativa": "ID 3740 - Asesoria para uso de Materiales",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Generar un pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la asesoría de uso de material con el fin de cancelar una factura de un viaje para grabar un contenido digital",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Grupo Naranja Media SAS - 901060138",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "C106500014",
      "Nombre_lider_EVC": "Carolina Barrera Galvis",
      "SR_ARIBA": 3740,
      "Familias": "Producción y Postproducción",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "08/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "08/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3739,
      "Title": "Forms",
      "Fecha_solicitud": "08/06/2023",
      "Correo_solicitante": "vaortega@bancolombia.com.co",
      "Nombre_solicitante": "Valentina Ortega Aguirre",
      "Nombre_iniciativa": "ID 3739 - Toma de fotografias inmuebles BRP disponibles",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Buen día, solicito su amable colaboración con un proveedor que tome fotografías profesionales a los Inmuebles BRP que tenemos disponibles a nivel Nacional para ofertar en las paginas de Bancolombia (Usados Bancolombia y Tu360). Muchas gracias",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "Tenemos 30mil millones para todo lo relacionado con los BRP, incluido este requerimiento.",
      "Proveedores_conocidos": "No tengo nombre",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia Estrategia BRP Centro de Costos C101000045",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4046183929",
      "Familias": "Servicios profesionales de Mercadeo",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Katherine Sanchez Henao",
      "Rol_asesor": "Monica Marcela Alzate Granda",
      "Observaciones": "Beatri OK PN.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "16/06/2023",
      "Fecha Asignación/Delegación": "16/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "08/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "13/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3738,
      "Title": "Forms",
      "Fecha_solicitud": "08/06/2023",
      "Correo_solicitante": "RICASALL@bancolombia.com.co",
      "Nombre_solicitante": "Ricardo Casallas Lopez",
      "Nombre_iniciativa": "ID 3738 - Renovación contrato CW2230800 servicio línea ética - proveedor ONELINK S.A.S NIT 900964443",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2230800-OT3",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se solicita colaboración para dar tramite a la renovación de tarifas contrato CW2230800 para la nueva vigencia del contrato 2023-2024. Ya se negocio con el proveedor y este ya envio otro si para firma con el banco",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "150.000.000",
      "Proveedores_conocidos": "ONELINK S.A.S NIT 900964443",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "LDC FC ETICA PAF ANTICORRUPCION CECO C102600011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4046183912",
      "Familias": "Líneas de Entrada",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "08/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "08/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios Canal Telefónico",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3736,
      "Title": "Forms",
      "Fecha_solicitud": "08/06/2023",
      "Correo_solicitante": "gyate@bancolombia.com.co",
      "Nombre_solicitante": "Gilma Carolina Yate Guzman",
      "Nombre_iniciativa": "ID 3736 - Vinculacion proveedor",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Contratación proveedor, realiza artesanías, detalles",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 132000000,
      "Proveedores_conocidos": "FAT FIT",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C102100354, gerencia de gestion comercial region centro",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3736,
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "08/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "08/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3734,
      "Title": "Forms",
      "Fecha_solicitud": "08/06/2023",
      "Correo_solicitante": "anmarios@bancolombia.com.co",
      "Nombre_solicitante": "Ana Maria Rios Benjumea",
      "Nombre_iniciativa": "ID 3734 - Negociación nuevo aliado para Seguros para Empleados",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere el ingreso de una nueva aseguradora al portafolio de productos disponibles que tenemos para los empleados en el área de Seguros para Empleados. Quienes se encargaran de ofrecer como opción seguros adicionales para el empleado y sus familias cómo vehículos, hogar, salud, entre otros.",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "No hace parte del negocio y no pertenece al minimo vital, legal y prioridad del negocio",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "MAPFRE, SBS.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC SEGUROS C105500010",
      "Nombre_lider_EVC": "Ricardo Mejia Tobon",
      "SR_ARIBA": "SR4046016790",
      "Familias": "Seguros",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "la usuaria aclaró que solo requiwere vinculación.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "09/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "GASTO NO GESTIONADO",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3737,
      "Title": "Forms",
      "Fecha_solicitud": "07/06/2023",
      "Correo_solicitante": "MASANTAM@bancolombia.com.co",
      "Nombre_solicitante": "Manuel Jose Santa Maria Uribe",
      "Nombre_iniciativa": "ID 3737 - Vincular como proveedor a miembro de comité de inversiones",
      "Tipo_Requerimiento": "Es un requerimiento del equipo de Renta y Uso de Leasing",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "En aplicativo Banco (SAP)",
      "Detalle_producto_o_servicio": "Se requiere vincular como proveedor a un miembro externo para el comité de inversiones de renta y uso. El objetivo es pagarle unos recursos por cada comité al que asiste.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 15000000,
      "Proveedores_conocidos": "Juan Hinestrosa Gallego",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Soluciones Renta y Uso, C103808202",
      "Nombre_lider_EVC": "Juan Pablo Acosta Vélez",
      "SR_ARIBA": 3737,
      "Familias": "Consultorias Corporativas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "08/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "08/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Consultorias Corporativas",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3735,
      "Title": "Forms",
      "Fecha_solicitud": "07/06/2023",
      "Correo_solicitante": "MAPUERTA@bancolombia.com.co",
      "Nombre_solicitante": "Maria Fernanda Puerta Gonzalez",
      "Nombre_iniciativa": "ID 3735 - Iniciativa de Gestion de Cambio de la Vicepresidencia Financiera",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Línea gráfica y diseño para la transformación de la Vicepresidencia Financiera",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 3000000,
      "Proveedores_conocidos": "Creario Design",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia inteligencia de Fiananzas C102500000",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3735,
      "Familias": "Servicios profesionales de Mercadeo",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "08/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "08/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3733,
      "Title": "Forms",
      "Fecha_solicitud": "07/06/2023",
      "Correo_solicitante": "amesa@bancolombia.com.co",
      "Nombre_solicitante": "Ana Catalina Mesa Uribe",
      "Nombre_iniciativa": "ID 3733 - Conferencia sobre manejo del tiempo en semana del empleado",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Solicitar material para hacer la orden de compra",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Conferencia dictada en el marco de la semana del empleado relacionada con manejo del tiempo y bienestar",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Puntos en Común",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Dirección Diversidad Equidad Inclusión",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3733,
      "Familias": "Servicios Profesionales Formación y Entrenamiento",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "08/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "08/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3732,
      "Title": "Forms",
      "Fecha_solicitud": "07/06/2023",
      "Correo_solicitante": "marcamgi@bancolombia.com.co",
      "Nombre_solicitante": "Maria Camila Gil Gomez",
      "Nombre_iniciativa": "ID 3732 - Renovación Actualización Contrato Blackcore  CW2291226",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2291226",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación servicios profesionales de licenciamiento bajo la modalidad de renta de software en modelo SaaS, denominado SAX utilizado para la generación, administración y aprobación de avalúos o tasaciones automatizados.   CW2291226",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "300.000.000",
      "Proveedores_conocidos": "Blackcore",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C104300032",
      "Nombre_lider_EVC": "Ciclo de Credito",
      "SR_ARIBA": "SR4044973754",
      "Familias": "Servicios SaaS",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Luisa Fernanda Garcia Guzman",
      "Rol_asesor": "Andres Osorio Castano",
      "Observaciones": "José OK PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "16/06/2023",
      "Fecha Asignación/Delegación": "16/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "07/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "13/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de plataformas",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3731,
      "Title": "Forms",
      "Fecha_solicitud": "07/06/2023",
      "Correo_solicitante": "emizulua@bancolombia.com.co",
      "Nombre_solicitante": "Emily Johana Zuluaga Osorio",
      "Nombre_iniciativa": "ID 3731 - Sello B - Anticipar aprobación del inmueble",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere negociar con el proveedor una tarifa de servicio para la recolección de documentos, estudio de títulos completo y escrituración para la certificación de un inmueble.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "No es necesario porque se le transfiere al cliente",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "BIU by Brigard u otros",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Inmobiliaria C105500050",
      "Nombre_lider_EVC": "EVC Inmobiliaria",
      "SR_ARIBA": "SR4045861271",
      "Familias": "Honorarios Avalúos",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Laura Serna Rodriguez",
      "Rol_asesor": "No aplica",
      "Observaciones": "Biatri ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "16/06/2023",
      "Fecha Asignación/Delegación": "16/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "09/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "13/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios Profesionales Procesos del Negocio",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3730,
      "Title": "Forms",
      "Fecha_solicitud": "07/06/2023",
      "Correo_solicitante": "vedelgad@bancolombia.com.co",
      "Nombre_solicitante": "Veronica Delgado Taua",
      "Nombre_iniciativa": "ID 3730 - Renovación de Post Producción Audiovisual Sancho . CW2269746",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2269746",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación de este servicio en las mismas condiciones.  Hace parte de la oferta que tiene Mercadeo para temas de post producción audiovisual. CW2269746",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Porque esto es por licitación. Se tiene presupuesto por campaña.",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "N/A",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "DIRECCION DE MARCA",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4044973731",
      "Familias": "Producción y Postproducción",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Katherine Sanchez Henao",
      "Rol_asesor": "No aplica",
      "Observaciones": "Naty es renovación, proveedor riesgo 3 no va a PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "09/06/2023",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "07/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3729,
      "Title": "Forms",
      "Fecha_solicitud": "07/06/2023",
      "Correo_solicitante": "dicagome@bancolombia.com.co",
      "Nombre_solicitante": "Diana Carolina Gomez Arango",
      "Nombre_iniciativa": "ID 3729 - Modificación contrato proveedor SERVICIOS AMBIENTALES PARA EL DESARROLLO SAD NIT 900.574.841-5",
      "Tipo_Requerimiento": "Es un requerimiento del equipo de Renta y Uso de Leasing",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "En aplicativos de Leasing como Mercurio y/o Delfin",
      "Detalle_producto_o_servicio": "se requiere incluir cláusula en el contrato vigente:\nCon ocasión a la entrada en vigencia del Plan de Acción Indicativo que desarrollará el Programa Ahorro y Uso Racional de Energía – PROURE durante el período 2022-2030, se derogó tácitamente la Resolución 1988 de 2017, expedida por los Ministerios de Ambiente y Desarrollo Sostenible; Minas y Energía y, Hacienda y Crédito Público, norma en la cual la Autoridad Nacional de Licencias Ambientales – ANLA fundamentaba jurídicamente la expedición de las certificaciones ambientales con la que las que se certifican los bienes que hacen parte de proyectos de eficiencia energética, para que los contribuyentes apliquen sobre la inversión el beneficio de renta de que trata el artículo 255 del Estatuto Tributario. Para solucionar el impase normativo se debe sustituir la citada resolución; mientras se realiza esta gestión, y por orden expresa de BANCOLOMBIA, el PROVEEDOR se compromete a elaborar las solicitudes de certificados que se radicarán ante la Unidad de Planeación Minero Energética – UPME, correspondientes a la inversión 2023 en proyectos de eficiencia energética, requisito indispensable para continuar con el trámite ante la ANLA. Así mismo, BANCOLOMBIA se compromete a pagar las respectivas tarifas que cobra la UPME por evaluar dichas solicitudes. Si la nueva resolución no es expedida por los referidos Ministerios antes del 1° de octubre de 2023, el PROVEEDOR no se verá obligado a elaborar las solicitudes de certificación ambiental para continuar el trámite ante la ANLA. Si la Resolución 1988/17 no es sustituida antes de la citada fecha, impidiendo continuar el trámite ante la ANLA, BANCOLOMBIA decidirá si aplica el beneficio de renta de la Ley 1715 de 2014 a que tiene derecho con el certificado expedido por la UPME; solo si BANCOLOMBIA aplica este beneficio, se le reconocerá al PROVEEDOR el pago de la respectiva comisión de éxito, tal como se estableció en la cláusula 3. VALOR Y FORMA DE PAGO.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "No aplica",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "SERVICIOS AMBIENTALES PARA EL DESARROLLO SAD",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC ACTIVOS LEASING RENTA Y USO",
      "Nombre_lider_EVC": "Alberto Echeverri Arcila",
      "SR_ARIBA": "SR4045050541",
      "Familias": "Consultorias Corporativas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Katherine Sanchez Henao",
      "Rol_asesor": "No aplica",
      "Observaciones": "Naty de este tema veo el contrato CW2277609 a nombre de juanpa de consultorías. No lo envié a PN  es proveedor riesgo 4 y está proximo a vencerse en julio.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "09/06/2023",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "07/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Consultorias Corporativas",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3728,
      "Title": "Forms",
      "Fecha_solicitud": "07/06/2023",
      "Correo_solicitante": "shcastan@bancolombia.com.co",
      "Nombre_solicitante": "Shirley Castano Ortega",
      "Nombre_iniciativa": "ID 3728 - Patrocinio Bazar Avenida Jardin",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Patrocinio 10 stands bazar love day avenida jardín, 15 y 16 de septiembre de 2023, el propósito de este espacio es premiar a los 10 comercios (emprendedores) que mas facturen con código QR para pagar su estadía en la feria.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 8750000,
      "Proveedores_conocidos": "CAROLINA PÉREZ MONTOYA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Gerencia Mercadeo Uso -MDO01036 pertenece al Centro de Costos C106500008",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3728,
      "Familias": "Patrocinios Mercadeo",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "07/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "07/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3727,
      "Title": "Forms",
      "Fecha_solicitud": "06/06/2023",
      "Correo_solicitante": "amovarga@bancolombia.com.co",
      "Nombre_solicitante": "Ana Maria Ospina Vargas",
      "Nombre_iniciativa": "ID 3727 -  VINCULACIÓN PROVEEDOR PARA REPRESENTACIÓN  EN PROCESO EN CONTRA DEL BANCO",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "PROPUESTA DE SERVICIO JUDICIAL PARA REPRESENTACIÓN EN PROCESO EN CONTRA DEL BANCO",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "150.000.000",
      "Proveedores_conocidos": "O.I.V.S LAWYERS S.A.S NIT. 901.217.298-9",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C102400160 GERENCIA PROCESOS JUDICIALES",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4045861252",
      "Familias": "Servicios Legales",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "08/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "08/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios Profesionales Procesos del Negocio",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3726,
      "Title": "Forms",
      "Fecha_solicitud": "06/06/2023",
      "Correo_solicitante": "aplopez@bancolombia.com.co",
      "Nombre_solicitante": "Adriana Patricia Lopez Arango",
      "Nombre_iniciativa": "ID 3726 - Renovación Licencias DISCO Fluxicom. CW2256791",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2256791",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la renovación de la licencias de DISCO, del proveedor Fluxicom que vence 01/Jul/2023. CW2256791",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "aproximadamente $21 millones de pesos",
      "Proveedores_conocidos": "Fluxicom",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Evolución Digital",
      "Nombre_lider_EVC": "Fernando Enrique Velasco Forero",
      "SR_ARIBA": "SR4044973716",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Nicolas Quiceno Carmona",
      "Rol_asesor": "Monica Marcela Alzate Granda",
      "Observaciones": "Kathe OK PN.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "16/06/2023",
      "Fecha Asignación/Delegación": "16/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "07/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "13/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3725,
      "Title": "Forms",
      "Fecha_solicitud": "06/06/2023",
      "Correo_solicitante": "mobernal@bancolombia.com.co",
      "Nombre_solicitante": "Monica Yineth Bernal Gomez",
      "Nombre_iniciativa": "ID 3725 - PRG_2023_677777 -  MUNICIPIO DE ROLDANILLO (Segunda parte)",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vinculación y generar pedido en SAP.",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "ALQUILER DE SONIDO JTORREX DURANTE EL RECORRIDO de la Primera válida MTB SHORT TRACK de la feria de Roldanillo.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "JULIAN MAURICIO TORRES FRANCO",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "PATROCINIOS GOBIERNO DE RED - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3725,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "07/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "07/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3724,
      "Title": "Forms",
      "Fecha_solicitud": "06/06/2023",
      "Correo_solicitante": "fevelasc@bancolombia.com.co",
      "Nombre_solicitante": "Fernando Enrique Velasco Forero",
      "Nombre_iniciativa": "ID 3724 - Generación contrato para administración Oracle WCC en la nube Proveedor ASIC",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Por la migración de Oracle WCC a la nube, la cual esta cubierta por un contrato de servicio de administración con el proveedor ASIC de máquina en tierra. Se requiere generar un nuevo contrato de administración de los componentes Oracle WCC migrados a la nube AWS Bancolombia.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Priorizado por el CAE",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "3.0 mil mm",
      "Proveedores_conocidos": "ASIC",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVOLUCION DIGITAL C103500106",
      "Nombre_lider_EVC": "Fernando Enrique Velasco Forero",
      "SR_ARIBA": "SR4045861191",
      "Familias": "Servicios SaaS",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Juan Esteban Franco Vargas",
      "Rol_asesor": "No aplica",
      "Observaciones": "Jose ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "23/06/2023",
      "Fecha Asignación/Delegación": "23/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "08/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "08/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de plataformas",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3723,
      "Title": "Forms",
      "Fecha_solicitud": "06/06/2023",
      "Correo_solicitante": "mobernal@bancolombia.com.co",
      "Nombre_solicitante": "Monica Yineth Bernal Gomez",
      "Nombre_iniciativa": "ID 3723 - PRG_2023_763664 MUNICIPIO DE POPAYAN",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "VINCULAR Y GENERAR UN PEDIDO EN SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Los servicios prestados son la decoración del evento y catering de la semana Santa en Popayán",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Marie Claire Simmonds Muskus",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "PATROCINIOS GOBIERNO DE RED - C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3723,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "06/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "06/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3722,
      "Title": "power_apps",
      "Fecha_solicitud": "06/06/2023",
      "Correo_solicitante": "LUEOSPIN@bancolombia.com.co",
      "Nombre_solicitante": "Luz Emerida Ospina Mazo",
      "Nombre_iniciativa": "ID 3722 - Renovación Kobiton, CW2281513",
      "Tipo_Requerimiento": "Renovación",
      "CW_a_renovar": "CW2281513",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación Granja de dispositivos móviles para pruebas. CW2281513",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "50.520.762",
      "Proveedores_conocidos": "Kobiton INC",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "VICEPRESIDENCIA SERV DE TECNOLOGIA",
      "Nombre_area_y_ceco": "CDE INGENIERIA DE TI DEVEXP - CC 103500022",
      "Nombre_lider_EVC": "Camilo Piedrahita Macias",
      "SR_ARIBA": "SR4043172386",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Nicolas Quiceno Carmona",
      "Rol_asesor": "Monica Marcela Alzate Granda",
      "Observaciones": "Kathe OK PN.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "16/06/2023",
      "Fecha Asignación/Delegación": "16/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "06/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "13/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3721,
      "Title": "Forms",
      "Fecha_solicitud": "06/06/2023",
      "Correo_solicitante": "jmpulgar@bancolombia.com.co",
      "Nombre_solicitante": "John Mauricio Pulgarin",
      "Nombre_iniciativa": "ID 3721 - EVALUACIONES MEDICO PERIODICAS",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "VAMOS A COMENZAR CON COMFAMA LA ATENCION DE EVALUACIONES MEDICO PERIODICAS PARA LOS EMPLEADOS DEL GRUPO BANCOLOMBIA A NIVEL PAIS, TENIENDO EN CUENTA QUE SURA, QUE ERA EL PROVEEDOR QUE NOS PRESTABA ESTE SERVICIO, NO CONTINUA CON ELLO POR DECISION DIRECTA DE ELLOS.",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "250.000.000",
      "Proveedores_conocidos": "CAJA DE COMPENSACION FAMILIAR COMFAMA 890900841",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GERENCIA DE BIENESTAR C103200030",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4042937928",
      "Familias": "Salud para Empleados",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "Lina Maria Monsalve Burgos",
      "Rol_asesor": "",
      "Observaciones": "Kathe ok PN",
      "Comentarios BP": "Hola Moni. Hablé con John Mauricio, me indicó que hicieron el proceso de selección del proveedor y quedó adjudicado Comfama, así mismo me confirma que la negociación esta lista, por lo que este requerimiento puede delegarse. El usuario ya tiene contexto. Gracias.",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "14/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "06/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "14/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3720,
      "Title": "Forms",
      "Fecha_solicitud": "06/06/2023",
      "Correo_solicitante": "jobayona@bancolombia.com.co",
      "Nombre_solicitante": "Jonathan Antonio Bayona Del Ducca",
      "Nombre_iniciativa": "ID 3720 - Renovación licenciamiento - SAM anual PORFIN. CW2221898",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2221898",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "nos llega la oferta comercial para la renovación de SAM para el producto financiero PORFIN.  contrato CW2221898 el único incremento asociado vs año pasado es IPC... solicito revisar si es necesario la revisión de abastecimiento dado que como líder técnico cuento con el presupuesto y el servicio se viene prestando de forma exitosa con proveedor",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "80.000.000",
      "Proveedores_conocidos": "ALFA GL(PROVEEDOR EXISTENTE) ES UNICAMENTE RENOVACIÓN  LICENCIAMIENTO . INCREMENTO IPC",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC NVERSIONES",
      "Nombre_lider_EVC": "JONATHAN BAYONA - RAFAEL LUNA",
      "SR_ARIBA": "SR4043050473",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Leidy Tatiana Tangarife Gonzalez",
      "Rol_asesor": "Monica Marcela Alzate Granda",
      "Observaciones": "Naty ok. PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "09/06/2023",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "06/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "06/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3719,
      "Title": "Forms",
      "Fecha_solicitud": "06/06/2023",
      "Correo_solicitante": "JGONZALE@bancolombia.com.co",
      "Nombre_solicitante": "Jesus Alberto Gonzalez Alvarez",
      "Nombre_iniciativa": "ID 3719 - ZTNA - Acceso Remoto Corportativo",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Aprovechando el servicio que tenemos de SWG con Netskope, queremos aprovechar el agente instalado en las estaciones de trabajo, para utilizarlo como Acceso Remoto a las aplicaciones internas cuando las requerimos utilizar fuera de la oficina.  \nSe requiere realizar una POC para Banistmo y BAM con posibilidad, que en caso que la aplicación cumpla con nuestros requerimientos se una esa característica al contrato corporativo de SWG.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "porque por ahora es una POC, sin embargo en caso que la palicación nos cumpla con las necesidades del Banco, se revisaría el presupuesto.",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Gamma Ingenieros",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Servicios de Ciberseguridad - C104300559",
      "Nombre_lider_EVC": "Andres Felipe Rivas Gonzalez",
      "SR_ARIBA": "SR4042937945",
      "Familias": "Controles de Ciberseguridad",
      "Categoría": "Seguridad",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Pablo Zapata Franco",
      "Rol_asesor": "No aplica",
      "Observaciones": "Cata ok PN",
      "Comentarios BP": "Llevar al MP y asignar a pablo",
      "Fecha MarketPlace": "09/06/2023",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "06/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "07/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Ciberseguridad y seguridad de la información",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3718,
      "Title": "Forms",
      "Fecha_solicitud": "06/06/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 3718 - Compra de curso de extensión 56 CONGRESO DE SEGURIDAD, SALUD Y AMBIENTE\tCONGRESO COLOMBIANO DE SEGURIDAD",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión 56 CONGRESO DE SEGURIDAD, SALUD Y AMBIENTE\tCONGRESO COLOMBIANO DE SEGURIDAD",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "CONGRESO COLOMBIANO DE SEGURIDAD",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3718,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "06/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "06/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3717,
      "Title": "Forms",
      "Fecha_solicitud": "06/06/2023",
      "Correo_solicitante": "MARTRUJI@bancolombia.com.co",
      "Nombre_solicitante": "Mariluz Trujillo Perez",
      "Nombre_iniciativa": "ID 3717 - Vinculación proveedor AROCA VIVES ABOGADOS S.A.S NIT. 901.144.919-1",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular al proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Capacitación dirigida a la Escuela de Negocios énfasis Inversiones.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "AROCA VIVES ABOGADOS S.A.S NIT. 901.144.919-1",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3717,
      "Familias": "Servicios Profesionales Formación y Entrenamiento",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "06/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "06/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3716,
      "Title": "Forms",
      "Fecha_solicitud": "06/06/2023",
      "Correo_solicitante": "mcardozo@bancolombia.com.co",
      "Nombre_solicitante": "Martha Sofia Cardozo Castillo",
      "Nombre_iniciativa": "ID 3716 - Reactivar Proveedor Sap 3202 Acopi Cundinamarca",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Desbloquear el proveedor Sap 3202 - Acopi Cundinamarca Rut. 860015715-3",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Paquete: Vinculación Comercial Día Mundial MiPyme piezas del evento a realizar el 14 de junio de 2023 en Bogotá y Cundinamarca\nAño de las relaciones",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Sap 3202 - Acopi Cundinamarca Rut. 860015715-3",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia Gestión Comercial Bogotá C102100892",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3716,
      "Familias": "Suscripciones",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "06/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "06/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios de Información",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3715,
      "Title": "Forms",
      "Fecha_solicitud": "05/06/2023",
      "Correo_solicitante": "tportaci@bancolombia.com.co",
      "Nombre_solicitante": "Tatiana Paola Portacio Martelo",
      "Nombre_iniciativa": "ID 3715 - Proveedores disposición final maquinaria",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la búsqueda de proveedores en el mercado que realicen el proceso de chatarrización (disposición final) de maquinaria recibida por el banco (BRP) que no tiene ningún valor comercial o es catalogada como chatarra por la Gerencia de Valoración de Garantías y Activos",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "Tenemos $30.000 millones para todo lo relacionado con los BRPs, incluido este requerimiento",
      "Proveedores_conocidos": "No se tiene nombre de proveedor",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia Estrategia BRP Centro de Costos C101000045 193.279.450",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4042302940",
      "Familias": "SOFT (Operadores de Aseo)",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Luis Guillermo Salcedo Valderrama",
      "Rol_asesor": "No aplica",
      "Observaciones": "Naty ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "09/06/2023",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "06/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "07/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Facility Managment",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3714,
      "Title": "Forms",
      "Fecha_solicitud": "05/06/2023",
      "Correo_solicitante": "maapizan@bancolombia.com.co",
      "Nombre_solicitante": "Marcela Aguirre Pizano",
      "Nombre_iniciativa": "ID 3714 - Renovar herramienta Bitly",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2282961",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Acortador de URLS para SMS, desde el 2021 utilizamos Bitly. Para este año lo compraremos teniendo en cuenta los criterios de cyberseguridad agregando un dominio.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "12.000.000",
      "Proveedores_conocidos": "Bitly",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Mercadeo Engagement C106500018",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR No requerido",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Contención",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Junio 05. Usuaria repitió el mismo req. 3709 el cual ya se le procesó.  se le notifica por correo que este queda cancelado.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "05/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3713,
      "Title": "Forms",
      "Fecha_solicitud": "05/06/2023",
      "Correo_solicitante": "marigavi@bancolombia.com.co",
      "Nombre_solicitante": "Mariana Gaviria Agudelo",
      "Nombre_iniciativa": "ID 3713 - Inconvenientes con el proveedor DOMINA",
      "Tipo_Requerimiento": "Es un escalamiento (reclamación a un proveedor por un incumplimiento contractual)",
      "CW_a_renovar": "CW2264124",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "",
      "Nombre_area_y_ceco": "",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR No requerido",
      "Familias": "",
      "Categoría": "",
      "¿Cómo se va a gestionar?": "Escalamiento",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "05/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "",
      "Subcategoría_F": "",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3712,
      "Title": "Forms",
      "Fecha_solicitud": "05/06/2023",
      "Correo_solicitante": "scasalin@bancolombia.com.co",
      "Nombre_solicitante": "Scarlett De Jesus Casalins Pertuz",
      "Nombre_iniciativa": "ID 3712 - Servicio de catering para evento lanzamiento premier “DE COLOMBIA PA’L MUNDO”",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vinculación del proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Servicio de catering y refrigerios para evento lanzamiento premier “DE COLOMBIA PA’L MUNDO”",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "BASILIC SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GERENCIA DE GESTION COMERCIAL CARIBE C102100403",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3712,
      "Familias": "BTL",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "05/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "05/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3711,
      "Title": "Forms",
      "Fecha_solicitud": "05/06/2023",
      "Correo_solicitante": "itovar@bancolombia.com.co",
      "Nombre_solicitante": "Ivan Mauricio Tovar Hernandez",
      "Nombre_iniciativa": "ID 3711 - Cargue, retiro y disposición de material de escombros",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Cargue, retiro y disposición de materiales sobrantes del desmonte, limpieza, descapote, demoliciones y excavaciones realizadas para desmontar el muro en tierra reforzado fallado en la obra del lote de Bancolombia, en el plan parcial caminos de la Romera en el municipio de Sabaneta.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "$16.000.000",
      "Proveedores_conocidos": "Estamos abiertos a realizarlo con un proveedor registrado en cadena de abastecimiento",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia Estrategica BRP Centro de Costos:C104300379",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4041301658",
      "Familias": "Obra Civil y Eléctrica",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Carlos Andres Ramos Ospina",
      "Rol_asesor": "No aplica",
      "Observaciones": "Naty ok. PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "09/06/2023",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "06/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "07/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de adecuaciones",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3710,
      "Title": "Forms",
      "Fecha_solicitud": "05/06/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 3710 - Compra de curso de extensión CONSTRUVERDE\tCONSEJO COLOMBIANO DE CONSTRUCCION SOSTENIBLE",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión CONSTRUVERDE\tCONSEJO COLOMBIANO DE CONSTRUCCION SOSTENIBLE",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "CONSEJO COLOMBIANO DE CONSTRUCCION SOSTENIBLE",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3710,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "05/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "05/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3709,
      "Title": "power_apps",
      "Fecha_solicitud": "05/06/2023",
      "Correo_solicitante": "maapizan@bancolombia.com.co",
      "Nombre_solicitante": "Marcela Aguirre Pizano",
      "Nombre_iniciativa": "ID 3709 - Renovar herrramienta Bitly. CW2282961",
      "Tipo_Requerimiento": "Renovación",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovar herramienta bitly para acortar URLS CW2282961",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "12.000.000",
      "Proveedores_conocidos": "Bitly",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "VICEPRESIDENCIA DE MERCADEO",
      "Nombre_area_y_ceco": "",
      "Nombre_lider_EVC": "Jorge Alejandro Vargas Perdomo",
      "SR_ARIBA": "SR4041301614",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "John Alexis Velasquez Garcia",
      "Rol_asesor": "Monica Marcela Alzate Granda",
      "Observaciones": "Naty ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "09/06/2023",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "05/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "06/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3708,
      "Title": "Forms",
      "Fecha_solicitud": "05/06/2023",
      "Correo_solicitante": "fcifuent@bancolombia.com.co",
      "Nombre_solicitante": "Fabio Leon Cifuentes Roldan",
      "Nombre_iniciativa": "ID 3708 - Licencias Finacle CDT",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la compra de 250.000 licencias de Finacle CDT",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Necesitamos saber el mejor precio de las lincencias, para presupuestarnos. el presupuesto saldra del entorno de productos.",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Infosys",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Depositos y Cuentas Espaciales",
      "Nombre_lider_EVC": "Juan Esteban Tobon Mendez",
      "SR_ARIBA": "SR4041301584",
      "Familias": "Licenciamiento Mayor",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Retirar Requerimiento",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Jose ok PN",
      "Comentarios BP": "Se retira requerimiento dado que el usuario ya no necesita comprar las licencias",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "26/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "05/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "23/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "Retirado",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3707,
      "Title": "Forms",
      "Fecha_solicitud": "05/06/2023",
      "Correo_solicitante": "julmoral@bancolombia.com.co",
      "Nombre_solicitante": "Julian Morales Patino",
      "Nombre_iniciativa": "ID 3707 - Estudio Plataforma Confirming",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la integración con la plataforma con el objetivo de conectarnos directamente a sus pagadores y proveedores para el fondeo de sus facturas. La plataforma se integra al ERP de los clientes para tomar la información directamente y así facilitar el proceso para estos y después nos envían la información a través de H2H. La plataforma es un tercero con el cual trabajamos de la mano, en donde no se contrata pagando un fee por sus servicios, sino que ellos cobran unos puntos básicos sobre la tasa de las facturas descontadas a través de esta; ellos entran como un proveedor que nos permite una mejor integración de cara a pagadores y proveedores.",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "La plataforma es un tercero con el cual trabajamos de la mano, en donde no se contrata pagando un fee por sus servicios, sino que ellos cobran unos puntos básicos sobre la tasa de las facturas descontadas a través de esta, razón por la cual no es necesario un presupuesto previo, dado que el pago se hará en forma de comisiones con forme estas se vayan generando",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Colfimax Confirming SA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Nuevos Negocios",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4040881785",
      "Familias": "Servicios SaaS",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "05/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "05/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicio de plataformas",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3706,
      "Title": "Forms",
      "Fecha_solicitud": "05/06/2023",
      "Correo_solicitante": "angperez@bancolombia.com.co",
      "Nombre_solicitante": "Angela Maria Perez Hernandez",
      "Nombre_iniciativa": "ID 3706 - Evento de Lanzamiento MAX herramienta para la práctica del diseño de procesos",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra al proveedor Mercado Creativo, Sra. Marcela Correa, 200 unidades de Crispetas, para el evento de lanzamiento de la herramienta para la práctica del diseño de procesos.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 853000,
      "Proveedores_conocidos": "Marcela Correa - Mercado Creativo",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "C103700012",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3706,
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "05/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "05/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3705,
      "Title": "Forms",
      "Fecha_solicitud": "05/06/2023",
      "Correo_solicitante": "",
      "Nombre_solicitante": "Ana Maria Gomez Henao",
      "Nombre_iniciativa": "ID 3705 - Consultoria para diagnostico y revisión de los arrendamientos de los locales de bancolombia",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Diagnostico del parque actual de los arrendamientos de locales bancolombia, para encontrar posibles eficiencias en esta familia.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "La consutoria se pagaría con las eficiencias encontradas por el proveedor",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "CBRE",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Gestión Inmobiliaria (Ana Maria Gomez Henao)",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4040670666",
      "Familias": "Consultorias Corporativas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Natalia Ceballos Quintero",
      "Rol_asesor": "No aplica",
      "Observaciones": "Naty te lo envio sin pasar por PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "09/06/2023",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "05/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Consultorias Corporativas",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3704,
      "Title": "power_apps",
      "Fecha_solicitud": "02/06/2023",
      "Correo_solicitante": "esramire@bancolombia.com.co",
      "Nombre_solicitante": "Esteban Ramirez Correa",
      "Nombre_iniciativa": "ID 3704 - Renovación Licencias AutoCAD LT x 10",
      "Tipo_Requerimiento": "Renovación",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovación de la licencia de AutoCAD LT por 3 años, 10 usuarios, venicimiento Junio 30",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "10000 USD",
      "Proveedores_conocidos": "MCAD",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "VICEPRESIDENCIA DE NEGOCIOS",
      "Nombre_area_y_ceco": "C306200010",
      "Nombre_lider_EVC": "David Andres Gallego Cano",
      "SR_ARIBA": "SR4038554337",
      "Familias": "Licenciamiento Menor",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "John Alexis Velasquez Garcia",
      "Rol_asesor": "Monica Marcela Alzate Granda",
      "Observaciones": "Naty ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "09/06/2023",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "05/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "08/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3703,
      "Title": "Forms",
      "Fecha_solicitud": "02/06/2023",
      "Correo_solicitante": "trlondon@bancolombia.com.co",
      "Nombre_solicitante": "Trinidad Estella Londono Quiceno",
      "Nombre_iniciativa": "ID 3703 - Contratación de talento a nivel internacional",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere inscribir como proveedor a Deel SAS Colombia; ya se tiene inscrito a Deel INC bajo ID 1533 y la información sobre ciberseguridad y el análisis de polizas y demas es la misma. Se requiere inscribir a Deel SAS para facturación.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "$350M",
      "Proveedores_conocidos": "Deel SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "VP. Tecnología",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3703,
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Junio 05. Se clasifica en una familia que no requiera análisis del riesgo, dado que ya lo gestionó con el req. 2787 (servicios selección de personal) este es un reproceso, porque el proceso de facturación será con el mismo proveedor pero con su representación en Colombia y las áreas que se activaron, Ciber y Seguros, le informaron al usuario que el riesgo era el mismo, así que no es necesario repetir ese proceso, solo vincular este proveedor (se habló con la usuario telefónicamente el 02 de junio).",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "05/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "05/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3702,
      "Title": "MP MANUAL",
      "Fecha_solicitud": "02/06/2023",
      "Correo_solicitante": "",
      "Nombre_solicitante": "Maria Catalina Mesa Gonzalez",
      "Nombre_iniciativa": "ID 3702 -",
      "Tipo_Requerimiento": "Requerimiento nuevo",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Contrato nuevo Nequi Iuvity Generación de QR",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "",
      "Nombre_area_y_ceco": "Nequi C102200039",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4036617179",
      "Familias": "Canales Digitales",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Luisa Fernanda Londono Jimenez",
      "Rol_asesor": "Monica Marcela Alzate Granda",
      "Observaciones": "Junio 02.  requerimiento manual llevado al MP el cual se solicite que gestione PN a la par de la asignación del negociador.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "02/06/2023",
      "Fecha Asignación/Delegación": "02/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "02/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Canales Digitales",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3701,
      "Title": "MP MANUAL",
      "Fecha_solicitud": "02/06/2023",
      "Correo_solicitante": "",
      "Nombre_solicitante": "Oscar Ricardo Acosta Jaramillo",
      "Nombre_iniciativa": "ID 3701 -",
      "Tipo_Requerimiento": "Renovación",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Renovacion tarifas TP Genesys Cloud",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "TP",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "",
      "Nombre_area_y_ceco": "EVC Distribución a distancia",
      "Nombre_lider_EVC": "Cristina Duque",
      "SR_ARIBA": "SR4037927709",
      "Familias": "Líneas de Entrada",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Yohany Anibal Gaviria Quintero",
      "Rol_asesor": "No aplica",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "02/06/2023",
      "Fecha Asignación/Delegación": "02/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios Canal Telefónico",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3700,
      "Title": "MP MANUAL",
      "Fecha_solicitud": "02/06/2023",
      "Correo_solicitante": "",
      "Nombre_solicitante": "",
      "Nombre_iniciativa": "ID 3700 -",
      "Tipo_Requerimiento": "",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "",
      "Nombre_area_y_ceco": "",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR No requerido",
      "Familias": "",
      "Categoría": "",
      "¿Cómo se va a gestionar?": "Contención",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Req.generado por error los de proyecto VITA no se notifica asignacion, el negociador los trabaja internamenre",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "02/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "",
      "Subcategoría_F": "",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3699,
      "Title": "MP MANUAL",
      "Fecha_solicitud": "02/06/2023",
      "Correo_solicitante": "",
      "Nombre_solicitante": "",
      "Nombre_iniciativa": "ID 3699 -",
      "Tipo_Requerimiento": "",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "",
      "Nombre_area_y_ceco": "",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR No requerido",
      "Familias": "",
      "Categoría": "",
      "¿Cómo se va a gestionar?": "Contención",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Req.generado por error los de proyecto VITA no se notifica asignacion, el negociador los trabaja internamenre",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "02/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "",
      "Subcategoría_F": "",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3698,
      "Title": "Forms",
      "Fecha_solicitud": "02/06/2023",
      "Correo_solicitante": "dppulido@bancolombia.com.co",
      "Nombre_solicitante": "Diana Patricia Pulido Garcia",
      "Nombre_iniciativa": "ID 3698 - Pago Process Agent - Tender",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Designación de agente de proceso para el contrato entre JP Morgan y Bancolombia por la operación de recompra de los bonos ordinarios USD 2025.\nEste servicio se pide como parte de la operación de recompra que se realizará de unos bonos ordinarios que tenemos denominados en USD. Dicha transacción se encuentra aprobada y en ejecución. \n\nEste intermediario, Law Debenture, se necesita como intermediario internacional y se encargará de recibir y transmitir notificaciones de dicha transacción a las partes involucadas.\nEste proveedor ya se encuentra aprobado por el Banco, por lo cual no necesita ningún negociador ni área involucrada. Desde el área de Bancos corresponsales ya han hecho el procedimiento anteriormente",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 1500,
      "Proveedores_conocidos": "Law Debenture Corporate Services Inc.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia Operaciones Estructuradas, EB0000005",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3698,
      "Familias": "Servicios Bursátiles",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "05/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "05/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "Retirado",
      "Estado": "Mercados de Capitales",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3697,
      "Title": "Forms",
      "Fecha_solicitud": "02/06/2023",
      "Correo_solicitante": "mcontado@bancolombia.com.co",
      "Nombre_solicitante": "Manuel Fernando Contador Pabon",
      "Nombre_iniciativa": "ID 3697 - conocer el material correcto de un proveedor",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "generar Solped, solicitar material",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se realizo una minisierie de videos para experiencias comerciales",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Alcubo",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Pricing c107203",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3697,
      "Familias": "BTL",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "05/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "05/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3696,
      "Title": "Forms",
      "Fecha_solicitud": "02/06/2023",
      "Correo_solicitante": "ntilano@bancolombia.com.co",
      "Nombre_solicitante": "Nahomy Daniela Tilano Diaz",
      "Nombre_iniciativa": "ID 3696 - Patrocinio al municipio Arboletes",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular un proveedor y hacer pedido en SAP",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor es un grupo musical de porro, que suministra el servicio de toques en eventos en el municipio de Arboletes.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Luz Amparo Fuentes Pereira",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gobierno de Red : C105900011",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3696,
      "Familias": "Patrocinios Gobierno",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "05/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "05/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3695,
      "Title": "Forms",
      "Fecha_solicitud": "02/06/2023",
      "Correo_solicitante": "mariospi@bancolombia.com.co",
      "Nombre_solicitante": "Maria Fernanda Ospina Perez",
      "Nombre_iniciativa": "ID 3695 - Consultoría para diseño de herramientas de autogestión Cobranza",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Diseño de herramientas autogestión cobranza. \nDescripción: \n1. Adecuar oferta de soluciones por el canal digital autogestionado \n2. Diseñar Journey del cliente al realizar un proceso de conciliación y cobranza, priorizando funcionalidades de mayor valor \n3. Desarrollar un roadmap de largo plazo, para implementar soluciones viables en el corto plazo y tener una oferta digital líder en Colombia",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "3.500.000.000",
      "Proveedores_conocidos": "BCG Boston Consulting Group, Inc",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Ciclo de crédito, C104300370",
      "Nombre_lider_EVC": "Esteban Sanchez Moreno",
      "SR_ARIBA": "SR4038397976 (R)",
      "Familias": "Consultorias Corporativas",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Retirar Requerimiento",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Biatri aun no tenemos acá las nuevas familias, pero esto sería una consultoría de procesos del negocio.\nOK PN\n\nJunio 09. a solicitud de Biatri, por Teams, se cancela este req. está repetido con el 3397  del 19 de abril, que ya tiene asignado un negociador y está activo, en curso de negociación.  Se le notifica al usuario. al parecer el usuario no estaba en esas otras conversaciones, sino el dueño de la EVC.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "02/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "06/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Consultorias Corporativas",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3694,
      "Title": "Forms",
      "Fecha_solicitud": "02/06/2023",
      "Correo_solicitante": "valet@bancolombia.com.co",
      "Nombre_solicitante": "Valentina Torres Orozco",
      "Nombre_iniciativa": "ID 3694 - Asesoria uso de Material",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Solicitar Material",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere una consultoría  para el uso de material con el fin de cancelar una factura de una Multa por un servicio de un simulador cancelado antes de tiempo",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "CMA INC 133163973",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC sitio de contenidos C106500024",
      "Nombre_lider_EVC": "Juliana Rodriguez Jaramillo",
      "SR_ARIBA": "SR4042654390",
      "Familias": "Servicios SaaS",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Retirar Requerimiento",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Joselín, por la particularidad de la solicitud no va a PN y lo dejo en la familia que están las otras OS.  la usuaria me compartió por correo la OS %23 que no la veo en Ariba.  te la compartí por Teams.",
      "Comentarios BP": "No se lleva al MP ahora mismo estamos gestionando la definición contable  y validación contractual.",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "20/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "06/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "Retirado",
      "Estado": "Servicio de plataformas",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3693,
      "Title": "Forms",
      "Fecha_solicitud": "02/06/2023",
      "Correo_solicitante": "gyate@bancolombia.com.co",
      "Nombre_solicitante": "Gilma Carolina Yate Guzman",
      "Nombre_iniciativa": "ID 3693 - Vinculacion proveedor",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Vinculación del proveedor para futuros eventos, brinda servicios logísticos y de alimentación",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 132000000,
      "Proveedores_conocidos": "Pastelitos la tercera",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C102100354, gerencia de gestion comercial region centro",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3693,
      "Familias": "BTL",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "02/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "02/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3692,
      "Title": "Forms",
      "Fecha_solicitud": "02/06/2023",
      "Correo_solicitante": "gyate@bancolombia.com.co",
      "Nombre_solicitante": "Gilma Carolina Yate Guzman",
      "Nombre_iniciativa": "ID 3692 - Vinculacion proveedor",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Vinculación proveedor para próximos eventos, genera productos alimenticios",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 132000000,
      "Proveedores_conocidos": "El tiesto del taita",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C102100354, Gerencia de gestion comercial region centro",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3692,
      "Familias": "BTL",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "02/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "02/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3691,
      "Title": "Forms",
      "Fecha_solicitud": "02/06/2023",
      "Correo_solicitante": "gyate@bancolombia.com.co",
      "Nombre_solicitante": "Gilma Carolina Yate Guzman",
      "Nombre_iniciativa": "ID 3691 - Vinculacion proveedor",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Vinculacion proveedor futuros eventos, realiza productos alimenticios",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 132000000,
      "Proveedores_conocidos": "Hosteleria matamundo",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C102100354, Gerencia de gestion comercial region centro",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3691,
      "Familias": "BTL",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "02/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "02/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3690,
      "Title": "Forms",
      "Fecha_solicitud": "02/06/2023",
      "Correo_solicitante": "mmmartin@bancolombia.com.co",
      "Nombre_solicitante": "Monica Maria Martinez Medina",
      "Nombre_iniciativa": "ID 3690 - Prueba para validar que lleguen requerimientos",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Prueba.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 1,
      "Proveedores_conocidos": "Prueba",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Abastecimiento",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR No requerido",
      "Familias": "",
      "Categoría": "",
      "¿Cómo se va a gestionar?": "Contención",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "02/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "",
      "Subcategoría_F": "",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3689,
      "Title": "Forms",
      "Fecha_solicitud": "31/05/2023",
      "Correo_solicitante": "lucigonz@bancolombia.com.co",
      "Nombre_solicitante": "Luciana Gonzalez Diaz Granados",
      "Nombre_iniciativa": "ID 3689 - Renovación ORden de Servicio Accenture. CW2271045",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2271045",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Actualizar clausulas y vigencia de la Orden de Servicios. CW2271045",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "No requiere",
      "Proveedores_conocidos": "Accenture",
      "Cuadrante_Proveedor": 2,
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Administración Integarl de Equipos c103500002",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4036090390",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Daniel Jimenez Delgado",
      "Rol_asesor": "No aplica",
      "Observaciones": "Jose ok. PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "09/06/2023",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "01/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "06/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3688,
      "Title": "Forms",
      "Fecha_solicitud": "31/05/2023",
      "Correo_solicitante": "mtamayo@bancolombia.com.co",
      "Nombre_solicitante": "Maria Alejandra Tamayo Estrada",
      "Nombre_iniciativa": "ID 3688 - RFE Ventas digitales y profundización Sufi",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Como estrategia comercial de Sufi para aliados estrategicos, vemos la necesidad de tener las campañas distribuidad entre minimo 2 aliados y maximo 3 diferentes, esto con el fin de generar una sana competencia, mejorar los indicadores de gestión y calidad, y medir los resultados de un aliado frente a sus pares para entender y declarar los modelos ideales",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "Es el valor asignado a pago de comisiones",
      "Proveedores_conocidos": "Se tiene pensado invitar a participar a ATENTO, EMERGIA, KONECTA, TENTEN y CONTACTO SOLUTIONS (Todos ya son proveedores de banco)",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C105000014  Equipo Comercial SUFI",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4035835471",
      "Familias": "Ventas Digitales",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Andres Felipe Viana Casas",
      "Rol_asesor": "No aplica",
      "Observaciones": "Diana ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "23/06/2023",
      "Fecha Asignación/Delegación": "23/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "01/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "15/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Modelos de Relacionamiento Integral",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3687,
      "Title": "Forms",
      "Fecha_solicitud": "31/05/2023",
      "Correo_solicitante": "DIMCASTA@bancolombia.com.co",
      "Nombre_solicitante": "Diana Marcela Castano Gomez",
      "Nombre_iniciativa": "ID 3687 - CCS Fase II",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere activar SOW II con el proveedor Fiserv para CCS , con el fin de realizar implementación y desarrollos de restricciones de seguridad (LS/LB) entre Falcon y Vision+ para que se apliquen automáticamente en VISION y seamos opórtunos ante el cliente, adicionalmente tener la teradata de la información de CCS en el datelake de Bancolombia, con el fin de tener la trazabilidad e informes.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "El ppto se esta gestionando por los lideres de la EVC de Gestion de Fraude y Medios de Pago.",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Fiserv",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC de Gestión de Fraude",
      "Nombre_lider_EVC": "Mauricio Cano",
      "SR_ARIBA": "SR4036174589",
      "Familias": "Seguridad Canales y Productos",
      "Categoría": "Seguridad",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Mateo Villada Rodriguez",
      "Rol_asesor": "Andres Osorio Castano",
      "Observaciones": "Cata está en proceso de PN",
      "Comentarios BP": "Llevar al MP y asignar a Mateo",
      "Fecha MarketPlace": "02/06/2023",
      "Fecha Asignación/Delegación": "02/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "01/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "02/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Gestión del Fraude",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3686,
      "Title": "Forms",
      "Fecha_solicitud": "31/05/2023",
      "Correo_solicitante": "vavgomez@bancolombia.com.co",
      "Nombre_solicitante": "Valentina Velasquez Gomez",
      "Nombre_iniciativa": "ID 3686 - Gestionar un acuerdo de confidencialidad con el proveedor 60707 Synaptica S.A.S.",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Gestionar un acuerdo de confidencialidad con el proveedor 60707 Synaptica S.A.S.",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Es necesario radicar esta carta porque son Instructores y van a la dar clases de SQL y Python, y la idea es que lo realizen en el entorno Banco con el fin de que las personas tengan este aprendizaje sea sobre los aplicativos del entorno Banco: Hue, HewNoMore... y para ello es esencial que los instructores puedan dar la clase sobre estos y no sobre un ambiente externo",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "60707 Synaptica S.A.S.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia Aprendizaje C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR No requerido",
      "Familias": "",
      "Categoría": "",
      "¿Cómo se va a gestionar?": "Contención",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Mayo 31,  Se habló telefónicamente con la usuario, como ya había generado req. anterior para vincular al proveedor, se le indicó que lo reutilizara para gestionar el NDA",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "01/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "",
      "Subcategoría_F": "",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3685,
      "Title": "Forms",
      "Fecha_solicitud": "31/05/2023",
      "Correo_solicitante": "acsantia@bancolombia.com.co",
      "Nombre_solicitante": "Ana Cristina Santiago Rios",
      "Nombre_iniciativa": "ID 3685 - Solicitar propuesta económica categorías SAP a Capgemini",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Desde el equipo de Administración de Proveedores requerimos que se realice una solicitud de propuesta económica de servicios en categoría SAP a Capgemini, en busca de tener otra opción de proveedor para esta categoría adicional a Perceptio. Las categorías son similares a las negociadas en su momento con BCSupport o NETW.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "El objetivo de la so",
      "Valor_presupuesto": "No aplica",
      "Proveedores_conocidos": "CAPGEMINI COLOMBIA SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "ADMINISTRACION INTEGRAL EQUIPOS DE TI -  C103500002",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4035835454",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Daniel Jimenez Delgado",
      "Rol_asesor": "No aplica",
      "Observaciones": "Jose ok. PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "09/06/2023",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "01/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "05/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3684,
      "Title": "Forms",
      "Fecha_solicitud": "31/05/2023",
      "Correo_solicitante": "zvilla@bancolombia.com.co",
      "Nombre_solicitante": "Zuleima Villa Cespedes",
      "Nombre_iniciativa": "ID 3684 - Renovación Tarifas Bancolombia A la mano - Feeling - CW2264066 (marco) OS CW2264068",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2264066",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere contratación de personal, para cargo de gestores y movilizadores, que apoyan labores con Bancolombia A la mano . Renovación Tarifas Bancolombia A la mano - Feeling - CW2264066 (marco) OS CW2264068",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "$1.787 mm",
      "Proveedores_conocidos": "Feeling Company",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC INCLUSIÓN  C105900003",
      "Nombre_lider_EVC": "Maria Clara Palacio Uribe",
      "SR_ARIBA": "SR4035762263",
      "Familias": "Venta en Campo",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Luis Guillermo Salcedo Valderrama",
      "Rol_asesor": "No aplica",
      "Observaciones": "Dianis es renovación, proveedor riesgo 3 no va a PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "02/06/2023",
      "Fecha Asignación/Delegación": "02/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "01/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Modelos de Relacionamiento Integral",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3683,
      "Title": "Forms",
      "Fecha_solicitud": "31/05/2023",
      "Correo_solicitante": "NANURIBE@bancolombia.com.co",
      "Nombre_solicitante": "Nancy Milena Uribe Cardona",
      "Nombre_iniciativa": "ID 3683 - Alquiler de espacios para evento Sur Extraordinaria en Armenia",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere alquiler de un salón en Armenia para realización del taller Sur Extraordinaria",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 0,
      "Proveedores_conocidos": "Asociación Club Campestre de Armenia",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento (Aprendizaje)-C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3683,
      "Familias": "Otros Servicios Bienes Inmuebles - Muebles",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "01/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "01/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Gestión Inmobiliaria",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3682,
      "Title": "Forms",
      "Fecha_solicitud": "31/05/2023",
      "Correo_solicitante": "mavramir@bancolombia.com.co",
      "Nombre_solicitante": "Maria Fernanda Velez Ramirez",
      "Nombre_iniciativa": "ID 3682 - Legalizar factura del evento de integración del EVC de Distribución Física",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Requiero saber a que material contable debo vincular el gasto",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Nosotros contratamos un proveedor (Exploralo) para que nos organizara la actividad de integración, ellos gestionarán refrigerio y actividades para conectar el equipo",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "EXPLORALO S.A.S.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Distribución Física C105400007",
      "Nombre_lider_EVC": "Juan Camilo Moreno Gomez",
      "SR_ARIBA": 3682,
      "Familias": "Comunicaciones y Reputación",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "01/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "01/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3681,
      "Title": "Forms",
      "Fecha_solicitud": "31/05/2023",
      "Correo_solicitante": "juliaher@bancolombia.com.co",
      "Nombre_solicitante": "Julian Leonardo Hernandez Diaz",
      "Nombre_iniciativa": "ID 3681 - Trámite de consecución de EIN Valores Bancolombia",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular al proveedor y solicitar material para pago.",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Asesoría para la realización del trámite y un concepto jurídico sobre las implicaciones de obtener el EIN en USA (sobre todo tributarias).",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "H&CO Entity Management LLC",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Tesorería y Valores - C102400020",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3681,
      "Familias": "Servicios Legales",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "01/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "01/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios Profesionales Procesos del Negocio",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3680,
      "Title": "Forms",
      "Fecha_solicitud": "31/05/2023",
      "Correo_solicitante": "allopera@bancolombia.com.co",
      "Nombre_solicitante": "Alexander Lopera Cano",
      "Nombre_iniciativa": "ID 3680 - Actualización tarifas TP para el Contact Center - CW2294341",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2294341",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Actualización de tarifas del CC para los servicios migrados a plataforma Genesys cloud.  CW2294341",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 250316,
      "Proveedores_conocidos": "Teleperformance",
      "Cuadrante_Proveedor": 0,
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Contact Center C105400001",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4035835437",
      "Familias": "Líneas de Entrada",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Yohany Anibal Gaviria Quintero",
      "Rol_asesor": "No aplica",
      "Observaciones": "Dianis ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "09/06/2023",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "01/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "05/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios Canal Telefónico",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3679,
      "Title": "Forms",
      "Fecha_solicitud": "31/05/2023",
      "Correo_solicitante": "caramor@Bancolombia.com.co",
      "Nombre_solicitante": "Carolina Ramirez Orozco",
      "Nombre_iniciativa": "ID 3679 - Formalización contratación analista de canales Sufi",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere un analista de Canales Sufi para hacer parte de la LDC de Canales Sufi. Se adelantó la negociación con el aliado Personal Soft, la persona ya fue elegida y la tarifa definida. Sólo es formalizar la OS.\nTendrá la administración de los aliados y el acompañamiento desde la estrategia para la implementación de proyectos en los canales Sufi.\nSe tuvo que hacer la contratación por un tercero, por temas de ppto y por eso no fue directa con banco",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "128.520.000",
      "Proveedores_conocidos": "Personal Soft",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Estrategia de clientes, pero el recurso será pagado con este centro de costos que corresponde al área de seguros Sufi C105500002",
      "Nombre_lider_EVC": "Juliana Velásquez",
      "SR_ARIBA": "SR No requerido",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Contención",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Junio 02.  El requerimiento me lo revisó Diana por Teams y me confirmó que era de Jose y que a la usuaria la asesoraba Diana Milena Arango, sin necesidad de llevar el req. al MP_  porque so servicios ya están contratados.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "02/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3678,
      "Title": "Forms",
      "Fecha_solicitud": "30/05/2023",
      "Correo_solicitante": "dmquinte@bancolombia.com.co",
      "Nombre_solicitante": "Diana Marcela Quintero Palacio",
      "Nombre_iniciativa": "ID 3678 - Certificación doble materialidad",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Buen día actualmente tenemos una negociación con Deloitte para la auditoria de indicadores ASG, sin embargo Deloitte no pudo incluir los indicadores de materialidad en la revisión actual del informe GRI por lo tanto se requiere validar en el mercado quien puede realizar la validación de la consulta que se realizará este año sobre doble materialidad.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "50millones",
      "Proveedores_conocidos": "PWC, E&Y",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "CDE sostenibilidad y bienestar Ccostos 102200062",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4035762246",
      "Familias": "Revisoría Fiscal",
      "Categoría": "Procesos del negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Andrea Diaz Soto",
      "Rol_asesor": "No aplica",
      "Observaciones": "Biatri OK PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "09/06/2023",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "01/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "06/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios Profesionales Procesos del Negocio",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3677,
      "Title": "Forms",
      "Fecha_solicitud": "30/05/2023",
      "Correo_solicitante": "dmquinte@bancolombia.com.co",
      "Nombre_solicitante": "Diana Marcela Quintero Palacio",
      "Nombre_iniciativa": "ID 3677 - Consulta Grupos de relación",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Análisis de doble materialidad, desde el área de reputación realizan la consultar a través de KPMG y evalúan los resultado del banco a través de la consulta a los grupos de relación, desde sostenibilidad tenemos la necesidad de identificar los impactos que genera el banco a través de consultas muy similares a las que realiza reputación, al conocer la consulta de reputación pudimos conocer la oferta de KPMG  sobre este tema de doble materialidad que es a la fecha una exigencia desde la Superfinanciera en la circular 031 y en las mejores prácticas de sostenibilidad en estándares como el Índice de  Dow Jones de sostenibilidad",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "150 millones",
      "Proveedores_conocidos": "KPMG, E&Y, DELOITTE pero de lo que conocemos KPMG es el más acertado.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "CDE Sostenibilidad y Bienestar CCostos 102200062",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4035835420",
      "Familias": "Consultorias Corporativas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Luis Guillermo Salcedo Valderrama",
      "Rol_asesor": "No aplica",
      "Observaciones": "Naty ok. PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "09/06/2023",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "01/06/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "06/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Consultorias Corporativas",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3676,
      "Title": "Forms",
      "Fecha_solicitud": "30/05/2023",
      "Correo_solicitante": "andrmari@bancolombia.com.co",
      "Nombre_solicitante": "Andrea Marin Cadavid",
      "Nombre_iniciativa": "ID 3676 - Asesoría para contratación de asesor Konecta en instalaciones Banco",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se solicita asesoría para una necesidad que se tiene actualmente en el equipo de seguridad de tener una persona de Konecta en instalaciones Banco para la revisión de unos casos mal radicados por la línea telefónica, queremos revisar la viabilidad de esta necesidad de cara a lo contractual",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Se está revisando el tema y no sería una persona nueva, la idea es trasladar a alguien que ya esté en la línea de fraudes",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Konecta",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia Servicios Contact Center C105500019",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR No requerido",
      "Familias": "",
      "Categoría": "",
      "¿Cómo se va a gestionar?": "Contención",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Mayo 31.  Se le informó al usuario por correo que validara si a nivel contractual se puede traer a la persona.  Debe validarlo con Jurídico.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "31/05/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "",
      "Subcategoría_F": "",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3675,
      "Title": "Forms",
      "Fecha_solicitud": "30/05/2023",
      "Correo_solicitante": "FERANLOP@bancolombia.com.co",
      "Nombre_solicitante": "Fernando Antonio Lopez Jimenez",
      "Nombre_iniciativa": "ID 3675 - WAS  Negociación Capex y Opex Tenable - Axity",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Actualmente se tiene un servicio contratado con Devel el cual vemos como posibilidad la negociación con Tenable como fabricante de las licencias de WAS y Axity como canal que opera y nos suministra los servicio de operación y evolución de las soluciones.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "70.000 USD",
      "Proveedores_conocidos": "Axity - Tenable",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Seccion Cibersalubridad",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4033301925",
      "Familias": "Controles de Ciberseguridad",
      "Categoría": "Seguridad",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Pablo Zapata Franco",
      "Rol_asesor": "Andres Osorio Castano",
      "Observaciones": "Cata de acuerdo a tu solicitud, te lo remito sin gestión de PN",
      "Comentarios BP": "Llevar al MP y asignar a Pablo Zapata",
      "Fecha MarketPlace": "02/06/2023",
      "Fecha Asignación/Delegación": "02/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "31/05/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "01/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Ciberseguridad y seguridad de la información",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3674,
      "Title": "Forms",
      "Fecha_solicitud": "30/05/2023",
      "Correo_solicitante": "ANGMAROD@bancolombia.com.co",
      "Nombre_solicitante": "Angela Maria Rodriguez Castano",
      "Nombre_iniciativa": "ID 3674 - Contratacion provedor spencer stuart",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Servicio de reclutamiento apoyo al area de talento, por lo cual se requiere la cuenta contable y materia para realizar el pago al proveedor",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "35.000.000",
      "Proveedores_conocidos": "SPENCER STUART ANDINA S.A.S.  900487454",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Atraccion  talento y cultura  centro de costos c103200040",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4032279560",
      "Familias": "Servicios Selección al Personal",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "31/05/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "31/05/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Atracción y desarrollo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3673,
      "Title": "Forms",
      "Fecha_solicitud": "30/05/2023",
      "Correo_solicitante": "agdereix@bancolombia.com.co",
      "Nombre_solicitante": "Alejandra Gomez Dereix",
      "Nombre_iniciativa": "ID 3673 - Asesoría para un proyecto de Disponibilizar archivos de tarjeta de crédito en nube",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Asesoría para una iniciativa del EVC de Medios de Pago, donde se migraran unos archivos de Tarjeta de crédito a AWS, y se requiere consultas con el proveedor BROADCOM para validar que tipos de licencias debemos tener con ellos con el fin de disponibilizar una instancia de XCOM en nube",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Priorizado por el CAE",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "n.a",
      "Proveedores_conocidos": "BROADCOM",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC Medios de Pago EVC0019",
      "Nombre_lider_EVC": "Luisa Fernanda Monsalve",
      "SR_ARIBA": "SR No requerido",
      "Familias": "Licenciamiento Mayor",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Contención",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Mayo 30. usuario volvió a generar req. igual al 3604 que no ha gestionado PN.  por correo se le indica que gestione el 3604 y este se le cancela.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "30/05/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3672,
      "Title": "Forms",
      "Fecha_solicitud": "30/05/2023",
      "Correo_solicitante": "gyate@bancolombia.com.co",
      "Nombre_solicitante": "Gilma Carolina Yate Guzman",
      "Nombre_iniciativa": "ID 3672 - Vinculacion proveedores",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Vinculación proveedor para futuros eventos, servicios alimenticios",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 132000000,
      "Proveedores_conocidos": "frederick",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C102100354, GERENCIA DE GESTION COMERCIAL REGION CENTRO",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3672,
      "Familias": "BTL",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "30/05/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "30/05/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3671,
      "Title": "Forms",
      "Fecha_solicitud": "30/05/2023",
      "Correo_solicitante": "jogarcia@bancolombia.com.co",
      "Nombre_solicitante": "Jorge Mario Garcia Palacio",
      "Nombre_iniciativa": "ID 3671 - Vinculacion de proveedor LO QUE NECESITO SAS",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular al proveedor para poder realizar el pago de comisiones",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El aliado Proptech LO QUE NECESITO SAS genera nuevos negocios de créditos de vivienda o leasing habitacional y procede con dichas solicitudes en el aplicativo Bizagi GO Solución inmobiliaria, posteriormente a los desembolsos efectivos se debe proceder a pagar comisiones",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "LO QUE NECESITO SAS",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Tu360 Inmobiliario, centro de costos C107500006",
      "Nombre_lider_EVC": "Maria Catalina Horta Gomez",
      "SR_ARIBA": "SR4032344910",
      "Familias": "Venta en Campo",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Maria Alejandra Delgado Leon",
      "Rol_asesor": "No aplica",
      "Observaciones": "Dianis ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "02/06/2023",
      "Fecha Asignación/Delegación": "02/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "30/05/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "31/05/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Modelos de Relacionamiento Integral",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3670,
      "Title": "Forms",
      "Fecha_solicitud": "30/05/2023",
      "Correo_solicitante": "dbgavir@bancolombia.com.co",
      "Nombre_solicitante": "Daniela Botero Gaviria",
      "Nombre_iniciativa": "ID 3670 - Consultoría Proyecto Sostenibilidad",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular al Proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "El proveedor es un experto que nos prestará el servicio de consultoría y asesoría técnica en el proyecto de sostenibilidad.",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Ximena Escovar",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Dirección de Marca C106500001",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3670,
      "Familias": "Consultorias Corporativas",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "30/05/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "30/05/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Consultorias Corporativas",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3669,
      "Title": "Forms",
      "Fecha_solicitud": "30/05/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 3669 - Compra de curso de extensión CONGRESO CAMACOL 2023\tCÁMARA COLOMBIANA DE LA CONSTRUCCIÓN - ATLANTICO",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión CONGRESO CAMACOL 2023\tCÁMARA COLOMBIANA DE LA CONSTRUCCIÓN - ATLANTICO",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "CÁMARA COLOMBIANA DE LA CONSTRUCCIÓN - ATLANTICO",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3669,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "30/05/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "30/05/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3668,
      "Title": "Forms",
      "Fecha_solicitud": "30/05/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 3668 - Compra de curso de extensión CONGRESO CAMACOL 2023\tCÁMARA COLOMBIANA DE LA CONSTRUCCIÓN - CUNDINAMARCA",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión CONGRESO CAMACOL 2023\tCÁMARA COLOMBIANA DE LA CONSTRUCCIÓN - CUNDINAMARCA",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "CÁMARA COLOMBIANA DE LA CONSTRUCCIÓN - CUNDINAMARCA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3668,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "30/05/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "30/05/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3667,
      "Title": "Forms",
      "Fecha_solicitud": "30/05/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 3667 - Compra de curso de extensión CONGRESO CAMACOL 2023\tCÁMARA COLOMBIANA DE LA CONSTRUCCIÓN - VALLE",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión CONGRESO CAMACOL 2023\tCÁMARA COLOMBIANA DE LA CONSTRUCCIÓN - VALLE",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "CÁMARA COLOMBIANA DE LA CONSTRUCCIÓN - VALLE",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3667,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "30/05/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "30/05/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3666,
      "Title": "Forms",
      "Fecha_solicitud": "30/05/2023",
      "Correo_solicitante": "rmperez@bancolombia.com.co",
      "Nombre_solicitante": "Rene Mauricio Perez Forero",
      "Nombre_iniciativa": "ID 3666 - Realizar el proceso de negociación para la renovación del contrato con la firma IDT. CW2266762",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2266762",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Realizar la renovación del contrato CW2266762 con la firma IDT S.A.S. para el mantenimiento de las Plantas eléctricas y UPS",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "180.000.000",
      "Proveedores_conocidos": "INGENIERIA DE TELECOMUNICACIONES IDT S.A.S.",
      "Cuadrante_Proveedor": 4,
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Dirección Gestión del Activo y Seguridad  C104300023",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4032171914",
      "Familias": "HARD (Operadores de Mantenimiento)",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Carlos Andres Ramos Ospina",
      "Rol_asesor": "No aplica",
      "Observaciones": "Naty hola, es renovación, proveedor riesgo 4 no va a PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "02/06/2023",
      "Fecha Asignación/Delegación": "02/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "30/05/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Facility Managment",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3665,
      "Title": "Forms",
      "Fecha_solicitud": "30/05/2023",
      "Correo_solicitante": "rmperez@bancolombia.com.co",
      "Nombre_solicitante": "Rene Mauricio Perez Forero",
      "Nombre_iniciativa": "ID 3665 - Realizar el proceso de negociación para la renovación del Contrato con la firma EQUITEC. CW2285252",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2285252",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Necesitamos llevar a cabo la renovación del contrato CW2285252 con la firma EQUITEC para el mantenimiento de  UPS y Plantas Eléctricas",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "180.000.000",
      "Proveedores_conocidos": "EQUITEC S.A.",
      "Cuadrante_Proveedor": 4,
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Dirección Gestión del Activo y Seguridad   C104300023",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4032171891",
      "Familias": "HARD (Operadores de Mantenimiento)",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Carlos Andres Ramos Ospina",
      "Rol_asesor": "No aplica",
      "Observaciones": "Naty es renovación. Proveedor riesgo 4 no va a PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "02/06/2023",
      "Fecha Asignación/Delegación": "02/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "30/05/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Facility Managment",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3664,
      "Title": "Forms",
      "Fecha_solicitud": "30/05/2023",
      "Correo_solicitante": "danicast@bancolombia.com.co",
      "Nombre_solicitante": "Daniela Castano Ballesteros",
      "Nombre_iniciativa": "ID 3664 - Paletas - congreso de centros comerciales",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "solictar material",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "se solicitaron 300 paletas de agua para el 1er congreso de centros comerciales de Latinoamerica en el que participo la EVC Pagos sin Fricción,",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "GRUPO HEROICA S.A.S.",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Pagos sin Friccion C107500005",
      "Nombre_lider_EVC": "Santiago Ceballos",
      "SR_ARIBA": 3664,
      "Familias": "Merchandising e Impresos",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "30/05/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "30/05/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3663,
      "Title": "Forms",
      "Fecha_solicitud": "30/05/2023",
      "Correo_solicitante": "gyate@bancolombia.com.co",
      "Nombre_solicitante": "Gilma Carolina Yate Guzman",
      "Nombre_iniciativa": "ID 3663 - Vinculacion proveedor",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Vinculación proveedor, apoya desde el área logística y de alimentos, para eventos a realizar",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 132000000,
      "Proveedores_conocidos": "Pasteles de la tercera",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C102100354, GERENCIA DE GESTION COMERCIAL REGION CENTRO",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3663,
      "Familias": "BTL",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "30/05/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "30/05/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3662,
      "Title": "Forms",
      "Fecha_solicitud": "30/05/2023",
      "Correo_solicitante": "gyate@bancolombia.com.co",
      "Nombre_solicitante": "Gilma Carolina Yate Guzman",
      "Nombre_iniciativa": "ID 3662 - VINCULACION PROVEEDOR",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Proveedor para próximos eventos a realizar, apoya brindándonos servicios alimenticios",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": 132000000,
      "Proveedores_conocidos": "El tiesto del taita",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C102100354, gerencia de gestion comercial region centro",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3662,
      "Familias": "BTL",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "30/05/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "30/05/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3661,
      "Title": "Forms",
      "Fecha_solicitud": "30/05/2023",
      "Correo_solicitante": "DRIVERA@bancolombia.com.co",
      "Nombre_solicitante": "Deisy Liliana Rivera Rodriguez",
      "Nombre_iniciativa": "ID 3661 - Actualización Tarifas Proveedor Industria Ambiental . CW2296268",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2296268",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la actualización tarifaria e inclusión de algunos ítems dentro del contrato de residuos reciclables. CW2296268",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "La avctualización no requiere presupuesto , debido a que el servicio que nos prestan es retribuido al banco con la venta de residuos reciclables",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Industria Ambiental",
      "Cuadrante_Proveedor": 4,
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia Gestión Inmobiliaria C104300023",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4032016710",
      "Familias": "SOFT (Operadores de Aseo)",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Luis Guillermo Salcedo Valderrama",
      "Rol_asesor": "No aplica",
      "Observaciones": "Naty, es renovación, proveedor riesgo 4 no va a PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "02/06/2023",
      "Fecha Asignación/Delegación": "02/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "30/05/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Facility Managment",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3660,
      "Title": "Forms",
      "Fecha_solicitud": "30/05/2023",
      "Correo_solicitante": "jmpulgar@bancolombia.com.co",
      "Nombre_solicitante": "John Mauricio Pulgarin",
      "Nombre_iniciativa": "ID 3660 - TALLERES DE CRECIMIENTO PERSONAL",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "VINCULAR AL PROVEEDOR",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "TALLERES DE CRECIMIENTO PERSONAL",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "19484997-3 FERNANDO JOSE ROCA CORREA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GERENCIA DE BIENESTAR C103200030",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3660,
      "Familias": "Convenios y Beneficios",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "30/05/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "30/05/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3659,
      "Title": "Forms",
      "Fecha_solicitud": "29/05/2023",
      "Correo_solicitante": "andcamar@bancolombia.com.co",
      "Nombre_solicitante": "Andrea Paola Camargo Maldonado",
      "Nombre_iniciativa": "ID 3659 - Vincular proveedor en Cartagena",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular Proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere vincular proveedor para actividades en Cartagena",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "ACOD ENTERPRISE SOLUTIONS S.A.S 901676483-3",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Calida de Vida c103200170",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3659,
      "Familias": "Convenios y Beneficios",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "30/05/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "30/05/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3658,
      "Title": "Forms",
      "Fecha_solicitud": "29/05/2023",
      "Correo_solicitante": "hejmejia@bancolombia.com.co",
      "Nombre_solicitante": "Hector Julian Mejia Arango",
      "Nombre_iniciativa": "ID 3658 - Actualización Soporte de Fabricante HSM Atalla Bancolombia  CW2279121",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2279121",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Dada una actualización que recientemente se viene realizando de la infraestructura HSM Atalla del Banco, debemos revisar el contexto de costos de soporte de Fabricante UTIMACO para ellos, dado que con la implementación de los nuevos equipos, cambian los tiempos del soporte anual que con los dispositivos anteriores se tenía establecido.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "14000 USD",
      "Proveedores_conocidos": "PTESA (Profesionales en Transacciones Electrónicas S.A.)",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC de Capacidades de Ciberseguridad CECO C104300559",
      "Nombre_lider_EVC": "Andrés Felipe Rivas González",
      "SR_ARIBA": "SR4032016727",
      "Familias": "Servicios de Soporte",
      "Categoría": "Seguridad",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Mateo Villada Rodriguez",
      "Rol_asesor": "Andres Osorio Castano",
      "Observaciones": "Hola  Cata. ok PN",
      "Comentarios BP": "Llevar al MP y asignar a Mateo Villada",
      "Fecha MarketPlace": "02/06/2023",
      "Fecha Asignación/Delegación": "02/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "30/05/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "01/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de seguridad",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3657,
      "Title": "Forms",
      "Fecha_solicitud": "29/05/2023",
      "Correo_solicitante": "andcamar@bancolombia.com.co",
      "Nombre_solicitante": "Andrea Paola Camargo Maldonado",
      "Nombre_iniciativa": "ID 3657 - Vinculación Proveedor Masajes Santa Marta",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular al proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere vincular al proveedor para realizar actividades de bienestar para Santa Marta",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "GERALDINE ALEJANDRA MENDINUETA CRUZ",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Calidad de Vida c103200170",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3657,
      "Familias": "Convenios y Beneficios",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "30/05/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "30/05/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Calidad de vida",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3656,
      "Title": "Forms",
      "Fecha_solicitud": "29/05/2023",
      "Correo_solicitante": "hejmejia@bancolombia.com.co",
      "Nombre_solicitante": "Hector Julian Mejia Arango",
      "Nombre_iniciativa": "ID 3656 - Aumento de capacidad de procesamiento TPS Atalla Bancolombia",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Adquirir capacidad adicional (licenciamiento) para los procesadores criptográficos HSM Atalla que brindan servicio en el contexto criptográfico para el Núcleo Transaccional del Banco, específicamente en la funcionalidad de operaciones criptográficas de tratamiento de PIN (aumento de TPS, operaciones de traducciones de PIN por Segundo).",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "Es una necesidad reciente que de no atenderse impactaría considerablemente los canales/servicios transaccionales de la Organización por temas de capacidad en infraestructura tecnológica y de ciberseguridad.",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "PTESA (Profesionales en Transacciones Electrónicas S.A.)",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC de Capacidades de Ciberseguridad CECO C104300559",
      "Nombre_lider_EVC": "Andrés Felipe Rivas González",
      "SR_ARIBA": "SR4032016692",
      "Familias": "Servicios de Soporte",
      "Categoría": "Seguridad",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Mateo Villada Rodriguez",
      "Rol_asesor": "No aplica",
      "Observaciones": "Cata, dado que es un incremento en la capacidad y que Andrea me dijo que este cpntrato lo van a renovar, no lo envié a PN",
      "Comentarios BP": "Llevar al MP y asignar a Mateo",
      "Fecha MarketPlace": "02/06/2023",
      "Fecha Asignación/Delegación": "02/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "30/05/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de seguridad",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3655,
      "Title": "Forms",
      "Fecha_solicitud": "29/05/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 3655 - Compra de curso de extensión CONGRESO CAMACOL 2023 - CÁMARA COLOMBIANA DE LA CONSTRUCCIÓN - SANTANDER",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión CONGRESO CAMACOL 2023 - CÁMARA COLOMBIANA DE LA CONSTRUCCIÓN - SANTANDER",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "CÁMARA COLOMBIANA DE LA CONSTRUCCIÓN - SANTANDER",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3655,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "29/05/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "29/05/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3654,
      "Title": "Forms",
      "Fecha_solicitud": "29/05/2023",
      "Correo_solicitante": "julihena@bancolombia.com.co",
      "Nombre_solicitante": "Juliana Henao Tamayo",
      "Nombre_iniciativa": "ID 3654 - Compra de curso de extensión CONGRESO CAMACOL 2023 - CÁMARA COLOMBIANA DE LA CONSTRUCCIÓN - META Y HUILA",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Evaluar/vincular/actualizar el proveedor para compra de curso de extensión",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Compra de curso de extensión CONGRESO CAMACOL 2023 - CÁMARA COLOMBIANA DE LA CONSTRUCCIÓN - META Y HUILA",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "CÁMARA COLOMBIANA DE LA CONSTRUCCIÓN - META Y HUILA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Formación y Entrenamiento - C103200060",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3654,
      "Familias": "Programas de Formación y Estudio",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "29/05/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "29/05/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Formación y entrenamiento",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3653,
      "Title": "Forms",
      "Fecha_solicitud": "29/05/2023",
      "Correo_solicitante": "jgsanche@bancolombia.com.co",
      "Nombre_solicitante": "Juan Guillermo Sanchez Blandon",
      "Nombre_iniciativa": "ID 3653 - Proveedor logístico Bintec 2023",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere la contratación del servicio logístico para la feria BINTEC 2023 para asegurar el montaje del inmobiliario en la sede DG auditorios torre sur piso 11 y el streaming del evento al público que atenderá la feria; cumpliendo con los requerimientos que el Banco demanda para esta clase de evento.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "164.000.000",
      "Proveedores_conocidos": "Eventos Efectivos y Banda-l (Opcionados)",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "CdeE (Centro de Excelencia)",
      "Nombre_area_y_ceco": "Estrategia e Innovacion de TI - Centro de costo: C103500240",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4032016673",
      "Familias": "Telecomunicaciones",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Carlos Andres Ramos Ospina",
      "Rol_asesor": "No aplica",
      "Observaciones": "Naty le puse familia de RTI porque harán streaming y eso toca a telecomunicaciones (así lo hicimos en años anteriores)",
      "Comentarios BP": "",
      "Fecha MarketPlace": "09/06/2023",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "30/05/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "30/05/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicio telecomunicación",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3652,
      "Title": "Forms",
      "Fecha_solicitud": "29/05/2023",
      "Correo_solicitante": "saravela@bancolombia.com.co",
      "Nombre_solicitante": "Sara Velasquez Bedoya",
      "Nombre_iniciativa": "ID 3652 - Contratación a chef Lizo Valencia",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Servicio a evento de Presidencia",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Lizandro Wbeimar Valencia Franco",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C102000000",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3652,
      "Familias": "Comunicaciones y Reputación",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Se deja esa familia por ser del grupo de comunicaciones y es la mas parecida para un evento de presidencia.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "29/05/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "29/05/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Proyección Institucional",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3651,
      "Title": "Forms",
      "Fecha_solicitud": "29/05/2023",
      "Correo_solicitante": "carescob@bancolombia.com.co",
      "Nombre_solicitante": "Carolina Escobar Pemberthy",
      "Nombre_iniciativa": "ID 3651 - Estudios de Investigación Inmark",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere gestionar el acuerdo y pago con el proveedor Inmark a quien anualmente le compramos el estudio de Pyme y/o Personas naturales.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "USD 42.500",
      "Proveedores_conocidos": "Inmark",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Conocimiento del Cliente C105900005",
      "Nombre_lider_EVC": "Camilo Restrepo Saldarriag",
      "SR_ARIBA": "SR4030725794",
      "Familias": "Investigaciones de Mercado",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "29/05/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "29/05/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercadeo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3650,
      "Title": "Forms",
      "Fecha_solicitud": "29/05/2023",
      "Correo_solicitante": "JOHAESPI@bancolombia.com.co",
      "Nombre_solicitante": "Johanna Espinosa Castrillon",
      "Nombre_iniciativa": "ID 3650 - Vinculacion proveedor talento murex",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "se requiere vincular un proveedor nuevo proveedor de talento especializado en murex para trabajar eventualmente en proyectos en la EVC de tesoreria.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "depende de la demanda de los proyectos que se vayan priorizando",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "NTT DATA: Global IT Services Provider & Consultant",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "EVC de Tesoreria - C105600006",
      "Nombre_lider_EVC": "Lina Marcela Cardenas Paniagua",
      "SR_ARIBA": "SR4031774956",
      "Familias": "Servicios Profesionales de TI",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Juan Esteban Franco Vargas",
      "Rol_asesor": "Andres Osorio Castano",
      "Observaciones": "Jose no lo envie a PN, porque tengo entendido que estos servicios profesionales ya los tenemos contratados, es sumarle más personas.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "30/06/2023",
      "Fecha Asignación/Delegación": "30/06/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "30/05/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios profesionales de TI",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3649,
      "Title": "Forms",
      "Fecha_solicitud": "29/05/2023",
      "Correo_solicitante": "ANMOSCOS@bancolombia.com.co",
      "Nombre_solicitante": "Andrea del Pilar Moscoso Cogua",
      "Nombre_iniciativa": "ID 3649 - Bloomberg Index Services Limited",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Se requiere vincular y hacer definicion contable para pagar la factura del servicio prestado",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Bloomberg Index Services Limited\nes un seervicio de la linea de valores anual de suscripcion",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Bloomberg",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "GERENCIA SERVICIOS MESAS DE DINERO",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3649,
      "Familias": "Servicios Bursátiles",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "29/05/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "29/05/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Mercados de Capitales",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3648,
      "Title": "Forms",
      "Fecha_solicitud": "29/05/2023",
      "Correo_solicitante": "JORGVALD@Bancolombia.com.co",
      "Nombre_solicitante": "Jorge Valderrama Betancur",
      "Nombre_iniciativa": "ID 3648 - Dominio Licencias Salesforce, contrato CW2290366",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2290366",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Actualmente tenemos una necesidad de definir el responsable de administrar la asignación de las 329 licencias de salesforce Factoring para los diferentes equipos comerciales. La compra inicial de las licencias se hizo desde el equipo de Tecnología de Factoring, pero la administración, es decir, asignación, retiro y necesidades de los usuarios de las licencias las atiende un área de conocimiento de clientes que nada tiene que ver con este proceso. Se requiere apoyo para hacer un análisis de gobierno sobre la administración de las licencias en cuestión.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Aún no",
      "Justificación_sin_presupuesto": "No se requiere presupuesto para esta solicitud",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Salesforce",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Factoring C103500007",
      "Nombre_lider_EVC": "Jorge Valderrama Betancur",
      "SR_ARIBA": "SR No requerido",
      "Familias": "Licenciamiento Mayor",
      "Categoría": "Transformación de TI",
      "¿Cómo se va a gestionar?": "Contención",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Mayo 30. Jose indica que él lo asesora, dado que no es una negociación, sino aclarar el gobierno del servicio.  Se le informa al usuario por correo.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "30/05/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Servicio de software",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3647,
      "Title": "Forms",
      "Fecha_solicitud": "28/05/2023",
      "Correo_solicitante": "luferodr@bancolombia.com.co",
      "Nombre_solicitante": "Luis Fernando Rodriguez Canaveral",
      "Nombre_iniciativa": "ID 3647 - Renovar Operación de impuesto de vehículos en favor de la gobernación de Boyacá. contrato CW2293644",
      "Tipo_Requerimiento": "Renovación de un bien o servicio con el que ya se cuenta (debes indicar el numero CW del contrato - el Administrador te lo informa)",
      "CW_a_renovar": "CW2293644",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere Renovar CW2293644 el proceso de  soporte, servicios,uso y administración de un software tecnológico para la liquidación  de impuesto vehiculos del departamento de Boyacá",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "3.000.000.000",
      "Proveedores_conocidos": "NA",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "Gerencia de Recaudos y Pagos",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4030498669 (R)",
      "Familias": "Redes",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Retirar Requerimiento",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "Junio 08. Se cancela req. porque usuario no gestionó PN, se le recordó el 05 de junio y se le había solicitado desde el 29 de mayo,.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "08/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "29/05/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Medios de Pago",
      "Subcategoría_F": "Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3646,
      "Title": "Forms",
      "Fecha_solicitud": "28/05/2023",
      "Correo_solicitante": "edangel@bancolombia.com.co",
      "Nombre_solicitante": "Eduardo Angel Gutierrez",
      "Nombre_iniciativa": "ID 3646 - Vinculación de proveedor actual para pago de facturas",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Vincular al proveedor SuperPagos para poder pagarle las facturas",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Requerimos desde Nequi vincular a SuperPagos como proveedor para poder pagarle las facturas del servicio de corresponsalía bancaria Nequi que esta prestando en este momento. NIT_900616155",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Super Pagos",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "Gerencia de desarrollo de producto",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4033301907",
      "Familias": "Corresponsales Agregadores",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Maria Fernanda Urrea Parra",
      "Rol_asesor": "Monica Marcela Alzate Granda",
      "Observaciones": "Dianis ok PN",
      "Comentarios BP": "",
      "Fecha MarketPlace": "09/06/2023",
      "Fecha Asignación/Delegación": "09/06/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "31/05/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "05/06/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Servicios Corresponsales Bancarios",
      "Subcategoría_F": "Estratégico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3645,
      "Title": "Forms",
      "Fecha_solicitud": "27/05/2023",
      "Correo_solicitante": "vivcardo@bancolombia.com.co",
      "Nombre_solicitante": "Vivian Mary Cardona Parra",
      "Nombre_iniciativa": "ID 3645 - Proveedor de pruebas técnicas",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se requiere vincular a proveedor de pruebas técnicas para procesos de selección de perfiles analíticos y de tecnología.",
      "Requerimiento_legal": "No",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "4.200.000",
      "Proveedores_conocidos": "Evalart",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Nequi",
      "Nombre_area_y_ceco": "C475000000",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": "SR4030638811",
      "Familias": "Servicios Selección al Personal",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "29/05/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "29/05/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Atracción y desarrollo",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3644,
      "Title": "Forms",
      "Fecha_solicitud": "26/05/2023",
      "Correo_solicitante": "aeecheve@bancolombia.com.co",
      "Nombre_solicitante": "Andrea Estefania Echeverri Idarraga",
      "Nombre_iniciativa": "ID 3644 - Envio masivo QRs 3.0 digitales",
      "Tipo_Requerimiento": "Negociación nueva (Negociación que apenas se va a iniciar con proveedor nuevo o ya existente)",
      "CW_a_renovar": "",
      "Justificación_legalización": "",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Se necesita hacer envío de correo electrónico masivo a los clientes que actualizaron su QR 3.0. Esta solicitud es una única vez.",
      "Requerimiento_legal": "Si",
      "Tiene_presupuesto": "Si",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "10.000.000",
      "Proveedores_conocidos": "Paradigma",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "EVC (Equipo de Valor Continuo)",
      "Nombre_area_y_ceco": "Pagos sin Fricción C107500005",
      "Nombre_lider_EVC": "Santiago Ceballos Aristizabal",
      "SR_ARIBA": "SR4095926354",
      "Familias": "Email",
      "Categoría": "Canales y medios de pago",
      "¿Cómo se va a gestionar?": "Llevar al MarketPlace",
      "Negociador": "Isabella Correa Valencia",
      "Rol_asesor": "No aplica",
      "Observaciones": "Mayo 29 por correo Se redirigió a la usuaria con la centralizadora de contactabilidad Sara Parra. que ese servicio ya lo tenemos contratado.\n\nJulio 12. usuaria solicita asignación de negociador, la solución que tiene el banco no le sirve y requiere este servicio puntual.\n\nJulio 13. Ok. PN, se le envía a Diana.",
      "Comentarios BP": "",
      "Fecha MarketPlace": "14/07/2023",
      "Fecha Asignación/Delegación": "14/07/2023",
      "En_fábricas": "True",
      "Fecha_envío_fábricas": "12/07/2023",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "13/07/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "True",
      "Envío aprobación BP": "",
      "Estado": "Contactabilidad con Clientes",
      "Subcategoría_F": "Apalancable",
      "Criticidad_F": ""
    },
    {
      "ID_lista": 3643,
      "Title": "Forms",
      "Fecha_solicitud": "26/05/2023",
      "Correo_solicitante": "AMHOYOS@bancolombia.com.co",
      "Nombre_solicitante": "Ana Milena Hoyos Ruiz",
      "Nombre_iniciativa": "ID 3643 - Nuestro propio viaje del heroe",
      "Tipo_Requerimiento": "Legalización de un Servicio - Pedido SAP, etc. (Ya se aprobó, o solicitó, o prestó el servicio, y lo que requieren es pagar o vincular/actualizar al proveedor o solicitar def. contable, entre otras)",
      "CW_a_renovar": "",
      "Justificación_legalización": "Actualizar proveedor",
      "Es_core_leasing": "",
      "Detalle_producto_o_servicio": "Con Corporación Serrezuela Country Club se va a realizar actividades de VP de T y C",
      "Requerimiento_legal": "",
      "Tiene_presupuesto": "",
      "Justificación_sin_presupuesto": "",
      "Valor_presupuesto": "",
      "Proveedores_conocidos": "Corporacion Serrezuela Country Club NIT 800219965-6",
      "Cuadrante_Proveedor": "",
      "EVC_AreaFuncional_CdeE": "Área Funcional",
      "Nombre_area_y_ceco": "C 103200030 Area de Calidad de Vida o Bienestar",
      "Nombre_lider_EVC": "",
      "SR_ARIBA": 3643,
      "Familias": "Otros Servicios Bienes Inmuebles - Muebles",
      "Categoría": "Apoyo al negocio",
      "¿Cómo se va a gestionar?": "Delegar al área usuaria",
      "Negociador": "",
      "Rol_asesor": "",
      "Observaciones": "delegar",
      "Comentarios BP": "",
      "Fecha MarketPlace": "",
      "Fecha Asignación/Delegación": "29/05/2023",
      "En_fábricas": "False",
      "Fecha_envío_fábricas": "",
      "Fecha ok. PN": "",
      "sin equipo": "",
      "Áreas pendientes": "29/05/2023",
      "Fecha_fin_fábricas": "False",
      "Es_fuera_de_política": "False",
      "Envío aprobación BP": "",
      "Estado": "Gestión Inmobiliaria",
      "Subcategoría_F": "No Crítico",
      "Criticidad_F": ""
    },
  ]
}